/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redteclab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBasicAuthToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const AddCostDisclaimerDataType = {
    NoInformation: 'NO_INFORMATION',
    NotAffected: 'NOT_AFFECTED',
    No: 'NO',
    Yes: 'YES'
};
export const AddressDetailsCountryCodeEnum = {
    De: 'DE'
};
export const AddressGet403MessageEnum = {
    AddressErrorAccessForbidden: 'address.error.access.forbidden',
    CustomerDataErrorAccessForbidden: 'customerData.error.access.forbidden'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AlternativeType = {
    Default: 'DEFAULT',
    Restricted: 'RESTRICTED',
    Biosimilar: 'BIOSIMILAR',
    Otc: 'OTC'
};
export const AmountV1CurrencyEnum = {
    Eur: 'EUR',
    Chf: 'CHF'
};
export const BadRequestCheckoutController400MessageEnum = {
    ValidationException: 'Validation Exception',
    VoucherInvalid: 'voucher.invalid',
    OverdraftsExisting: 'overdrafts.existing',
    ProfessionalCustomerHasMedicineError: 'professional.customer.has.medicine.error'
};
export const BillingAddressTypeEnum = {
    Billing: 'billing'
};
export const BillingAddressV1TypeEnum = {
    Billing: 'BILLING'
};
export const BillingRequestV2TypeEnum = {
    Billing: 'billing'
};
export const BillingResponseV2TypeEnum = {
    Billing: 'billing'
};
export const BillingResponseV2WithNowDataTypeEnum = {
    Billing: 'billing'
};
export const BusinessHoursDayInternalNameEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
};
export const CartDiscountsV2TypeEnum = {
    Voucher: 'voucher',
    Redpoints: 'redpoints'
};
export const CartDiscountsV2PromotionTypeEnum = {
    TotalPercent: 'totalPercent',
    TotalAmount: 'totalAmount',
    LinePercent: 'linePercent',
    LineAmount: 'lineAmount'
};
export const CartEntryItemERxV2MedicationTypeEnum = {
    Pzn: 'pzn',
    Composite: 'composite',
    ActiveSubstance: 'activeSubstance',
    Freetext: 'freetext'
};
export const CartEntryItemV2NowProductGroupEnum = {
    Nextday: 'nextday',
    None: 'none',
    SamedayNextday: 'sameday_nextday'
};
export const CartEntryItemV2EntryTypeEnum = {
    Article: 'article',
    Service: 'service',
    Set: 'set'
};
export const CartGroupEntryERxV2TypeEnum = {
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription'
};
export const CartGroupEntryV2TypeEnum = {
    OdsSection: 'odsSection',
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription',
    NoPrescription: 'noPrescription',
    BonusSection: 'bonusSection'
};
export const CartMessageV2TypeEnum = {
    Error: 'error',
    Warn: 'warn',
    Info: 'info'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CartPrescriptionTypeV2 = {
    NoPrescription: 'noPrescription',
    PrivatePrescription: 'privatePrescription',
    InsurancePrescription: 'insurancePrescription',
    FreePrescription: 'freePrescription'
};
export const CartV2RedPointsRegistrationStatusEnum = {
    NoMember: 'NO_MEMBER',
    Pending: 'PENDING',
    Subscribed: 'SUBSCRIBED'
};
export const CheckoutBillingAddressTypeEnum = {
    Billing: 'billing'
};
export const CheckoutCarrierEntriesTypeEnum = {
    DiscountRemoved: 'discountRemoved',
    PositionRemoved: 'positionRemoved',
    PositionPriceChanged: 'positionPriceChanged',
    DiscountApplied: 'discountApplied'
};
export const CheckoutCustomerMasterDataRedPointsRegistrationStatusEnum = {
    NoMember: 'NO_MEMBER',
    Pending: 'PENDING',
    Subscribed: 'SUBSCRIBED'
};
export const CheckoutDiscountTypeEnum = {
    Voucher: 'voucher',
    Redpoints: 'redpoints'
};
export const CheckoutDocumentPositionNowProductGroupEnum = {
    Nextday: 'nextday',
    None: 'none',
    SamedayNextday: 'sameday_nextday'
};
export const CheckoutDocumentPositionPrescriptionTypeEnum = {
    NoPrescription: 'noPrescription',
    PrivatePrescription: 'privatePrescription',
    InsurancePrescription: 'insurancePrescription',
    FreePrescription: 'freePrescription'
};
export const CheckoutDocumentPositionEntryTypeEnum = {
    Set: 'set',
    Service: 'service',
    Article: 'article'
};
export const CheckoutDocumentPositionERxMedicationTypeEnum = {
    Pzn: 'pzn',
    Composite: 'composite',
    ActiveSubstance: 'activeSubstance',
    Freetext: 'freetext'
};
export const CheckoutDocumentPositionERxNowProductGroupEnum = {
    Nextday: 'nextday',
    None: 'none',
    SamedayNextday: 'sameday_nextday'
};
export const CheckoutDoorDeliveryAddressTypeEnum = {
    Shipping: 'shipping',
    Billing: 'billing'
};
export const CheckoutOrderDocumentTypeEnum = {
    OdsSection: 'odsSection',
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription',
    NoPrescription: 'noPrescription'
};
export const CheckoutOrderDocumentERxTypeEnum = {
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription'
};
export const CheckoutOrderMasterDataSubOrderTypesIncludedEnum = {
    MarketPlace: 'MarketPlace',
    Now: 'Now',
    ShopApothekeEurope: 'ShopApothekeEurope'
};
export const CheckoutPaymentRequestPaymentKindEnum = {
    Applepay: 'applepay',
    DirectEbanking: 'directEbanking',
    Klarna: 'klarna',
    KlarnaPaynow: 'klarna_paynow',
    NativeCashOnDelivery: 'nativeCashOnDelivery',
    NativeDirectDebit: 'nativeDirectDebit',
    NativeInvoice: 'nativeInvoice',
    NativePostFinance: 'nativePostFinance',
    NativePrepayment: 'nativePrepayment',
    Paypal: 'paypal',
    Ratepay: 'ratepay',
    Scheme: 'scheme',
    Twint: 'twint'
};
export const CheckoutPaymentRequestMerchantAccountEnum = {
    ShopApothekeDirectSales: 'ShopApothekeDirectSales',
    EuropaApotheek: 'EuropaApotheek',
    ShopApothekeEcom: 'ShopApothekeECOM',
    ShopApotheke: 'Shop-Apotheke',
    ShopApothekeAt: 'Shop-ApothekeAT',
    ShopApothekeIt: 'Shop-ApothekeIT'
};
export const CheckoutPaymentResponsePaymentKindEnum = {
    Applepay: 'applepay',
    DirectEbanking: 'directEbanking',
    Klarna: 'klarna',
    KlarnaPaynow: 'klarna_paynow',
    NativeCashOnDelivery: 'nativeCashOnDelivery',
    NativeDirectDebit: 'nativeDirectDebit',
    NativeInvoice: 'nativeInvoice',
    NativePostFinance: 'nativePostFinance',
    NativePrepayment: 'nativePrepayment',
    Paypal: 'paypal',
    Ratepay: 'ratepay',
    Scheme: 'scheme',
    Twint: 'twint'
};
export const CheckoutPaymentResponseMerchantAccountEnum = {
    ShopApothekeDirectSales: 'ShopApothekeDirectSales',
    EuropaApotheek: 'EuropaApotheek',
    ShopApothekeEcom: 'ShopApothekeECOM',
    ShopApotheke: 'Shop-Apotheke',
    ShopApothekeAt: 'Shop-ApothekeAT',
    ShopApothekeIt: 'Shop-ApothekeIT'
};
export const CheckoutPaymentsActionTypeEnum = {
    Await: 'await',
    Donate: 'donate',
    QrCode: 'qrCode',
    Redirect: 'redirect',
    Sdk: 'sdk',
    ThreeDs2Challenge: 'threeDS2Challenge',
    ThreeDs2Fingerprint: 'threeDS2Fingerprint',
    Voucher: 'voucher',
    WechatpaySdk: 'wechatpaySDK'
};
export const CheckoutPickupStationAddressTypeEnum = {
    PickupStation: 'pickupStation'
};
export const CheckoutShippingAddressRequestV1ClientPlatformEnum = {
    WebDesktop: 'web_desktop',
    WebMobile: 'web_mobile',
    Ios: 'ios',
    Android: 'android'
};
export const CheckoutSubOrderOrderTypeEnum = {
    Standard: 'standard',
    Subscription: 'subscription',
    Guest: 'guest'
};
export const ClaimPrescriptionByInsuranceNumberInvalidObjectErrorTypeEnum = {
    NoMatch: 'no_match',
    Redeemed: 'redeemed',
    Deleted: 'deleted',
    GeneralError: 'general_error'
};
export const CmsComponentHeadingSchemaEnum = {
    CmsComponentHeading: 'cms.component.Heading'
};
export const CmsDataProviderPimProductOffersSchemaEnum = {
    PimProductOffers: 'pim.ProductOffers'
};
export const CmsSearchFilterDiscountRangeSchemaEnum = {
    PimSearchFilterDiscountRange: 'pim.SearchFilterDiscountRange'
};
export const CmsTemplateCategoryLeafSchemaEnum = {
    CmsTemplateCategoryLeaf: 'cms.template.CategoryLeaf'
};
/**
 * state of the co-Payment exemption
 * @export
 * @enum {string}
 */
export const CoPaymentStatus = {
    CoPayment: 'coPayment',
    NoCoPayment: 'noCoPayment',
    _27aSgbv: '27aSGBV'
};
export const ConfirmationDataResponseV1CustomerStatusEnum = {
    Existing: 'EXISTING',
    New: 'NEW'
};
/**
 * entity that pays for the prescription
 * @export
 * @enum {string}
 */
export const CoverageType = {
    Gkv: 'GKV',
    Pkv: 'PKV',
    Bg: 'BG',
    Sel: 'SEL',
    Gpv: 'GPV',
    Ppv: 'PPV',
    Bei: 'BEI',
    Skt: 'SKT',
    Sa: 'SA',
    Uk: 'UK'
};
export const CreateOrder400MessageEnum = {
    RequestBodyValidation: 'checkout.error.requestBody.validation',
    RedPointsReservation: 'checkout.error.redPoints.reservation',
    RequestBodyValidationNowSlotOrderCreationExpired: 'checkout.error.requestBody.validation.NOW_SLOT_ORDER_CREATION_EXPIRED'
};
export const CreatePayment400MessageEnum = {
    RequestBodyValidation: 'payment.error.requestBody.validation',
    RedPointsReservation: 'payment.error.redPoints.reservation'
};
export const CustomerPurchaseHistoryResponseV1OrdersInnerSubOrderStatusEnum = {
    New: 'new',
    WaitingForPrepayment: 'waitingForPrepayment',
    Processing: 'processing',
    Dispatched: 'dispatched',
    Canceled: 'canceled',
    Closed: 'closed'
};
export const CustomerPurchaseHistoryResponseV1OrdersInnerItemsInnerPrescriptionTypeEnum = {
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription',
    NoPrescription: 'noPrescription'
};
/**
 * The type of the customer data
 * @export
 * @enum {string}
 */
export const CustomerTypeV1 = {
    Customer: 'customer',
    Professional: 'professional'
};
export const DeliveryAddressV1TypeEnum = {
    Shipping: 'SHIPPING',
    Pickupstation: 'PICKUPSTATION'
};
export const DeliveryV1DeliveryModeServiceEnum = {
    Express: 'EXPRESS',
    Standard: 'STANDARD'
};
export const DisableResponseV1ResponseEnum = {
    DetailSuccessfullyDisabled: 'detail-successfully-disabled',
    AllDetailsSuccessfullyDisabled: 'all-details-successfully-disabled'
};
export const DiscountTypeEnum = {
    Voucher: 'voucher',
    Redpoints: 'redpoints'
};
export const DiscountPromotionTypeEnum = {
    TotalPercent: 'totalPercent',
    TotalAmount: 'totalAmount',
    LinePercent: 'linePercent',
    LineAmount: 'lineAmount'
};
/**
 *
 * @export
 * @enum {string}
 */
export const DivisibilityValue = {
    NoInformation: 'NO_INFORMATION',
    IndifferentDivisible: 'INDIFFERENT_DIVISIBLE',
    DivisibleIntoTwoParts: 'DIVISIBLE_INTO_TWO_PARTS',
    DivisibleIntoThreeParts: 'DIVISIBLE_INTO_THREE_PARTS',
    DivisibleIntoFourParts: 'DIVISIBLE_INTO_FOUR_PARTS',
    DivisibleIntoSixParts: 'DIVISIBLE_INTO_SIX_PARTS'
};
export const DocumentLinkV3DoctypeEnum = {
    ExternalLmivpdf: 'externalLMIVPDF',
    ExternalProductPdf: 'externalProductPDF',
    Importantpharmaceuticalnotices: 'IMPORTANTPHARMACEUTICALNOTICES',
    InternalLmivpdf: 'internalLMIVPDF',
    InternalProductPdf: 'internalProductPDF'
};
export const DocumentPositionPrescriptionTypeEnum = {
    NoPrescription: 'noPrescription',
    PrivatePrescription: 'privatePrescription',
    InsurancePrescription: 'insurancePrescription',
    FreePrescription: 'freePrescription'
};
export const DocumentPositionEntryTypeEnum = {
    Set: 'set',
    Service: 'service',
    Article: 'article'
};
export const DocumentPositionERxMedicationTypeEnum = {
    Pzn: 'pzn',
    Composite: 'composite',
    ActiveSubstance: 'activeSubstance',
    Freetext: 'freetext'
};
export const DoorDeliveryAddressTypeEnum = {
    Shipping: 'shipping',
    Billing: 'billing'
};
export const GetCarriersV1GroupEnum = {
    Dhl: 'DHL',
    Hermes: 'HERMES',
    Thermomed: 'THERMOMED',
    Diepost: 'DIEPOST'
};
export const GetCarriersV1ShippingMethodEnum = {
    Standard: 'STANDARD',
    Express: 'EXPRESS'
};
export const GtmDataLayerResponseCountryCodeEnum = {
    De: 'DE',
    Fr: 'FR',
    Ch: 'CH',
    It: 'IT',
    At: 'AT'
};
export const GtmDataLayerResponseEnvironmentEnum = {
    Reference: 'reference',
    Production: 'production'
};
export const GtmDataLayerResponseLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InsuranceType = {
    Public: 'public',
    Private: 'private'
};
export const InvalidParamCreateAddressKeyEnum = {
    Missing: 'parameter.error.missing',
    Invalid: 'parameter.error.invalid',
    LimitsExceeding: 'parameter.error.limitsExceeding'
};
export const InvalidParamUpdateAddressKeyEnum = {
    Missing: 'parameter.error.missing',
    Invalid: 'parameter.error.invalid',
    LimitsExceeding: 'parameter.error.limitsExceeding'
};
export const KlarnaDataErrorKeyEnum = {
    ValidationInput: 'klarna-data-adapter.error.validation.input',
    Server: 'klarna-data-adapter.error.server'
};
/**
 * legalEntity identifier, e.g. MILANO, currently used to distinguish IT tenant and IT milano
 * @export
 * @enum {string}
 */
export const LegalEntityPropertyEnum = {
    Milano: 'MILANO'
};
/**
 * A document may be provided in the context of a prescription type. This information can be used to group documents wihtin the UI. Note that this property will default to **none** if a document cannot be associated with a prescription type. An invoice having prescription type **none** will usually indicate an OTC order.
 * @export
 * @enum {string}
 */
export const LetterboxPrescriptionTypeV1 = {
    None: 'none',
    InsurancePrescription: 'insurance_prescription',
    PrivatePrescription: 'private_prescription'
};
export const MaxDosageCartRequestedItemPrescriptionTypeEnum = {
    OdsSection: 'odsSection',
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription',
    NoPrescription: 'noPrescription'
};
/**
 * Name of the maximum dosage group
 * @export
 * @enum {string}
 */
export const MaxDosageGroups = {
    SingletonProduct: 'maxdosage.groups.singletonProduct',
    Abfhrtabl: 'maxdosage.groups.abführtabl',
    Abfhrtrop: 'maxdosage.groups.abführtrop',
    Abfhrzpf: 'maxdosage.groups.abführzäpf',
    Aciclovir: 'maxdosage.groups.aciclovir',
    AlOxid: 'maxdosage.groups.al_oxid',
    AlOxidfl: 'maxdosage.groups.al_oxidfl',
    AlOxidgr: 'maxdosage.groups.al_oxidgr',
    Allergant: 'maxdosage.groups.allergant',
    Allergie: 'maxdosage.groups.allergie',
    Amorolfin: 'maxdosage.groups.amorolfin',
    Antazida: 'maxdosage.groups.antazida',
    Antikoag: 'maxdosage.groups.antikoag',
    Beclometha: 'maxdosage.groups.beclometha',
    Bifonazol: 'maxdosage.groups.bifonazol',
    CetirizFl: 'maxdosage.groups.cetiriz_fl',
    CetirizTr: 'maxdosage.groups.cetiriz_tr',
    Clotrimkpg: 'maxdosage.groups.clotrimkpg',
    Clotrimvcr: 'maxdosage.groups.clotrimvcr',
    Clotrvag: 'maxdosage.groups.clotrvag',
    Dextrome2: 'maxdosage.groups.dextrome2',
    Dextrometh: 'maxdosage.groups.dextrometh',
    Diclogel: 'maxdosage.groups.diclogel',
    DiphDoxyl: 'maxdosage.groups.diph_doxyl',
    Durchfall: 'maxdosage.groups.durchfall',
    Eisen: 'maxdosage.groups.eisen',
    Eisenfl: 'maxdosage.groups.eisenfl',
    Erklsus: 'maxdosage.groups.erkälsus',
    Erkltung: 'maxdosage.groups.erkältung',
    Etilefrin: 'maxdosage.groups.etilefrin',
    Flohsamen: 'maxdosage.groups.flohsamen',
    Flohsamen2: 'maxdosage.groups.flohsamen2',
    Fluorgel: 'maxdosage.groups.fluorgel',
    Hals3: 'maxdosage.groups.hals_3',
    Halschmerz: 'maxdosage.groups.halschmerz',
    Halsschmer: 'maxdosage.groups.halsschmer',
    Halsschmfl: 'maxdosage.groups.halsschmfl',
    Hautpilz: 'maxdosage.groups.hautpilz',
    Hautpilzf: 'maxdosage.groups.hautpilzf',
    Ibulokal: 'maxdosage.groups.ibulokal',
    Ibuprofen: 'maxdosage.groups.ibuprofen',
    Ibuprofflu: 'maxdosage.groups.ibuprofflu',
    Ibuprofsup: 'maxdosage.groups.ibuprofsup',
    Loperamid: 'maxdosage.groups.loperamid',
    Minoxidil: 'maxdosage.groups.minoxidil',
    Orlistat: 'maxdosage.groups.orlistat',
    Pcm: 'maxdosage.groups.pcm',
    Pcmflss: 'maxdosage.groups.pcmflüss',
    Pcmkomb: 'maxdosage.groups.pcmkomb',
    Pcmkombi: 'maxdosage.groups.pcmkombi',
    Pentofuryl: 'maxdosage.groups.pentofuryl',
    Schleimfl: 'maxdosage.groups.schleimfl',
    Schleimls: 'maxdosage.groups.schleimlös',
    Schmerzen1: 'maxdosage.groups.schmerzen1',
    Schmerzen2: 'maxdosage.groups.schmerzen2',
    Schmerzen3: 'maxdosage.groups.schmerzen3',
    Schmerzen5: 'maxdosage.groups.schmerzen5',
    Schmerzpfl: 'maxdosage.groups.schmerzpfl',
    Schnupfen: 'maxdosage.groups.schnupfen',
    Triptane: 'maxdosage.groups.triptane',
    Vaprino: 'maxdosage.groups.vaprino',
    Vitamd3fl: 'maxdosage.groups.vitamd3fl',
    Vitamind3: 'maxdosage.groups.vitamind3'
};
/**
 * Unit of dosage values
 * @export
 * @enum {string}
 */
export const MaxDosageProductUnits = {
    Package: 'product.attribute.unit.package',
    Pcs: 'product.attribute.unit.pcs',
    Ml: 'product.attribute.unit.ml',
    G: 'product.attribute.unit.g'
};
export const MedicationOfferMedicationTypeEnum = {
    Pzn: 'pzn',
    Composite: 'composite',
    ActiveSubstance: 'activeSubstance',
    Freetext: 'freetext'
};
export const MigrateAddresses400MessageEnum = {
    AddressErrorRequestInvalid: 'address.error.request.invalid'
};
export const MigrateAddressesRequestV1AddressesInnerSalutationEnum = {
    Mr: 'mr',
    Mrs: 'mrs',
    Unspecified: 'unspecified'
};
export const MigrateAddressesRequestV1AddressesInnerTypeEnum = {
    Billing: 'billing',
    Shipping: 'shipping',
    PickupStation: 'pickupStation'
};
export const MiraklAttachmentRequestV2TypeEnum = {
    ImagePng: 'image/png',
    ImageJpg: 'image/jpg',
    ApplicationPdf: 'application/pdf'
};
export const MiraklMessagesV2MessagesInnerFromEnum = {
    Customer: 'CUSTOMER',
    Shop: 'SHOP',
    Operator: 'OPERATOR'
};
export const MiraklMessagingOrderLineV2StatusEnum = {
    Staging: 'STAGING',
    WaitingAcceptance: 'WAITING_ACCEPTANCE',
    WaitingDebit: 'WAITING_DEBIT',
    WaitingDebitPayment: 'WAITING_DEBIT_PAYMENT',
    Shipping: 'SHIPPING',
    Shipped: 'SHIPPED',
    ToCollect: 'TO_COLLECT',
    Received: 'RECEIVED',
    Closed: 'CLOSED',
    Refused: 'REFUSED',
    Canceled: 'CANCELED',
    IncidentOpen: 'INCIDENT_OPEN',
    Refunded: 'REFUNDED'
};
export const MiraklReasonV2TypeEnum = {
    IncidentOpen: 'INCIDENT_OPEN',
    OrderMessaging: 'ORDER_MESSAGING'
};
export const NewsletterRequestV1SexEnum = {
    M: 'm',
    F: 'f',
    D: 'd'
};
export const NowCheckoutMerchantsServiceObjectTypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay',
    ThirdDay: 'thirdDay'
};
export const NowCheckoutMerchantsServiceObjectDeliveryDayEnum = {
    Heute: 'heute',
    Morgen: 'morgen'
};
export const NowCheckoutMerchantsServiceObjectPickupTypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay'
};
export const NowCheckoutMerchantsServiceObjectPickupPickupDayEnum = {
    Heute: 'heute',
    Morgen: 'morgen'
};
export const NowPickupSlotExtendedTypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay',
    ThirdDay: 'thirdDay'
};
export const NowPickupSlotExtendedPickupDayEnum = {
    Heute: 'heute',
    Morgen: 'morgen'
};
export const NowPickupSlotExtendedV2TypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay',
    ThirdDay: 'thirdDay'
};
export const NowPickupSlotExtendedV2PickupDayEnum = {
    Heute: 'heute',
    Morgen: 'morgen'
};
export const NowSlotTypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay'
};
export const NowSlotExtendedTypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay'
};
export const NowSlotExtendedV2TypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay'
};
export const NowSlotPickupTypeEnum = {
    SameDay: 'sameDay',
    NextDay: 'nextDay'
};
export const NowSlotPickupPickupDayEnum = {
    Heute: 'heute',
    Morgen: 'morgen'
};
export const NowV1InitCartResponseEnvEnum = {
    Local: 'local',
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
export const NowV1InitCartResponsePlatformEnum = {
    Web: 'web',
    Ios: 'ios',
    Android: 'android'
};
export const OdsPatchCartRequestV1ProductsInnerPrescriptionTypeEnum = {
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    NoPrescription: 'noPrescription',
    InsurancePrescription: 'insurancePrescription'
};
export const OfferDetailsV1OfferFlagsEnum = {
    BestOffer: 'bestOffer',
    ServiceOffer: 'serviceOffer',
    IsPromotionSet: 'isPromotionSet'
};
export const OfferDetailsV1NowProductGroupEnum = {
    Nextday: 'nextday',
    None: 'none',
    SamedayNextday: 'sameday_nextday'
};
export const OfferDetailsV1OfferTypeEnum = {
    Mirakl: 'MIRAKL',
    Sae: 'SAE'
};
export const OfferRequestPrescriptionTypeEnum = {
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription',
    NoPrescription: 'noPrescription'
};
export const OfferV1NowProductGroupEnum = {
    Nextday: 'nextday',
    None: 'none',
    SamedayNextday: 'sameday_nextday'
};
export const OfferV1OfferFlagsEnum = {
    BestOffer: 'bestOffer',
    ServiceOffer: 'serviceOffer',
    IsPromotionSet: 'isPromotionSet'
};
export const OfferV1OfferTypeEnum = {
    Sae: 'SAE',
    Mirakl: 'MIRAKL'
};
export const OptimizelyDecisionTypeEnum = {
    Feature: 'feature',
    Experiment: 'experiment'
};
export const OrderDocumentTypeEnum = {
    OdsSection: 'odsSection',
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription',
    NoPrescription: 'noPrescription'
};
export const OrderDocumentERxTypeEnum = {
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription'
};
export const OrderDocumentItemsV1PrescriptionTypeEnum = {
    NoPrescription: 'noPrescription',
    PrivatePrescription: 'privatePrescription',
    InsurancePrescription: 'insurancePrescription',
    FreePrescription: 'freePrescription'
};
export const OrderDocumentItemsV1EntryTypeEnum = {
    Set: 'set',
    Service: 'service',
    Article: 'article'
};
export const OrderMasterDataSubOrderTypesIncludedEnum = {
    MarketPlace: 'MarketPlace',
    Now: 'Now',
    ShopApothekeEurope: 'ShopApothekeEurope'
};
export const OrderPaymentV1MerchantAccountEnum = {
    ShopApothekeDirectSales: 'ShopApothekeDirectSales',
    EuropaApotheek: 'EuropaApotheek',
    ShopApothekeEcom: 'ShopApothekeECOM',
    ShopApotheke: 'Shop-Apotheke',
    ShopApothekeAt: 'Shop-ApothekeAT',
    ShopApothekeIt: 'Shop-ApothekeIT'
};
/**
 * Therapy correlating packaging size in accord with N-Notation (N stands for standard size in German (Normgröße)).  * `NOT_AFFECTED` - Not specified (Keine Angabe)  * `NOT_THERAPY_ORIENTED` - Not a therapy correlating packaging size (Keine therapiegerechte Packungsgröße)  * `N1` - Standard size 1 (Normgröße 1)  * `N2` - Standard size 2 (Normgröße 2)  * `N3` - Standard size 3 (Normgröße 3)  * `NOT_AFFECTED` - Not affected (Nicht betroffen von der Packungsgrößenverordnung)
 * @export
 * @enum {string}
 */
export const PackageNormSizeCode = {
    NotSpecified: 'NOT_SPECIFIED',
    NotTherapyOriented: 'NOT_THERAPY_ORIENTED',
    N1: 'N1',
    N2: 'N2',
    N3: 'N3',
    NotAffected: 'NOT_AFFECTED'
};
export const PaymentMerchantAccountEnum = {
    ShopApothekeDirectSales: 'ShopApothekeDirectSales',
    EuropaApotheek: 'EuropaApotheek',
    ShopApothekeEcom: 'ShopApothekeECOM',
    ShopApotheke: 'Shop-Apotheke',
    ShopApothekeAt: 'Shop-ApothekeAT',
    ShopApothekeIt: 'Shop-ApothekeIT'
};
export const PaymentMethodV1GroupEnum = {
    Ratepay: 'ratepay',
    Klarna: 'klarna',
    Paypal: 'paypal',
    NativeInvoice: 'nativeInvoice',
    NativeDirectDebit: 'nativeDirectDebit',
    NativePrepayment: 'nativePrepayment',
    NativeCashOnDelivery: 'nativeCashOnDelivery',
    Twint: 'twint',
    Applepay: 'applepay',
    CreditCard: 'creditCard'
};
export const PaymentMethodV1TypeEnum = {
    Applepay: 'applepay',
    DirectEbanking: 'directEbanking',
    Klarna: 'klarna',
    KlarnaPaynow: 'klarna_paynow',
    NativeCashOnDelivery: 'nativeCashOnDelivery',
    NativeDirectDebit: 'nativeDirectDebit',
    NativeInvoice: 'nativeInvoice',
    NativePostFinance: 'nativePostFinance',
    NativePrepayment: 'nativePrepayment',
    Paypal: 'paypal',
    Ratepay: 'ratepay',
    Scheme: 'scheme',
    Twint: 'twint'
};
export const PaymentMethodsResponseV1UnavailableServicesEnum = {
    Ac: 'ac',
    Pmc: 'pmc',
    Sds: 'sds',
    Kds: 'kds'
};
export const PaymentsDetailsRequestV1PaymentMethodTypeEnum = {
    Applepay: 'applepay',
    DirectEbanking: 'directEbanking',
    Klarna: 'klarna',
    KlarnaPaynow: 'klarna_paynow',
    Paypal: 'paypal',
    Ratepay: 'ratepay',
    Scheme: 'scheme'
};
export const PaymentsRequestCreditCardV1TypeEnum = {
    Scheme: 'scheme'
};
export const PaymentsRequestRecurringV1TypeEnum = {
    Scheme: 'scheme',
    Paypal: 'paypal'
};
export const PaymentsRequestSimpleV1TypeEnum = {
    Applepay: 'applepay',
    DirectEbanking: 'directEbanking',
    Klarna: 'klarna',
    KlarnaPaynow: 'klarna_paynow',
    NativeCashOnDelivery: 'nativeCashOnDelivery',
    NativeDirectDebit: 'nativeDirectDebit',
    NativeInvoice: 'nativeInvoice',
    NativePostFinance: 'nativePostFinance',
    NativePrepayment: 'nativePrepayment',
    Paypal: 'paypal',
    Ratepay: 'ratepay',
    Twint: 'twint'
};
export const PaymentsRequestV1ChannelEnum = {
    IOs: 'iOS',
    Adroid: 'Adroid',
    Web: 'Web'
};
export const PaymentsRequestV1RecurringProcessingModelEnum = {
    CardOnFile: 'CardOnFile',
    Subscription: 'Subscription',
    UnscheduledCardOnFile: 'UnscheduledCardOnFile'
};
export const PaymentsRequestV1ShopperInteractionEnum = {
    Ecommerce: 'Ecommerce',
    Moto: 'Moto',
    Pos: 'POS'
};
export const PaymentsResponseV1UnavailableServicesEnum = {
    Ac: 'ac',
    Kds: 'kds',
    Os: 'os'
};
export const PaymentsShopperNameGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN'
};
/**
 * group of person for prescription for more info ERX-883
 * @export
 * @enum {string}
 */
export const PersonGroup = {
    Soz: 'SOZ',
    Bvg: 'BVG',
    Sva1: 'SVA1',
    Sva2: 'SVA2',
    Asy: 'ASY',
    None: 'NONE'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PharmacyOnlyDataType = {
    NotSpecified: 'NOT_SPECIFIED',
    True: 'TRUE',
    False: 'FALSE',
    ExemptionFalse: 'EXEMPTION_FALSE'
};
export const PickupStationAddressTypeEnum = {
    PickupStation: 'pickupStation'
};
export const PickupStationRequestV2TypeEnum = {
    PickupStation: 'pickupStation'
};
export const PickupStationResponseV2TypeEnum = {
    PickupStation: 'pickupStation'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsClinicalRelevance = {
    Unknown: 'UNKNOWN',
    NoInteraction: 'NO_INTERACTION',
    ProductSpecific: 'PRODUCT_SPECIFIC',
    Low: 'LOW',
    Medium: 'MEDIUM',
    Serious: 'SERIOUS',
    Contraindicated: 'CONTRAINDICATED'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsDirection = {
    NoDirection: 'NO_DIRECTION',
    Unidirectional: 'UNIDIRECTIONAL',
    Bidirectional: 'BIDIRECTIONAL'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsFrequency = {
    VeryOften: 'VERY_OFTEN',
    Often: 'OFTEN',
    Occasionally: 'OCCASIONALLY',
    Seldom: 'SELDOM',
    VerySeldom: 'VERY_SELDOM',
    Unknown: 'UNKNOWN'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsIgnoreReason = {
    NotMarketable: 'NOT_MARKETABLE',
    ConsultationRequired: 'CONSULTATION_REQUIRED',
    UnknownProduct: 'UNKNOWN_PRODUCT'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsInteractionStatus = {
    NoInteractionsFound: 'NO_INTERACTIONS_FOUND',
    DrugDrugInteractionsFound: 'DRUG_DRUG_INTERACTIONS_FOUND',
    OnlyDrugFoodInteractionsFound: 'ONLY_DRUG_FOOD_INTERACTIONS_FOUND',
    InteractionsPossible: 'INTERACTIONS_POSSIBLE'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsPlausibility = {
    Unknown: 'UNKNOWN',
    Plausible: 'PLAUSIBLE',
    Proved: 'PROVED'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PicsSourceAssessment = {
    Unknown: 'UNKNOWN',
    Insufficient: 'INSUFFICIENT',
    Weak: 'WEAK',
    Sufficient: 'SUFFICIENT',
    Good: 'GOOD'
};
export const PimABDASubstanceV1TypeEnum = {
    /**
    * Specifying an active substance (Wirkstoff)
    */
    ACTIVE: 0,
    /**
    * Specifying an additive substance (Hilfsstoff)
    */
    ADDITIVE: 1
};
export const PimDocumentV1TypeEnum = {
    InternalHw: 'internal-hw',
    InternalLv: 'internal-lv',
    InternalBp: 'internal-bp',
    ExternalLv: 'external-lv',
    ExternalBp: 'external-bp'
};
export const PimProductV1LifestyleProductEnum = {
    True: 'true',
    TrueWithExceptions: 'true_with_exceptions',
    False: 'false'
};
export const PimProductV1NowProductGroupEnum = {
    None: 'none',
    SamedayNextday: 'sameday_nextday',
    Nextday: 'nextday'
};
export const PimProductV1StockStatusEnum = {
    Available: 'available',
    OutOfSale: 'out_of_sale',
    OutOfStock: 'out_of_stock',
    NotInCatalog: 'not_in_catalog',
    Free: 'free',
    Service: 'service',
    Variant: 'variant'
};
export const PimProductV1TypeEnum = {
    Article: 'article',
    Service: 'service',
    Set: 'set'
};
export const PimProductWithNotepadAndOffersV1LifestyleProductEnum = {
    True: 'true',
    TrueWithExceptions: 'true_with_exceptions',
    False: 'false'
};
export const PimProductWithNotepadAndOffersV1NowProductGroupEnum = {
    None: 'none',
    SamedayNextday: 'sameday_nextday',
    Nextday: 'nextday'
};
export const PimProductWithNotepadAndOffersV1StockStatusEnum = {
    Available: 'available',
    OutOfSale: 'out_of_sale',
    OutOfStock: 'out_of_stock',
    NotInCatalog: 'not_in_catalog',
    Free: 'free',
    Service: 'service',
    Variant: 'variant'
};
export const PimProductWithNotepadAndOffersV1TypeEnum = {
    Article: 'article',
    Service: 'service',
    Set: 'set'
};
export const PimProductWithNotepadAndOffersV1AllOfOffersInnerNowProductGroupEnum = {
    Nextday: 'nextday',
    None: 'none',
    SamedayNextday: 'sameday_nextday'
};
export const PimProductWithNotepadAndOffersV1AllOfOffersInnerOfferFlagsEnum = {
    BestOffer: 'bestOffer',
    ServiceOffer: 'serviceOffer',
    IsPromotionSet: 'isPromotionSet'
};
export const PimProductWithNotepadAndOffersV1AllOfOffersInnerOfferTypeEnum = {
    Sae: 'SAE',
    Mirakl: 'MIRAKL'
};
export const PimProductWithVariantsV1LifestyleProductEnum = {
    True: 'true',
    TrueWithExceptions: 'true_with_exceptions',
    False: 'false'
};
export const PimProductWithVariantsV1NowProductGroupEnum = {
    None: 'none',
    SamedayNextday: 'sameday_nextday',
    Nextday: 'nextday'
};
export const PimProductWithVariantsV1StockStatusEnum = {
    Available: 'available',
    OutOfSale: 'out_of_sale',
    OutOfStock: 'out_of_stock',
    NotInCatalog: 'not_in_catalog',
    Free: 'free',
    Service: 'service',
    Variant: 'variant'
};
export const PimProductWithVariantsV1TypeEnum = {
    Article: 'article',
    Service: 'service',
    Set: 'set'
};
export const PimRedirectV1TypeEnum = {
    Product: 'product',
    Category: 'category'
};
export const PimVATV1CodeEnum = {
    XxXx: 'XX_XX',
    DeSr: 'DE_SR',
    DeRr: 'DE_RR',
    AtSr: 'AT_SR',
    AtTs: 'AT_TS',
    AtBi: 'AT_BI',
    FrSr: 'FR_SR',
    FrRr: 'FR_RR',
    FrUt: 'FR_UT',
    FrPr: 'FR_PR',
    ItSr: 'IT_SR',
    ItRr: 'IT_RR',
    ItFb: 'IT_FB',
    ChSr: 'CH_SR',
    ChRr: 'CH_RR'
};
export const PimVariantAttributeV1TypeEnum = {
    Color: 'COLOR',
    List: 'LIST',
    Text: 'TEXT'
};
export const PimWeightMetricValueV1UnitEnum = {
    Microgram: 'MICROGRAM',
    Milligram: 'MILLIGRAM',
    Gram: 'GRAM',
    Kilogram: 'KILOGRAM',
    Ton: 'TON',
    Grain: 'GRAIN',
    Denier: 'DENIER',
    Once: 'ONCE',
    Marc: 'MARC',
    Livre: 'LIVRE',
    Ounce: 'OUNCE',
    Pound: 'POUND'
};
export const PrescriptionPrescriptionTypeEnum = {
    InsurancePrescription: 'insurancePrescription',
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    NoPrescription: 'noPrescription'
};
export const PrescriptionMedicationTypeEnum = {
    Pzn: 'pzn',
    Composite: 'composite',
    ActiveSubstance: 'activeSubstance',
    Freetext: 'freetext'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PrescriptionOnlyDataType = {
    NotSpecified: 'NOT_SPECIFIED',
    True: 'TRUE',
    False: 'FALSE',
    ExemptionTrue: 'EXEMPTION_TRUE',
    ExemptionFalse: 'EXEMPTION_FALSE'
};
export const PrescriptionPriceDataV1LabelEnum = {
    AfterInvoice: 'afterInvoice',
    SelfPaymentDueToExpiry: 'selfPaymentDueToExpiry',
    SelfPayment: 'selfPayment',
    Copayment: 'copayment',
    CopaymentUpTo: 'copaymentUpTo',
    NoCopayment: 'noCopayment'
};
export const PrescriptionV3PrescriptionTypeEnum = {
    InsurancePrescription: 'insurancePrescription',
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    NoPrescription: 'noPrescription'
};
export const PriceV3TypeEnum = {
    Retail: 'retail',
    List: 'list',
    NoPrescription: 'noPrescription',
    InsurancePrescription: 'insurancePrescription',
    FreePrescription: 'freePrescription',
    PrivatePrescription: 'privatePrescription'
};
/**
 * Statement about the availability of the article at the supplier. No statement about availability at wholesale nor about marketability.  * `NOT_SPECIFIED` - Not specified (keine Angabe)  * `OUT_OF_DISTR` - Out of distribution (außer Vertrieb) but allowed to be sold out except marketability states something against (e.g. NOT_TRADEABLE)  * `DISTRIBUTED` - Being distributed (im Vertrieb)  * `RETREATED` - Retreated (zurückgezogen (Lagerware ist nicht zur Abgabe und zum Abverkauf bestimmt)) and not allowed to be sold out
 * @export
 * @enum {string}
 */
export const ProductDistributionStatus = {
    NotSpecified: 'NOT_SPECIFIED',
    OutOfDistr: 'OUT_OF_DISTR',
    Distributed: 'DISTRIBUTED',
    Retreated: 'RETREATED'
};
/**
 * What phase of the life cycle is the product in?  * `TRADED` - Being traded (im Handel)  * `OUT_OF_DISTR` - Out of distribution (außer Vertrieb)  * `NOT_TRADEABLE` - Not tradeable (nicht verkehrsfähig)
 * @export
 * @enum {string}
 */
export const ProductLifecycleStatus = {
    Traded: 'TRADED',
    OutOfDistr: 'OUT_OF_DISTR',
    BeforeLaunch: 'BEFORE_LAUNCH',
    NotTradeable: 'NOT_TRADEABLE'
};
/**
 * Allowance to trade with the product.  * `NOT_SPECIFIED` - Not specified (keine Angabe)  * `NOT_TRADEABLE` - Not tradeable (nicht verkehrsfähig)  * `TRADEABLE` - Tradeable product (verkehrsfähig)  * `AUDIT` - Being audited (Verkehrsfähigkeit in Prüfung)
 * @export
 * @enum {string}
 */
export const ProductMarketAllowanceStatus = {
    NotSpecified: 'NOT_SPECIFIED',
    NotTradeable: 'NOT_TRADEABLE',
    Tradeable: 'TRADEABLE',
    Audit: 'AUDIT'
};
export const ProductV3NowProductGroupEnum = {
    None: 'none',
    SamedayNextday: 'sameday_nextday',
    Nextday: 'nextday'
};
export const ProductWithVariantsV3NowProductGroupEnum = {
    None: 'none',
    SamedayNextday: 'sameday_nextday',
    Nextday: 'nextday'
};
export const RecentOrdersOfferResponseV1NowProductGroupEnum = {
    Nextday: 'nextday',
    None: 'none',
    SamedayNextday: 'sameday_nextday'
};
export const RecentOrdersOfferResponseV1OfferFlagsEnum = {
    BestOffer: 'bestOffer',
    ServiceOffer: 'serviceOffer',
    IsPromotionSet: 'isPromotionSet'
};
export const RecentOrdersOfferResponseV1OfferTypeEnum = {
    Sae: 'SAE',
    Mirakl: 'MIRAKL'
};
export const RecentOrdersV1ProductLifestyleProductEnum = {
    True: 'true',
    TrueWithExceptions: 'true_with_exceptions',
    False: 'false'
};
export const RecentOrdersV1ProductNowProductGroupEnum = {
    None: 'none',
    SamedayNextday: 'sameday_nextday',
    Nextday: 'nextday'
};
export const RecentOrdersV1ProductStockStatusEnum = {
    Available: 'available',
    OutOfSale: 'out_of_sale',
    OutOfStock: 'out_of_stock',
    NotInCatalog: 'not_in_catalog',
    Free: 'free',
    Service: 'service',
    Variant: 'variant'
};
export const RecentOrdersV1ProductTypeEnum = {
    Article: 'article',
    Service: 'service',
    Set: 'set'
};
export const RedPointsCalculationItemTypeEnum = {
    Item: 'item',
    Voucher: 'voucher',
    Total: 'total'
};
export const RedPointsCalculationItemRxTypeEnum = {
    Insuranceprescription: 'INSURANCEPRESCRIPTION',
    Privateprescription: 'PRIVATEPRESCRIPTION',
    Freeprescription: 'FREEPRESCRIPTION',
    Noprescription: 'NOPRESCRIPTION'
};
export const RedPointsOrderOrderStatusEnum = {
    Reserved: 'RESERVED',
    Ordered: 'ORDERED',
    Exported: 'EXPORTED',
    Shipped: 'SHIPPED',
    Canceled: 'CANCELED'
};
export const RedPointsOrderOrderTypeEnum = {
    Abo: 'ABO',
    Normal: 'NORMAL',
    Subscription: 'SUBSCRIPTION'
};
export const RedPointsPointsPerItemRxRxTypeEnum = {
    Freeprescription: 'FREEPRESCRIPTION',
    Insuranceprescription: 'INSURANCEPRESCRIPTION',
    Noprescription: 'NOPRESCRIPTION',
    Privateprescription: 'PRIVATEPRESCRIPTION'
};
export const RedpointsInterestedRequestBodyV1OnboardTypeEnum = {
    Manual: 'MANUAL',
    Auto: 'AUTO',
    Checkout: 'CHECKOUT'
};
export const RedpointsRegistrationstatusResponseV1StatusEnum = {
    NoMember: 'NO_MEMBER',
    Pending: 'PENDING',
    Subscribed: 'SUBSCRIBED'
};
/**
 * https://wiki.shop-apotheke.com/pages/viewpage.action?pageId=243880971 represents the reason set on a \"belgian RX by principle product\". Depending on reason set, different reasons, will be presented to be chosen from by customer when he attempts to buy a \"belgian RX by principle product\"
 * @export
 * @enum {string}
 */
export const RxByPrincipleReasonSet = {
    PseudoEfedrine: 'PSEUDO_EFEDRINE',
    Dextromethorfan: 'DEXTROMETHORFAN',
    Paracetamol: 'PARACETAMOL'
};
/**
 * https://wiki.shop-apotheke.com/pages/viewpage.action?pageId=243880971 represents the selectable reason when customer attempts to buy a belgian RX by principle product
 * @export
 * @enum {string}
 */
export const RxByPrincipleSelectableReason = {
    Fever: 'FEVER',
    Pain: 'PAIN',
    Arthritis: 'ARTHRITIS',
    NasalBlockage: 'NASAL_BLOCKAGE',
    DryCough: 'DRY_COUGH'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SalutationV1 = {
    Mr: 'mr',
    Mrs: 'mrs',
    Unspecified: 'unspecified',
    Diverse: 'diverse'
};
export const SellerV1IsAllowedToEvaluateMessageEnum = {
    AlreadyEvaluated: 'seller.evaluation.error.alreadyEvaluated',
    WrongOrderStatus: 'seller.evaluation.error.wrongOrderStatus'
};
export const SellerV1ShopAdditionalFieldsInnerCodeEnum = {
    Imprint: 'imprint',
    ReturnPolicy2: 'return-policy-2'
};
export const SellerV1ShopAdditionalFieldsInnerTypeEnum = {
    Textarea: 'TEXTAREA'
};
export const SensitiveExpiredErrorEnum = {
    Unauthorized: 'Unauthorized'
};
export const SensitiveExpiredMessageEnum = {
    SensitiveLoginExpired: 'sensitive.login.expired'
};
export const ShippingRequestV2TypeEnum = {
    Shipping: 'shipping'
};
export const ShippingResponseV2TypeEnum = {
    Shipping: 'shipping'
};
export const ShippingResponseV2WithNowDataTypeEnum = {
    Shipping: 'shipping'
};
export const StartCampaignRequestBodyV1CreateDispositionEnum = {
    CreateNever: 'CreateNever',
    CreateIfNeeded: 'CreateIfNeeded'
};
export const SubOrderOrderTypeEnum = {
    Standard: 'standard',
    Subscription: 'subscription',
    Guest: 'guest'
};
export const SubOrderStatusEnum = {
    New: 'new',
    WaitingForPrepayment: 'waitingForPrepayment',
    Processing: 'processing',
    Dispatched: 'dispatched',
    Canceled: 'canceled',
    Closed: 'closed'
};
export const SubOrderCancellationStatusEnum = {
    Requested: 'requested',
    Accepted: 'accepted',
    Rejected: 'rejected'
};
export const SubOrderDiscountsV1VoucherTypeEnum = {
    Fix: 'FIX',
    Percentage: 'PERCENTAGE',
    Redpoints: 'REDPOINTS'
};
export const SubOrderV1OrderTypeEnum = {
    Standard: 'STANDARD',
    Subscription: 'SUBSCRIPTION',
    Guest: 'GUEST'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionStatus = {
    New: 'new',
    Subscribed: 'subscribed',
    Unsubscribed: 'unsubscribed',
    OptinAwaiting: 'optin_awaiting'
};
/**
 * Possible subscription types
 * @export
 * @enum {string}
 */
export const SubscriptionTypeV1 = {
    Newsletter: 'newsletter',
    Redpoints: 'redpoints'
};
/**
 * * `substituted` - substitution successful * `substituted_with_same_pzn` - substitution successful with original product * `not_able_to_substitute` - substitution not possible, because pharmaceutical/technical/logistical reasons * `error` - http error other than 2**
 * @export
 * @enum {string}
 */
export const SubstitutionStates = {
    Substituted: 'substituted',
    SubstitutedWithSamePzn: 'substituted_with_same_pzn',
    NotAbleToSubstitute: 'not_able_to_substitute',
    Error: 'error'
};
/**
 * Possible status values provided by the swap-service after it attempted to swap the eRX item
 * @export
 * @enum {string}
 */
export const SubstitutionStatus = {
    Substituted: 'substituted',
    NotAbleToSubstitute: 'not_able_to_substitute',
    NotAllowedToSubstitute: 'not_allowed_to_substitute',
    SubstitutedWithSamePzn: 'substituted_with_same_pzn',
    Error: 'error'
};
/**
 * * `DEFAULT` - Exchange according to discount contract (Rabattvertrag) * `MANUAL` - Products that can only be exchanged manually by a pharmacist. * `NOT_POSSIBLE` - no substitution possible (fallback) * `RESTRICTED` - Product substitution is restricted because they are excluded or autidem * `KEEP_PRODUCT` - original product will be returned exclusively if available * `ACCIDENT_DEFAULT` - DEFAULT exchange for accident prescriptions (BG, UK) * `ACCIDENT_RESTRICTED`- RESTRICTED exchange for accident prescriptions (BG, UK) * `SIMPLE_STANDARD`- DEFAULT/STANDARD exchange for simple strategies for private insurances, self-paid or other prescriptions (SEL, PPV, BEI, GPV, SA) * `SIMPLE_RESTRICTED`- RESTRICTED exchange for simple strategies for private insurances, self-paid or other prescriptions (SEL, PPV, BEI, GPV, SA) * `VALIDATION`- for any validation issues like unknown products
 * @export
 * @enum {string}
 */
export const SubstitutionTypes = {
    Default: 'DEFAULT',
    Manual: 'MANUAL',
    NotPossible: 'NOT_POSSIBLE',
    Restricted: 'RESTRICTED',
    KeepProduct: 'KEEP_PRODUCT',
    AccidentDefault: 'ACCIDENT_DEFAULT',
    AccidentRestricted: 'ACCIDENT_RESTRICTED',
    SimpleStandard: 'SIMPLE_STANDARD',
    SimpleRestricted: 'SIMPLE_RESTRICTED',
    Validation: 'VALIDATION'
};
export const SuccessGetAccountCustomerRedPointsMembershipEnum = {
    NoMember: 'NO_MEMBER',
    Pending: 'PENDING',
    Subscribed: 'SUBSCRIBED'
};
export const SuccessGetAddressesWithAndWithoutNowDataAddressesInnerTypeEnum = {
    PickupStation: 'pickupStation'
};
export const SuccessGetDoorDeliveryAddressesAddressesInnerTypeEnum = {
    Shipping: 'shipping'
};
export const SuccessGetDoorDeliveryAddressesWithNowDataAddressesInnerTypeEnum = {
    Shipping: 'shipping'
};
/**
 * * `0` - not applicable * `1` - generic product * `2` - solitary * `3` - multiple distribution group * `4` - aut-idem prescription * `5` - prohibited prescribed product
 * @export
 * @enum {string}
 */
export const SwapAdditionalAttributeGroup1Key = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
};
/**
 * * `0` - not relevant * `1` - disocunted product dispensed * `2` - discounted product not available * `4` - pharmaceutical concern
 * @export
 * @enum {string}
 */
export const SwapAdditionalAttributeGroup2Key = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_4: 4
};
/**
 * * `0` - not relevant * `1` - product in four cheapest prices dispensed * `2` - products in four cheapest prices not available * `4` - pharmaceutical concerns
 * @export
 * @enum {string}
 */
export const SwapAdditionalAttributeGroup3Key = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_4: 4
};
/**
 * * `0` - not relevant * `1` - import within price anchor dispensed * `2` - import within price anchor not available * `4` - pharmaceutical concerns * `5` - parallel drug dispensed
 * @export
 * @enum {string}
 */
export const SwapAdditionalAttributeGroup4Key = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_4: 4,
    NUMBER_5: 5
};
/**
 * * `1` - additional cost compensated because of unavailable discounted product * `2` - product specific exemption for additional cost
 * @export
 * @enum {string}
 */
export const SwapAdditionalAttributeGroup5Key = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
/**
 * * `1` - co-payment paragraph 27a
 * @export
 * @enum {string}
 */
export const SwapAdditionalAttributeGroup9Key = {
    NUMBER_1: 1
};
/**
 *
 * @export
 * @enum {string}
 */
export const SwapProcessLogType = {
    AutomaticSubstitution: 'AUTOMATIC_SUBSTITUTION',
    ManualAlternative: 'MANUAL_ALTERNATIVE'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TradeabilityDataType = {
    NotSpecified: 'NOT_SPECIFIED',
    NotTradeable: 'NOT_TRADEABLE',
    Tradeable: 'TRADEABLE',
    Audit: 'AUDIT'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TristateConditionalDataType = {
    True: 'TRUE',
    False: 'FALSE',
    Conditional: 'CONDITIONAL'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TristateDataType = {
    True: 'TRUE',
    False: 'FALSE',
    NotSpecified: 'NOT_SPECIFIED'
};
export const UnsubscribeSubscriptionRequestV1ActionEnum = {
    Unsubscribe: 'unsubscribe'
};
export const UserDocumentPositionPrescriptionTypeEnum = {
    NoPrescription: 'noPrescription',
    PrivatePrescription: 'privatePrescription',
    InsurancePrescription: 'insurancePrescription',
    FreePrescription: 'freePrescription'
};
export const UserDocumentPositionEntryTypeEnum = {
    Set: 'set',
    Service: 'service',
    Article: 'article'
};
export const UserDocumentPositionERxMedicationTypeEnum = {
    Pzn: 'pzn',
    Composite: 'composite',
    ActiveSubstance: 'activeSubstance',
    Freetext: 'freetext'
};
export const UserOrderDocumentERxTypeEnum = {
    PrivatePrescription: 'privatePrescription',
    FreePrescription: 'freePrescription',
    InsurancePrescription: 'insurancePrescription'
};
export const UserSubOrderOrderTypeEnum = {
    Standard: 'standard',
    Subscription: 'subscription',
    Guest: 'guest'
};
export const UserV1OnboardTypeEnum = {
    Manual: 'MANUAL',
    Manualeav: 'MANUALEAV',
    Auto: 'AUTO',
    Checkout: 'CHECKOUT',
    Checkouteav: 'CHECKOUTEAV'
};
export const ZavaProviderEnum = {
    Zava: 'zava'
};
export const ZavaDataProviderEnum = {
    Zava: 'zava'
};
/**
 * ASAPServiceApi - axios parameter creator
 * @export
 */
export const ASAPServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of inventory information objects for requested products.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {Set<string>} products List with products (id or PZN in Germany) the inventory status is being requested for.
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryByProductIds: (tenant, products, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getInventoryByProductIds', 'tenant', tenant);
            // verify required parameter 'products' is not null or undefined
            assertParamExists('getInventoryByProductIds', 'products', products);
            const localVarPath = `/asap/v1/{tenant}/inventory`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (products) {
                localVarQueryParameter['products'] = Array.from(products).join(COLLECTION_FORMATS.csv);
            }
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ASAPServiceApi - functional programming interface
 * @export
 */
export const ASAPServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = ASAPServiceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of inventory information objects for requested products.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {Set<string>} products List with products (id or PZN in Germany) the inventory status is being requested for.
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryByProductIds(tenant, products, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInventoryByProductIds(tenant, products, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ASAPServiceApi - factory interface
 * @export
 */
export const ASAPServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ASAPServiceApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of inventory information objects for requested products.
         * @param {ASAPServiceApiGetInventoryByProductIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryByProductIds(requestParameters, options) {
            return localVarFp.getInventoryByProductIds(requestParameters.tenant, requestParameters.products, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ASAPServiceApi - object-oriented interface
 * @export
 * @class ASAPServiceApi
 * @extends {BaseAPI}
 */
export class ASAPServiceApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of inventory information objects for requested products.
     * @param {ASAPServiceApiGetInventoryByProductIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ASAPServiceApi
     */
    getInventoryByProductIds(requestParameters, options) {
        return ASAPServiceApiFp(this.configuration).getInventoryByProductIds(requestParameters.tenant, requestParameters.products, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccountControllerApi - axios parameter creator
 * @export
 */
export const AccountControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersGet: (tenant, page, itemsPerPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV1TenantOrdersGet', 'tenant', tenant);
            const localVarPath = `/account/v1/{tenant}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersOrderNumberGet: (tenant, orderNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV1TenantOrdersOrderNumberGet', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('accountV1TenantOrdersOrderNumberGet', 'orderNumber', orderNumber);
            const localVarPath = `/account/v1/{tenant}/orders/{orderNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantUserGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV1TenantUserGet', 'tenant', tenant);
            const localVarPath = `/account/v1/{tenant}/user`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersGet(tenant, page, itemsPerPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV1TenantOrdersGet(tenant, page, itemsPerPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantUserGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV1TenantUserGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountControllerApiFp(configuration);
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {AccountControllerApiAccountV1TenantOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersGet(requestParameters, options) {
            return localVarFp.accountV1TenantOrdersGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {AccountControllerApiAccountV1TenantOrdersOrderNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersOrderNumberGet(requestParameters, options) {
            return localVarFp.accountV1TenantOrdersOrderNumberGet(requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {AccountControllerApiAccountV1TenantUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantUserGet(requestParameters, options) {
            return localVarFp.accountV1TenantUserGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {AccountControllerApiAccountV1TenantOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    accountV1TenantOrdersGet(requestParameters, options) {
        return AccountControllerApiFp(this.configuration).accountV1TenantOrdersGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve a single order.
     * @param {AccountControllerApiAccountV1TenantOrdersOrderNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    accountV1TenantOrdersOrderNumberGet(requestParameters, options) {
        return AccountControllerApiFp(this.configuration).accountV1TenantOrdersOrderNumberGet(requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {AccountControllerApiAccountV1TenantUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    accountV1TenantUserGet(requestParameters, options) {
        return AccountControllerApiFp(this.configuration).accountV1TenantUserGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccountControllerV2Api - axios parameter creator
 * @export
 */
export const AccountControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageCustomerNumberGet: (tenant, language, customerNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageCustomerNumberGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageCustomerNumberGet', 'language', language);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('accountV2TenantLanguageCustomerNumberGet', 'customerNumber', customerNumber);
            const localVarPath = `/account/v2/{tenant}/{language}/{customerNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve the last order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageLastOrderGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageLastOrderGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageLastOrderGet', 'language', language);
            const localVarPath = `/account/v2/{tenant}/{language}/lastOrder`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersGet: (tenant, language, page, itemsPerPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersGet', 'language', language);
            const localVarPath = `/account/v2/{tenant}/{language}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersOrderNumberGet: (tenant, language, orderNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersOrderNumberGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersOrderNumberGet', 'language', language);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersOrderNumberGet', 'orderNumber', orderNumber);
            const localVarPath = `/account/v2/{tenant}/{language}/orders/{orderNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageUserGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageUserGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageUserGet', 'language', language);
            const localVarPath = `/account/v2/{tenant}/{language}/user`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountControllerV2Api - functional programming interface
 * @export
 */
export const AccountControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by a customer to retrieve the last order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageLastOrderGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageLastOrderGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageUserGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageUserGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AccountControllerV2Api - factory interface
 * @export
 */
export const AccountControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountControllerV2ApiFp(configuration);
    return {
        /**
         * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageCustomerNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageCustomerNumberGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageCustomerNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.customerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve the last order.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageLastOrderGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageLastOrderGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageLastOrderGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the customer to retrieve all its orders.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageOrdersGet(requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersOrderNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersOrderNumberGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageOrdersOrderNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageUserGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageUserGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountControllerV2Api - object-oriented interface
 * @export
 * @class AccountControllerV2Api
 * @extends {BaseAPI}
 */
export class AccountControllerV2Api extends BaseAPI {
    /**
     * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageCustomerNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageCustomerNumberGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageCustomerNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.customerNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve the last order.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageLastOrderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageLastOrderGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageLastOrderGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by the customer to retrieve all its orders.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageOrdersGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageOrdersGet(requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve a single order.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersOrderNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageOrdersOrderNumberGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageOrdersOrderNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageUserGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageUserGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AddressControllerApi - axios parameter creator
 * @export
 */
export const AddressControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Endpoint for migrating addresses (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantAddressesPost: (tenant, MigrateAddressesRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantAddressesPost', 'tenant', tenant);
            // verify required parameter 'MigrateAddressesRequestV1' is not null or undefined
            assertParamExists('addressesV2TenantAddressesPost', 'MigrateAddressesRequestV1', MigrateAddressesRequestV1);
            const localVarPath = `/addresses/v2/{tenant}/addresses`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MigrateAddressesRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDefaultZipGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantDefaultZipGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}/defaultZip`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDoorDeliveryGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantDoorDeliveryGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}/doorDelivery`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
         * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantGet: (tenant, clientPlatform, types, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (clientPlatform !== undefined) {
                localVarQueryParameter['clientPlatform'] = clientPlatform;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (orderDraftId !== undefined) {
                localVarQueryParameter['orderDraftId'] = orderDraftId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to delete an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdDelete: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantIdDelete', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addressesV2TenantIdDelete', 'id', id);
            const localVarPath = `/addresses/v2/{tenant}/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to update an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdPut: (tenant, id, AddressesV2TenantIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantIdPut', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addressesV2TenantIdPut', 'id', id);
            // verify required parameter 'AddressesV2TenantIdPutRequest' is not null or undefined
            assertParamExists('addressesV2TenantIdPut', 'AddressesV2TenantIdPutRequest', AddressesV2TenantIdPutRequest);
            const localVarPath = `/addresses/v2/{tenant}/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(AddressesV2TenantIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantOrderDraftIdDoorDeliveryGet: (tenant, orderDraftId, clientPlatform, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantOrderDraftIdDoorDeliveryGet', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('addressesV2TenantOrderDraftIdDoorDeliveryGet', 'orderDraftId', orderDraftId);
            const localVarPath = `/addresses/v2/{tenant}/{orderDraftId}/doorDelivery`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (clientPlatform !== undefined) {
                localVarQueryParameter['clientPlatform'] = clientPlatform;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to get pickupStation addresses of a customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPickupStationDeliveryGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantPickupStationDeliveryGet', 'tenant', tenant);
            const localVarPath = `/addresses/v2/{tenant}/pickupStationDelivery`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint to create an address
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPost: (tenant, AddressesV2TenantPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV2TenantPost', 'tenant', tenant);
            // verify required parameter 'AddressesV2TenantPostRequest' is not null or undefined
            assertParamExists('addressesV2TenantPost', 'AddressesV2TenantPostRequest', AddressesV2TenantPostRequest);
            const localVarPath = `/addresses/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(AddressesV2TenantPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AddressControllerApi - functional programming interface
 * @export
 */
export const AddressControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AddressControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Endpoint for migrating addresses (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MigrateAddressesRequestV1} MigrateAddressesRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantAddressesPost(tenant, MigrateAddressesRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDefaultZipGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantDefaultZipGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDoorDeliveryGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantDoorDeliveryGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
         * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantGet(tenant, clientPlatform, types, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to delete an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdDelete(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantIdDelete(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to update an address given address id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {AddressesV2TenantIdPutRequest} AddressesV2TenantIdPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantIdPut(tenant, id, AddressesV2TenantIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantOrderDraftIdDoorDeliveryGet(tenant, orderDraftId, clientPlatform, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to get pickupStation addresses of a customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPickupStationDeliveryGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantPickupStationDeliveryGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint to create an address
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AddressesV2TenantPostRequest} AddressesV2TenantPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV2TenantPost(tenant, AddressesV2TenantPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AddressControllerApi - factory interface
 * @export
 */
export const AddressControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AddressControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Endpoint for migrating addresses (for internal usage only)
         * @param {AddressControllerApiAddressesV2TenantAddressesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantAddressesPost(requestParameters, options) {
            return localVarFp.addressesV2TenantAddressesPost(requestParameters.tenant, requestParameters.MigrateAddressesRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
         * @param {AddressControllerApiAddressesV2TenantDefaultZipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDefaultZipGet(requestParameters, options) {
            return localVarFp.addressesV2TenantDefaultZipGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
         * @param {AddressControllerApiAddressesV2TenantDoorDeliveryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantDoorDeliveryGet(requestParameters, options) {
            return localVarFp.addressesV2TenantDoorDeliveryGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {AddressControllerApiAddressesV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantGet(requestParameters, options) {
            return localVarFp.addressesV2TenantGet(requestParameters.tenant, requestParameters.clientPlatform, requestParameters.types, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to delete an address given address id
         * @param {AddressControllerApiAddressesV2TenantIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdDelete(requestParameters, options) {
            return localVarFp.addressesV2TenantIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to update an address given address id
         * @param {AddressControllerApiAddressesV2TenantIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantIdPut(requestParameters, options) {
            return localVarFp.addressesV2TenantIdPut(requestParameters.tenant, requestParameters.id, requestParameters.AddressesV2TenantIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
         * @param {AddressControllerApiAddressesV2TenantOrderDraftIdDoorDeliveryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters, options) {
            return localVarFp.addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.clientPlatform, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to get pickupStation addresses of a customer
         * @param {AddressControllerApiAddressesV2TenantPickupStationDeliveryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPickupStationDeliveryGet(requestParameters, options) {
            return localVarFp.addressesV2TenantPickupStationDeliveryGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint to create an address
         * @param {AddressControllerApiAddressesV2TenantPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV2TenantPost(requestParameters, options) {
            return localVarFp.addressesV2TenantPost(requestParameters.tenant, requestParameters.AddressesV2TenantPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AddressControllerApi - object-oriented interface
 * @export
 * @class AddressControllerApi
 * @extends {BaseAPI}
 */
export class AddressControllerApi extends BaseAPI {
    /**
     *
     * @summary Endpoint for migrating addresses (for internal usage only)
     * @param {AddressControllerApiAddressesV2TenantAddressesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantAddressesPost(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantAddressesPost(requestParameters.tenant, requestParameters.MigrateAddressesRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get the ZIP of the default door delivery address of a customer. The endpoint is needed for the NOW Modals
     * @param {AddressControllerApiAddressesV2TenantDefaultZipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantDefaultZipGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantDefaultZipGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses
     * @param {AddressControllerApiAddressesV2TenantDoorDeliveryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantDoorDeliveryGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantDoorDeliveryGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
     * @param {AddressControllerApiAddressesV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantGet(requestParameters.tenant, requestParameters.clientPlatform, requestParameters.types, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to delete an address given address id
     * @param {AddressControllerApiAddressesV2TenantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantIdDelete(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to update an address given address id
     * @param {AddressControllerApiAddressesV2TenantIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantIdPut(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantIdPut(requestParameters.tenant, requestParameters.id, requestParameters.AddressesV2TenantIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get door delivery addresses of a customer. Door delivery addresses are billing + shipping (excluding pickupStation) addresses that also include \'now service\' data.
     * @param {AddressControllerApiAddressesV2TenantOrderDraftIdDoorDeliveryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantOrderDraftIdDoorDeliveryGet(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.clientPlatform, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to get pickupStation addresses of a customer
     * @param {AddressControllerApiAddressesV2TenantPickupStationDeliveryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantPickupStationDeliveryGet(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantPickupStationDeliveryGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint to create an address
     * @param {AddressControllerApiAddressesV2TenantPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    addressesV2TenantPost(requestParameters, options) {
        return AddressControllerApiFp(this.configuration).addressesV2TenantPost(requestParameters.tenant, requestParameters.AddressesV2TenantPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AddressControllerV3Api - axios parameter creator
 * @export
 */
export const AddressControllerV3ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
         * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV3TenantLanguageGet: (tenant, language, clientPlatform, types, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('addressesV3TenantLanguageGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('addressesV3TenantLanguageGet', 'language', language);
            const localVarPath = `/addresses/v3/{tenant}/{language}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (clientPlatform !== undefined) {
                localVarQueryParameter['clientPlatform'] = clientPlatform;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (orderDraftId !== undefined) {
                localVarQueryParameter['orderDraftId'] = orderDraftId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AddressControllerV3Api - functional programming interface
 * @export
 */
export const AddressControllerV3ApiFp = function (configuration) {
    const localVarAxiosParamCreator = AddressControllerV3ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {'web_desktop' | 'web_mobile' | 'ios' | 'android'} [clientPlatform] The number of items to skip before starting to collect the result set
         * @param {Array<'billing' | 'pickupStation' | 'shipping'>} [types] used to get specific types of addresses
         * @param {string} [orderDraftId] Id of odrder draft that is needed for fetching Now data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV3TenantLanguageGet(tenant, language, clientPlatform, types, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesV3TenantLanguageGet(tenant, language, clientPlatform, types, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AddressControllerV3Api - factory interface
 * @export
 */
export const AddressControllerV3ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AddressControllerV3ApiFp(configuration);
    return {
        /**
         *
         * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
         * @param {AddressControllerV3ApiAddressesV3TenantLanguageGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesV3TenantLanguageGet(requestParameters, options) {
            return localVarFp.addressesV3TenantLanguageGet(requestParameters.tenant, requestParameters.language, requestParameters.clientPlatform, requestParameters.types, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AddressControllerV3Api - object-oriented interface
 * @export
 * @class AddressControllerV3Api
 * @extends {BaseAPI}
 */
export class AddressControllerV3Api extends BaseAPI {
    /**
     *
     * @summary Endpoint to get all addresses of a customer with ability to exclude pickupStation addresses that also include \'now service\' data.
     * @param {AddressControllerV3ApiAddressesV3TenantLanguageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerV3Api
     */
    addressesV3TenantLanguageGet(requestParameters, options) {
        return AddressControllerV3ApiFp(this.configuration).addressesV3TenantLanguageGet(requestParameters.tenant, requestParameters.language, requestParameters.clientPlatform, requestParameters.types, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdyenCheckoutConnectorControllerApi - axios parameter creator
 * @export
 */
export const AdyenCheckoutConnectorControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * adyen platform - get account holder
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {GetAccountHolderRequest} GetAccountHolderRequest Request payload for getting account holder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenV1TenantPlatformGetAccountHolderPost: (tenant, GetAccountHolderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('adyenV1TenantPlatformGetAccountHolderPost', 'tenant', tenant);
            // verify required parameter 'GetAccountHolderRequest' is not null or undefined
            assertParamExists('adyenV1TenantPlatformGetAccountHolderPost', 'GetAccountHolderRequest', GetAccountHolderRequest);
            const localVarPath = `/adyen/v1/{tenant}/platform/getAccountHolder`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(GetAccountHolderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdyenCheckoutConnectorControllerApi - functional programming interface
 * @export
 */
export const AdyenCheckoutConnectorControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdyenCheckoutConnectorControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * adyen platform - get account holder
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {GetAccountHolderRequest} GetAccountHolderRequest Request payload for getting account holder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenV1TenantPlatformGetAccountHolderPost(tenant, GetAccountHolderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adyenV1TenantPlatformGetAccountHolderPost(tenant, GetAccountHolderRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdyenCheckoutConnectorControllerApi - factory interface
 * @export
 */
export const AdyenCheckoutConnectorControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdyenCheckoutConnectorControllerApiFp(configuration);
    return {
        /**
         * adyen platform - get account holder
         * @param {AdyenCheckoutConnectorControllerApiAdyenV1TenantPlatformGetAccountHolderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenV1TenantPlatformGetAccountHolderPost(requestParameters, options) {
            return localVarFp.adyenV1TenantPlatformGetAccountHolderPost(requestParameters.tenant, requestParameters.GetAccountHolderRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdyenCheckoutConnectorControllerApi - object-oriented interface
 * @export
 * @class AdyenCheckoutConnectorControllerApi
 * @extends {BaseAPI}
 */
export class AdyenCheckoutConnectorControllerApi extends BaseAPI {
    /**
     * adyen platform - get account holder
     * @param {AdyenCheckoutConnectorControllerApiAdyenV1TenantPlatformGetAccountHolderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenCheckoutConnectorControllerApi
     */
    adyenV1TenantPlatformGetAccountHolderPost(requestParameters, options) {
        return AdyenCheckoutConnectorControllerApiFp(this.configuration).adyenV1TenantPlatformGetAccountHolderPost(requestParameters.tenant, requestParameters.GetAccountHolderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AppCheckoutConfigControllerApi - axios parameter creator
 * @export
 */
export const AppCheckoutConfigControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used by app to retrieve checkout config
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {AppCheckoutConfigV1TenantLanguagePostRequest} AppCheckoutConfigV1TenantLanguagePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCheckoutConfigV1TenantLanguagePost: (tenant, language, AppCheckoutConfigV1TenantLanguagePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('appCheckoutConfigV1TenantLanguagePost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('appCheckoutConfigV1TenantLanguagePost', 'language', language);
            // verify required parameter 'AppCheckoutConfigV1TenantLanguagePostRequest' is not null or undefined
            assertParamExists('appCheckoutConfigV1TenantLanguagePost', 'AppCheckoutConfigV1TenantLanguagePostRequest', AppCheckoutConfigV1TenantLanguagePostRequest);
            const localVarPath = `/app-checkout-config/v1/{tenant}/{language}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(AppCheckoutConfigV1TenantLanguagePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppCheckoutConfigControllerApi - functional programming interface
 * @export
 */
export const AppCheckoutConfigControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppCheckoutConfigControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Used by app to retrieve checkout config
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {AppCheckoutConfigV1TenantLanguagePostRequest} AppCheckoutConfigV1TenantLanguagePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCheckoutConfigV1TenantLanguagePost(tenant, language, AppCheckoutConfigV1TenantLanguagePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appCheckoutConfigV1TenantLanguagePost(tenant, language, AppCheckoutConfigV1TenantLanguagePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppCheckoutConfigControllerApi - factory interface
 * @export
 */
export const AppCheckoutConfigControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppCheckoutConfigControllerApiFp(configuration);
    return {
        /**
         * Used by app to retrieve checkout config
         * @param {AppCheckoutConfigControllerApiAppCheckoutConfigV1TenantLanguagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCheckoutConfigV1TenantLanguagePost(requestParameters, options) {
            return localVarFp.appCheckoutConfigV1TenantLanguagePost(requestParameters.tenant, requestParameters.language, requestParameters.AppCheckoutConfigV1TenantLanguagePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppCheckoutConfigControllerApi - object-oriented interface
 * @export
 * @class AppCheckoutConfigControllerApi
 * @extends {BaseAPI}
 */
export class AppCheckoutConfigControllerApi extends BaseAPI {
    /**
     * Used by app to retrieve checkout config
     * @param {AppCheckoutConfigControllerApiAppCheckoutConfigV1TenantLanguagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCheckoutConfigControllerApi
     */
    appCheckoutConfigV1TenantLanguagePost(requestParameters, options) {
        return AppCheckoutConfigControllerApiFp(this.configuration).appCheckoutConfigV1TenantLanguagePost(requestParameters.tenant, requestParameters.language, requestParameters.AppCheckoutConfigV1TenantLanguagePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AppConfigControllerV1Api - axios parameter creator
 * @export
 */
export const AppConfigControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used by a guest user to retrieve app config
         * @param {string} [countryId] filterCriteriaField CountryId
         * @param {string} [osName] filterCriteriaField OSName
         * @param {string} [osVersion] filterCriteriaField OSVersion
         * @param {string} [appVersion] filterCriteriaField AppVersion
         * @param {string} [language] filterCriteriaField Language
         * @param {string} [environment] filterCriteriaField Env
         * @param {string} [deviceType] filterCriteriaField DeviceType
         * @param {string} [buildType] filterCriteriaField BuildType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appConfigV1Get: (countryId, osName, osVersion, appVersion, language, environment, deviceType, buildType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/app-config/v1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (countryId !== undefined) {
                localVarQueryParameter['countryId'] = countryId;
            }
            if (osName !== undefined) {
                localVarQueryParameter['osName'] = osName;
            }
            if (osVersion !== undefined) {
                localVarQueryParameter['osVersion'] = osVersion;
            }
            if (appVersion !== undefined) {
                localVarQueryParameter['appVersion'] = appVersion;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }
            if (deviceType !== undefined) {
                localVarQueryParameter['deviceType'] = deviceType;
            }
            if (buildType !== undefined) {
                localVarQueryParameter['buildType'] = buildType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppConfigControllerV1Api - functional programming interface
 * @export
 */
export const AppConfigControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppConfigControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Used by a guest user to retrieve app config
         * @param {string} [countryId] filterCriteriaField CountryId
         * @param {string} [osName] filterCriteriaField OSName
         * @param {string} [osVersion] filterCriteriaField OSVersion
         * @param {string} [appVersion] filterCriteriaField AppVersion
         * @param {string} [language] filterCriteriaField Language
         * @param {string} [environment] filterCriteriaField Env
         * @param {string} [deviceType] filterCriteriaField DeviceType
         * @param {string} [buildType] filterCriteriaField BuildType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appConfigV1Get(countryId, osName, osVersion, appVersion, language, environment, deviceType, buildType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appConfigV1Get(countryId, osName, osVersion, appVersion, language, environment, deviceType, buildType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppConfigControllerV1Api - factory interface
 * @export
 */
export const AppConfigControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppConfigControllerV1ApiFp(configuration);
    return {
        /**
         * Used by a guest user to retrieve app config
         * @param {AppConfigControllerV1ApiAppConfigV1GetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appConfigV1Get(requestParameters = {}, options) {
            return localVarFp.appConfigV1Get(requestParameters.countryId, requestParameters.osName, requestParameters.osVersion, requestParameters.appVersion, requestParameters.language, requestParameters.environment, requestParameters.deviceType, requestParameters.buildType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppConfigControllerV1Api - object-oriented interface
 * @export
 * @class AppConfigControllerV1Api
 * @extends {BaseAPI}
 */
export class AppConfigControllerV1Api extends BaseAPI {
    /**
     * Used by a guest user to retrieve app config
     * @param {AppConfigControllerV1ApiAppConfigV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppConfigControllerV1Api
     */
    appConfigV1Get(requestParameters = {}, options) {
        return AppConfigControllerV1ApiFp(this.configuration).appConfigV1Get(requestParameters.countryId, requestParameters.osName, requestParameters.osVersion, requestParameters.appVersion, requestParameters.language, requestParameters.environment, requestParameters.deviceType, requestParameters.buildType, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuthControllerApi - axios parameter creator
 * @export
 */
export const AuthControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {EnableRequestV1} EnableRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantEnablePost: (tenant, EnableRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantEnablePost', 'tenant', tenant);
            // verify required parameter 'EnableRequestV1' is not null or undefined
            assertParamExists('authV1TenantEnablePost', 'EnableRequestV1', EnableRequestV1);
            const localVarPath = `/auth/v1/{tenant}/enable`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(EnableRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} version public key version
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantKeyVersionGet: (version, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('authV1TenantKeyVersionGet', 'version', version);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantKeyVersionGet', 'tenant', tenant);
            const localVarPath = `/auth/v1/{tenant}/key/{version}`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantLoginGuestGet: (tenant, Sae_Device_Type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantLoginGuestGet', 'tenant', tenant);
            const localVarPath = `/auth/v1/{tenant}/login/guest`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {LoginRequestV1} LoginRequestV1
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantLoginPost: (tenant, LoginRequestV1, Sae_Device_Type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantLoginPost', 'tenant', tenant);
            // verify required parameter 'LoginRequestV1' is not null or undefined
            assertParamExists('authV1TenantLoginPost', 'LoginRequestV1', LoginRequestV1);
            const localVarPath = `/auth/v1/{tenant}/login`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(LoginRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {UpdateRequestV1} UpdateRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantPasswordPost: (tenant, UpdateRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantPasswordPost', 'tenant', tenant);
            // verify required parameter 'UpdateRequestV1' is not null or undefined
            assertParamExists('authV1TenantPasswordPost', 'UpdateRequestV1', UpdateRequestV1);
            const localVarPath = `/auth/v1/{tenant}/password`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UpdateRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantRefreshGet: (tenant, Sae_Device_Type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantRefreshGet', 'tenant', tenant);
            const localVarPath = `/auth/v1/{tenant}/refresh`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {RegisterRequestV1} RegisterRequestV1
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantRegisterPost: (tenant, RegisterRequestV1, Sae_Device_Type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantRegisterPost', 'tenant', tenant);
            // verify required parameter 'RegisterRequestV1' is not null or undefined
            assertParamExists('authV1TenantRegisterPost', 'RegisterRequestV1', RegisterRequestV1);
            const localVarPath = `/auth/v1/{tenant}/register`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RegisterRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
         * @param {string} customerNumber QueryParam customerNumber
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantResetGet: (customerNumber, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('authV1TenantResetGet', 'customerNumber', customerNumber);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantResetGet', 'tenant', tenant);
            const localVarPath = `/auth/v1/{tenant}/reset`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {ResetRequestV1} ResetRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantResetPost: (tenant, ResetRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV1TenantResetPost', 'tenant', tenant);
            // verify required parameter 'ResetRequestV1' is not null or undefined
            assertParamExists('authV1TenantResetPost', 'ResetRequestV1', ResetRequestV1);
            const localVarPath = `/auth/v1/{tenant}/reset`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ResetRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {LoginRequestV2} LoginRequestV2
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV2TenantLoginPost: (tenant, LoginRequestV2, Sae_Device_Type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantLoginPost', 'tenant', tenant);
            // verify required parameter 'LoginRequestV2' is not null or undefined
            assertParamExists('authV2TenantLoginPost', 'LoginRequestV2', LoginRequestV2);
            const localVarPath = `/auth/v2/{tenant}/login`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(LoginRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantLogoutPost: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantLogoutPost', 'tenant', tenant);
            const localVarPath = `/auth/v2/{tenant}/logout`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {UpdatePasswordRequestV2} UpdatePasswordRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantPasswordPatch: (tenant, UpdatePasswordRequestV2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantPasswordPatch', 'tenant', tenant);
            // verify required parameter 'UpdatePasswordRequestV2' is not null or undefined
            assertParamExists('authV2TenantPasswordPatch', 'UpdatePasswordRequestV2', UpdatePasswordRequestV2);
            const localVarPath = `/auth/v2/{tenant}/password`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UpdatePasswordRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {RegisterRequestV2} RegisterRequestV2
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantRegisterPost: (tenant, RegisterRequestV2, Sae_Device_Type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantRegisterPost', 'tenant', tenant);
            // verify required parameter 'RegisterRequestV2' is not null or undefined
            assertParamExists('authV2TenantRegisterPost', 'RegisterRequestV2', RegisterRequestV2);
            const localVarPath = `/auth/v2/{tenant}/register`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RegisterRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Triggers the password reset process
         * @param {string} email Email Address Query Param
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetGet: (email, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('authV2TenantResetGet', 'email', email);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantResetGet', 'tenant', tenant);
            const localVarPath = `/auth/v2/{tenant}/reset`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set the new password for the customers account with the help of the Reset Token
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PasswordResetRequestV2} PasswordResetRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetPost: (tenant, PasswordResetRequestV2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantResetPost', 'tenant', tenant);
            // verify required parameter 'PasswordResetRequestV2' is not null or undefined
            assertParamExists('authV2TenantResetPost', 'PasswordResetRequestV2', PasswordResetRequestV2);
            const localVarPath = `/auth/v2/{tenant}/reset`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PasswordResetRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetVerifyGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantResetVerifyGet', 'tenant', tenant);
            const localVarPath = `/auth/v2/{tenant}/reset/verify`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {ValidateCustomersPasswordRequestV2} ValidateCustomersPasswordRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantValidateCustomersPasswordPost: (tenant, ValidateCustomersPasswordRequestV2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV2TenantValidateCustomersPasswordPost', 'tenant', tenant);
            // verify required parameter 'ValidateCustomersPasswordRequestV2' is not null or undefined
            assertParamExists('authV2TenantValidateCustomersPasswordPost', 'ValidateCustomersPasswordRequestV2', ValidateCustomersPasswordRequestV2);
            const localVarPath = `/auth/v2/{tenant}/validateCustomersPassword`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ValidateCustomersPasswordRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Triggers the password reset process
         * @param {string} email Email Address Query Param
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} fcSolution FriendlyCaptcha Solution Query Param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV3TenantResetGet: (email, tenant, fcSolution, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('authV3TenantResetGet', 'email', email);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('authV3TenantResetGet', 'tenant', tenant);
            // verify required parameter 'fcSolution' is not null or undefined
            assertParamExists('authV3TenantResetGet', 'fcSolution', fcSolution);
            const localVarPath = `/auth/v3/{tenant}/reset`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (fcSolution !== undefined) {
                localVarQueryParameter['fcSolution'] = fcSolution;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {LoginRequestV3} LoginRequestV3
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyAppPerformLogin: (tenant, LoginRequestV3, Sae_Device_Type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyAppPerformLogin', 'tenant', tenant);
            // verify required parameter 'LoginRequestV3' is not null or undefined
            assertParamExists('bullyAppPerformLogin', 'LoginRequestV3', LoginRequestV3);
            const localVarPath = `/auth/v3/{tenant}/login`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(LoginRequestV3, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthControllerApi - functional programming interface
 * @export
 */
export const AuthControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {EnableRequestV1} EnableRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantEnablePost(tenant, EnableRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantEnablePost(tenant, EnableRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} version public key version
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantKeyVersionGet(version, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantKeyVersionGet(version, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantLoginGuestGet(tenant, Sae_Device_Type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantLoginGuestGet(tenant, Sae_Device_Type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {LoginRequestV1} LoginRequestV1
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantLoginPost(tenant, LoginRequestV1, Sae_Device_Type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantLoginPost(tenant, LoginRequestV1, Sae_Device_Type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {UpdateRequestV1} UpdateRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantPasswordPost(tenant, UpdateRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantPasswordPost(tenant, UpdateRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantRefreshGet(tenant, Sae_Device_Type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantRefreshGet(tenant, Sae_Device_Type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {RegisterRequestV1} RegisterRequestV1
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantRegisterPost(tenant, RegisterRequestV1, Sae_Device_Type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantRegisterPost(tenant, RegisterRequestV1, Sae_Device_Type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
         * @param {string} customerNumber QueryParam customerNumber
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantResetGet(customerNumber, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantResetGet(customerNumber, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {ResetRequestV1} ResetRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantResetPost(tenant, ResetRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV1TenantResetPost(tenant, ResetRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {LoginRequestV2} LoginRequestV2
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV2TenantLoginPost(tenant, LoginRequestV2, Sae_Device_Type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantLoginPost(tenant, LoginRequestV2, Sae_Device_Type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantLogoutPost(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantLogoutPost(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {UpdatePasswordRequestV2} UpdatePasswordRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantPasswordPatch(tenant, UpdatePasswordRequestV2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantPasswordPatch(tenant, UpdatePasswordRequestV2, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {RegisterRequestV2} RegisterRequestV2
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantRegisterPost(tenant, RegisterRequestV2, Sae_Device_Type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantRegisterPost(tenant, RegisterRequestV2, Sae_Device_Type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Triggers the password reset process
         * @param {string} email Email Address Query Param
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetGet(email, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantResetGet(email, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Set the new password for the customers account with the help of the Reset Token
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PasswordResetRequestV2} PasswordResetRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetPost(tenant, PasswordResetRequestV2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantResetPost(tenant, PasswordResetRequestV2, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetVerifyGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantResetVerifyGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {ValidateCustomersPasswordRequestV2} ValidateCustomersPasswordRequestV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantValidateCustomersPasswordPost(tenant, ValidateCustomersPasswordRequestV2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV2TenantValidateCustomersPasswordPost(tenant, ValidateCustomersPasswordRequestV2, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Triggers the password reset process
         * @param {string} email Email Address Query Param
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} fcSolution FriendlyCaptcha Solution Query Param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV3TenantResetGet(email, tenant, fcSolution, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authV3TenantResetGet(email, tenant, fcSolution, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {LoginRequestV3} LoginRequestV3
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyAppPerformLogin(tenant, LoginRequestV3, Sae_Device_Type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyAppPerformLogin(tenant, LoginRequestV3, Sae_Device_Type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AuthControllerApi - factory interface
 * @export
 */
export const AuthControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthControllerApiFp(configuration);
    return {
        /**
         *
         * @param {AuthControllerApiAuthV1TenantEnablePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantEnablePost(requestParameters, options) {
            return localVarFp.authV1TenantEnablePost(requestParameters.tenant, requestParameters.EnableRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV1TenantKeyVersionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantKeyVersionGet(requestParameters, options) {
            return localVarFp.authV1TenantKeyVersionGet(requestParameters.version, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV1TenantLoginGuestGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantLoginGuestGet(requestParameters, options) {
            return localVarFp.authV1TenantLoginGuestGet(requestParameters.tenant, requestParameters.Sae_Device_Type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV1TenantLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantLoginPost(requestParameters, options) {
            return localVarFp.authV1TenantLoginPost(requestParameters.tenant, requestParameters.LoginRequestV1, requestParameters.Sae_Device_Type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV1TenantPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantPasswordPost(requestParameters, options) {
            return localVarFp.authV1TenantPasswordPost(requestParameters.tenant, requestParameters.UpdateRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV1TenantRefreshGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV1TenantRefreshGet(requestParameters, options) {
            return localVarFp.authV1TenantRefreshGet(requestParameters.tenant, requestParameters.Sae_Device_Type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV1TenantRegisterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantRegisterPost(requestParameters, options) {
            return localVarFp.authV1TenantRegisterPost(requestParameters.tenant, requestParameters.RegisterRequestV1, requestParameters.Sae_Device_Type, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
         * @param {AuthControllerApiAuthV1TenantResetGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantResetGet(requestParameters, options) {
            return localVarFp.authV1TenantResetGet(requestParameters.customerNumber, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV1TenantResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV1TenantResetPost(requestParameters, options) {
            return localVarFp.authV1TenantResetPost(requestParameters.tenant, requestParameters.ResetRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV2TenantLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authV2TenantLoginPost(requestParameters, options) {
            return localVarFp.authV2TenantLoginPost(requestParameters.tenant, requestParameters.LoginRequestV2, requestParameters.Sae_Device_Type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV2TenantLogoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantLogoutPost(requestParameters, options) {
            return localVarFp.authV2TenantLogoutPost(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV2TenantPasswordPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantPasswordPatch(requestParameters, options) {
            return localVarFp.authV2TenantPasswordPatch(requestParameters.tenant, requestParameters.UpdatePasswordRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV2TenantRegisterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantRegisterPost(requestParameters, options) {
            return localVarFp.authV2TenantRegisterPost(requestParameters.tenant, requestParameters.RegisterRequestV2, requestParameters.Sae_Device_Type, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers the password reset process
         * @param {AuthControllerApiAuthV2TenantResetGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetGet(requestParameters, options) {
            return localVarFp.authV2TenantResetGet(requestParameters.email, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the new password for the customers account with the help of the Reset Token
         * @param {AuthControllerApiAuthV2TenantResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetPost(requestParameters, options) {
            return localVarFp.authV2TenantResetPost(requestParameters.tenant, requestParameters.PasswordResetRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
         * @param {AuthControllerApiAuthV2TenantResetVerifyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantResetVerifyGet(requestParameters, options) {
            return localVarFp.authV2TenantResetVerifyGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiAuthV2TenantValidateCustomersPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV2TenantValidateCustomersPasswordPost(requestParameters, options) {
            return localVarFp.authV2TenantValidateCustomersPasswordPost(requestParameters.tenant, requestParameters.ValidateCustomersPasswordRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers the password reset process
         * @param {AuthControllerApiAuthV3TenantResetGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authV3TenantResetGet(requestParameters, options) {
            return localVarFp.authV3TenantResetGet(requestParameters.email, requestParameters.tenant, requestParameters.fcSolution, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthControllerApiBullyAppPerformLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyAppPerformLogin(requestParameters, options) {
            return localVarFp.bullyAppPerformLogin(requestParameters.tenant, requestParameters.LoginRequestV3, requestParameters.Sae_Device_Type, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
export class AuthControllerApi extends BaseAPI {
    /**
     *
     * @param {AuthControllerApiAuthV1TenantEnablePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantEnablePost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantEnablePost(requestParameters.tenant, requestParameters.EnableRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV1TenantKeyVersionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantKeyVersionGet(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantKeyVersionGet(requestParameters.version, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV1TenantLoginGuestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantLoginGuestGet(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantLoginGuestGet(requestParameters.tenant, requestParameters.Sae_Device_Type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV1TenantLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantLoginPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantLoginPost(requestParameters.tenant, requestParameters.LoginRequestV1, requestParameters.Sae_Device_Type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV1TenantPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantPasswordPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantPasswordPost(requestParameters.tenant, requestParameters.UpdateRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV1TenantRefreshGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantRefreshGet(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantRefreshGet(requestParameters.tenant, requestParameters.Sae_Device_Type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV1TenantRegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantRegisterPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantRegisterPost(requestParameters.tenant, requestParameters.RegisterRequestV1, requestParameters.Sae_Device_Type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by the customer to get a reset token for resetting his password. The x-shop-auth-token is required for this endpoint.
     * @param {AuthControllerApiAuthV1TenantResetGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantResetGet(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantResetGet(requestParameters.customerNumber, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV1TenantResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV1TenantResetPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV1TenantResetPost(requestParameters.tenant, requestParameters.ResetRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV2TenantLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantLoginPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantLoginPost(requestParameters.tenant, requestParameters.LoginRequestV2, requestParameters.Sae_Device_Type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV2TenantLogoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantLogoutPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantLogoutPost(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV2TenantPasswordPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantPasswordPatch(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantPasswordPatch(requestParameters.tenant, requestParameters.UpdatePasswordRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV2TenantRegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantRegisterPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantRegisterPost(requestParameters.tenant, requestParameters.RegisterRequestV2, requestParameters.Sae_Device_Type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Triggers the password reset process
     * @param {AuthControllerApiAuthV2TenantResetGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantResetGet(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantResetGet(requestParameters.email, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set the new password for the customers account with the help of the Reset Token
     * @param {AuthControllerApiAuthV2TenantResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantResetPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantResetPost(requestParameters.tenant, requestParameters.PasswordResetRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Verifies the Customers Password Reset Token. The password reset token must be set in the Authorization header
     * @param {AuthControllerApiAuthV2TenantResetVerifyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantResetVerifyGet(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantResetVerifyGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiAuthV2TenantValidateCustomersPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV2TenantValidateCustomersPasswordPost(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV2TenantValidateCustomersPasswordPost(requestParameters.tenant, requestParameters.ValidateCustomersPasswordRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Triggers the password reset process
     * @param {AuthControllerApiAuthV3TenantResetGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    authV3TenantResetGet(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).authV3TenantResetGet(requestParameters.email, requestParameters.tenant, requestParameters.fcSolution, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthControllerApiBullyAppPerformLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    bullyAppPerformLogin(requestParameters, options) {
        return AuthControllerApiFp(this.configuration).bullyAppPerformLogin(requestParameters.tenant, requestParameters.LoginRequestV3, requestParameters.Sae_Device_Type, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CarriersControllerApi - axios parameter creator
 * @export
 */
export const CarriersControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantFreeShippingThresholdsGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('carriersV1TenantFreeShippingThresholdsGet', 'tenant', tenant);
            const localVarPath = `/carriers/v1/{tenant}/freeShippingThresholds`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('carriersV1TenantGet', 'tenant', tenant);
            const localVarPath = `/carriers/v1/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantOrderDraftIdGet: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('carriersV1TenantOrderDraftIdGet', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('carriersV1TenantOrderDraftIdGet', 'orderDraftId', orderDraftId);
            const localVarPath = `/carriers/v1/{tenant}/{orderDraftId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find all shipping methods for order draft ID
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantShippingMethodsOrderDraftIdGet: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('carriersV1TenantShippingMethodsOrderDraftIdGet', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('carriersV1TenantShippingMethodsOrderDraftIdGet', 'orderDraftId', orderDraftId);
            const localVarPath = `/carriers/v1/{tenant}/shippingMethods/{orderDraftId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CarriersControllerApi - functional programming interface
 * @export
 */
export const CarriersControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CarriersControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantFreeShippingThresholdsGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.carriersV1TenantFreeShippingThresholdsGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.carriersV1TenantGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantOrderDraftIdGet(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.carriersV1TenantOrderDraftIdGet(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find all shipping methods for order draft ID
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantShippingMethodsOrderDraftIdGet(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.carriersV1TenantShippingMethodsOrderDraftIdGet(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CarriersControllerApi - factory interface
 * @export
 */
export const CarriersControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CarriersControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CarriersControllerApiCarriersV1TenantFreeShippingThresholdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantFreeShippingThresholdsGet(requestParameters, options) {
            return localVarFp.carriersV1TenantFreeShippingThresholdsGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CarriersControllerApiCarriersV1TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantGet(requestParameters, options) {
            return localVarFp.carriersV1TenantGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
         * @param {CarriersControllerApiCarriersV1TenantOrderDraftIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantOrderDraftIdGet(requestParameters, options) {
            return localVarFp.carriersV1TenantOrderDraftIdGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find all shipping methods for order draft ID
         * @param {CarriersControllerApiCarriersV1TenantShippingMethodsOrderDraftIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV1TenantShippingMethodsOrderDraftIdGet(requestParameters, options) {
            return localVarFp.carriersV1TenantShippingMethodsOrderDraftIdGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CarriersControllerApi - object-oriented interface
 * @export
 * @class CarriersControllerApi
 * @extends {BaseAPI}
 */
export class CarriersControllerApi extends BaseAPI {
    /**
     *
     * @param {CarriersControllerApiCarriersV1TenantFreeShippingThresholdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersControllerApi
     */
    carriersV1TenantFreeShippingThresholdsGet(requestParameters, options) {
        return CarriersControllerApiFp(this.configuration).carriersV1TenantFreeShippingThresholdsGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CarriersControllerApiCarriersV1TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersControllerApi
     */
    carriersV1TenantGet(requestParameters, options) {
        return CarriersControllerApiFp(this.configuration).carriersV1TenantGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request
     * @param {CarriersControllerApiCarriersV1TenantOrderDraftIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersControllerApi
     */
    carriersV1TenantOrderDraftIdGet(requestParameters, options) {
        return CarriersControllerApiFp(this.configuration).carriersV1TenantOrderDraftIdGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find all shipping methods for order draft ID
     * @param {CarriersControllerApiCarriersV1TenantShippingMethodsOrderDraftIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersControllerApi
     */
    carriersV1TenantShippingMethodsOrderDraftIdGet(requestParameters, options) {
        return CarriersControllerApiFp(this.configuration).carriersV1TenantShippingMethodsOrderDraftIdGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CarriersControllerV2Api - axios parameter creator
 * @export
 */
export const CarriersControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {boolean} [isCoolingRequired] boolean flag for receiving carriers supporting cooling
         * @param {boolean} [hasPrescription] boolean flag for receiving carriers supporting shipping for rx offers
         * @param {number} [amountToPay] amount to pay carriers
         * @param {boolean} [allowExpressCarriers] boolean flag for receiving carriers supporting express
         * @param {string} [group] string value for grouping of carrier related products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV2TenantGet: (tenant, isCoolingRequired, hasPrescription, amountToPay, allowExpressCarriers, group, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('carriersV2TenantGet', 'tenant', tenant);
            const localVarPath = `/carriers/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isCoolingRequired !== undefined) {
                localVarQueryParameter['isCoolingRequired'] = isCoolingRequired;
            }
            if (hasPrescription !== undefined) {
                localVarQueryParameter['hasPrescription'] = hasPrescription;
            }
            if (amountToPay !== undefined) {
                localVarQueryParameter['amountToPay'] = amountToPay;
            }
            if (allowExpressCarriers !== undefined) {
                localVarQueryParameter['allowExpressCarriers'] = allowExpressCarriers;
            }
            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        carriersV2TenantOrderDraftIdGet: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('carriersV2TenantOrderDraftIdGet', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('carriersV2TenantOrderDraftIdGet', 'orderDraftId', orderDraftId);
            const localVarPath = `/carriers/v2/{tenant}/{orderDraftId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CarriersControllerV2Api - functional programming interface
 * @export
 */
export const CarriersControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CarriersControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {boolean} [isCoolingRequired] boolean flag for receiving carriers supporting cooling
         * @param {boolean} [hasPrescription] boolean flag for receiving carriers supporting shipping for rx offers
         * @param {number} [amountToPay] amount to pay carriers
         * @param {boolean} [allowExpressCarriers] boolean flag for receiving carriers supporting express
         * @param {string} [group] string value for grouping of carrier related products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV2TenantGet(tenant, isCoolingRequired, hasPrescription, amountToPay, allowExpressCarriers, group, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.carriersV2TenantGet(tenant, isCoolingRequired, hasPrescription, amountToPay, allowExpressCarriers, group, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        carriersV2TenantOrderDraftIdGet(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.carriersV2TenantOrderDraftIdGet(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CarriersControllerV2Api - factory interface
 * @export
 */
export const CarriersControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CarriersControllerV2ApiFp(configuration);
    return {
        /**
         *
         * @param {CarriersControllerV2ApiCarriersV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV2TenantGet(requestParameters, options) {
            return localVarFp.carriersV2TenantGet(requestParameters.tenant, requestParameters.isCoolingRequired, requestParameters.hasPrescription, requestParameters.amountToPay, requestParameters.allowExpressCarriers, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
         * @param {CarriersControllerV2ApiCarriersV2TenantOrderDraftIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        carriersV2TenantOrderDraftIdGet(requestParameters, options) {
            return localVarFp.carriersV2TenantOrderDraftIdGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CarriersControllerV2Api - object-oriented interface
 * @export
 * @class CarriersControllerV2Api
 * @extends {BaseAPI}
 */
export class CarriersControllerV2Api extends BaseAPI {
    /**
     *
     * @param {CarriersControllerV2ApiCarriersV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersControllerV2Api
     */
    carriersV2TenantGet(requestParameters, options) {
        return CarriersControllerV2ApiFp(this.configuration).carriersV2TenantGet(requestParameters.tenant, requestParameters.isCoolingRequired, requestParameters.hasPrescription, requestParameters.amountToPay, requestParameters.allowExpressCarriers, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
     * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
     * @param {CarriersControllerV2ApiCarriersV2TenantOrderDraftIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CarriersControllerV2Api
     */
    carriersV2TenantOrderDraftIdGet(requestParameters, options) {
        return CarriersControllerV2ApiFp(this.configuration).carriersV2TenantOrderDraftIdGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CarriersControllerV3Api - axios parameter creator
 * @export
 */
export const CarriersControllerV3ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV3TenantLanguageOrderDraftIdGet: (tenant, language, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('carriersV3TenantLanguageOrderDraftIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('carriersV3TenantLanguageOrderDraftIdGet', 'language', language);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('carriersV3TenantLanguageOrderDraftIdGet', 'orderDraftId', orderDraftId);
            const localVarPath = `/carriers/v3/{tenant}/{language}/{orderDraftId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CarriersControllerV3Api - functional programming interface
 * @export
 */
export const CarriersControllerV3ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CarriersControllerV3ApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV3TenantLanguageOrderDraftIdGet(tenant, language, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.carriersV3TenantLanguageOrderDraftIdGet(tenant, language, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CarriersControllerV3Api - factory interface
 * @export
 */
export const CarriersControllerV3ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CarriersControllerV3ApiFp(configuration);
    return {
        /**
         * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
         * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
         * @param {CarriersControllerV3ApiCarriersV3TenantLanguageOrderDraftIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersV3TenantLanguageOrderDraftIdGet(requestParameters, options) {
            return localVarFp.carriersV3TenantLanguageOrderDraftIdGet(requestParameters.tenant, requestParameters.language, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CarriersControllerV3Api - object-oriented interface
 * @export
 * @class CarriersControllerV3Api
 * @extends {BaseAPI}
 */
export class CarriersControllerV3Api extends BaseAPI {
    /**
     * Returns multiple NOW merchants (multiple pick-up slots and multiple home-delivery options).
     * @summary Use OrderDraft instead of Cart to derive query parameters for the SHIPSe request.
     * @param {CarriersControllerV3ApiCarriersV3TenantLanguageOrderDraftIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersControllerV3Api
     */
    carriersV3TenantLanguageOrderDraftIdGet(requestParameters, options) {
        return CarriersControllerV3ApiFp(this.configuration).carriersV3TenantLanguageOrderDraftIdGet(requestParameters.tenant, requestParameters.language, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CartControllerV2Api - axios parameter creator
 * @export
 */
export const CartControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantDelete', 'tenant', tenant);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} hashedToken
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete: (tenant, hashedToken, Accept_Language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'tenant', tenant);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'hashedToken', hashedToken);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/entries/eRx/{hashedToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {Array<string>} request_body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost: (tenant, Accept_Language, request_body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'request_body' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'request_body', request_body);
            const localVarPath = `/cart/v2/{tenant}/entries/eRx`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create multiple cartEntries
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesPost: (tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntriesRequestV1' is not null or undefined
            assertParamExists('cartV2TenantEntriesPost', 'CartV2CartEntriesRequestV1', CartV2CartEntriesRequestV1);
            const localVarPath = `/cart/v2/{tenant}/entries`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntriesRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} offerId
         * @param {string} Accept_Language
         * @param {string} prescriptionType
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryOfferIdDelete: (tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'tenant', tenant);
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'offerId', offerId);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'Accept_Language', Accept_Language);
            // verify required parameter 'prescriptionType' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'prescriptionType', prescriptionType);
            const localVarPath = `/cart/v2/{tenant}/entry/{offerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (prescriptionType !== undefined) {
                localVarQueryParameter['prescriptionType'] = prescriptionType;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create or update cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryPost: (tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntryPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntryPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntryRequestV1' is not null or undefined
            assertParamExists('cartV2TenantEntryPost', 'CartV2CartEntryRequestV1', CartV2CartEntryRequestV1);
            const localVarPath = `/cart/v2/{tenant}/entry`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntryRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * replace cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryReplacePost: (tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntryReplacePost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntryReplacePost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartReplaceEntryRequestV1' is not null or undefined
            assertParamExists('cartV2TenantEntryReplacePost', 'CartV2CartReplaceEntryRequestV1', CartV2CartReplaceEntryRequestV1);
            const localVarPath = `/cart/v2/{tenant}/entry/replace`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartReplaceEntryRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet: (tenant, Accept_Language, purgeMessages, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides information about the cart data
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet: (tenant, Accept_Language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantMetadataGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantMetadataGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/metadata`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [disableRefresh]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantMinicartGet: (tenant, Accept_Language, disableRefresh, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantMinicartGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantMinicartGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/minicart`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (disableRefresh !== undefined) {
                localVarQueryParameter['disableRefresh'] = disableRefresh;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantPut: (tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantPut', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantPut', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2TenantPutRequest' is not null or undefined
            assertParamExists('cartV2TenantPut', 'CartV2TenantPutRequest', CartV2TenantPutRequest);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2TenantPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsDelete: (tenant, Accept_Language, purgeMessages, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantRedpointsDelete', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantRedpointsDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/redpoints`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsPost: (tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantRedpointsPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantRedpointsPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2RedPointsRequestV1' is not null or undefined
            assertParamExists('cartV2TenantRedpointsPost', 'CartV2RedPointsRequestV1', CartV2RedPointsRequestV1);
            const localVarPath = `/cart/v2/{tenant}/redpoints`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2RedPointsRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherPost: (tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantVoucherPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantVoucherPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2VoucherRequestV1' is not null or undefined
            assertParamExists('cartV2TenantVoucherPost', 'CartV2VoucherRequestV1', CartV2VoucherRequestV1);
            const localVarPath = `/cart/v2/{tenant}/voucher`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2VoucherRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} voucherCode
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherVoucherCodeDelete: (tenant, voucherCode, Accept_Language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantVoucherVoucherCodeDelete', 'tenant', tenant);
            // verify required parameter 'voucherCode' is not null or undefined
            assertParamExists('cartV2TenantVoucherVoucherCodeDelete', 'voucherCode', voucherCode);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantVoucherVoucherCodeDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/voucher/{voucherCode}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"voucherCode"}}`, encodeURIComponent(String(voucherCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CartControllerV2Api - functional programming interface
 * @export
 */
export const CartControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CartControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantDelete(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} hashedToken
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {Array<string>} request_body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create multiple cartEntries
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesPost(tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesPost(tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} offerId
         * @param {string} Accept_Language
         * @param {string} prescriptionType
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create or update cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * replace cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryReplacePost(tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntryReplacePost(tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Provides information about the cart data
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet(tenant, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantMetadataGet(tenant, Accept_Language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [disableRefresh]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsPost(tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantRedpointsPost(tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} voucherCode
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CartControllerV2Api - factory interface
 * @export
 */
export const CartControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CartControllerV2ApiFp(configuration);
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {CartControllerV2ApiCartV2TenantDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete(requestParameters, options) {
            return localVarFp.cartV2TenantDelete(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantEntriesERxHashedTokenDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesERxHashedTokenDelete(requestParameters.tenant, requestParameters.hashedToken, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {CartControllerV2ApiCartV2TenantEntriesERxPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesERxPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.request_body, options).then((request) => request(axios, basePath));
        },
        /**
         * create multiple cartEntries
         * @param {CartControllerV2ApiCartV2TenantEntriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesPost(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantEntryOfferIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryOfferIdDelete(requestParameters, options) {
            return localVarFp.cartV2TenantEntryOfferIdDelete(requestParameters.tenant, requestParameters.offerId, requestParameters.Accept_Language, requestParameters.prescriptionType, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * create or update cartEntry
         * @param {CartControllerV2ApiCartV2TenantEntryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryPost(requestParameters, options) {
            return localVarFp.cartV2TenantEntryPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * replace cartEntry
         * @param {CartControllerV2ApiCartV2TenantEntryReplacePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryReplacePost(requestParameters, options) {
            return localVarFp.cartV2TenantEntryReplacePost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartReplaceEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get new or existing cart for customer (including guests)
         * @param {CartControllerV2ApiCartV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet(requestParameters, options) {
            return localVarFp.cartV2TenantGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides information about the cart data
         * @param {CartControllerV2ApiCartV2TenantMetadataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet(requestParameters, options) {
            return localVarFp.cartV2TenantMetadataGet(requestParameters.tenant, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {CartControllerV2ApiCartV2TenantMinicartGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantMinicartGet(requestParameters, options) {
            return localVarFp.cartV2TenantMinicartGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.disableRefresh, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {CartControllerV2ApiCartV2TenantPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantPut(requestParameters, options) {
            return localVarFp.cartV2TenantPut(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantPutRequest, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantRedpointsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsDelete(requestParameters, options) {
            return localVarFp.cartV2TenantRedpointsDelete(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantRedpointsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsPost(requestParameters, options) {
            return localVarFp.cartV2TenantRedpointsPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2RedPointsRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantVoucherPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherPost(requestParameters, options) {
            return localVarFp.cartV2TenantVoucherPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2VoucherRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantVoucherVoucherCodeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherVoucherCodeDelete(requestParameters, options) {
            return localVarFp.cartV2TenantVoucherVoucherCodeDelete(requestParameters.tenant, requestParameters.voucherCode, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CartControllerV2Api - object-oriented interface
 * @export
 * @class CartControllerV2Api
 * @extends {BaseAPI}
 */
export class CartControllerV2Api extends BaseAPI {
    /**
     * Endpoint to delete the existing cart, if it exists
     * @param {CartControllerV2ApiCartV2TenantDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantDelete(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantEntriesERxHashedTokenDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntriesERxHashedTokenDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesERxHashedTokenDelete(requestParameters.tenant, requestParameters.hashedToken, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create or update eRx entries providing eRx hashedTokens
     * @param {CartControllerV2ApiCartV2TenantEntriesERxPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntriesERxPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesERxPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create multiple cartEntries
     * @param {CartControllerV2ApiCartV2TenantEntriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntriesPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantEntryOfferIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntryOfferIdDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntryOfferIdDelete(requestParameters.tenant, requestParameters.offerId, requestParameters.Accept_Language, requestParameters.prescriptionType, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create or update cartEntry
     * @param {CartControllerV2ApiCartV2TenantEntryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntryPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntryPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * replace cartEntry
     * @param {CartControllerV2ApiCartV2TenantEntryReplacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntryReplacePost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntryReplacePost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartReplaceEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get new or existing cart for customer (including guests)
     * @param {CartControllerV2ApiCartV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides information about the cart data
     * @param {CartControllerV2ApiCartV2TenantMetadataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantMetadataGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantMetadataGet(requestParameters.tenant, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {CartControllerV2ApiCartV2TenantMinicartGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantMinicartGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantMinicartGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.disableRefresh, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {CartControllerV2ApiCartV2TenantPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantPut(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantPut(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantPutRequest, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantRedpointsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantRedpointsDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantRedpointsDelete(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantRedpointsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantRedpointsPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantRedpointsPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2RedPointsRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantVoucherPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantVoucherPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantVoucherPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2VoucherRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantVoucherVoucherCodeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantVoucherVoucherCodeDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantVoucherVoucherCodeDelete(requestParameters.tenant, requestParameters.voucherCode, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CartControllerV3Api - axios parameter creator
 * @export
 */
export const CartControllerV3ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartGetCartLocalized: (language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('cartServiceCartGetCartLocalized', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartServiceCartGetCartLocalized', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartServiceCartGetCartLocalized', 'Accept_Language', Accept_Language);
            const localVarPath = `/{language}/cart/v3/{tenant}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create or update cartEntry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostCartEntryLocalized: (language, tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('cartServiceCartPostCartEntryLocalized', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartServiceCartPostCartEntryLocalized', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartServiceCartPostCartEntryLocalized', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntryRequestV1' is not null or undefined
            assertParamExists('cartServiceCartPostCartEntryLocalized', 'CartV2CartEntryRequestV1', CartV2CartEntryRequestV1);
            const localVarPath = `/{language}/cart/v3/{tenant}/entry`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntryRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create multiple cartEntries
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntriesPost: (language, tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantEntriesPost', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantEntriesPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantEntriesPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntriesRequestV1' is not null or undefined
            assertParamExists('languageCartV3TenantEntriesPost', 'CartV2CartEntriesRequestV1', CartV2CartEntriesRequestV1);
            const localVarPath = `/{language}/cart/v3/{tenant}/entries`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntriesRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} offerId
         * @param {string} Accept_Language
         * @param {string} prescriptionType
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntryOfferIdDelete: (language, tenant, offerId, Accept_Language, prescriptionType, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantEntryOfferIdDelete', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantEntryOfferIdDelete', 'tenant', tenant);
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('languageCartV3TenantEntryOfferIdDelete', 'offerId', offerId);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantEntryOfferIdDelete', 'Accept_Language', Accept_Language);
            // verify required parameter 'prescriptionType' is not null or undefined
            assertParamExists('languageCartV3TenantEntryOfferIdDelete', 'prescriptionType', prescriptionType);
            const localVarPath = `/{language}/cart/v3/{tenant}/entry/{offerId}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (prescriptionType !== undefined) {
                localVarQueryParameter['prescriptionType'] = prescriptionType;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * replace cartEntry
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntryReplacePost: (language, tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, includeMaxDosage, isNowSelected, slotId, distributionType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantEntryReplacePost', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantEntryReplacePost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantEntryReplacePost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartReplaceEntryRequestV1' is not null or undefined
            assertParamExists('languageCartV3TenantEntryReplacePost', 'CartV2CartReplaceEntryRequestV1', CartV2CartReplaceEntryRequestV1);
            const localVarPath = `/{language}/cart/v3/{tenant}/entry/replace`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartReplaceEntryRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [disableRefresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantMinicartGet: (language, tenant, Accept_Language, disableRefresh, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantMinicartGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantMinicartGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantMinicartGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/{language}/cart/v3/{tenant}/minicart`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (disableRefresh !== undefined) {
                localVarQueryParameter['disableRefresh'] = disableRefresh;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantPut: (language, tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantPut', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantPut', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantPut', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2TenantPutRequest' is not null or undefined
            assertParamExists('languageCartV3TenantPut', 'CartV2TenantPutRequest', CartV2TenantPutRequest);
            const localVarPath = `/{language}/cart/v3/{tenant}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2TenantPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantRedpointsDelete: (language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantRedpointsDelete', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantRedpointsDelete', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantRedpointsDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/{language}/cart/v3/{tenant}/redpoints`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantRedpointsPost: (language, tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantRedpointsPost', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantRedpointsPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantRedpointsPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2RedPointsRequestV1' is not null or undefined
            assertParamExists('languageCartV3TenantRedpointsPost', 'CartV2RedPointsRequestV1', CartV2RedPointsRequestV1);
            const localVarPath = `/{language}/cart/v3/{tenant}/redpoints`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2RedPointsRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantVoucherPost: (language, tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherPost', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2VoucherRequestV1' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherPost', 'CartV2VoucherRequestV1', CartV2VoucherRequestV1);
            const localVarPath = `/{language}/cart/v3/{tenant}/voucher`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2VoucherRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} voucherCode
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantVoucherVoucherCodeDelete: (language, tenant, voucherCode, Accept_Language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherVoucherCodeDelete', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherVoucherCodeDelete', 'tenant', tenant);
            // verify required parameter 'voucherCode' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherVoucherCodeDelete', 'voucherCode', voucherCode);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('languageCartV3TenantVoucherVoucherCodeDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/{language}/cart/v3/{tenant}/voucher/{voucherCode}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"voucherCode"}}`, encodeURIComponent(String(voucherCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CartControllerV3Api - functional programming interface
 * @export
 */
export const CartControllerV3ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CartControllerV3ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartGetCartLocalized(language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartServiceCartGetCartLocalized(language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create or update cartEntry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostCartEntryLocalized(language, tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartServiceCartPostCartEntryLocalized(language, tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create multiple cartEntries
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntriesPost(language, tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantEntriesPost(language, tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} offerId
         * @param {string} Accept_Language
         * @param {string} prescriptionType
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntryOfferIdDelete(language, tenant, offerId, Accept_Language, prescriptionType, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantEntryOfferIdDelete(language, tenant, offerId, Accept_Language, prescriptionType, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * replace cartEntry
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntryReplacePost(language, tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, includeMaxDosage, isNowSelected, slotId, distributionType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantEntryReplacePost(language, tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, includeMaxDosage, isNowSelected, slotId, distributionType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [disableRefresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantMinicartGet(language, tenant, Accept_Language, disableRefresh, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantMinicartGet(language, tenant, Accept_Language, disableRefresh, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantPut(language, tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantPut(language, tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantRedpointsDelete(language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantRedpointsDelete(language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantRedpointsPost(language, tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantRedpointsPost(language, tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {'none' | 'delivery' | 'pickup'} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantVoucherPost(language, tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantVoucherPost(language, tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} voucherCode
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantVoucherVoucherCodeDelete(language, tenant, voucherCode, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV3TenantVoucherVoucherCodeDelete(language, tenant, voucherCode, Accept_Language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CartControllerV3Api - factory interface
 * @export
 */
export const CartControllerV3ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CartControllerV3ApiFp(configuration);
    return {
        /**
         * Get new or existing cart for customer (including guests)
         * @param {CartControllerV3ApiCartServiceCartGetCartLocalizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartGetCartLocalized(requestParameters, options) {
            return localVarFp.cartServiceCartGetCartLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.includeMaxDosage, requestParameters.distributionType, options).then((request) => request(axios, basePath));
        },
        /**
         * create or update cartEntry
         * @param {CartControllerV3ApiCartServiceCartPostCartEntryLocalizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostCartEntryLocalized(requestParameters, options) {
            return localVarFp.cartServiceCartPostCartEntryLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(axios, basePath));
        },
        /**
         * create multiple cartEntries
         * @param {CartControllerV3ApiLanguageCartV3TenantEntriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntriesPost(requestParameters, options) {
            return localVarFp.languageCartV3TenantEntriesPost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV3ApiLanguageCartV3TenantEntryOfferIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntryOfferIdDelete(requestParameters, options) {
            return localVarFp.languageCartV3TenantEntryOfferIdDelete(requestParameters.language, requestParameters.tenant, requestParameters.offerId, requestParameters.Accept_Language, requestParameters.prescriptionType, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(axios, basePath));
        },
        /**
         * replace cartEntry
         * @param {CartControllerV3ApiLanguageCartV3TenantEntryReplacePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantEntryReplacePost(requestParameters, options) {
            return localVarFp.languageCartV3TenantEntryReplacePost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartReplaceEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.includeMaxDosage, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {CartControllerV3ApiLanguageCartV3TenantMinicartGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantMinicartGet(requestParameters, options) {
            return localVarFp.languageCartV3TenantMinicartGet(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.disableRefresh, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {CartControllerV3ApiLanguageCartV3TenantPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantPut(requestParameters, options) {
            return localVarFp.languageCartV3TenantPut(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantPutRequest, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.includeMaxDosage, requestParameters.distributionType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV3ApiLanguageCartV3TenantRedpointsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantRedpointsDelete(requestParameters, options) {
            return localVarFp.languageCartV3TenantRedpointsDelete(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV3ApiLanguageCartV3TenantRedpointsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantRedpointsPost(requestParameters, options) {
            return localVarFp.languageCartV3TenantRedpointsPost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2RedPointsRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV3ApiLanguageCartV3TenantVoucherPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantVoucherPost(requestParameters, options) {
            return localVarFp.languageCartV3TenantVoucherPost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2VoucherRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV3ApiLanguageCartV3TenantVoucherVoucherCodeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV3TenantVoucherVoucherCodeDelete(requestParameters, options) {
            return localVarFp.languageCartV3TenantVoucherVoucherCodeDelete(requestParameters.language, requestParameters.tenant, requestParameters.voucherCode, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CartControllerV3Api - object-oriented interface
 * @export
 * @class CartControllerV3Api
 * @extends {BaseAPI}
 */
export class CartControllerV3Api extends BaseAPI {
    /**
     * Get new or existing cart for customer (including guests)
     * @param {CartControllerV3ApiCartServiceCartGetCartLocalizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    cartServiceCartGetCartLocalized(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).cartServiceCartGetCartLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.includeMaxDosage, requestParameters.distributionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create or update cartEntry
     * @param {CartControllerV3ApiCartServiceCartPostCartEntryLocalizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    cartServiceCartPostCartEntryLocalized(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).cartServiceCartPostCartEntryLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create multiple cartEntries
     * @param {CartControllerV3ApiLanguageCartV3TenantEntriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantEntriesPost(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantEntriesPost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV3ApiLanguageCartV3TenantEntryOfferIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantEntryOfferIdDelete(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantEntryOfferIdDelete(requestParameters.language, requestParameters.tenant, requestParameters.offerId, requestParameters.Accept_Language, requestParameters.prescriptionType, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * replace cartEntry
     * @param {CartControllerV3ApiLanguageCartV3TenantEntryReplacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantEntryReplacePost(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantEntryReplacePost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartReplaceEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.includeMaxDosage, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {CartControllerV3ApiLanguageCartV3TenantMinicartGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantMinicartGet(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantMinicartGet(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.disableRefresh, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {CartControllerV3ApiLanguageCartV3TenantPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantPut(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantPut(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantPutRequest, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.includeMaxDosage, requestParameters.distributionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV3ApiLanguageCartV3TenantRedpointsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantRedpointsDelete(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantRedpointsDelete(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV3ApiLanguageCartV3TenantRedpointsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantRedpointsPost(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantRedpointsPost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2RedPointsRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV3ApiLanguageCartV3TenantVoucherPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantVoucherPost(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantVoucherPost(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2VoucherRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV3ApiLanguageCartV3TenantVoucherVoucherCodeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV3Api
     */
    languageCartV3TenantVoucherVoucherCodeDelete(requestParameters, options) {
        return CartControllerV3ApiFp(this.configuration).languageCartV3TenantVoucherVoucherCodeDelete(requestParameters.language, requestParameters.tenant, requestParameters.voucherCode, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CartControllerV4Api - axios parameter creator
 * @export
 */
export const CartControllerV4ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * get total number of entries in the cart
         * @param {string} language
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV4TenantMinicartGet: (language, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV4TenantMinicartGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV4TenantMinicartGet', 'tenant', tenant);
            const localVarPath = `/{language}/cart/v4/{tenant}/minicart`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CartControllerV4Api - functional programming interface
 * @export
 */
export const CartControllerV4ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CartControllerV4ApiAxiosParamCreator(configuration);
    return {
        /**
         * get total number of entries in the cart
         * @param {string} language
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV4TenantMinicartGet(language, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV4TenantMinicartGet(language, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CartControllerV4Api - factory interface
 * @export
 */
export const CartControllerV4ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CartControllerV4ApiFp(configuration);
    return {
        /**
         * get total number of entries in the cart
         * @param {CartControllerV4ApiLanguageCartV4TenantMinicartGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV4TenantMinicartGet(requestParameters, options) {
            return localVarFp.languageCartV4TenantMinicartGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CartControllerV4Api - object-oriented interface
 * @export
 * @class CartControllerV4Api
 * @extends {BaseAPI}
 */
export class CartControllerV4Api extends BaseAPI {
    /**
     * get total number of entries in the cart
     * @param {CartControllerV4ApiLanguageCartV4TenantMinicartGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV4Api
     */
    languageCartV4TenantMinicartGet(requestParameters, options) {
        return CartControllerV4ApiFp(this.configuration).languageCartV4TenantMinicartGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CategoriesControllerApi - axios parameter creator
 * @export
 */
export const CategoriesControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCategoriesV2TenantGet: (tenant, language, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCategoriesV2TenantGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCategoriesV2TenantGet', 'language', language);
            const localVarPath = `/{language}/categories/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCategoriesV2TenantIdGet: (id, tenant, language, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageCategoriesV2TenantIdGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCategoriesV2TenantIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCategoriesV2TenantIdGet', 'language', language);
            const localVarPath = `/{language}/categories/v2/{tenant}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CategoriesControllerApi - functional programming interface
 * @export
 */
export const CategoriesControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CategoriesControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCategoriesV2TenantGet(tenant, language, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCategoriesV2TenantGet(tenant, language, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCategoriesV2TenantIdGet(id, tenant, language, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCategoriesV2TenantIdGet(id, tenant, language, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CategoriesControllerApi - factory interface
 * @export
 */
export const CategoriesControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CategoriesControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CategoriesControllerApiLanguageCategoriesV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCategoriesV2TenantGet(requestParameters, options) {
            return localVarFp.languageCategoriesV2TenantGet(requestParameters.tenant, requestParameters.language, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CategoriesControllerApiLanguageCategoriesV2TenantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCategoriesV2TenantIdGet(requestParameters, options) {
            return localVarFp.languageCategoriesV2TenantIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CategoriesControllerApi - object-oriented interface
 * @export
 * @class CategoriesControllerApi
 * @extends {BaseAPI}
 */
export class CategoriesControllerApi extends BaseAPI {
    /**
     *
     * @param {CategoriesControllerApiLanguageCategoriesV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesControllerApi
     */
    languageCategoriesV2TenantGet(requestParameters, options) {
        return CategoriesControllerApiFp(this.configuration).languageCategoriesV2TenantGet(requestParameters.tenant, requestParameters.language, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CategoriesControllerApiLanguageCategoriesV2TenantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesControllerApi
     */
    languageCategoriesV2TenantIdGet(requestParameters, options) {
        return CategoriesControllerApiFp(this.configuration).languageCategoriesV2TenantIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CheckoutControllerV1Api - axios parameter creator
 * @export
 */
export const CheckoutControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Unset chosen payment for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftDeletePayment: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftDeletePayment', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftDeletePayment', 'orderDraftId', orderDraftId);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/payment`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get existing order draft with orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftGetDraft: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftGetDraft', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftGetDraft', 'orderDraftId', orderDraftId);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutOrderMasterDataRequestV1} CheckoutOrderMasterDataRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPatchOrderMasterData: (tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPatchOrderMasterData', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPatchOrderMasterData', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutOrderMasterDataRequestV1' is not null or undefined
            assertParamExists('bullyDraftPatchOrderMasterData', 'CheckoutOrderMasterDataRequestV1', CheckoutOrderMasterDataRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/orderMasterData`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutOrderMasterDataRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update or set billing address for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutBillingAddressRequestV1} CheckoutBillingAddressRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutBillingAddress: (tenant, orderDraftId, CheckoutBillingAddressRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutBillingAddress', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutBillingAddress', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutBillingAddressRequestV1' is not null or undefined
            assertParamExists('bullyDraftPutBillingAddress', 'CheckoutBillingAddressRequestV1', CheckoutBillingAddressRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/billingAddress`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutBillingAddressRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update or set chosen carrier for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutCarrierRequestBody} CheckoutCarrierRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutCarrier: (tenant, orderDraftId, CheckoutCarrierRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutCarrier', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutCarrier', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutCarrierRequestBody' is not null or undefined
            assertParamExists('bullyDraftPutCarrier', 'CheckoutCarrierRequestBody', CheckoutCarrierRequestBody);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/carrier`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutCarrierRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPutCarriers: (tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutCarriers', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutCarriers', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutCarrierListUpdateRequestBody' is not null or undefined
            assertParamExists('bullyDraftPutCarriers', 'CheckoutCarrierListUpdateRequestBody', CheckoutCarrierListUpdateRequestBody);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/carriers`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutCarrierListUpdateRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update or set chosen payment for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutPaymentRequest} CheckoutPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutPayment: (tenant, orderDraftId, CheckoutPaymentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutPayment', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutPayment', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutPaymentRequest' is not null or undefined
            assertParamExists('bullyDraftPutPayment', 'CheckoutPaymentRequest', CheckoutPaymentRequest);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/payment`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutPaymentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutPhoneNumberRequestV1} CheckoutPhoneNumberRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutPhoneNumber: (tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutPhoneNumber', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutPhoneNumber', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutPhoneNumberRequestV1' is not null or undefined
            assertParamExists('bullyDraftPutPhoneNumber', 'CheckoutPhoneNumberRequestV1', CheckoutPhoneNumberRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/phoneNumber`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutPhoneNumberRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update or set shipping address for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPutShippingAddress: (tenant, orderDraftId, CheckoutShippingAddressRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutShippingAddress', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutShippingAddress', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutShippingAddressRequestV1' is not null or undefined
            assertParamExists('bullyDraftPutShippingAddress', 'CheckoutShippingAddressRequestV1', CheckoutShippingAddressRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/shippingAddress`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutShippingAddressRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates orderDraft with payment that is allowed for zero amount order
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutZeroAmountPayment: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutZeroAmountPayment', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutZeroAmountPayment', 'orderDraftId', orderDraftId);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/zeroAmountPayment`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Validates the vatNumber and updates orderDraft prices for professional customers
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdApplyVatPut: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdApplyVatPut', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdApplyVatPut', 'orderDraftId', orderDraftId);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/applyVat`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Determines price change on the fly for the given carrier (Does not persist to order draft)
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutCarrierListCalculatePriceRequestBody} CheckoutCarrierListCalculatePriceRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdCarrierCalculatePricePost: (tenant, orderDraftId, CheckoutCarrierListCalculatePriceRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdCarrierCalculatePricePost', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdCarrierCalculatePricePost', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutCarrierListCalculatePriceRequestBody' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdCarrierCalculatePricePost', 'CheckoutCarrierListCalculatePriceRequestBody', CheckoutCarrierListCalculatePriceRequestBody);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/carrier/calculatePrice`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutCarrierListCalculatePriceRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates order from order-draft.
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {string} Accept_Language
         * @param {CheckoutSubmitOrderRequestV1} CheckoutSubmitOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdOrderPost: (tenant, orderDraftId, Accept_Language, CheckoutSubmitOrderRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdOrderPost', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdOrderPost', 'orderDraftId', orderDraftId);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdOrderPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CheckoutSubmitOrderRequestV1' is not null or undefined
            assertParamExists('checkoutV1TenantOrderDraftIdOrderPost', 'CheckoutSubmitOrderRequestV1', CheckoutSubmitOrderRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/{orderDraftId}/order`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutSubmitOrderRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new checkout process
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CheckoutCreateDataRequestV1} [CheckoutCreateDataRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantPost: (tenant, Accept_Language, CheckoutCreateDataRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('checkoutV1TenantPost', 'Accept_Language', Accept_Language);
            const localVarPath = `/checkout/v1/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutCreateDataRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {string} Accept_Language
         * @param {QuickCheckoutSubmitOrderRequestV1} QuickCheckoutSubmitOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdOrderPost: (tenant, orderDraftId, Accept_Language, QuickCheckoutSubmitOrderRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdOrderPost', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdOrderPost', 'orderDraftId', orderDraftId);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdOrderPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'QuickCheckoutSubmitOrderRequestV1' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdOrderPost', 'QuickCheckoutSubmitOrderRequestV1', QuickCheckoutSubmitOrderRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/quick/{orderDraftId}/order`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(QuickCheckoutSubmitOrderRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Change the orderType field in the sub-orders from Integration Quick Checkout
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {OrderTypeQuickCheckoutOrderRequestV1} OrderTypeQuickCheckoutOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdOrderTypePatch: (tenant, orderDraftId, OrderTypeQuickCheckoutOrderRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdOrderTypePatch', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdOrderTypePatch', 'orderDraftId', orderDraftId);
            // verify required parameter 'OrderTypeQuickCheckoutOrderRequestV1' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdOrderTypePatch', 'OrderTypeQuickCheckoutOrderRequestV1', OrderTypeQuickCheckoutOrderRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/quick/{orderDraftId}/order-type`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OrderTypeQuickCheckoutOrderRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {string} Accept_Language
         * @param {PreAuthedQuickCheckoutSubmitOrderRequestV1} PreAuthedQuickCheckoutSubmitOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost: (tenant, orderDraftId, Accept_Language, PreAuthedQuickCheckoutSubmitOrderRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost', 'orderDraftId', orderDraftId);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'PreAuthedQuickCheckoutSubmitOrderRequestV1' is not null or undefined
            assertParamExists('checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost', 'PreAuthedQuickCheckoutSubmitOrderRequestV1', PreAuthedQuickCheckoutSubmitOrderRequestV1);
            const localVarPath = `/checkout/v1/{tenant}/quick/{orderDraftId}/pre-authed-order`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PreAuthedQuickCheckoutSubmitOrderRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new quick ERX checkout process
         * @param {string} tenant
         * @param {HashedTokensPayload} HashedTokensPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickPost: (tenant, HashedTokensPayload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('checkoutV1TenantQuickPost', 'tenant', tenant);
            // verify required parameter 'HashedTokensPayload' is not null or undefined
            assertParamExists('checkoutV1TenantQuickPost', 'HashedTokensPayload', HashedTokensPayload);
            const localVarPath = `/checkout/v1/{tenant}/quick`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(HashedTokensPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CheckoutControllerV1Api - functional programming interface
 * @export
 */
export const CheckoutControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CheckoutControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Unset chosen payment for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftDeletePayment(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftDeletePayment(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get existing order draft with orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftGetDraft(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftGetDraft(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutOrderMasterDataRequestV1} CheckoutOrderMasterDataRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPatchOrderMasterData(tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPatchOrderMasterData(tenant, orderDraftId, CheckoutOrderMasterDataRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update or set billing address for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutBillingAddressRequestV1} CheckoutBillingAddressRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutBillingAddress(tenant, orderDraftId, CheckoutBillingAddressRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutBillingAddress(tenant, orderDraftId, CheckoutBillingAddressRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update or set chosen carrier for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutCarrierRequestBody} CheckoutCarrierRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutCarrier(tenant, orderDraftId, CheckoutCarrierRequestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutCarrier(tenant, orderDraftId, CheckoutCarrierRequestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPutCarriers(tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutCarriers(tenant, orderDraftId, CheckoutCarrierListUpdateRequestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update or set chosen payment for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutPaymentRequest} CheckoutPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutPayment(tenant, orderDraftId, CheckoutPaymentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutPayment(tenant, orderDraftId, CheckoutPaymentRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutPhoneNumberRequestV1} CheckoutPhoneNumberRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutPhoneNumber(tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutPhoneNumber(tenant, orderDraftId, CheckoutPhoneNumberRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update or set shipping address for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPutShippingAddress(tenant, orderDraftId, CheckoutShippingAddressRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutShippingAddress(tenant, orderDraftId, CheckoutShippingAddressRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Updates orderDraft with payment that is allowed for zero amount order
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutZeroAmountPayment(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutZeroAmountPayment(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Validates the vatNumber and updates orderDraft prices for professional customers
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdApplyVatPut(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantOrderDraftIdApplyVatPut(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Determines price change on the fly for the given carrier (Does not persist to order draft)
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {CheckoutCarrierListCalculatePriceRequestBody} CheckoutCarrierListCalculatePriceRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(tenant, orderDraftId, CheckoutCarrierListCalculatePriceRequestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(tenant, orderDraftId, CheckoutCarrierListCalculatePriceRequestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Creates order from order-draft.
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {string} Accept_Language
         * @param {CheckoutSubmitOrderRequestV1} CheckoutSubmitOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdOrderPost(tenant, orderDraftId, Accept_Language, CheckoutSubmitOrderRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantOrderDraftIdOrderPost(tenant, orderDraftId, Accept_Language, CheckoutSubmitOrderRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create new checkout process
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CheckoutCreateDataRequestV1} [CheckoutCreateDataRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantPost(tenant, Accept_Language, CheckoutCreateDataRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantPost(tenant, Accept_Language, CheckoutCreateDataRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {string} Accept_Language
         * @param {QuickCheckoutSubmitOrderRequestV1} QuickCheckoutSubmitOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdOrderPost(tenant, orderDraftId, Accept_Language, QuickCheckoutSubmitOrderRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantQuickOrderDraftIdOrderPost(tenant, orderDraftId, Accept_Language, QuickCheckoutSubmitOrderRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Change the orderType field in the sub-orders from Integration Quick Checkout
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {OrderTypeQuickCheckoutOrderRequestV1} OrderTypeQuickCheckoutOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdOrderTypePatch(tenant, orderDraftId, OrderTypeQuickCheckoutOrderRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantQuickOrderDraftIdOrderTypePatch(tenant, orderDraftId, OrderTypeQuickCheckoutOrderRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
         * @param {string} tenant
         * @param {string} orderDraftId
         * @param {string} Accept_Language
         * @param {PreAuthedQuickCheckoutSubmitOrderRequestV1} PreAuthedQuickCheckoutSubmitOrderRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(tenant, orderDraftId, Accept_Language, PreAuthedQuickCheckoutSubmitOrderRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(tenant, orderDraftId, Accept_Language, PreAuthedQuickCheckoutSubmitOrderRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create new quick ERX checkout process
         * @param {string} tenant
         * @param {HashedTokensPayload} HashedTokensPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickPost(tenant, HashedTokensPayload, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkoutV1TenantQuickPost(tenant, HashedTokensPayload, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CheckoutControllerV1Api - factory interface
 * @export
 */
export const CheckoutControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CheckoutControllerV1ApiFp(configuration);
    return {
        /**
         * Unset chosen payment for checkoutId / orderDraftId
         * @param {CheckoutControllerV1ApiBullyDraftDeletePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftDeletePayment(requestParameters, options) {
            return localVarFp.bullyDraftDeletePayment(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get existing order draft with orderDraftId
         * @param {CheckoutControllerV1ApiBullyDraftGetDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftGetDraft(requestParameters, options) {
            return localVarFp.bullyDraftGetDraft(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
         * @param {CheckoutControllerV1ApiBullyDraftPatchOrderMasterDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPatchOrderMasterData(requestParameters, options) {
            return localVarFp.bullyDraftPatchOrderMasterData(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutOrderMasterDataRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Update or set billing address for checkoutId / orderDraftId
         * @param {CheckoutControllerV1ApiBullyDraftPutBillingAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutBillingAddress(requestParameters, options) {
            return localVarFp.bullyDraftPutBillingAddress(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutBillingAddressRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Update or set chosen carrier for checkoutId / orderDraftId
         * @param {CheckoutControllerV1ApiBullyDraftPutCarrierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutCarrier(requestParameters, options) {
            return localVarFp.bullyDraftPutCarrier(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutCarrierRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
         * @param {CheckoutControllerV1ApiBullyDraftPutCarriersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPutCarriers(requestParameters, options) {
            return localVarFp.bullyDraftPutCarriers(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutCarrierListUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update or set chosen payment for checkoutId / orderDraftId
         * @param {CheckoutControllerV1ApiBullyDraftPutPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutPayment(requestParameters, options) {
            return localVarFp.bullyDraftPutPayment(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
         * @param {CheckoutControllerV1ApiBullyDraftPutPhoneNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutPhoneNumber(requestParameters, options) {
            return localVarFp.bullyDraftPutPhoneNumber(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutPhoneNumberRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Update or set shipping address for checkoutId / orderDraftId
         * @param {CheckoutControllerV1ApiBullyDraftPutShippingAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bullyDraftPutShippingAddress(requestParameters, options) {
            return localVarFp.bullyDraftPutShippingAddress(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutShippingAddressRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates orderDraft with payment that is allowed for zero amount order
         * @param {CheckoutControllerV1ApiBullyDraftPutZeroAmountPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutZeroAmountPayment(requestParameters, options) {
            return localVarFp.bullyDraftPutZeroAmountPayment(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the vatNumber and updates orderDraft prices for professional customers
         * @param {CheckoutControllerV1ApiCheckoutV1TenantOrderDraftIdApplyVatPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdApplyVatPut(requestParameters, options) {
            return localVarFp.checkoutV1TenantOrderDraftIdApplyVatPut(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         * Determines price change on the fly for the given carrier (Does not persist to order draft)
         * @param {CheckoutControllerV1ApiCheckoutV1TenantOrderDraftIdCarrierCalculatePricePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(requestParameters, options) {
            return localVarFp.checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutCarrierListCalculatePriceRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates order from order-draft.
         * @param {CheckoutControllerV1ApiCheckoutV1TenantOrderDraftIdOrderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantOrderDraftIdOrderPost(requestParameters, options) {
            return localVarFp.checkoutV1TenantOrderDraftIdOrderPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.Accept_Language, requestParameters.CheckoutSubmitOrderRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new checkout process
         * @param {CheckoutControllerV1ApiCheckoutV1TenantPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantPost(requestParameters, options) {
            return localVarFp.checkoutV1TenantPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CheckoutCreateDataRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
         * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickOrderDraftIdOrderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdOrderPost(requestParameters, options) {
            return localVarFp.checkoutV1TenantQuickOrderDraftIdOrderPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.Accept_Language, requestParameters.QuickCheckoutSubmitOrderRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the orderType field in the sub-orders from Integration Quick Checkout
         * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickOrderDraftIdOrderTypePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdOrderTypePatch(requestParameters, options) {
            return localVarFp.checkoutV1TenantQuickOrderDraftIdOrderTypePatch(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.OrderTypeQuickCheckoutOrderRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
         * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickOrderDraftIdPreAuthedOrderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(requestParameters, options) {
            return localVarFp.checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.Accept_Language, requestParameters.PreAuthedQuickCheckoutSubmitOrderRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new quick ERX checkout process
         * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutV1TenantQuickPost(requestParameters, options) {
            return localVarFp.checkoutV1TenantQuickPost(requestParameters.tenant, requestParameters.HashedTokensPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CheckoutControllerV1Api - object-oriented interface
 * @export
 * @class CheckoutControllerV1Api
 * @extends {BaseAPI}
 */
export class CheckoutControllerV1Api extends BaseAPI {
    /**
     * Unset chosen payment for checkoutId / orderDraftId
     * @param {CheckoutControllerV1ApiBullyDraftDeletePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftDeletePayment(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftDeletePayment(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get existing order draft with orderDraftId
     * @param {CheckoutControllerV1ApiBullyDraftGetDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftGetDraft(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftGetDraft(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * As the flag is now set while starting the checkout this endpoint is deprecated! Sets prescriptionFollows flag on draft\'s orderMasterData
     * @param {CheckoutControllerV1ApiBullyDraftPatchOrderMasterDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPatchOrderMasterData(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPatchOrderMasterData(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutOrderMasterDataRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update or set billing address for checkoutId / orderDraftId
     * @param {CheckoutControllerV1ApiBullyDraftPutBillingAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPutBillingAddress(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPutBillingAddress(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutBillingAddressRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update or set chosen carrier for checkoutId / orderDraftId
     * @param {CheckoutControllerV1ApiBullyDraftPutCarrierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPutCarrier(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPutCarrier(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutCarrierRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
     * @param {CheckoutControllerV1ApiBullyDraftPutCarriersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPutCarriers(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPutCarriers(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutCarrierListUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update or set chosen payment for checkoutId / orderDraftId
     * @param {CheckoutControllerV1ApiBullyDraftPutPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPutPayment(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPutPayment(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update customer\'s phone number in checkout billing address step for billingAddressId / orderDraftId
     * @param {CheckoutControllerV1ApiBullyDraftPutPhoneNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPutPhoneNumber(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPutPhoneNumber(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutPhoneNumberRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update or set shipping address for checkoutId / orderDraftId
     * @param {CheckoutControllerV1ApiBullyDraftPutShippingAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPutShippingAddress(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPutShippingAddress(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutShippingAddressRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates orderDraft with payment that is allowed for zero amount order
     * @param {CheckoutControllerV1ApiBullyDraftPutZeroAmountPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    bullyDraftPutZeroAmountPayment(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).bullyDraftPutZeroAmountPayment(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Validates the vatNumber and updates orderDraft prices for professional customers
     * @param {CheckoutControllerV1ApiCheckoutV1TenantOrderDraftIdApplyVatPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantOrderDraftIdApplyVatPut(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantOrderDraftIdApplyVatPut(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Determines price change on the fly for the given carrier (Does not persist to order draft)
     * @param {CheckoutControllerV1ApiCheckoutV1TenantOrderDraftIdCarrierCalculatePricePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantOrderDraftIdCarrierCalculatePricePost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.CheckoutCarrierListCalculatePriceRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates order from order-draft.
     * @param {CheckoutControllerV1ApiCheckoutV1TenantOrderDraftIdOrderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantOrderDraftIdOrderPost(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantOrderDraftIdOrderPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.Accept_Language, requestParameters.CheckoutSubmitOrderRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new checkout process
     * @param {CheckoutControllerV1ApiCheckoutV1TenantPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantPost(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CheckoutCreateDataRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates order from order-draft (for use with QuickCheckout non-logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-916)
     * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickOrderDraftIdOrderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantQuickOrderDraftIdOrderPost(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantQuickOrderDraftIdOrderPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.Accept_Language, requestParameters.QuickCheckoutSubmitOrderRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change the orderType field in the sub-orders from Integration Quick Checkout
     * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickOrderDraftIdOrderTypePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantQuickOrderDraftIdOrderTypePatch(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantQuickOrderDraftIdOrderTypePatch(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.OrderTypeQuickCheckoutOrderRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates order from order-draft (for use with QuickCheckout logged-in flow). [See more](https://jira.shop-apotheke.com/browse/WSSSH-518)
     * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickOrderDraftIdPreAuthedOrderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantQuickOrderDraftIdPreAuthedOrderPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.Accept_Language, requestParameters.PreAuthedQuickCheckoutSubmitOrderRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new quick ERX checkout process
     * @param {CheckoutControllerV1ApiCheckoutV1TenantQuickPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV1Api
     */
    checkoutV1TenantQuickPost(requestParameters, options) {
        return CheckoutControllerV1ApiFp(this.configuration).checkoutV1TenantQuickPost(requestParameters.tenant, requestParameters.HashedTokensPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CheckoutControllerV2Api - axios parameter creator
 * @export
 */
export const CheckoutControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
         * @param {string} tenant
         * @param {string} language
         * @param {string} orderDraftId
         * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutCarriersV2: (tenant, language, orderDraftId, CheckoutCarrierListUpdateRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutCarriersV2', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('bullyDraftPutCarriersV2', 'language', language);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutCarriersV2', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutCarrierListUpdateRequestBody' is not null or undefined
            assertParamExists('bullyDraftPutCarriersV2', 'CheckoutCarrierListUpdateRequestBody', CheckoutCarrierListUpdateRequestBody);
            const localVarPath = `/checkout/v2/{tenant}/{language}/{orderDraftId}/carriers`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutCarrierListUpdateRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update or set shipping address for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} language
         * @param {string} orderDraftId
         * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutShippingAddressV2: (tenant, language, orderDraftId, CheckoutShippingAddressRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyDraftPutShippingAddressV2', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('bullyDraftPutShippingAddressV2', 'language', language);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('bullyDraftPutShippingAddressV2', 'orderDraftId', orderDraftId);
            // verify required parameter 'CheckoutShippingAddressRequestV1' is not null or undefined
            assertParamExists('bullyDraftPutShippingAddressV2', 'CheckoutShippingAddressRequestV1', CheckoutShippingAddressRequestV1);
            const localVarPath = `/checkout/v2/{tenant}/{language}/{orderDraftId}/shippingAddress`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CheckoutShippingAddressRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CheckoutControllerV2Api - functional programming interface
 * @export
 */
export const CheckoutControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CheckoutControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
         * @param {string} tenant
         * @param {string} language
         * @param {string} orderDraftId
         * @param {CheckoutCarrierListUpdateRequestBody} CheckoutCarrierListUpdateRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutCarriersV2(tenant, language, orderDraftId, CheckoutCarrierListUpdateRequestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutCarriersV2(tenant, language, orderDraftId, CheckoutCarrierListUpdateRequestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update or set shipping address for checkoutId / orderDraftId
         * @param {string} tenant
         * @param {string} language
         * @param {string} orderDraftId
         * @param {CheckoutShippingAddressRequestV1} CheckoutShippingAddressRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutShippingAddressV2(tenant, language, orderDraftId, CheckoutShippingAddressRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyDraftPutShippingAddressV2(tenant, language, orderDraftId, CheckoutShippingAddressRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CheckoutControllerV2Api - factory interface
 * @export
 */
export const CheckoutControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CheckoutControllerV2ApiFp(configuration);
    return {
        /**
         * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
         * @param {CheckoutControllerV2ApiBullyDraftPutCarriersV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutCarriersV2(requestParameters, options) {
            return localVarFp.bullyDraftPutCarriersV2(requestParameters.tenant, requestParameters.language, requestParameters.orderDraftId, requestParameters.CheckoutCarrierListUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update or set shipping address for checkoutId / orderDraftId
         * @param {CheckoutControllerV2ApiBullyDraftPutShippingAddressV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyDraftPutShippingAddressV2(requestParameters, options) {
            return localVarFp.bullyDraftPutShippingAddressV2(requestParameters.tenant, requestParameters.language, requestParameters.orderDraftId, requestParameters.CheckoutShippingAddressRequestV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CheckoutControllerV2Api - object-oriented interface
 * @export
 * @class CheckoutControllerV2Api
 * @extends {BaseAPI}
 */
export class CheckoutControllerV2Api extends BaseAPI {
    /**
     * updates carriers (standard, market place and now) in orderDraft given orderDraftId, subOrderId and carrierList.
     * @param {CheckoutControllerV2ApiBullyDraftPutCarriersV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV2Api
     */
    bullyDraftPutCarriersV2(requestParameters, options) {
        return CheckoutControllerV2ApiFp(this.configuration).bullyDraftPutCarriersV2(requestParameters.tenant, requestParameters.language, requestParameters.orderDraftId, requestParameters.CheckoutCarrierListUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update or set shipping address for checkoutId / orderDraftId
     * @param {CheckoutControllerV2ApiBullyDraftPutShippingAddressV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutControllerV2Api
     */
    bullyDraftPutShippingAddressV2(requestParameters, options) {
        return CheckoutControllerV2ApiFp(this.configuration).bullyDraftPutShippingAddressV2(requestParameters.tenant, requestParameters.language, requestParameters.orderDraftId, requestParameters.CheckoutShippingAddressRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CleansiteControllerV1Api - axios parameter creator
 * @export
 */
export const CleansiteControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Republished all reviews results for given language-tenant combinations
         * @param {Array<RepublishAllReviewsRequestV1Inner>} RepublishAllReviewsRequestV1Inner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleansiteV1RepublishAllReviewsPost: (RepublishAllReviewsRequestV1Inner, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'RepublishAllReviewsRequestV1Inner' is not null or undefined
            assertParamExists('cleansiteV1RepublishAllReviewsPost', 'RepublishAllReviewsRequestV1Inner', RepublishAllReviewsRequestV1Inner);
            const localVarPath = `/cleansite/v1/republish-all-reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RepublishAllReviewsRequestV1Inner, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns blacklisting results for given review
         * @param {EvaluateReviewRequestV1} EvaluateReviewRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleansiteV1ReviewPost: (EvaluateReviewRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'EvaluateReviewRequestV1' is not null or undefined
            assertParamExists('cleansiteV1ReviewPost', 'EvaluateReviewRequestV1', EvaluateReviewRequestV1);
            const localVarPath = `/cleansite/v1/review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(EvaluateReviewRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CleansiteControllerV1Api - functional programming interface
 * @export
 */
export const CleansiteControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CleansiteControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Republished all reviews results for given language-tenant combinations
         * @param {Array<RepublishAllReviewsRequestV1Inner>} RepublishAllReviewsRequestV1Inner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleansiteV1RepublishAllReviewsPost(RepublishAllReviewsRequestV1Inner, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cleansiteV1RepublishAllReviewsPost(RepublishAllReviewsRequestV1Inner, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns blacklisting results for given review
         * @param {EvaluateReviewRequestV1} EvaluateReviewRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleansiteV1ReviewPost(EvaluateReviewRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cleansiteV1ReviewPost(EvaluateReviewRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CleansiteControllerV1Api - factory interface
 * @export
 */
export const CleansiteControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CleansiteControllerV1ApiFp(configuration);
    return {
        /**
         * Republished all reviews results for given language-tenant combinations
         * @param {CleansiteControllerV1ApiCleansiteV1RepublishAllReviewsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleansiteV1RepublishAllReviewsPost(requestParameters, options) {
            return localVarFp.cleansiteV1RepublishAllReviewsPost(requestParameters.RepublishAllReviewsRequestV1Inner, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns blacklisting results for given review
         * @param {CleansiteControllerV1ApiCleansiteV1ReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleansiteV1ReviewPost(requestParameters, options) {
            return localVarFp.cleansiteV1ReviewPost(requestParameters.EvaluateReviewRequestV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CleansiteControllerV1Api - object-oriented interface
 * @export
 * @class CleansiteControllerV1Api
 * @extends {BaseAPI}
 */
export class CleansiteControllerV1Api extends BaseAPI {
    /**
     * Republished all reviews results for given language-tenant combinations
     * @param {CleansiteControllerV1ApiCleansiteV1RepublishAllReviewsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CleansiteControllerV1Api
     */
    cleansiteV1RepublishAllReviewsPost(requestParameters, options) {
        return CleansiteControllerV1ApiFp(this.configuration).cleansiteV1RepublishAllReviewsPost(requestParameters.RepublishAllReviewsRequestV1Inner, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns blacklisting results for given review
     * @param {CleansiteControllerV1ApiCleansiteV1ReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CleansiteControllerV1Api
     */
    cleansiteV1ReviewPost(requestParameters, options) {
        return CleansiteControllerV1ApiFp(this.configuration).cleansiteV1ReviewPost(requestParameters.EvaluateReviewRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ClientSessionControllerV1Api - axios parameter creator
 * @export
 */
export const ClientSessionControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get the customer data for a given client session. Returns empty values for Guest users
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantCustomerGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sessionV1TenantCustomerGet', 'tenant', tenant);
            const localVarPath = `/session/v1/{tenant}/customer`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClientSessionControllerV1Api - functional programming interface
 * @export
 */
export const ClientSessionControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClientSessionControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get the customer data for a given client session. Returns empty values for Guest users
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantCustomerGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sessionV1TenantCustomerGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClientSessionControllerV1Api - factory interface
 * @export
 */
export const ClientSessionControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClientSessionControllerV1ApiFp(configuration);
    return {
        /**
         * Get the customer data for a given client session. Returns empty values for Guest users
         * @param {ClientSessionControllerV1ApiSessionV1TenantCustomerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantCustomerGet(requestParameters, options) {
            return localVarFp.sessionV1TenantCustomerGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClientSessionControllerV1Api - object-oriented interface
 * @export
 * @class ClientSessionControllerV1Api
 * @extends {BaseAPI}
 */
export class ClientSessionControllerV1Api extends BaseAPI {
    /**
     * Get the customer data for a given client session. Returns empty values for Guest users
     * @param {ClientSessionControllerV1ApiSessionV1TenantCustomerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientSessionControllerV1Api
     */
    sessionV1TenantCustomerGet(requestParameters, options) {
        return ClientSessionControllerV1ApiFp(this.configuration).sessionV1TenantCustomerGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfirmationPageControllerApi - axios parameter creator
 * @export
 */
export const ConfirmationPageControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns the order by order number
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationpageV1TenantConfirmationShopOrderIdGet: (tenant, shopOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('confirmationpageV1TenantConfirmationShopOrderIdGet', 'tenant', tenant);
            // verify required parameter 'shopOrderId' is not null or undefined
            assertParamExists('confirmationpageV1TenantConfirmationShopOrderIdGet', 'shopOrderId', shopOrderId);
            const localVarPath = `/confirmationpage/v1/{tenant}/confirmation/{shopOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"shopOrderId"}}`, encodeURIComponent(String(shopOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfirmationPageControllerApi - functional programming interface
 * @export
 */
export const ConfirmationPageControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfirmationPageControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns the order by order number
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationpageV1TenantConfirmationShopOrderIdGet(tenant, shopOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmationpageV1TenantConfirmationShopOrderIdGet(tenant, shopOrderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConfirmationPageControllerApi - factory interface
 * @export
 */
export const ConfirmationPageControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfirmationPageControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Returns the order by order number
         * @param {ConfirmationPageControllerApiConfirmationpageV1TenantConfirmationShopOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationpageV1TenantConfirmationShopOrderIdGet(requestParameters, options) {
            return localVarFp.confirmationpageV1TenantConfirmationShopOrderIdGet(requestParameters.tenant, requestParameters.shopOrderId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfirmationPageControllerApi - object-oriented interface
 * @export
 * @class ConfirmationPageControllerApi
 * @extends {BaseAPI}
 */
export class ConfirmationPageControllerApi extends BaseAPI {
    /**
     *
     * @summary Returns the order by order number
     * @param {ConfirmationPageControllerApiConfirmationpageV1TenantConfirmationShopOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfirmationPageControllerApi
     */
    confirmationpageV1TenantConfirmationShopOrderIdGet(requestParameters, options) {
        return ConfirmationPageControllerApiFp(this.configuration).confirmationpageV1TenantConfirmationShopOrderIdGet(requestParameters.tenant, requestParameters.shopOrderId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContactControllerApi - axios parameter creator
 * @export
 */
export const ContactControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {CallbackRequestV1} CallbackRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        contactV1TenantLanguageCallbackPost: (tenant, language, CallbackRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('contactV1TenantLanguageCallbackPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('contactV1TenantLanguageCallbackPost', 'language', language);
            // verify required parameter 'CallbackRequestV1' is not null or undefined
            assertParamExists('contactV1TenantLanguageCallbackPost', 'CallbackRequestV1', CallbackRequestV1);
            const localVarPath = `/contact/v1/{tenant}/{language}/callback`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CallbackRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ContactRequestV1} ContactRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactV1TenantLanguageContactPost: (tenant, language, ContactRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('contactV1TenantLanguageContactPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('contactV1TenantLanguageContactPost', 'language', language);
            // verify required parameter 'ContactRequestV1' is not null or undefined
            assertParamExists('contactV1TenantLanguageContactPost', 'ContactRequestV1', ContactRequestV1);
            const localVarPath = `/contact/v1/{tenant}/{language}/contact`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ContactRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContactControllerApi - functional programming interface
 * @export
 */
export const ContactControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContactControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {CallbackRequestV1} CallbackRequestV1
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        contactV1TenantLanguageCallbackPost(tenant, language, CallbackRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.contactV1TenantLanguageCallbackPost(tenant, language, CallbackRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ContactRequestV1} ContactRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactV1TenantLanguageContactPost(tenant, language, ContactRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.contactV1TenantLanguageContactPost(tenant, language, ContactRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ContactControllerApi - factory interface
 * @export
 */
export const ContactControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContactControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ContactControllerApiContactV1TenantLanguageCallbackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        contactV1TenantLanguageCallbackPost(requestParameters, options) {
            return localVarFp.contactV1TenantLanguageCallbackPost(requestParameters.tenant, requestParameters.language, requestParameters.CallbackRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContactControllerApiContactV1TenantLanguageContactPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactV1TenantLanguageContactPost(requestParameters, options) {
            return localVarFp.contactV1TenantLanguageContactPost(requestParameters.tenant, requestParameters.language, requestParameters.ContactRequestV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContactControllerApi - object-oriented interface
 * @export
 * @class ContactControllerApi
 * @extends {BaseAPI}
 */
export class ContactControllerApi extends BaseAPI {
    /**
     *
     * @param {ContactControllerApiContactV1TenantLanguageCallbackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ContactControllerApi
     */
    contactV1TenantLanguageCallbackPost(requestParameters, options) {
        return ContactControllerApiFp(this.configuration).contactV1TenantLanguageCallbackPost(requestParameters.tenant, requestParameters.language, requestParameters.CallbackRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContactControllerApiContactV1TenantLanguageContactPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactControllerApi
     */
    contactV1TenantLanguageContactPost(requestParameters, options) {
        return ContactControllerApiFp(this.configuration).contactV1TenantLanguageContactPost(requestParameters.tenant, requestParameters.language, requestParameters.ContactRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContentControllerApi - axios parameter creator
 * @export
 */
export const ContentControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV2TenantGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV2TenantGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV2TenantGet', 'language', language);
            const localVarPath = `/{language}/content/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {string} [contentsFilter] QueryParam contentsFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV2TenantIdGet: (id, tenant, language, fields, contentsFilter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageContentV2TenantIdGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV2TenantIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV2TenantIdGet', 'language', language);
            const localVarPath = `/{language}/content/v2/{tenant}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            if (contentsFilter !== undefined) {
                localVarQueryParameter['contentsFilter'] = contentsFilter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContentControllerApi - functional programming interface
 * @export
 */
export const ContentControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContentControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV2TenantGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV2TenantGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'ch-dev' | 'com-dev' | 'es-dev' | 'fr-dev' | 'it-dev'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {string} [contentsFilter] QueryParam contentsFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV2TenantIdGet(id, tenant, language, fields, contentsFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV2TenantIdGet(id, tenant, language, fields, contentsFilter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ContentControllerApi - factory interface
 * @export
 */
export const ContentControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContentControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ContentControllerApiLanguageContentV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV2TenantGet(requestParameters, options) {
            return localVarFp.languageContentV2TenantGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerApiLanguageContentV2TenantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV2TenantIdGet(requestParameters, options) {
            return localVarFp.languageContentV2TenantIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.fields, requestParameters.contentsFilter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContentControllerApi - object-oriented interface
 * @export
 * @class ContentControllerApi
 * @extends {BaseAPI}
 */
export class ContentControllerApi extends BaseAPI {
    /**
     *
     * @param {ContentControllerApiLanguageContentV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerApi
     */
    languageContentV2TenantGet(requestParameters, options) {
        return ContentControllerApiFp(this.configuration).languageContentV2TenantGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerApiLanguageContentV2TenantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerApi
     */
    languageContentV2TenantIdGet(requestParameters, options) {
        return ContentControllerApiFp(this.configuration).languageContentV2TenantIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.fields, requestParameters.contentsFilter, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContentControllerV3Api - axios parameter creator
 * @export
 */
export const ContentControllerV3ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantBlocksCodeGet: (code, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('languageContentV3TenantBlocksCodeGet', 'code', code);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantBlocksCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantBlocksCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/blocks/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet: (categoryCode, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryCode' is not null or undefined
            assertParamExists('languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet', 'categoryCode', categoryCode);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/category-url-path-by-code/{categoryCode}`
                .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesByCodeCategoryCodeGet: (categoryCode, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryCode' is not null or undefined
            assertParamExists('languageContentV3TenantNodesByCodeCategoryCodeGet', 'categoryCode', categoryCode);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantNodesByCodeCategoryCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantNodesByCodeCategoryCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/nodes-by-code/{categoryCode}`
                .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesPathGet: (path, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('languageContentV3TenantNodesPathGet', 'path', path);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantNodesPathGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantNodesPathGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/nodes/{path}`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPageCodeGet: (code, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('languageContentV3TenantPageCodeGet', 'code', code);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantPageCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantPageCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/page/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPagesGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantPagesGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantPagesGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/pages/}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantRoutePathGet: (path, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('languageContentV3TenantRoutePathGet', 'path', path);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantRoutePathGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantRoutePathGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/route/{path}`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContentControllerV3Api - functional programming interface
 * @export
 */
export const ContentControllerV3ApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContentControllerV3ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantBlocksCodeGet(code, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantBlocksCodeGet(code, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(categoryCode, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(categoryCode, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesPathGet(path, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantNodesPathGet(path, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPageCodeGet(code, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantPageCodeGet(code, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPagesGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantPagesGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantRoutePathGet(path, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantRoutePathGet(path, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ContentControllerV3Api - factory interface
 * @export
 */
export const ContentControllerV3ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContentControllerV3ApiFp(configuration);
    return {
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantBlocksCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantBlocksCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantBlocksCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantCategoryUrlPathByCodeCategoryCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantNodesByCodeCategoryCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantNodesPathGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesPathGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantNodesPathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantPageCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPageCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantPageCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantPagesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPagesGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantPagesGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantRoutePathGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantRoutePathGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantRoutePathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContentControllerV3Api - object-oriented interface
 * @export
 * @class ContentControllerV3Api
 * @extends {BaseAPI}
 */
export class ContentControllerV3Api extends BaseAPI {
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantBlocksCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerV3Api
     */
    languageContentV3TenantBlocksCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantBlocksCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantCategoryUrlPathByCodeCategoryCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerV3Api
     */
    languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantNodesByCodeCategoryCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerV3Api
     */
    languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantNodesPathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerV3Api
     */
    languageContentV3TenantNodesPathGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantNodesPathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantPageCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerV3Api
     */
    languageContentV3TenantPageCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantPageCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantPagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerV3Api
     */
    languageContentV3TenantPagesGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantPagesGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantRoutePathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentControllerV3Api
     */
    languageContentV3TenantRoutePathGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantRoutePathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CreditBalanceControllerV1Api - axios parameter creator
 * @export
 */
export const CreditBalanceControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets eligible credit for currently logged in user
         * @param {string} tenant
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet', 'language', language);
            const localVarPath = `/creditBalance/v1/{tenant}/{language}/getEligibleCreditForCurrentUser`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CreditBalanceControllerV1Api - functional programming interface
 * @export
 */
export const CreditBalanceControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CreditBalanceControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets eligible credit for currently logged in user
         * @param {string} tenant
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CreditBalanceControllerV1Api - factory interface
 * @export
 */
export const CreditBalanceControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CreditBalanceControllerV1ApiFp(configuration);
    return {
        /**
         * Gets eligible credit for currently logged in user
         * @param {CreditBalanceControllerV1ApiCreditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(requestParameters, options) {
            return localVarFp.creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CreditBalanceControllerV1Api - object-oriented interface
 * @export
 * @class CreditBalanceControllerV1Api
 * @extends {BaseAPI}
 */
export class CreditBalanceControllerV1Api extends BaseAPI {
    /**
     * Gets eligible credit for currently logged in user
     * @param {CreditBalanceControllerV1ApiCreditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditBalanceControllerV1Api
     */
    creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(requestParameters, options) {
        return CreditBalanceControllerV1ApiFp(this.configuration).creditBalanceV1TenantLanguageGetEligibleCreditForCurrentUserGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CrosssellersControllerV1Api - axios parameter creator
 * @export
 */
export const CrosssellersControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get data about crossselers
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crosssellersV1TenantLanguageGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('crosssellersV1TenantLanguageGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('crosssellersV1TenantLanguageGet', 'language', language);
            const localVarPath = `/crosssellers/v1/{tenant}/{language}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CrosssellersControllerV1Api - functional programming interface
 * @export
 */
export const CrosssellersControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CrosssellersControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get data about crossselers
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crosssellersV1TenantLanguageGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.crosssellersV1TenantLanguageGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CrosssellersControllerV1Api - factory interface
 * @export
 */
export const CrosssellersControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CrosssellersControllerV1ApiFp(configuration);
    return {
        /**
         * Get data about crossselers
         * @param {CrosssellersControllerV1ApiCrosssellersV1TenantLanguageGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crosssellersV1TenantLanguageGet(requestParameters, options) {
            return localVarFp.crosssellersV1TenantLanguageGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CrosssellersControllerV1Api - object-oriented interface
 * @export
 * @class CrosssellersControllerV1Api
 * @extends {BaseAPI}
 */
export class CrosssellersControllerV1Api extends BaseAPI {
    /**
     * Get data about crossselers
     * @param {CrosssellersControllerV1ApiCrosssellersV1TenantLanguageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrosssellersControllerV1Api
     */
    crosssellersV1TenantLanguageGet(requestParameters, options) {
        return CrosssellersControllerV1ApiFp(this.configuration).crosssellersV1TenantLanguageGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CustomerDataControllerApi - axios parameter creator
 * @export
 */
export const CustomerDataControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
         * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1SyncLmsPost: (CustomerDataSyncBlob, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/customer/v1/sync/lms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataSyncBlob, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate email change. Validates the email, password and sends link for verification .
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantChangeEmailPost: (tenant, CustomerDataChangeEmail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantChangeEmailPost', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/changeEmail`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataChangeEmail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantDateOfBirthPatch: (tenant, CustomerDataChangeDateOfBirth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantDateOfBirthPatch', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/dateOfBirth`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataChangeDateOfBirth, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} emailToken Token issued by CDS or LMS to update customers email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantEmailEmailTokenPatch: (tenant, emailToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantEmailEmailTokenPatch', 'tenant', tenant);
            // verify required parameter 'emailToken' is not null or undefined
            assertParamExists('customerV1TenantEmailEmailTokenPatch', 'emailToken', emailToken);
            const localVarPath = `/customer/v1/{tenant}/email/{emailToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"emailToken"}}`, encodeURIComponent(String(emailToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMailSchedulerCustomerNumberMarketingLockGet: (tenant, customerNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantMailSchedulerCustomerNumberMarketingLockGet', 'tenant', tenant);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('customerV1TenantMailSchedulerCustomerNumberMarketingLockGet', 'customerNumber', customerNumber);
            const localVarPath = `/customer/v1/{tenant}/mail-scheduler/{customerNumber}/marketing-lock`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows to fetch the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguageGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantPreferredLanguageGet', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/preferredLanguage`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows to change the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataPreferredLanguage} [CustomerDataPreferredLanguage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguagePatch: (tenant, CustomerDataPreferredLanguage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantPreferredLanguagePatch', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/preferredLanguage`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataPreferredLanguage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows to import a JSON String representation of customer data from Farmaline. Use only with basic auth credentials.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantSyncFarmalinePost: (tenant, CustomerDataSyncBlob, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantSyncFarmalinePost', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/sync/farmaline`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataSyncBlob, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CustomerDataControllerApi - functional programming interface
 * @export
 */
export const CustomerDataControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomerDataControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
         * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1SyncLmsPost(CustomerDataSyncBlob, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1SyncLmsPost(CustomerDataSyncBlob, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Initiate email change. Validates the email, password and sends link for verification .
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} emailToken Token issued by CDS or LMS to update customers email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(tenant, customerNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(tenant, customerNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint allows to fetch the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguageGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantPreferredLanguageGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint allows to change the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataPreferredLanguage} [CustomerDataPreferredLanguage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguagePatch(tenant, CustomerDataPreferredLanguage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantPreferredLanguagePatch(tenant, CustomerDataPreferredLanguage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint allows to import a JSON String representation of customer data from Farmaline. Use only with basic auth credentials.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataSyncBlob} [CustomerDataSyncBlob]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantSyncFarmalinePost(tenant, CustomerDataSyncBlob, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantSyncFarmalinePost(tenant, CustomerDataSyncBlob, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CustomerDataControllerApi - factory interface
 * @export
 */
export const CustomerDataControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomerDataControllerApiFp(configuration);
    return {
        /**
         * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
         * @param {CustomerDataControllerApiCustomerV1SyncLmsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1SyncLmsPost(requestParameters = {}, options) {
            return localVarFp.customerV1SyncLmsPost(requestParameters.CustomerDataSyncBlob, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate email change. Validates the email, password and sends link for verification .
         * @param {CustomerDataControllerApiCustomerV1TenantChangeEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantChangeEmailPost(requestParameters, options) {
            return localVarFp.customerV1TenantChangeEmailPost(requestParameters.tenant, requestParameters.CustomerDataChangeEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
         * @param {CustomerDataControllerApiCustomerV1TenantDateOfBirthPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantDateOfBirthPatch(requestParameters, options) {
            return localVarFp.customerV1TenantDateOfBirthPatch(requestParameters.tenant, requestParameters.CustomerDataChangeDateOfBirth, options).then((request) => request(axios, basePath));
        },
        /**
         * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
         * @param {CustomerDataControllerApiCustomerV1TenantEmailEmailTokenPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantEmailEmailTokenPatch(requestParameters, options) {
            return localVarFp.customerV1TenantEmailEmailTokenPatch(requestParameters.tenant, requestParameters.emailToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
         * @param {CustomerDataControllerApiCustomerV1TenantMailSchedulerCustomerNumberMarketingLockGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters, options) {
            return localVarFp.customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows to fetch the user\'s preferred language
         * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguageGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguageGet(requestParameters, options) {
            return localVarFp.customerV1TenantPreferredLanguageGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows to change the user\'s preferred language
         * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguagePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguagePatch(requestParameters, options) {
            return localVarFp.customerV1TenantPreferredLanguagePatch(requestParameters.tenant, requestParameters.CustomerDataPreferredLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows to import a JSON String representation of customer data from Farmaline. Use only with basic auth credentials.
         * @param {CustomerDataControllerApiCustomerV1TenantSyncFarmalinePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantSyncFarmalinePost(requestParameters, options) {
            return localVarFp.customerV1TenantSyncFarmalinePost(requestParameters.tenant, requestParameters.CustomerDataSyncBlob, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomerDataControllerApi - object-oriented interface
 * @export
 * @class CustomerDataControllerApi
 * @extends {BaseAPI}
 */
export class CustomerDataControllerApi extends BaseAPI {
    /**
     * This endpoint allows to import a JSON String representation of customer data from LMS based systems. Use only with service token.
     * @param {CustomerDataControllerApiCustomerV1SyncLmsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1SyncLmsPost(requestParameters = {}, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1SyncLmsPost(requestParameters.CustomerDataSyncBlob, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate email change. Validates the email, password and sends link for verification .
     * @param {CustomerDataControllerApiCustomerV1TenantChangeEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1TenantChangeEmailPost(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantChangeEmailPost(requestParameters.tenant, requestParameters.CustomerDataChangeEmail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
     * @param {CustomerDataControllerApiCustomerV1TenantDateOfBirthPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1TenantDateOfBirthPatch(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantDateOfBirthPatch(requestParameters.tenant, requestParameters.CustomerDataChangeDateOfBirth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * On user confirmation this API endpoint will update the email for the customer and send out confirmation mails.
     * @param {CustomerDataControllerApiCustomerV1TenantEmailEmailTokenPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1TenantEmailEmailTokenPatch(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantEmailEmailTokenPatch(requestParameters.tenant, requestParameters.emailToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
     * @param {CustomerDataControllerApiCustomerV1TenantMailSchedulerCustomerNumberMarketingLockGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows to fetch the user\'s preferred language
     * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1TenantPreferredLanguageGet(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantPreferredLanguageGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows to change the user\'s preferred language
     * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguagePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1TenantPreferredLanguagePatch(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantPreferredLanguagePatch(requestParameters.tenant, requestParameters.CustomerDataPreferredLanguage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows to import a JSON String representation of customer data from Farmaline. Use only with basic auth credentials.
     * @param {CustomerDataControllerApiCustomerV1TenantSyncFarmalinePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataControllerApi
     */
    customerV1TenantSyncFarmalinePost(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantSyncFarmalinePost(requestParameters.tenant, requestParameters.CustomerDataSyncBlob, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CustomerPurchaseHistoryControllerApi - axios parameter creator
 * @export
 */
export const CustomerPurchaseHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a JSON object containing the customer\'s purchase history, filtered by a date range. If date range is not specified, default value of 30 days will be used. Customer ID is fetched from JWT.
         * @summary Fetch customer purchase history
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerId ID of the customer to fetch purchase history for
         * @param {string} [startDateTime] Start date-time of the period to filter by
         * @param {string} [endDateTime] End date-time of the period to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantCustomersCustomerIdPurchaseHistoryGet: (tenant, customerId, startDateTime, endDateTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('tenantCustomersCustomerIdPurchaseHistoryGet', 'tenant', tenant);
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('tenantCustomersCustomerIdPurchaseHistoryGet', 'customerId', customerId);
            const localVarPath = `/{tenant}/customers/{customerId}/purchaseHistory`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDateTime !== undefined) {
                localVarQueryParameter['startDateTime'] = (startDateTime instanceof Date) ?
                    startDateTime.toISOString() :
                    startDateTime;
            }
            if (endDateTime !== undefined) {
                localVarQueryParameter['endDateTime'] = (endDateTime instanceof Date) ?
                    endDateTime.toISOString() :
                    endDateTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CustomerPurchaseHistoryControllerApi - functional programming interface
 * @export
 */
export const CustomerPurchaseHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomerPurchaseHistoryControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a JSON object containing the customer\'s purchase history, filtered by a date range. If date range is not specified, default value of 30 days will be used. Customer ID is fetched from JWT.
         * @summary Fetch customer purchase history
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerId ID of the customer to fetch purchase history for
         * @param {string} [startDateTime] Start date-time of the period to filter by
         * @param {string} [endDateTime] End date-time of the period to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantCustomersCustomerIdPurchaseHistoryGet(tenant, customerId, startDateTime, endDateTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tenantCustomersCustomerIdPurchaseHistoryGet(tenant, customerId, startDateTime, endDateTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CustomerPurchaseHistoryControllerApi - factory interface
 * @export
 */
export const CustomerPurchaseHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomerPurchaseHistoryControllerApiFp(configuration);
    return {
        /**
         * Returns a JSON object containing the customer\'s purchase history, filtered by a date range. If date range is not specified, default value of 30 days will be used. Customer ID is fetched from JWT.
         * @summary Fetch customer purchase history
         * @param {CustomerPurchaseHistoryControllerApiTenantCustomersCustomerIdPurchaseHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantCustomersCustomerIdPurchaseHistoryGet(requestParameters, options) {
            return localVarFp.tenantCustomersCustomerIdPurchaseHistoryGet(requestParameters.tenant, requestParameters.customerId, requestParameters.startDateTime, requestParameters.endDateTime, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomerPurchaseHistoryControllerApi - object-oriented interface
 * @export
 * @class CustomerPurchaseHistoryControllerApi
 * @extends {BaseAPI}
 */
export class CustomerPurchaseHistoryControllerApi extends BaseAPI {
    /**
     * Returns a JSON object containing the customer\'s purchase history, filtered by a date range. If date range is not specified, default value of 30 days will be used. Customer ID is fetched from JWT.
     * @summary Fetch customer purchase history
     * @param {CustomerPurchaseHistoryControllerApiTenantCustomersCustomerIdPurchaseHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPurchaseHistoryControllerApi
     */
    tenantCustomersCustomerIdPurchaseHistoryGet(requestParameters, options) {
        return CustomerPurchaseHistoryControllerApiFp(this.configuration).tenantCustomersCustomerIdPurchaseHistoryGet(requestParameters.tenant, requestParameters.customerId, requestParameters.startDateTime, requestParameters.endDateTime, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmailVerificationControllerApi - axios parameter creator
 * @export
 */
export const EmailVerificationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} email PathParam email
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageEmailverificationV1TenantEmailGet: (email, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('languageEmailverificationV1TenantEmailGet', 'email', email);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageEmailverificationV1TenantEmailGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageEmailverificationV1TenantEmailGet', 'language', language);
            const localVarPath = `/{language}/emailverification/v1/{tenant}/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EmailVerificationControllerApi - functional programming interface
 * @export
 */
export const EmailVerificationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmailVerificationControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} email PathParam email
         * @param {'at' | 'at-dev' | 'at-qs' | 'ch' | 'ch-dev' | 'ch-qs' | 'com' | 'com-dev' | 'com-qs' | 'fr' | 'fr-dev' | 'fr-qs' | 'es' | 'es-dev' | 'es-qs' | 'it' | 'it-dev' | 'it-qs'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageEmailverificationV1TenantEmailGet(email, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageEmailverificationV1TenantEmailGet(email, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EmailVerificationControllerApi - factory interface
 * @export
 */
export const EmailVerificationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmailVerificationControllerApiFp(configuration);
    return {
        /**
         *
         * @param {EmailVerificationControllerApiLanguageEmailverificationV1TenantEmailGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageEmailverificationV1TenantEmailGet(requestParameters, options) {
            return localVarFp.languageEmailverificationV1TenantEmailGet(requestParameters.email, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmailVerificationControllerApi - object-oriented interface
 * @export
 * @class EmailVerificationControllerApi
 * @extends {BaseAPI}
 */
export class EmailVerificationControllerApi extends BaseAPI {
    /**
     *
     * @param {EmailVerificationControllerApiLanguageEmailverificationV1TenantEmailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailVerificationControllerApi
     */
    languageEmailverificationV1TenantEmailGet(requestParameters, options) {
        return EmailVerificationControllerApiFp(this.configuration).languageEmailverificationV1TenantEmailGet(requestParameters.email, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FaqControllerApi - axios parameter creator
 * @export
 */
export const FaqControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} famId PathParam famId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageFaqV2TenantFamIdGet: (famId, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'famId' is not null or undefined
            assertParamExists('languageFaqV2TenantFamIdGet', 'famId', famId);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageFaqV2TenantFamIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageFaqV2TenantFamIdGet', 'language', language);
            const localVarPath = `/{language}/faq/v2/{tenant}/{famId}`
                .replace(`{${"famId"}}`, encodeURIComponent(String(famId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} pzn PathParam pzn
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch' | 'nl'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageFaqV2TenantPznPznGet: (pzn, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pzn' is not null or undefined
            assertParamExists('languageFaqV2TenantPznPznGet', 'pzn', pzn);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageFaqV2TenantPznPznGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageFaqV2TenantPznPznGet', 'language', language);
            const localVarPath = `/{language}/faq/v2/{tenant}/pzn/{pzn}`
                .replace(`{${"pzn"}}`, encodeURIComponent(String(pzn)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FaqControllerApi - functional programming interface
 * @export
 */
export const FaqControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = FaqControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} famId PathParam famId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageFaqV2TenantFamIdGet(famId, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageFaqV2TenantFamIdGet(famId, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} pzn PathParam pzn
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch' | 'nl'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageFaqV2TenantPznPznGet(pzn, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageFaqV2TenantPznPznGet(pzn, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FaqControllerApi - factory interface
 * @export
 */
export const FaqControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FaqControllerApiFp(configuration);
    return {
        /**
         *
         * @param {FaqControllerApiLanguageFaqV2TenantFamIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageFaqV2TenantFamIdGet(requestParameters, options) {
            return localVarFp.languageFaqV2TenantFamIdGet(requestParameters.famId, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FaqControllerApiLanguageFaqV2TenantPznPznGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageFaqV2TenantPznPznGet(requestParameters, options) {
            return localVarFp.languageFaqV2TenantPznPznGet(requestParameters.pzn, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FaqControllerApi - object-oriented interface
 * @export
 * @class FaqControllerApi
 * @extends {BaseAPI}
 */
export class FaqControllerApi extends BaseAPI {
    /**
     *
     * @param {FaqControllerApiLanguageFaqV2TenantFamIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqControllerApi
     */
    languageFaqV2TenantFamIdGet(requestParameters, options) {
        return FaqControllerApiFp(this.configuration).languageFaqV2TenantFamIdGet(requestParameters.famId, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FaqControllerApiLanguageFaqV2TenantPznPznGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqControllerApi
     */
    languageFaqV2TenantPznPznGet(requestParameters, options) {
        return FaqControllerApiFp(this.configuration).languageFaqV2TenantPznPznGet(requestParameters.pzn, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GtmControllerApi - axios parameter creator
 * @export
 */
export const GtmControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'login' | 'registration'} [after] origin page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsAccountOverviewGet: (language, tenant, after, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsAccountOverviewGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsAccountOverviewGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/account_overview`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {string} [dataLayerInfoPerSellerGroups] Info needed to populate some dataLayer payload that has to be passed in from the frontend because it\&#39;s not conveniently available in the backend; for example during gtm dataLayer \&#39;cart\&#39; events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCartGet: (language, tenant, dataLayerInfoPerSellerGroups, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCartGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCartGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/cart`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (dataLayerInfoPerSellerGroups !== undefined) {
                localVarQueryParameter['dataLayerInfoPerSellerGroups'] = dataLayerInfoPerSellerGroups;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {string} [prescriptionType] QueryParam prescriptionType
         * @param {string} [upid] QueryParam upid
         * @param {string} [hashedTokens] QueryParam hashedTokens
         * @param {number} [quantity] QueryParam quantity
         * @param {string} [channel] Channel based pricing for the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCartintermediateGet: (language, tenant, prescriptionType, upid, hashedTokens, quantity, channel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCartintermediateGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCartintermediateGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/cartintermediate`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (prescriptionType !== undefined) {
                localVarQueryParameter['prescriptionType'] = prescriptionType;
            }
            if (upid !== undefined) {
                localVarQueryParameter['upid'] = upid;
            }
            if (hashedTokens !== undefined) {
                localVarQueryParameter['hashedTokens'] = hashedTokens;
            }
            if (quantity !== undefined) {
                localVarQueryParameter['quantity'] = quantity;
            }
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet: (language, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/checkout_confirmation`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderDraftId origin page
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'login' | 'registration'} [after] origin page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCheckoutGet: (orderDraftId, language, tenant, after, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCheckoutGet', 'orderDraftId', orderDraftId);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCheckoutGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsCheckoutGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/checkout`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (orderDraftId !== undefined) {
                localVarQueryParameter['orderDraftId'] = orderDraftId;
            }
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} upids origin page
         * @param {Array<string>} offerIds origin page
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {string} [channel] Channel based pricing for the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsOfferGet: (upids, offerIds, language, tenant, channel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'upids' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsOfferGet', 'upids', upids);
            // verify required parameter 'offerIds' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsOfferGet', 'offerIds', offerIds);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsOfferGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsOfferGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/offer`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (upids) {
                localVarQueryParameter['upids'] = upids;
            }
            if (offerIds) {
                localVarQueryParameter['offerIds'] = offerIds;
            }
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} upids origin page
         * @param {Array<string>} offerIds origin page
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'login' | 'registration'} [after] origin page
         * @param {string} [channel] Channel based pricing for the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsProductGet: (upids, offerIds, language, tenant, after, channel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'upids' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsProductGet', 'upids', upids);
            // verify required parameter 'offerIds' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsProductGet', 'offerIds', offerIds);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsProductGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantEventsProductGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}/events/product`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (upids) {
                localVarQueryParameter['upids'] = upids;
            }
            if (offerIds) {
                localVarQueryParameter['offerIds'] = offerIds;
            }
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantGet: (language, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageGtmDataLayerV1TenantGet', 'tenant', tenant);
            const localVarPath = `/{language}/gtmDataLayer/v1/{tenant}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GtmControllerApi - functional programming interface
 * @export
 */
export const GtmControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = GtmControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'login' | 'registration'} [after] origin page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsAccountOverviewGet(language, tenant, after, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsAccountOverviewGet(language, tenant, after, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {string} [dataLayerInfoPerSellerGroups] Info needed to populate some dataLayer payload that has to be passed in from the frontend because it\&#39;s not conveniently available in the backend; for example during gtm dataLayer \&#39;cart\&#39; events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCartGet(language, tenant, dataLayerInfoPerSellerGroups, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCartGet(language, tenant, dataLayerInfoPerSellerGroups, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {string} [prescriptionType] QueryParam prescriptionType
         * @param {string} [upid] QueryParam upid
         * @param {string} [hashedTokens] QueryParam hashedTokens
         * @param {number} [quantity] QueryParam quantity
         * @param {string} [channel] Channel based pricing for the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCartintermediateGet(language, tenant, prescriptionType, upid, hashedTokens, quantity, channel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCartintermediateGet(language, tenant, prescriptionType, upid, hashedTokens, quantity, channel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(language, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(language, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} orderDraftId origin page
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'login' | 'registration'} [after] origin page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCheckoutGet(orderDraftId, language, tenant, after, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsCheckoutGet(orderDraftId, language, tenant, after, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<string>} upids origin page
         * @param {Array<string>} offerIds origin page
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {string} [channel] Channel based pricing for the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsOfferGet(upids, offerIds, language, tenant, channel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsOfferGet(upids, offerIds, language, tenant, channel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<string>} upids origin page
         * @param {Array<string>} offerIds origin page
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'login' | 'registration'} [after] origin page
         * @param {string} [channel] Channel based pricing for the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsProductGet(upids, offerIds, language, tenant, after, channel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantEventsProductGet(upids, offerIds, language, tenant, after, channel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantGet(language, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageGtmDataLayerV1TenantGet(language, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * GtmControllerApi - factory interface
 * @export
 */
export const GtmControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GtmControllerApiFp(configuration);
    return {
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsAccountOverviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsAccountOverviewGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantEventsAccountOverviewGet(requestParameters.language, requestParameters.tenant, requestParameters.after, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCartGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCartGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantEventsCartGet(requestParameters.language, requestParameters.tenant, requestParameters.dataLayerInfoPerSellerGroups, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCartintermediateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCartintermediateGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantEventsCartintermediateGet(requestParameters.language, requestParameters.tenant, requestParameters.prescriptionType, requestParameters.upid, requestParameters.hashedTokens, requestParameters.quantity, requestParameters.channel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCheckoutConfirmationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCheckoutGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsCheckoutGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantEventsCheckoutGet(requestParameters.orderDraftId, requestParameters.language, requestParameters.tenant, requestParameters.after, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsOfferGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsOfferGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantEventsOfferGet(requestParameters.upids, requestParameters.offerIds, requestParameters.language, requestParameters.tenant, requestParameters.channel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsProductGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantEventsProductGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantEventsProductGet(requestParameters.upids, requestParameters.offerIds, requestParameters.language, requestParameters.tenant, requestParameters.after, requestParameters.channel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GtmControllerApiLanguageGtmDataLayerV1TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageGtmDataLayerV1TenantGet(requestParameters, options) {
            return localVarFp.languageGtmDataLayerV1TenantGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GtmControllerApi - object-oriented interface
 * @export
 * @class GtmControllerApi
 * @extends {BaseAPI}
 */
export class GtmControllerApi extends BaseAPI {
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsAccountOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantEventsAccountOverviewGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantEventsAccountOverviewGet(requestParameters.language, requestParameters.tenant, requestParameters.after, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCartGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantEventsCartGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantEventsCartGet(requestParameters.language, requestParameters.tenant, requestParameters.dataLayerInfoPerSellerGroups, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCartintermediateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantEventsCartintermediateGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantEventsCartintermediateGet(requestParameters.language, requestParameters.tenant, requestParameters.prescriptionType, requestParameters.upid, requestParameters.hashedTokens, requestParameters.quantity, requestParameters.channel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCheckoutConfirmationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantEventsCheckoutConfirmationGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsCheckoutGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantEventsCheckoutGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantEventsCheckoutGet(requestParameters.orderDraftId, requestParameters.language, requestParameters.tenant, requestParameters.after, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsOfferGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantEventsOfferGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantEventsOfferGet(requestParameters.upids, requestParameters.offerIds, requestParameters.language, requestParameters.tenant, requestParameters.channel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantEventsProductGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantEventsProductGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantEventsProductGet(requestParameters.upids, requestParameters.offerIds, requestParameters.language, requestParameters.tenant, requestParameters.after, requestParameters.channel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GtmControllerApiLanguageGtmDataLayerV1TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GtmControllerApi
     */
    languageGtmDataLayerV1TenantGet(requestParameters, options) {
        return GtmControllerApiFp(this.configuration).languageGtmDataLayerV1TenantGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * KlarnaDataControllerApi - axios parameter creator
 * @export
 */
export const KlarnaDataControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * transform and anonymize order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {KlarnaDataOrderDraft} KlarnaDataOrderDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaDataV1TenantTransformPost: (tenant, KlarnaDataOrderDraft, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('klarnaDataV1TenantTransformPost', 'tenant', tenant);
            // verify required parameter 'KlarnaDataOrderDraft' is not null or undefined
            assertParamExists('klarnaDataV1TenantTransformPost', 'KlarnaDataOrderDraft', KlarnaDataOrderDraft);
            const localVarPath = `/klarna-data/v1/{tenant}/transform`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(KlarnaDataOrderDraft, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * KlarnaDataControllerApi - functional programming interface
 * @export
 */
export const KlarnaDataControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = KlarnaDataControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * transform and anonymize order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {KlarnaDataOrderDraft} KlarnaDataOrderDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaDataV1TenantTransformPost(tenant, KlarnaDataOrderDraft, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.klarnaDataV1TenantTransformPost(tenant, KlarnaDataOrderDraft, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * KlarnaDataControllerApi - factory interface
 * @export
 */
export const KlarnaDataControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = KlarnaDataControllerApiFp(configuration);
    return {
        /**
         * transform and anonymize order
         * @param {KlarnaDataControllerApiKlarnaDataV1TenantTransformPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaDataV1TenantTransformPost(requestParameters, options) {
            return localVarFp.klarnaDataV1TenantTransformPost(requestParameters.tenant, requestParameters.KlarnaDataOrderDraft, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * KlarnaDataControllerApi - object-oriented interface
 * @export
 * @class KlarnaDataControllerApi
 * @extends {BaseAPI}
 */
export class KlarnaDataControllerApi extends BaseAPI {
    /**
     * transform and anonymize order
     * @param {KlarnaDataControllerApiKlarnaDataV1TenantTransformPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KlarnaDataControllerApi
     */
    klarnaDataV1TenantTransformPost(requestParameters, options) {
        return KlarnaDataControllerApiFp(this.configuration).klarnaDataV1TenantTransformPost(requestParameters.tenant, requestParameters.KlarnaDataOrderDraft, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LeafletsControllerApi - axios parameter creator
 * @export
 */
export const LeafletsControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantBiozidIdGet: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('leafletsV1TenantBiozidIdGet', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('leafletsV1TenantBiozidIdGet', 'id', id);
            const localVarPath = `/leaflets/v1/{tenant}/biozid/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantLeafletsIdGet: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('leafletsV1TenantLeafletsIdGet', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('leafletsV1TenantLeafletsIdGet', 'id', id);
            const localVarPath = `/leaflets/v1/{tenant}/leaflets/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantLmivIdGet: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('leafletsV1TenantLmivIdGet', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('leafletsV1TenantLmivIdGet', 'id', id);
            const localVarPath = `/leaflets/v1/{tenant}/lmiv/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'leaflet' | 'lmiv'} kind PathParam kind
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantPznsKindGet: (kind, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('leafletsV1TenantPznsKindGet', 'kind', kind);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('leafletsV1TenantPznsKindGet', 'tenant', tenant);
            const localVarPath = `/leaflets/v1/{tenant}/pzns/{kind}`
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantRxIdGet: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('leafletsV1TenantRxIdGet', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('leafletsV1TenantRxIdGet', 'id', id);
            const localVarPath = `/leaflets/v1/{tenant}/rx/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LeafletsControllerApi - functional programming interface
 * @export
 */
export const LeafletsControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LeafletsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantBiozidIdGet(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leafletsV1TenantBiozidIdGet(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantLeafletsIdGet(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leafletsV1TenantLeafletsIdGet(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantLmivIdGet(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leafletsV1TenantLmivIdGet(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'leaflet' | 'lmiv'} kind PathParam kind
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantPznsKindGet(kind, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leafletsV1TenantPznsKindGet(kind, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'com-dev' | 'com-qs' | 'com'} tenant ControllerParam tenant
         * @param {string} id PathParam id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantRxIdGet(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leafletsV1TenantRxIdGet(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LeafletsControllerApi - factory interface
 * @export
 */
export const LeafletsControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LeafletsControllerApiFp(configuration);
    return {
        /**
         *
         * @param {LeafletsControllerApiLeafletsV1TenantBiozidIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantBiozidIdGet(requestParameters, options) {
            return localVarFp.leafletsV1TenantBiozidIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LeafletsControllerApiLeafletsV1TenantLeafletsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantLeafletsIdGet(requestParameters, options) {
            return localVarFp.leafletsV1TenantLeafletsIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LeafletsControllerApiLeafletsV1TenantLmivIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantLmivIdGet(requestParameters, options) {
            return localVarFp.leafletsV1TenantLmivIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LeafletsControllerApiLeafletsV1TenantPznsKindGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantPznsKindGet(requestParameters, options) {
            return localVarFp.leafletsV1TenantPznsKindGet(requestParameters.kind, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LeafletsControllerApiLeafletsV1TenantRxIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leafletsV1TenantRxIdGet(requestParameters, options) {
            return localVarFp.leafletsV1TenantRxIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LeafletsControllerApi - object-oriented interface
 * @export
 * @class LeafletsControllerApi
 * @extends {BaseAPI}
 */
export class LeafletsControllerApi extends BaseAPI {
    /**
     *
     * @param {LeafletsControllerApiLeafletsV1TenantBiozidIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeafletsControllerApi
     */
    leafletsV1TenantBiozidIdGet(requestParameters, options) {
        return LeafletsControllerApiFp(this.configuration).leafletsV1TenantBiozidIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LeafletsControllerApiLeafletsV1TenantLeafletsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeafletsControllerApi
     */
    leafletsV1TenantLeafletsIdGet(requestParameters, options) {
        return LeafletsControllerApiFp(this.configuration).leafletsV1TenantLeafletsIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LeafletsControllerApiLeafletsV1TenantLmivIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeafletsControllerApi
     */
    leafletsV1TenantLmivIdGet(requestParameters, options) {
        return LeafletsControllerApiFp(this.configuration).leafletsV1TenantLmivIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LeafletsControllerApiLeafletsV1TenantPznsKindGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeafletsControllerApi
     */
    leafletsV1TenantPznsKindGet(requestParameters, options) {
        return LeafletsControllerApiFp(this.configuration).leafletsV1TenantPznsKindGet(requestParameters.kind, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LeafletsControllerApiLeafletsV1TenantRxIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeafletsControllerApi
     */
    leafletsV1TenantRxIdGet(requestParameters, options) {
        return LeafletsControllerApiFp(this.configuration).leafletsV1TenantRxIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LeanplumProxyControllerV1Api - axios parameter creator
 * @export
 */
export const LeanplumProxyControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Starts campaign by campaignId for user userId
         * @param {string} campaignId ID of Leanplum campaign we want to start
         * @param {StartCampaignRequestBodyV1} StartCampaignRequestBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leanplumProxyV1CampaignsCampaignIdStartPost: (campaignId, StartCampaignRequestBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('leanplumProxyV1CampaignsCampaignIdStartPost', 'campaignId', campaignId);
            // verify required parameter 'StartCampaignRequestBodyV1' is not null or undefined
            assertParamExists('leanplumProxyV1CampaignsCampaignIdStartPost', 'StartCampaignRequestBodyV1', StartCampaignRequestBodyV1);
            const localVarPath = `/leanplum-proxy/v1/campaigns/{campaignId}/start`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(StartCampaignRequestBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LeanplumProxyControllerV1Api - functional programming interface
 * @export
 */
export const LeanplumProxyControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = LeanplumProxyControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Starts campaign by campaignId for user userId
         * @param {string} campaignId ID of Leanplum campaign we want to start
         * @param {StartCampaignRequestBodyV1} StartCampaignRequestBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leanplumProxyV1CampaignsCampaignIdStartPost(campaignId, StartCampaignRequestBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leanplumProxyV1CampaignsCampaignIdStartPost(campaignId, StartCampaignRequestBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LeanplumProxyControllerV1Api - factory interface
 * @export
 */
export const LeanplumProxyControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LeanplumProxyControllerV1ApiFp(configuration);
    return {
        /**
         * Starts campaign by campaignId for user userId
         * @param {LeanplumProxyControllerV1ApiLeanplumProxyV1CampaignsCampaignIdStartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leanplumProxyV1CampaignsCampaignIdStartPost(requestParameters, options) {
            return localVarFp.leanplumProxyV1CampaignsCampaignIdStartPost(requestParameters.campaignId, requestParameters.StartCampaignRequestBodyV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LeanplumProxyControllerV1Api - object-oriented interface
 * @export
 * @class LeanplumProxyControllerV1Api
 * @extends {BaseAPI}
 */
export class LeanplumProxyControllerV1Api extends BaseAPI {
    /**
     * Starts campaign by campaignId for user userId
     * @param {LeanplumProxyControllerV1ApiLeanplumProxyV1CampaignsCampaignIdStartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeanplumProxyControllerV1Api
     */
    leanplumProxyV1CampaignsCampaignIdStartPost(requestParameters, options) {
        return LeanplumProxyControllerV1ApiFp(this.configuration).leanplumProxyV1CampaignsCampaignIdStartPost(requestParameters.campaignId, requestParameters.StartCampaignRequestBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LetterboxControllerApi - axios parameter creator
 * @export
 */
export const LetterboxControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageLetterboxV1TenantDocumentsOrderNumberGet: (language, tenant, orderNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageLetterboxV1TenantDocumentsOrderNumberGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageLetterboxV1TenantDocumentsOrderNumberGet', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('languageLetterboxV1TenantDocumentsOrderNumberGet', 'orderNumber', orderNumber);
            const localVarPath = `/{language}/letterbox/v1/{tenant}/documents/{orderNumber}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download the binary content of a single document for SAE seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {string} document_type
         * @param {string} hash A secure hash of the binary content to be retrieved.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        letterboxApiGetOrderDocument: (tenant, language, orderNumber, document_type, hash, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('letterboxApiGetOrderDocument', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('letterboxApiGetOrderDocument', 'language', language);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('letterboxApiGetOrderDocument', 'orderNumber', orderNumber);
            // verify required parameter 'document_type' is not null or undefined
            assertParamExists('letterboxApiGetOrderDocument', 'document_type', document_type);
            // verify required parameter 'hash' is not null or undefined
            assertParamExists('letterboxApiGetOrderDocument', 'hash', hash);
            const localVarPath = `/{language}/letterbox/v1/{tenant}/document/{orderNumber}/{document-type}/{hash}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
                .replace(`{${"document-type"}}`, encodeURIComponent(String(document_type)))
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download the binary content of a single document for SAE seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} subOrderId
         * @param {string} document_type
         * @param {string} hash A secure hash of the binary content to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        letterboxApiGetSuborderDocument: (tenant, language, subOrderId, document_type, hash, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('letterboxApiGetSuborderDocument', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('letterboxApiGetSuborderDocument', 'language', language);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('letterboxApiGetSuborderDocument', 'subOrderId', subOrderId);
            // verify required parameter 'document_type' is not null or undefined
            assertParamExists('letterboxApiGetSuborderDocument', 'document_type', document_type);
            // verify required parameter 'hash' is not null or undefined
            assertParamExists('letterboxApiGetSuborderDocument', 'hash', hash);
            const localVarPath = `/{language}/letterbox/v1/{tenant}/document/sae/{subOrderId}/{document-type}/{hash}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
                .replace(`{${"document-type"}}`, encodeURIComponent(String(document_type)))
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download the binary content of a single document for marketplace seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} subOrderId
         * @param {string} documentId Unique document id of marketplace document to fetch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        letterboxApiGetSuborderMpDocument: (tenant, language, subOrderId, documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('letterboxApiGetSuborderMpDocument', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('letterboxApiGetSuborderMpDocument', 'language', language);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('letterboxApiGetSuborderMpDocument', 'subOrderId', subOrderId);
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('letterboxApiGetSuborderMpDocument', 'documentId', documentId);
            const localVarPath = `/{language}/letterbox/v1/{tenant}/document/marketplace/{subOrderId}/{documentId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LetterboxControllerApi - functional programming interface
 * @export
 */
export const LetterboxControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LetterboxControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageLetterboxV1TenantDocumentsOrderNumberGet(language, tenant, orderNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageLetterboxV1TenantDocumentsOrderNumberGet(language, tenant, orderNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Download the binary content of a single document for SAE seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {string} document_type
         * @param {string} hash A secure hash of the binary content to be retrieved.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        letterboxApiGetOrderDocument(tenant, language, orderNumber, document_type, hash, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.letterboxApiGetOrderDocument(tenant, language, orderNumber, document_type, hash, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Download the binary content of a single document for SAE seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} subOrderId
         * @param {string} document_type
         * @param {string} hash A secure hash of the binary content to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        letterboxApiGetSuborderDocument(tenant, language, subOrderId, document_type, hash, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.letterboxApiGetSuborderDocument(tenant, language, subOrderId, document_type, hash, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Download the binary content of a single document for marketplace seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} subOrderId
         * @param {string} documentId Unique document id of marketplace document to fetch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        letterboxApiGetSuborderMpDocument(tenant, language, subOrderId, documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.letterboxApiGetSuborderMpDocument(tenant, language, subOrderId, documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LetterboxControllerApi - factory interface
 * @export
 */
export const LetterboxControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LetterboxControllerApiFp(configuration);
    return {
        /**
         * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
         * @param {LetterboxControllerApiLanguageLetterboxV1TenantDocumentsOrderNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageLetterboxV1TenantDocumentsOrderNumberGet(requestParameters, options) {
            return localVarFp.languageLetterboxV1TenantDocumentsOrderNumberGet(requestParameters.language, requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the binary content of a single document for SAE seller
         * @param {LetterboxControllerApiLetterboxApiGetOrderDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        letterboxApiGetOrderDocument(requestParameters, options) {
            return localVarFp.letterboxApiGetOrderDocument(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, requestParameters.document_type, requestParameters.hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the binary content of a single document for SAE seller
         * @param {LetterboxControllerApiLetterboxApiGetSuborderDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        letterboxApiGetSuborderDocument(requestParameters, options) {
            return localVarFp.letterboxApiGetSuborderDocument(requestParameters.tenant, requestParameters.language, requestParameters.subOrderId, requestParameters.document_type, requestParameters.hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the binary content of a single document for marketplace seller
         * @param {LetterboxControllerApiLetterboxApiGetSuborderMpDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        letterboxApiGetSuborderMpDocument(requestParameters, options) {
            return localVarFp.letterboxApiGetSuborderMpDocument(requestParameters.tenant, requestParameters.language, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LetterboxControllerApi - object-oriented interface
 * @export
 * @class LetterboxControllerApi
 * @extends {BaseAPI}
 */
export class LetterboxControllerApi extends BaseAPI {
    /**
     * List all documents for the given order id. Note that if no documents can be found for the given parameters, an empty array will be returned (no 404).
     * @param {LetterboxControllerApiLanguageLetterboxV1TenantDocumentsOrderNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LetterboxControllerApi
     */
    languageLetterboxV1TenantDocumentsOrderNumberGet(requestParameters, options) {
        return LetterboxControllerApiFp(this.configuration).languageLetterboxV1TenantDocumentsOrderNumberGet(requestParameters.language, requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Download the binary content of a single document for SAE seller
     * @param {LetterboxControllerApiLetterboxApiGetOrderDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof LetterboxControllerApi
     */
    letterboxApiGetOrderDocument(requestParameters, options) {
        return LetterboxControllerApiFp(this.configuration).letterboxApiGetOrderDocument(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, requestParameters.document_type, requestParameters.hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Download the binary content of a single document for SAE seller
     * @param {LetterboxControllerApiLetterboxApiGetSuborderDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LetterboxControllerApi
     */
    letterboxApiGetSuborderDocument(requestParameters, options) {
        return LetterboxControllerApiFp(this.configuration).letterboxApiGetSuborderDocument(requestParameters.tenant, requestParameters.language, requestParameters.subOrderId, requestParameters.document_type, requestParameters.hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Download the binary content of a single document for marketplace seller
     * @param {LetterboxControllerApiLetterboxApiGetSuborderMpDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LetterboxControllerApi
     */
    letterboxApiGetSuborderMpDocument(requestParameters, options) {
        return LetterboxControllerApiFp(this.configuration).letterboxApiGetSuborderMpDocument(requestParameters.tenant, requestParameters.language, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MPSControllerApi - axios parameter creator
 * @export
 */
export const MPSControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MpCreateMedicationDtoV1} MpCreateMedicationDtoV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerCreate: (tenant, MpCreateMedicationDtoV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('medicationControllerCreate', 'tenant', tenant);
            // verify required parameter 'MpCreateMedicationDtoV1' is not null or undefined
            assertParamExists('medicationControllerCreate', 'MpCreateMedicationDtoV1', MpCreateMedicationDtoV1);
            const localVarPath = `/medicationplan/v1/{tenant}/medication`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MpCreateMedicationDtoV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerFindAll: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('medicationControllerFindAll', 'tenant', tenant);
            const localVarPath = `/medicationplan/v1/{tenant}/medication`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerFindOne: (id, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('medicationControllerFindOne', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('medicationControllerFindOne', 'tenant', tenant);
            const localVarPath = `/medicationplan/v1/{tenant}/medication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRemove: (id, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('medicationControllerRemove', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('medicationControllerRemove', 'tenant', tenant);
            const localVarPath = `/medicationplan/v1/{tenant}/medication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MpCheckMedicationDtoV1} MpCheckMedicationDtoV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRequestCheck: (tenant, MpCheckMedicationDtoV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('medicationControllerRequestCheck', 'tenant', tenant);
            // verify required parameter 'MpCheckMedicationDtoV1' is not null or undefined
            assertParamExists('medicationControllerRequestCheck', 'MpCheckMedicationDtoV1', MpCheckMedicationDtoV1);
            const localVarPath = `/medicationplan/v1/{tenant}/medication/requestCheck`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MpCheckMedicationDtoV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MpUpdateMedicationDtoV1} MpUpdateMedicationDtoV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdate: (id, tenant, MpUpdateMedicationDtoV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('medicationControllerUpdate', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('medicationControllerUpdate', 'tenant', tenant);
            // verify required parameter 'MpUpdateMedicationDtoV1' is not null or undefined
            assertParamExists('medicationControllerUpdate', 'MpUpdateMedicationDtoV1', MpUpdateMedicationDtoV1);
            const localVarPath = `/medicationplan/v1/{tenant}/medication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MpUpdateMedicationDtoV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MPSControllerApi - functional programming interface
 * @export
 */
export const MPSControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = MPSControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MpCreateMedicationDtoV1} MpCreateMedicationDtoV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerCreate(tenant, MpCreateMedicationDtoV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.medicationControllerCreate(tenant, MpCreateMedicationDtoV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerFindAll(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.medicationControllerFindAll(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerFindOne(id, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.medicationControllerFindOne(id, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRemove(id, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.medicationControllerRemove(id, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MpCheckMedicationDtoV1} MpCheckMedicationDtoV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRequestCheck(tenant, MpCheckMedicationDtoV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.medicationControllerRequestCheck(tenant, MpCheckMedicationDtoV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MpUpdateMedicationDtoV1} MpUpdateMedicationDtoV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdate(id, tenant, MpUpdateMedicationDtoV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.medicationControllerUpdate(id, tenant, MpUpdateMedicationDtoV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MPSControllerApi - factory interface
 * @export
 */
export const MPSControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MPSControllerApiFp(configuration);
    return {
        /**
         *
         * @param {MPSControllerApiMedicationControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerCreate(requestParameters, options) {
            return localVarFp.medicationControllerCreate(requestParameters.tenant, requestParameters.MpCreateMedicationDtoV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MPSControllerApiMedicationControllerFindAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerFindAll(requestParameters, options) {
            return localVarFp.medicationControllerFindAll(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MPSControllerApiMedicationControllerFindOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerFindOne(requestParameters, options) {
            return localVarFp.medicationControllerFindOne(requestParameters.id, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MPSControllerApiMedicationControllerRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRemove(requestParameters, options) {
            return localVarFp.medicationControllerRemove(requestParameters.id, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MPSControllerApiMedicationControllerRequestCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerRequestCheck(requestParameters, options) {
            return localVarFp.medicationControllerRequestCheck(requestParameters.tenant, requestParameters.MpCheckMedicationDtoV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MPSControllerApiMedicationControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationControllerUpdate(requestParameters, options) {
            return localVarFp.medicationControllerUpdate(requestParameters.id, requestParameters.tenant, requestParameters.MpUpdateMedicationDtoV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MPSControllerApi - object-oriented interface
 * @export
 * @class MPSControllerApi
 * @extends {BaseAPI}
 */
export class MPSControllerApi extends BaseAPI {
    /**
     *
     * @param {MPSControllerApiMedicationControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPSControllerApi
     */
    medicationControllerCreate(requestParameters, options) {
        return MPSControllerApiFp(this.configuration).medicationControllerCreate(requestParameters.tenant, requestParameters.MpCreateMedicationDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MPSControllerApiMedicationControllerFindAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPSControllerApi
     */
    medicationControllerFindAll(requestParameters, options) {
        return MPSControllerApiFp(this.configuration).medicationControllerFindAll(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MPSControllerApiMedicationControllerFindOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPSControllerApi
     */
    medicationControllerFindOne(requestParameters, options) {
        return MPSControllerApiFp(this.configuration).medicationControllerFindOne(requestParameters.id, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MPSControllerApiMedicationControllerRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPSControllerApi
     */
    medicationControllerRemove(requestParameters, options) {
        return MPSControllerApiFp(this.configuration).medicationControllerRemove(requestParameters.id, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MPSControllerApiMedicationControllerRequestCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPSControllerApi
     */
    medicationControllerRequestCheck(requestParameters, options) {
        return MPSControllerApiFp(this.configuration).medicationControllerRequestCheck(requestParameters.tenant, requestParameters.MpCheckMedicationDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MPSControllerApiMedicationControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPSControllerApi
     */
    medicationControllerUpdate(requestParameters, options) {
        return MPSControllerApiFp(this.configuration).medicationControllerUpdate(requestParameters.id, requestParameters.tenant, requestParameters.MpUpdateMedicationDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MailingSubscriptionControllerApi - axios parameter creator
 * @export
 */
export const MailingSubscriptionControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Activate the subscription with a given token
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subscription_token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut: (tenant, subscription_token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut', 'tenant', tenant);
            // verify required parameter 'subscription_token' is not null or undefined
            assertParamExists('mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut', 'subscription_token', subscription_token);
            const localVarPath = `/mailing-subscription/v1/{tenant}/activate/subscriptions/{subscription-token}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subscription-token"}}`, encodeURIComponent(String(subscription_token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows a customer to retrieve its own subscriptions only.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsGet: (tenant, customerNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mailingSubscriptionV1TenantSubscriptionsGet', 'tenant', tenant);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('mailingSubscriptionV1TenantSubscriptionsGet', 'customerNumber', customerNumber);
            const localVarPath = `/mailing-subscription/v1/{tenant}/subscriptions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (customerNumber !== undefined) {
                localVarQueryParameter['customerNumber'] = customerNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a specific subscription
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {UnsubscribeSubscriptionRequestV1} [UnsubscribeSubscriptionRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsPatch: (tenant, UnsubscribeSubscriptionRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mailingSubscriptionV1TenantSubscriptionsPatch', 'tenant', tenant);
            const localVarPath = `/mailing-subscription/v1/{tenant}/subscriptions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UnsubscribeSubscriptionRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MailingSubscriptionRequestV1} [MailingSubscriptionRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsPost: (tenant, MailingSubscriptionRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mailingSubscriptionV1TenantSubscriptionsPost', 'tenant', tenant);
            const localVarPath = `/mailing-subscription/v1/{tenant}/subscriptions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MailingSubscriptionRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MailingSubscriptionControllerApi - functional programming interface
 * @export
 */
export const MailingSubscriptionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = MailingSubscriptionControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Activate the subscription with a given token
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subscription_token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(tenant, subscription_token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(tenant, subscription_token, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint allows a customer to retrieve its own subscriptions only.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsGet(tenant, customerNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mailingSubscriptionV1TenantSubscriptionsGet(tenant, customerNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update a specific subscription
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {UnsubscribeSubscriptionRequestV1} [UnsubscribeSubscriptionRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsPatch(tenant, UnsubscribeSubscriptionRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mailingSubscriptionV1TenantSubscriptionsPatch(tenant, UnsubscribeSubscriptionRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MailingSubscriptionRequestV1} [MailingSubscriptionRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsPost(tenant, MailingSubscriptionRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mailingSubscriptionV1TenantSubscriptionsPost(tenant, MailingSubscriptionRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MailingSubscriptionControllerApi - factory interface
 * @export
 */
export const MailingSubscriptionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MailingSubscriptionControllerApiFp(configuration);
    return {
        /**
         * Activate the subscription with a given token
         * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(requestParameters, options) {
            return localVarFp.mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(requestParameters.tenant, requestParameters.subscription_token, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows a customer to retrieve its own subscriptions only.
         * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantSubscriptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsGet(requestParameters, options) {
            return localVarFp.mailingSubscriptionV1TenantSubscriptionsGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific subscription
         * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantSubscriptionsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsPatch(requestParameters, options) {
            return localVarFp.mailingSubscriptionV1TenantSubscriptionsPatch(requestParameters.tenant, requestParameters.UnsubscribeSubscriptionRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantSubscriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingSubscriptionV1TenantSubscriptionsPost(requestParameters, options) {
            return localVarFp.mailingSubscriptionV1TenantSubscriptionsPost(requestParameters.tenant, requestParameters.MailingSubscriptionRequestV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MailingSubscriptionControllerApi - object-oriented interface
 * @export
 * @class MailingSubscriptionControllerApi
 * @extends {BaseAPI}
 */
export class MailingSubscriptionControllerApi extends BaseAPI {
    /**
     * Activate the subscription with a given token
     * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingSubscriptionControllerApi
     */
    mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(requestParameters, options) {
        return MailingSubscriptionControllerApiFp(this.configuration).mailingSubscriptionV1TenantActivateSubscriptionsSubscriptionTokenPut(requestParameters.tenant, requestParameters.subscription_token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows a customer to retrieve its own subscriptions only.
     * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantSubscriptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingSubscriptionControllerApi
     */
    mailingSubscriptionV1TenantSubscriptionsGet(requestParameters, options) {
        return MailingSubscriptionControllerApiFp(this.configuration).mailingSubscriptionV1TenantSubscriptionsGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a specific subscription
     * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantSubscriptionsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingSubscriptionControllerApi
     */
    mailingSubscriptionV1TenantSubscriptionsPatch(requestParameters, options) {
        return MailingSubscriptionControllerApiFp(this.configuration).mailingSubscriptionV1TenantSubscriptionsPatch(requestParameters.tenant, requestParameters.UnsubscribeSubscriptionRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingSubscriptionControllerApiMailingSubscriptionV1TenantSubscriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingSubscriptionControllerApi
     */
    mailingSubscriptionV1TenantSubscriptionsPost(requestParameters, options) {
        return MailingSubscriptionControllerApiFp(this.configuration).mailingSubscriptionV1TenantSubscriptionsPost(requestParameters.tenant, requestParameters.MailingSubscriptionRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MaxDosageServiceV1Api - axios parameter creator
 * @export
 */
export const MaxDosageServiceV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
         * @summary Returns a list of overdrafts including the affected products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMaxdosageGetOverdrafts: (tenant, MaxDosageRequestV1, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyMaxdosageGetOverdrafts', 'tenant', tenant);
            // verify required parameter 'MaxDosageRequestV1' is not null or undefined
            assertParamExists('bullyMaxdosageGetOverdrafts', 'MaxDosageRequestV1', MaxDosageRequestV1);
            const localVarPath = `/maxdosage/v1/{tenant}/overdrafts`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MaxDosageRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the health status of MaxDosage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageApiGetMaxDosageHealth: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/maxdosage/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Calculates possible overdrafts against maximum dosage groups
         * @summary Returns a list of overdrafts including the affected products for PDP
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageV1TenantProductPageLimitPost: (tenant, MaxDosageRequestV2, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('maxdosageV1TenantProductPageLimitPost', 'tenant', tenant);
            // verify required parameter 'MaxDosageRequestV2' is not null or undefined
            assertParamExists('maxdosageV1TenantProductPageLimitPost', 'MaxDosageRequestV2', MaxDosageRequestV2);
            const localVarPath = `/maxdosage/v1/{tenant}/product-page-limit`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MaxDosageRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MaxDosageServiceV1Api - functional programming interface
 * @export
 */
export const MaxDosageServiceV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = MaxDosageServiceV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
         * @summary Returns a list of overdrafts including the affected products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMaxdosageGetOverdrafts(tenant, MaxDosageRequestV1, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyMaxdosageGetOverdrafts(tenant, MaxDosageRequestV1, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the health status of MaxDosage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageApiGetMaxDosageHealth(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.maxdosageApiGetMaxDosageHealth(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Calculates possible overdrafts against maximum dosage groups
         * @summary Returns a list of overdrafts including the affected products for PDP
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageV1TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.maxdosageV1TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MaxDosageServiceV1Api - factory interface
 * @export
 */
export const MaxDosageServiceV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MaxDosageServiceV1ApiFp(configuration);
    return {
        /**
         * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
         * @summary Returns a list of overdrafts including the affected products
         * @param {MaxDosageServiceV1ApiBullyMaxdosageGetOverdraftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMaxdosageGetOverdrafts(requestParameters, options) {
            return localVarFp.bullyMaxdosageGetOverdrafts(requestParameters.tenant, requestParameters.MaxDosageRequestV1, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the health status of MaxDosage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageApiGetMaxDosageHealth(options) {
            return localVarFp.maxdosageApiGetMaxDosageHealth(options).then((request) => request(axios, basePath));
        },
        /**
         * Calculates possible overdrafts against maximum dosage groups
         * @summary Returns a list of overdrafts including the affected products for PDP
         * @param {MaxDosageServiceV1ApiMaxdosageV1TenantProductPageLimitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageV1TenantProductPageLimitPost(requestParameters, options) {
            return localVarFp.maxdosageV1TenantProductPageLimitPost(requestParameters.tenant, requestParameters.MaxDosageRequestV2, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MaxDosageServiceV1Api - object-oriented interface
 * @export
 * @class MaxDosageServiceV1Api
 * @extends {BaseAPI}
 */
export class MaxDosageServiceV1Api extends BaseAPI {
    /**
     * Calculates possible overdrafts against maximum dosage groups for the provided cart items.
     * @summary Returns a list of overdrafts including the affected products
     * @param {MaxDosageServiceV1ApiBullyMaxdosageGetOverdraftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaxDosageServiceV1Api
     */
    bullyMaxdosageGetOverdrafts(requestParameters, options) {
        return MaxDosageServiceV1ApiFp(this.configuration).bullyMaxdosageGetOverdrafts(requestParameters.tenant, requestParameters.MaxDosageRequestV1, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the health status of MaxDosage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaxDosageServiceV1Api
     */
    maxdosageApiGetMaxDosageHealth(options) {
        return MaxDosageServiceV1ApiFp(this.configuration).maxdosageApiGetMaxDosageHealth(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Calculates possible overdrafts against maximum dosage groups
     * @summary Returns a list of overdrafts including the affected products for PDP
     * @param {MaxDosageServiceV1ApiMaxdosageV1TenantProductPageLimitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaxDosageServiceV1Api
     */
    maxdosageV1TenantProductPageLimitPost(requestParameters, options) {
        return MaxDosageServiceV1ApiFp(this.configuration).maxdosageV1TenantProductPageLimitPost(requestParameters.tenant, requestParameters.MaxDosageRequestV2, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MaxDosageServiceV2Api - axios parameter creator
 * @export
 */
export const MaxDosageServiceV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Calculates possible overdrafts against maximum dosage groups for the provided cart and potentially existing purchase history items.
         * @summary Returns a list of overdrafts including the affected products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMaxdosageGetOverdraftsWithHistory: (tenant, MaxDosageRequestV1, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyMaxdosageGetOverdraftsWithHistory', 'tenant', tenant);
            // verify required parameter 'MaxDosageRequestV1' is not null or undefined
            assertParamExists('bullyMaxdosageGetOverdraftsWithHistory', 'MaxDosageRequestV1', MaxDosageRequestV1);
            const localVarPath = `/maxdosage/v2/{tenant}/overdrafts`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MaxDosageRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Calculates possible overdrafts against maximum dosage groups
         * @summary Returns a list of overdrafts, including the cart and purchase history, for affected products for PDP
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageV2TenantProductPageLimitPost: (tenant, MaxDosageRequestV2, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('maxdosageV2TenantProductPageLimitPost', 'tenant', tenant);
            // verify required parameter 'MaxDosageRequestV2' is not null or undefined
            assertParamExists('maxdosageV2TenantProductPageLimitPost', 'MaxDosageRequestV2', MaxDosageRequestV2);
            const localVarPath = `/maxdosage/v2/{tenant}/product-page-limit`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MaxDosageRequestV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MaxDosageServiceV2Api - functional programming interface
 * @export
 */
export const MaxDosageServiceV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = MaxDosageServiceV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Calculates possible overdrafts against maximum dosage groups for the provided cart and potentially existing purchase history items.
         * @summary Returns a list of overdrafts including the affected products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV1} MaxDosageRequestV1 Current cart contents
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMaxdosageGetOverdraftsWithHistory(tenant, MaxDosageRequestV1, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyMaxdosageGetOverdraftsWithHistory(tenant, MaxDosageRequestV1, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Calculates possible overdrafts against maximum dosage groups
         * @summary Returns a list of overdrafts, including the cart and purchase history, for affected products for PDP
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MaxDosageRequestV2} MaxDosageRequestV2 overdrafts for PDP
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageV2TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.maxdosageV2TenantProductPageLimitPost(tenant, MaxDosageRequestV2, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MaxDosageServiceV2Api - factory interface
 * @export
 */
export const MaxDosageServiceV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MaxDosageServiceV2ApiFp(configuration);
    return {
        /**
         * Calculates possible overdrafts against maximum dosage groups for the provided cart and potentially existing purchase history items.
         * @summary Returns a list of overdrafts including the affected products
         * @param {MaxDosageServiceV2ApiBullyMaxdosageGetOverdraftsWithHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMaxdosageGetOverdraftsWithHistory(requestParameters, options) {
            return localVarFp.bullyMaxdosageGetOverdraftsWithHistory(requestParameters.tenant, requestParameters.MaxDosageRequestV1, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
        /**
         * Calculates possible overdrafts against maximum dosage groups
         * @summary Returns a list of overdrafts, including the cart and purchase history, for affected products for PDP
         * @param {MaxDosageServiceV2ApiMaxdosageV2TenantProductPageLimitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maxdosageV2TenantProductPageLimitPost(requestParameters, options) {
            return localVarFp.maxdosageV2TenantProductPageLimitPost(requestParameters.tenant, requestParameters.MaxDosageRequestV2, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MaxDosageServiceV2Api - object-oriented interface
 * @export
 * @class MaxDosageServiceV2Api
 * @extends {BaseAPI}
 */
export class MaxDosageServiceV2Api extends BaseAPI {
    /**
     * Calculates possible overdrafts against maximum dosage groups for the provided cart and potentially existing purchase history items.
     * @summary Returns a list of overdrafts including the affected products
     * @param {MaxDosageServiceV2ApiBullyMaxdosageGetOverdraftsWithHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaxDosageServiceV2Api
     */
    bullyMaxdosageGetOverdraftsWithHistory(requestParameters, options) {
        return MaxDosageServiceV2ApiFp(this.configuration).bullyMaxdosageGetOverdraftsWithHistory(requestParameters.tenant, requestParameters.MaxDosageRequestV1, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Calculates possible overdrafts against maximum dosage groups
     * @summary Returns a list of overdrafts, including the cart and purchase history, for affected products for PDP
     * @param {MaxDosageServiceV2ApiMaxdosageV2TenantProductPageLimitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaxDosageServiceV2Api
     */
    maxdosageV2TenantProductPageLimitPost(requestParameters, options) {
        return MaxDosageServiceV2ApiFp(this.configuration).maxdosageV2TenantProductPageLimitPost(requestParameters.tenant, requestParameters.MaxDosageRequestV2, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MiraklControllerV1Api - axios parameter creator
 * @export
 */
export const MiraklControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns the order split from mirakl
         * @summary Request order split
         * @param {string} offers QueryParam offers
         * @param {string} shippingZoneCode QueryParam shippingZoneCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMiraklOrderSplit: (offers, shippingZoneCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offers' is not null or undefined
            assertParamExists('bullyMiraklOrderSplit', 'offers', offers);
            // verify required parameter 'shippingZoneCode' is not null or undefined
            assertParamExists('bullyMiraklOrderSplit', 'shippingZoneCode', shippingZoneCode);
            const localVarPath = `/mirakl/v1/order/split`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offers !== undefined) {
                localVarQueryParameter['offers'] = offers;
            }
            if (shippingZoneCode !== undefined) {
                localVarQueryParameter['shippingZoneCode'] = shippingZoneCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ReasonsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/mirakl/v1/reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} type PathParam type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ReasonsTypeGet: (type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('miraklV1ReasonsTypeGet', 'type', type);
            const localVarPath = `/mirakl/v1/reasons/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} entityType QueryParam entityType
         * @param {string} [limit] QueryParam limit
         * @param {string} [pageToken] QueryParam pageToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsGet: (entityType, limit, pageToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('miraklV1ThreadsGet', 'entityType', entityType);
            const localVarPath = `/mirakl/v1/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (pageToken !== undefined) {
                localVarQueryParameter['pageToken'] = pageToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} threadId PathParam threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsThreadIdGet: (threadId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('miraklV1ThreadsThreadIdGet', 'threadId', threadId);
            const localVarPath = `/mirakl/v1/threads/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} threadId PathParam threadId
         * @param {MiraklThreadMessageBodyV1V1} MiraklThreadMessageBodyV1V1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsThreadIdPost: (threadId, MiraklThreadMessageBodyV1V1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('miraklV1ThreadsThreadIdPost', 'threadId', threadId);
            // verify required parameter 'MiraklThreadMessageBodyV1V1' is not null or undefined
            assertParamExists('miraklV1ThreadsThreadIdPost', 'MiraklThreadMessageBodyV1V1', MiraklThreadMessageBodyV1V1);
            const localVarPath = `/mirakl/v1/threads/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MiraklThreadMessageBodyV1V1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MiraklControllerV1Api - functional programming interface
 * @export
 */
export const MiraklControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = MiraklControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns the order split from mirakl
         * @summary Request order split
         * @param {string} offers QueryParam offers
         * @param {string} shippingZoneCode QueryParam shippingZoneCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMiraklOrderSplit(offers, shippingZoneCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyMiraklOrderSplit(offers, shippingZoneCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ReasonsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV1ReasonsGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} type PathParam type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ReasonsTypeGet(type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV1ReasonsTypeGet(type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} entityType QueryParam entityType
         * @param {string} [limit] QueryParam limit
         * @param {string} [pageToken] QueryParam pageToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsGet(entityType, limit, pageToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV1ThreadsGet(entityType, limit, pageToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} threadId PathParam threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsThreadIdGet(threadId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV1ThreadsThreadIdGet(threadId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} threadId PathParam threadId
         * @param {MiraklThreadMessageBodyV1V1} MiraklThreadMessageBodyV1V1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsThreadIdPost(threadId, MiraklThreadMessageBodyV1V1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV1ThreadsThreadIdPost(threadId, MiraklThreadMessageBodyV1V1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MiraklControllerV1Api - factory interface
 * @export
 */
export const MiraklControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MiraklControllerV1ApiFp(configuration);
    return {
        /**
         * Returns the order split from mirakl
         * @summary Request order split
         * @param {MiraklControllerV1ApiBullyMiraklOrderSplitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyMiraklOrderSplit(requestParameters, options) {
            return localVarFp.bullyMiraklOrderSplit(requestParameters.offers, requestParameters.shippingZoneCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ReasonsGet(options) {
            return localVarFp.miraklV1ReasonsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV1ApiMiraklV1ReasonsTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ReasonsTypeGet(requestParameters, options) {
            return localVarFp.miraklV1ReasonsTypeGet(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV1ApiMiraklV1ThreadsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsGet(requestParameters, options) {
            return localVarFp.miraklV1ThreadsGet(requestParameters.entityType, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV1ApiMiraklV1ThreadsThreadIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsThreadIdGet(requestParameters, options) {
            return localVarFp.miraklV1ThreadsThreadIdGet(requestParameters.threadId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV1ApiMiraklV1ThreadsThreadIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV1ThreadsThreadIdPost(requestParameters, options) {
            return localVarFp.miraklV1ThreadsThreadIdPost(requestParameters.threadId, requestParameters.MiraklThreadMessageBodyV1V1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MiraklControllerV1Api - object-oriented interface
 * @export
 * @class MiraklControllerV1Api
 * @extends {BaseAPI}
 */
export class MiraklControllerV1Api extends BaseAPI {
    /**
     * Returns the order split from mirakl
     * @summary Request order split
     * @param {MiraklControllerV1ApiBullyMiraklOrderSplitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV1Api
     */
    bullyMiraklOrderSplit(requestParameters, options) {
        return MiraklControllerV1ApiFp(this.configuration).bullyMiraklOrderSplit(requestParameters.offers, requestParameters.shippingZoneCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV1Api
     */
    miraklV1ReasonsGet(options) {
        return MiraklControllerV1ApiFp(this.configuration).miraklV1ReasonsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV1ApiMiraklV1ReasonsTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV1Api
     */
    miraklV1ReasonsTypeGet(requestParameters, options) {
        return MiraklControllerV1ApiFp(this.configuration).miraklV1ReasonsTypeGet(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV1ApiMiraklV1ThreadsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV1Api
     */
    miraklV1ThreadsGet(requestParameters, options) {
        return MiraklControllerV1ApiFp(this.configuration).miraklV1ThreadsGet(requestParameters.entityType, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV1ApiMiraklV1ThreadsThreadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV1Api
     */
    miraklV1ThreadsThreadIdGet(requestParameters, options) {
        return MiraklControllerV1ApiFp(this.configuration).miraklV1ThreadsThreadIdGet(requestParameters.threadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV1ApiMiraklV1ThreadsThreadIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV1Api
     */
    miraklV1ThreadsThreadIdPost(requestParameters, options) {
        return MiraklControllerV1ApiFp(this.configuration).miraklV1ThreadsThreadIdPost(requestParameters.threadId, requestParameters.MiraklThreadMessageBodyV1V1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MiraklControllerV2Api - axios parameter creator
 * @export
 */
export const MiraklControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantReasonsGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('miraklV2TenantReasonsGet', 'tenant', tenant);
            const localVarPath = `/mirakl/v2/{tenant}/reasons`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidGet: (tenant, subOrderid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidGet', 'tenant', tenant);
            // verify required parameter 'subOrderid' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidGet', 'subOrderid', subOrderid);
            const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsGet: (tenant, subOrderid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsGet', 'tenant', tenant);
            // verify required parameter 'subOrderid' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsGet', 'subOrderid', subOrderid);
            const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {MiraklCreateThreadRequestBodyV2} MiraklCreateThreadRequestBodyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsPost: (tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsPost', 'tenant', tenant);
            // verify required parameter 'subOrderid' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsPost', 'subOrderid', subOrderid);
            // verify required parameter 'MiraklCreateThreadRequestBodyV2' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsPost', 'MiraklCreateThreadRequestBodyV2', MiraklCreateThreadRequestBodyV2);
            const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MiraklCreateThreadRequestBodyV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {string} threadId the thread\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdGet: (tenant, subOrderid, threadId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdGet', 'tenant', tenant);
            // verify required parameter 'subOrderid' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdGet', 'subOrderid', subOrderid);
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdGet', 'threadId', threadId);
            const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads/{threadId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * dowload attachment with id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {string} threadId the thread\&#39;s id
         * @param {string} attachmentId the attachment\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet: (tenant, subOrderid, threadId, attachmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet', 'tenant', tenant);
            // verify required parameter 'subOrderid' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet', 'subOrderid', subOrderid);
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet', 'threadId', threadId);
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet', 'attachmentId', attachmentId);
            const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads/{threadId}/message/attachments/{attachmentId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {string} threadId the thread\&#39;s id
         * @param {MiraklAddMessageRequestBodyV2} MiraklAddMessageRequestBodyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdMessagePost: (tenant, subOrderid, threadId, MiraklAddMessageRequestBodyV2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessagePost', 'tenant', tenant);
            // verify required parameter 'subOrderid' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessagePost', 'subOrderid', subOrderid);
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessagePost', 'threadId', threadId);
            // verify required parameter 'MiraklAddMessageRequestBodyV2' is not null or undefined
            assertParamExists('miraklV2TenantSubOrderidThreadsThreadIdMessagePost', 'MiraklAddMessageRequestBodyV2', MiraklAddMessageRequestBodyV2);
            const localVarPath = `/mirakl/v2/{tenant}/{subOrderid}/threads/{threadId}/message`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subOrderid"}}`, encodeURIComponent(String(subOrderid)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MiraklAddMessageRequestBodyV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MiraklControllerV2Api - functional programming interface
 * @export
 */
export const MiraklControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = MiraklControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantReasonsGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV2TenantReasonsGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidGet(tenant, subOrderid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV2TenantSubOrderidGet(tenant, subOrderid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsGet(tenant, subOrderid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsGet(tenant, subOrderid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {MiraklCreateThreadRequestBodyV2} MiraklCreateThreadRequestBodyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsPost(tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsPost(tenant, subOrderid, MiraklCreateThreadRequestBodyV2, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {string} threadId the thread\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdGet(tenant, subOrderid, threadId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsThreadIdGet(tenant, subOrderid, threadId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * dowload attachment with id
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {string} threadId the thread\&#39;s id
         * @param {string} attachmentId the attachment\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(tenant, subOrderid, threadId, attachmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(tenant, subOrderid, threadId, attachmentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderid the seller\&#39;s suborder id
         * @param {string} threadId the thread\&#39;s id
         * @param {MiraklAddMessageRequestBodyV2} MiraklAddMessageRequestBodyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdMessagePost(tenant, subOrderid, threadId, MiraklAddMessageRequestBodyV2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.miraklV2TenantSubOrderidThreadsThreadIdMessagePost(tenant, subOrderid, threadId, MiraklAddMessageRequestBodyV2, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MiraklControllerV2Api - factory interface
 * @export
 */
export const MiraklControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MiraklControllerV2ApiFp(configuration);
    return {
        /**
         *
         * @param {MiraklControllerV2ApiMiraklV2TenantReasonsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantReasonsGet(requestParameters, options) {
            return localVarFp.miraklV2TenantReasonsGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidGet(requestParameters, options) {
            return localVarFp.miraklV2TenantSubOrderidGet(requestParameters.tenant, requestParameters.subOrderid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsGet(requestParameters, options) {
            return localVarFp.miraklV2TenantSubOrderidThreadsGet(requestParameters.tenant, requestParameters.subOrderid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsPost(requestParameters, options) {
            return localVarFp.miraklV2TenantSubOrderidThreadsPost(requestParameters.tenant, requestParameters.subOrderid, requestParameters.MiraklCreateThreadRequestBodyV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsThreadIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdGet(requestParameters, options) {
            return localVarFp.miraklV2TenantSubOrderidThreadsThreadIdGet(requestParameters.tenant, requestParameters.subOrderid, requestParameters.threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * dowload attachment with id
         * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(requestParameters, options) {
            return localVarFp.miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(requestParameters.tenant, requestParameters.subOrderid, requestParameters.threadId, requestParameters.attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsThreadIdMessagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miraklV2TenantSubOrderidThreadsThreadIdMessagePost(requestParameters, options) {
            return localVarFp.miraklV2TenantSubOrderidThreadsThreadIdMessagePost(requestParameters.tenant, requestParameters.subOrderid, requestParameters.threadId, requestParameters.MiraklAddMessageRequestBodyV2, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MiraklControllerV2Api - object-oriented interface
 * @export
 * @class MiraklControllerV2Api
 * @extends {BaseAPI}
 */
export class MiraklControllerV2Api extends BaseAPI {
    /**
     *
     * @param {MiraklControllerV2ApiMiraklV2TenantReasonsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV2Api
     */
    miraklV2TenantReasonsGet(requestParameters, options) {
        return MiraklControllerV2ApiFp(this.configuration).miraklV2TenantReasonsGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV2Api
     */
    miraklV2TenantSubOrderidGet(requestParameters, options) {
        return MiraklControllerV2ApiFp(this.configuration).miraklV2TenantSubOrderidGet(requestParameters.tenant, requestParameters.subOrderid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV2Api
     */
    miraklV2TenantSubOrderidThreadsGet(requestParameters, options) {
        return MiraklControllerV2ApiFp(this.configuration).miraklV2TenantSubOrderidThreadsGet(requestParameters.tenant, requestParameters.subOrderid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV2Api
     */
    miraklV2TenantSubOrderidThreadsPost(requestParameters, options) {
        return MiraklControllerV2ApiFp(this.configuration).miraklV2TenantSubOrderidThreadsPost(requestParameters.tenant, requestParameters.subOrderid, requestParameters.MiraklCreateThreadRequestBodyV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsThreadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV2Api
     */
    miraklV2TenantSubOrderidThreadsThreadIdGet(requestParameters, options) {
        return MiraklControllerV2ApiFp(this.configuration).miraklV2TenantSubOrderidThreadsThreadIdGet(requestParameters.tenant, requestParameters.subOrderid, requestParameters.threadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * dowload attachment with id
     * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV2Api
     */
    miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(requestParameters, options) {
        return MiraklControllerV2ApiFp(this.configuration).miraklV2TenantSubOrderidThreadsThreadIdMessageAttachmentsAttachmentIdGet(requestParameters.tenant, requestParameters.subOrderid, requestParameters.threadId, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MiraklControllerV2ApiMiraklV2TenantSubOrderidThreadsThreadIdMessagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiraklControllerV2Api
     */
    miraklV2TenantSubOrderidThreadsThreadIdMessagePost(requestParameters, options) {
        return MiraklControllerV2ApiFp(this.configuration).miraklV2TenantSubOrderidThreadsThreadIdMessagePost(requestParameters.tenant, requestParameters.subOrderid, requestParameters.threadId, requestParameters.MiraklAddMessageRequestBodyV2, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MobileAccountControllerV1Api - axios parameter creator
 * @export
 */
export const MobileAccountControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used by a customer to retrieve a push notifications configuration
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} leanPlumUserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet: (tenant, leanPlumUserId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet', 'tenant', tenant);
            // verify required parameter 'leanPlumUserId' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet', 'leanPlumUserId', leanPlumUserId);
            const localVarPath = `/mobileaccount/v1/{tenant}/pushNotificationsConfiguration/{leanPlumUserId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"leanPlumUserId"}}`, encodeURIComponent(String(leanPlumUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to set a push notifications toggles
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} leanPlumUserId
         * @param {PushNotificationsTogglesDto} PushNotificationsTogglesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost: (tenant, leanPlumUserId, PushNotificationsTogglesDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost', 'tenant', tenant);
            // verify required parameter 'leanPlumUserId' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost', 'leanPlumUserId', leanPlumUserId);
            // verify required parameter 'PushNotificationsTogglesDto' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost', 'PushNotificationsTogglesDto', PushNotificationsTogglesDto);
            const localVarPath = `/mobileaccount/v1/{tenant}/pushNotificationsConfiguration/{leanPlumUserId}/toggles`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"leanPlumUserId"}}`, encodeURIComponent(String(leanPlumUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PushNotificationsTogglesDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to set a push notifications toggles
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} leanPlumUserId
         * @param {string} toggleName
         * @param {MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost: (tenant, leanPlumUserId, toggleName, MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost', 'tenant', tenant);
            // verify required parameter 'leanPlumUserId' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost', 'leanPlumUserId', leanPlumUserId);
            // verify required parameter 'toggleName' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost', 'toggleName', toggleName);
            // verify required parameter 'MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest' is not null or undefined
            assertParamExists('mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost', 'MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest', MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest);
            const localVarPath = `/mobileaccount/v1/{tenant}/pushNotificationsConfiguration/{leanPlumUserId}/toggles/{toggleName}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"leanPlumUserId"}}`, encodeURIComponent(String(leanPlumUserId)))
                .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MobileAccountControllerV1Api - functional programming interface
 * @export
 */
export const MobileAccountControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = MobileAccountControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Used by a customer to retrieve a push notifications configuration
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} leanPlumUserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(tenant, leanPlumUserId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(tenant, leanPlumUserId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by a customer to set a push notifications toggles
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} leanPlumUserId
         * @param {PushNotificationsTogglesDto} PushNotificationsTogglesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(tenant, leanPlumUserId, PushNotificationsTogglesDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(tenant, leanPlumUserId, PushNotificationsTogglesDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by a customer to set a push notifications toggles
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} leanPlumUserId
         * @param {string} toggleName
         * @param {MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(tenant, leanPlumUserId, toggleName, MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(tenant, leanPlumUserId, toggleName, MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MobileAccountControllerV1Api - factory interface
 * @export
 */
export const MobileAccountControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MobileAccountControllerV1ApiFp(configuration);
    return {
        /**
         * Used by a customer to retrieve a push notifications configuration
         * @param {MobileAccountControllerV1ApiMobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(requestParameters, options) {
            return localVarFp.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(requestParameters.tenant, requestParameters.leanPlumUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to set a push notifications toggles
         * @param {MobileAccountControllerV1ApiMobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(requestParameters, options) {
            return localVarFp.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(requestParameters.tenant, requestParameters.leanPlumUserId, requestParameters.PushNotificationsTogglesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to set a push notifications toggles
         * @param {MobileAccountControllerV1ApiMobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(requestParameters, options) {
            return localVarFp.mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(requestParameters.tenant, requestParameters.leanPlumUserId, requestParameters.toggleName, requestParameters.MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MobileAccountControllerV1Api - object-oriented interface
 * @export
 * @class MobileAccountControllerV1Api
 * @extends {BaseAPI}
 */
export class MobileAccountControllerV1Api extends BaseAPI {
    /**
     * Used by a customer to retrieve a push notifications configuration
     * @param {MobileAccountControllerV1ApiMobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAccountControllerV1Api
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(requestParameters, options) {
        return MobileAccountControllerV1ApiFp(this.configuration).mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdGet(requestParameters.tenant, requestParameters.leanPlumUserId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to set a push notifications toggles
     * @param {MobileAccountControllerV1ApiMobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAccountControllerV1Api
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(requestParameters, options) {
        return MobileAccountControllerV1ApiFp(this.configuration).mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesPost(requestParameters.tenant, requestParameters.leanPlumUserId, requestParameters.PushNotificationsTogglesDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to set a push notifications toggles
     * @param {MobileAccountControllerV1ApiMobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAccountControllerV1Api
     */
    mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(requestParameters, options) {
        return MobileAccountControllerV1ApiFp(this.configuration).mobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePost(requestParameters.tenant, requestParameters.leanPlumUserId, requestParameters.toggleName, requestParameters.MobileaccountV1TenantPushNotificationsConfigurationLeanPlumUserIdTogglesToggleNamePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MyTherapyControllerV1Api - axios parameter creator
 * @export
 */
export const MyTherapyControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used by a customer to retrieve a MyTherapy activation link
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {'SAE App' | 'Email' | 'Webshop' | 'Package Insert'} [attributionChannel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mytherapyV1TenantOrdersOrderNumberActivationLinkGet: (tenant, orderNumber, attributionChannel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('mytherapyV1TenantOrdersOrderNumberActivationLinkGet', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('mytherapyV1TenantOrdersOrderNumberActivationLinkGet', 'orderNumber', orderNumber);
            const localVarPath = `/mytherapy/v1/{tenant}/orders/{orderNumber}/activationLink`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (attributionChannel !== undefined) {
                localVarQueryParameter['attributionChannel'] = attributionChannel;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MyTherapyControllerV1Api - functional programming interface
 * @export
 */
export const MyTherapyControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = MyTherapyControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Used by a customer to retrieve a MyTherapy activation link
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {'SAE App' | 'Email' | 'Webshop' | 'Package Insert'} [attributionChannel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mytherapyV1TenantOrdersOrderNumberActivationLinkGet(tenant, orderNumber, attributionChannel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mytherapyV1TenantOrdersOrderNumberActivationLinkGet(tenant, orderNumber, attributionChannel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MyTherapyControllerV1Api - factory interface
 * @export
 */
export const MyTherapyControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MyTherapyControllerV1ApiFp(configuration);
    return {
        /**
         * Used by a customer to retrieve a MyTherapy activation link
         * @param {MyTherapyControllerV1ApiMytherapyV1TenantOrdersOrderNumberActivationLinkGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mytherapyV1TenantOrdersOrderNumberActivationLinkGet(requestParameters, options) {
            return localVarFp.mytherapyV1TenantOrdersOrderNumberActivationLinkGet(requestParameters.tenant, requestParameters.orderNumber, requestParameters.attributionChannel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MyTherapyControllerV1Api - object-oriented interface
 * @export
 * @class MyTherapyControllerV1Api
 * @extends {BaseAPI}
 */
export class MyTherapyControllerV1Api extends BaseAPI {
    /**
     * Used by a customer to retrieve a MyTherapy activation link
     * @param {MyTherapyControllerV1ApiMytherapyV1TenantOrdersOrderNumberActivationLinkGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTherapyControllerV1Api
     */
    mytherapyV1TenantOrdersOrderNumberActivationLinkGet(requestParameters, options) {
        return MyTherapyControllerV1ApiFp(this.configuration).mytherapyV1TenantOrdersOrderNumberActivationLinkGet(requestParameters.tenant, requestParameters.orderNumber, requestParameters.attributionChannel, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NewsletterControllerApi - axios parameter creator
 * @export
 */
export const NewsletterControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantEmailDelete: (tenant, language, email, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNewsletterV1TenantEmailDelete', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNewsletterV1TenantEmailDelete', 'language', language);
            // verify required parameter 'email' is not null or undefined
            assertParamExists('languageNewsletterV1TenantEmailDelete', 'email', email);
            const localVarPath = `/{language}/newsletter/v1/{tenant}/{email}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} token
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantEmailOptinTokenGet: (tenant, language, token, email, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNewsletterV1TenantEmailOptinTokenGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNewsletterV1TenantEmailOptinTokenGet', 'language', language);
            // verify required parameter 'token' is not null or undefined
            assertParamExists('languageNewsletterV1TenantEmailOptinTokenGet', 'token', token);
            // verify required parameter 'email' is not null or undefined
            assertParamExists('languageNewsletterV1TenantEmailOptinTokenGet', 'email', email);
            const localVarPath = `/{language}/newsletter/v1/{tenant}/{email}/optin/{token}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {NewsletterRequestV1} NewsletterRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantPost: (tenant, language, NewsletterRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNewsletterV1TenantPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNewsletterV1TenantPost', 'language', language);
            // verify required parameter 'NewsletterRequestV1' is not null or undefined
            assertParamExists('languageNewsletterV1TenantPost', 'NewsletterRequestV1', NewsletterRequestV1);
            const localVarPath = `/{language}/newsletter/v1/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(NewsletterRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NewsletterControllerApi - functional programming interface
 * @export
 */
export const NewsletterControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = NewsletterControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantEmailDelete(tenant, language, email, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNewsletterV1TenantEmailDelete(tenant, language, email, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} token
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantEmailOptinTokenGet(tenant, language, token, email, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNewsletterV1TenantEmailOptinTokenGet(tenant, language, token, email, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {NewsletterRequestV1} NewsletterRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantPost(tenant, language, NewsletterRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNewsletterV1TenantPost(tenant, language, NewsletterRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NewsletterControllerApi - factory interface
 * @export
 */
export const NewsletterControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NewsletterControllerApiFp(configuration);
    return {
        /**
         *
         * @param {NewsletterControllerApiLanguageNewsletterV1TenantEmailDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantEmailDelete(requestParameters, options) {
            return localVarFp.languageNewsletterV1TenantEmailDelete(requestParameters.tenant, requestParameters.language, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NewsletterControllerApiLanguageNewsletterV1TenantEmailOptinTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantEmailOptinTokenGet(requestParameters, options) {
            return localVarFp.languageNewsletterV1TenantEmailOptinTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.token, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NewsletterControllerApiLanguageNewsletterV1TenantPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNewsletterV1TenantPost(requestParameters, options) {
            return localVarFp.languageNewsletterV1TenantPost(requestParameters.tenant, requestParameters.language, requestParameters.NewsletterRequestV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NewsletterControllerApi - object-oriented interface
 * @export
 * @class NewsletterControllerApi
 * @extends {BaseAPI}
 */
export class NewsletterControllerApi extends BaseAPI {
    /**
     *
     * @param {NewsletterControllerApiLanguageNewsletterV1TenantEmailDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsletterControllerApi
     */
    languageNewsletterV1TenantEmailDelete(requestParameters, options) {
        return NewsletterControllerApiFp(this.configuration).languageNewsletterV1TenantEmailDelete(requestParameters.tenant, requestParameters.language, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NewsletterControllerApiLanguageNewsletterV1TenantEmailOptinTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsletterControllerApi
     */
    languageNewsletterV1TenantEmailOptinTokenGet(requestParameters, options) {
        return NewsletterControllerApiFp(this.configuration).languageNewsletterV1TenantEmailOptinTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.token, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NewsletterControllerApiLanguageNewsletterV1TenantPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsletterControllerApi
     */
    languageNewsletterV1TenantPost(requestParameters, options) {
        return NewsletterControllerApiFp(this.configuration).languageNewsletterV1TenantPost(requestParameters.tenant, requestParameters.language, requestParameters.NewsletterRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NotepadControllerV2Api - axios parameter creator
 * @export
 */
export const NotepadControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets list of notepad entries accumulated with pim products and offers.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantGet: (language, tenant, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNotepadV2TenantGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNotepadV2TenantGet', 'tenant', tenant);
            const localVarPath = `/{language}/notepad/v2/{tenant}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes single notepad entry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifiers as comma separated list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidDelete: (language, tenant, upid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidDelete', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidDelete', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidDelete', 'upid', upid);
            const localVarPath = `/{language}/notepad/v2/{tenant}/{upid}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets single notepad entry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidGet: (language, tenant, upid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidGet', 'upid', upid);
            const localVarPath = `/{language}/notepad/v2/{tenant}/{upid}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Adds single notepad entry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidPut: (language, tenant, upid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidPut', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidPut', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidPut', 'upid', upid);
            const localVarPath = `/{language}/notepad/v2/{tenant}/{upid}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets list of upids for notepad entries.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidsGet: (language, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidsGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageNotepadV2TenantUpidsGet', 'tenant', tenant);
            const localVarPath = `/{language}/notepad/v2/{tenant}/upids`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NotepadControllerV2Api - functional programming interface
 * @export
 */
export const NotepadControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotepadControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets list of notepad entries accumulated with pim products and offers.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantGet(language, tenant, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNotepadV2TenantGet(language, tenant, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Deletes single notepad entry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifiers as comma separated list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidDelete(language, tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNotepadV2TenantUpidDelete(language, tenant, upid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gets single notepad entry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidGet(language, tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNotepadV2TenantUpidGet(language, tenant, upid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Adds single notepad entry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidPut(language, tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNotepadV2TenantUpidPut(language, tenant, upid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gets list of upids for notepad entries.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidsGet(language, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageNotepadV2TenantUpidsGet(language, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NotepadControllerV2Api - factory interface
 * @export
 */
export const NotepadControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotepadControllerV2ApiFp(configuration);
    return {
        /**
         * Gets list of notepad entries accumulated with pim products and offers.
         * @param {NotepadControllerV2ApiLanguageNotepadV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantGet(requestParameters, options) {
            return localVarFp.languageNotepadV2TenantGet(requestParameters.language, requestParameters.tenant, requestParameters.limit, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes single notepad entry
         * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidDelete(requestParameters, options) {
            return localVarFp.languageNotepadV2TenantUpidDelete(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets single notepad entry
         * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidGet(requestParameters, options) {
            return localVarFp.languageNotepadV2TenantUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds single notepad entry
         * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidPut(requestParameters, options) {
            return localVarFp.languageNotepadV2TenantUpidPut(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets list of upids for notepad entries.
         * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageNotepadV2TenantUpidsGet(requestParameters, options) {
            return localVarFp.languageNotepadV2TenantUpidsGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotepadControllerV2Api - object-oriented interface
 * @export
 * @class NotepadControllerV2Api
 * @extends {BaseAPI}
 */
export class NotepadControllerV2Api extends BaseAPI {
    /**
     * Gets list of notepad entries accumulated with pim products and offers.
     * @param {NotepadControllerV2ApiLanguageNotepadV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotepadControllerV2Api
     */
    languageNotepadV2TenantGet(requestParameters, options) {
        return NotepadControllerV2ApiFp(this.configuration).languageNotepadV2TenantGet(requestParameters.language, requestParameters.tenant, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes single notepad entry
     * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotepadControllerV2Api
     */
    languageNotepadV2TenantUpidDelete(requestParameters, options) {
        return NotepadControllerV2ApiFp(this.configuration).languageNotepadV2TenantUpidDelete(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets single notepad entry
     * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotepadControllerV2Api
     */
    languageNotepadV2TenantUpidGet(requestParameters, options) {
        return NotepadControllerV2ApiFp(this.configuration).languageNotepadV2TenantUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adds single notepad entry
     * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotepadControllerV2Api
     */
    languageNotepadV2TenantUpidPut(requestParameters, options) {
        return NotepadControllerV2ApiFp(this.configuration).languageNotepadV2TenantUpidPut(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets list of upids for notepad entries.
     * @param {NotepadControllerV2ApiLanguageNotepadV2TenantUpidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotepadControllerV2Api
     */
    languageNotepadV2TenantUpidsGet(requestParameters, options) {
        return NotepadControllerV2ApiFp(this.configuration).languageNotepadV2TenantUpidsGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NowControllerApi - axios parameter creator
 * @export
 */
export const NowControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {NowV1TenantInitCartPostRequest} [NowV1TenantInitCartPostRequest] Current cart contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV1TenantInitCartPost: (tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV1TenantInitCartPost', 'tenant', tenant);
            const localVarPath = `/now/v1/{tenant}/init/cart`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Sae_Device_Type != null) {
                localVarHeaderParameter['Sae-Device-Type'] = String(Sae_Device_Type);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(NowV1TenantInitCartPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NowControllerApi - functional programming interface
 * @export
 */
export const NowControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = NowControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'browser' | 'iosApp' | 'androidApp'} [Sae_Device_Type]
         * @param {NowV1TenantInitCartPostRequest} [NowV1TenantInitCartPostRequest] Current cart contents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV1TenantInitCartPost(tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV1TenantInitCartPost(tenant, Sae_Device_Type, NowV1TenantInitCartPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NowControllerApi - factory interface
 * @export
 */
export const NowControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NowControllerApiFp(configuration);
    return {
        /**
         * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
         * @param {NowControllerApiNowV1TenantInitCartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV1TenantInitCartPost(requestParameters, options) {
            return localVarFp.nowV1TenantInitCartPost(requestParameters.tenant, requestParameters.Sae_Device_Type, requestParameters.NowV1TenantInitCartPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NowControllerApi - object-oriented interface
 * @export
 * @class NowControllerApi
 * @extends {BaseAPI}
 */
export class NowControllerApi extends BaseAPI {
    /**
     * Wraps now-service\'s init checkout call for cart data using customer\'s billing address
     * @param {NowControllerApiNowV1TenantInitCartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerApi
     */
    nowV1TenantInitCartPost(requestParameters, options) {
        return NowControllerApiFp(this.configuration).nowV1TenantInitCartPost(requestParameters.tenant, requestParameters.Sae_Device_Type, requestParameters.NowV1TenantInitCartPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NowControllerV3Api - axios parameter creator
 * @export
 */
export const NowControllerV3ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckMerchantsPost: (tenant, BasicCheckObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV3TenantBasicCheckMerchantsPost', 'tenant', tenant);
            const localVarPath = `/now/v3/{tenant}/basicCheck/merchants`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckPost: (tenant, BasicCheckObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV3TenantBasicCheckPost', 'tenant', tenant);
            const localVarPath = `/now/v3/{tenant}/basicCheck`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckProductsPost: (tenant, BasicCheckObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV3TenantBasicCheckProductsPost', 'tenant', tenant);
            const localVarPath = `/now/v3/{tenant}/basicCheck/products`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Wraps now merchant center services
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantNowMerchantSellerIdGet: (tenant, sellerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV3TenantNowMerchantSellerIdGet', 'tenant', tenant);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('nowV3TenantNowMerchantSellerIdGet', 'sellerId', sellerId);
            const localVarPath = `/now/v3/{tenant}/nowMerchant/{sellerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get Now related invoices and other documents
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet: (tenant, orderNumber, subOrderId, documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'orderNumber', orderNumber);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'subOrderId', subOrderId);
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'documentId', documentId);
            const localVarPath = `/now/v3/{tenant}/orders/{orderNumber}/{subOrderId}/documents/{documentId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NowControllerV3Api - functional programming interface
 * @export
 */
export const NowControllerV3ApiFp = function (configuration) {
    const localVarAxiosParamCreator = NowControllerV3ApiAxiosParamCreator(configuration);
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckMerchantsPost(tenant, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV3TenantBasicCheckMerchantsPost(tenant, BasicCheckObject, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckPost(tenant, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV3TenantBasicCheckPost(tenant, BasicCheckObject, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckProductsPost(tenant, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV3TenantBasicCheckProductsPost(tenant, BasicCheckObject, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Wraps now merchant center services
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantNowMerchantSellerIdGet(tenant, sellerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV3TenantNowMerchantSellerIdGet(tenant, sellerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get Now related invoices and other documents
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, orderNumber, subOrderId, documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, orderNumber, subOrderId, documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NowControllerV3Api - factory interface
 * @export
 */
export const NowControllerV3ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NowControllerV3ApiFp(configuration);
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV3ApiNowV3TenantBasicCheckMerchantsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckMerchantsPost(requestParameters, options) {
            return localVarFp.nowV3TenantBasicCheckMerchantsPost(requestParameters.tenant, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV3ApiNowV3TenantBasicCheckPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckPost(requestParameters, options) {
            return localVarFp.nowV3TenantBasicCheckPost(requestParameters.tenant, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV3ApiNowV3TenantBasicCheckProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantBasicCheckProductsPost(requestParameters, options) {
            return localVarFp.nowV3TenantBasicCheckProductsPost(requestParameters.tenant, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Wraps now merchant center services
         * @param {NowControllerV3ApiNowV3TenantNowMerchantSellerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantNowMerchantSellerIdGet(requestParameters, options) {
            return localVarFp.nowV3TenantNowMerchantSellerIdGet(requestParameters.tenant, requestParameters.sellerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Now related invoices and other documents
         * @param {NowControllerV3ApiNowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters, options) {
            return localVarFp.nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters.tenant, requestParameters.orderNumber, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NowControllerV3Api - object-oriented interface
 * @export
 * @class NowControllerV3Api
 * @extends {BaseAPI}
 */
export class NowControllerV3Api extends BaseAPI {
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV3ApiNowV3TenantBasicCheckMerchantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV3Api
     */
    nowV3TenantBasicCheckMerchantsPost(requestParameters, options) {
        return NowControllerV3ApiFp(this.configuration).nowV3TenantBasicCheckMerchantsPost(requestParameters.tenant, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV3ApiNowV3TenantBasicCheckPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV3Api
     */
    nowV3TenantBasicCheckPost(requestParameters, options) {
        return NowControllerV3ApiFp(this.configuration).nowV3TenantBasicCheckPost(requestParameters.tenant, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV3ApiNowV3TenantBasicCheckProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV3Api
     */
    nowV3TenantBasicCheckProductsPost(requestParameters, options) {
        return NowControllerV3ApiFp(this.configuration).nowV3TenantBasicCheckProductsPost(requestParameters.tenant, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Wraps now merchant center services
     * @param {NowControllerV3ApiNowV3TenantNowMerchantSellerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV3Api
     */
    nowV3TenantNowMerchantSellerIdGet(requestParameters, options) {
        return NowControllerV3ApiFp(this.configuration).nowV3TenantNowMerchantSellerIdGet(requestParameters.tenant, requestParameters.sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get Now related invoices and other documents
     * @param {NowControllerV3ApiNowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV3Api
     */
    nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters, options) {
        return NowControllerV3ApiFp(this.configuration).nowV3TenantOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters.tenant, requestParameters.orderNumber, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NowControllerV4Api - axios parameter creator
 * @export
 */
export const NowControllerV4ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckMerchantsPost: (tenant, language, BasicCheckObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckMerchantsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckMerchantsPost', 'language', language);
            const localVarPath = `/now/v4/{tenant}/{language}/basicCheck/merchants`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckPost: (tenant, language, BasicCheckObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckPost', 'language', language);
            const localVarPath = `/now/v4/{tenant}/{language}/basicCheck`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckProductsPost: (tenant, language, BasicCheckObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckProductsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckProductsPost', 'language', language);
            const localVarPath = `/now/v4/{tenant}/{language}/basicCheck/products`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Wraps now merchant center services
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageNowMerchantSellerIdGet: (tenant, language, sellerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageNowMerchantSellerIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageNowMerchantSellerIdGet', 'language', language);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('nowV4TenantLanguageNowMerchantSellerIdGet', 'sellerId', sellerId);
            const localVarPath = `/now/v4/{tenant}/{language}/nowMerchant/{sellerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get Now related invoices and other documents
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet: (tenant, language, orderNumber, subOrderId, documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'language', language);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'orderNumber', orderNumber);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'subOrderId', subOrderId);
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'documentId', documentId);
            const localVarPath = `/now/v4/{tenant}/{language}/orders/{orderNumber}/{subOrderId}/documents/{documentId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NowControllerV4Api - functional programming interface
 * @export
 */
export const NowControllerV4ApiFp = function (configuration) {
    const localVarAxiosParamCreator = NowControllerV4ApiAxiosParamCreator(configuration);
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckMerchantsPost(tenant, language, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageBasicCheckMerchantsPost(tenant, language, BasicCheckObject, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckPost(tenant, language, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageBasicCheckPost(tenant, language, BasicCheckObject, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckProductsPost(tenant, language, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageBasicCheckProductsPost(tenant, language, BasicCheckObject, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Wraps now merchant center services
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageNowMerchantSellerIdGet(tenant, language, sellerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageNowMerchantSellerIdGet(tenant, language, sellerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get Now related invoices and other documents
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, language, orderNumber, subOrderId, documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, language, orderNumber, subOrderId, documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NowControllerV4Api - factory interface
 * @export
 */
export const NowControllerV4ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NowControllerV4ApiFp(configuration);
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckMerchantsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckPost(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageBasicCheckPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckProductsPost(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageBasicCheckProductsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Wraps now merchant center services
         * @param {NowControllerV4ApiNowV4TenantLanguageNowMerchantSellerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters.tenant, requestParameters.language, requestParameters.sellerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Now related invoices and other documents
         * @param {NowControllerV4ApiNowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NowControllerV4Api - object-oriented interface
 * @export
 * @class NowControllerV4Api
 * @extends {BaseAPI}
 */
export class NowControllerV4Api extends BaseAPI {
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckMerchantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV4Api
     */
    nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV4Api
     */
    nowV4TenantLanguageBasicCheckPost(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageBasicCheckPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV4Api
     */
    nowV4TenantLanguageBasicCheckProductsPost(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageBasicCheckProductsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Wraps now merchant center services
     * @param {NowControllerV4ApiNowV4TenantLanguageNowMerchantSellerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV4Api
     */
    nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters.tenant, requestParameters.language, requestParameters.sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get Now related invoices and other documents
     * @param {NowControllerV4ApiNowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NowControllerV4Api
     */
    nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OdsControllerApi - axios parameter creator
 * @export
 */
export const OdsControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Adds ods product and consultation to cart
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OdsPatchCartRequestV1} OdsPatchCartRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsApiPatchCart: (tenant, OdsPatchCartRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsApiPatchCart', 'tenant', tenant);
            // verify required parameter 'OdsPatchCartRequestV1' is not null or undefined
            assertParamExists('odsApiPatchCart', 'OdsPatchCartRequestV1', OdsPatchCartRequestV1);
            const localVarPath = `/ods/v1/{tenant}/cart`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OdsPatchCartRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get treatments by icd10 of product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV1TenantTreatmentsPost: (tenant, OdsRequestBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV1TenantTreatmentsPost', 'tenant', tenant);
            // verify required parameter 'OdsRequestBodyV1' is not null or undefined
            assertParamExists('odsV1TenantTreatmentsPost', 'OdsRequestBodyV1', OdsRequestBodyV1);
            const localVarPath = `/ods/v1/{tenant}/treatments`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OdsRequestBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all timeslots
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantProvidersProviderIdTimeslotsGet: (tenant, providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV2TenantProvidersProviderIdTimeslotsGet', 'tenant', tenant);
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('odsV2TenantProvidersProviderIdTimeslotsGet', 'providerId', providerId);
            const localVarPath = `/ods/v2/{tenant}/providers/{providerId}/timeslots`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all treatments by icd10 of product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'icd10'} [orderBy] orders the treatments by their id in ascending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsGet: (tenant, orderBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsGet', 'tenant', tenant);
            const localVarPath = `/ods/v2/{tenant}/treatments`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get treatments by icd10 of product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsPost: (tenant, OdsRequestBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsPost', 'tenant', tenant);
            // verify required parameter 'OdsRequestBodyV1' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsPost', 'OdsRequestBodyV1', OdsRequestBodyV1);
            const localVarPath = `/ods/v2/{tenant}/treatments`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OdsRequestBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a treatment by it\'s exact service id
         * @param {string} serviceId The service id for the treatment
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsServiceServiceIdGet: (serviceId, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsServiceServiceIdGet', 'serviceId', serviceId);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsServiceServiceIdGet', 'tenant', tenant);
            const localVarPath = `/ods/v2/{tenant}/treatments/service/{serviceId}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all providers of a certain treatment
         * @param {string} treatmentId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentIdProvidersGet: (treatmentId, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsTreatmentIdProvidersGet', 'treatmentId', treatmentId);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsTreatmentIdProvidersGet', 'tenant', tenant);
            const localVarPath = `/ods/v2/{tenant}/treatments/{treatmentId}/providers`
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get treatment by name of treatment
         * @param {string} treatmentName
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentNameTreatmentNameGet: (treatmentName, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'treatmentName' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsTreatmentNameTreatmentNameGet', 'treatmentName', treatmentName);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsTreatmentNameTreatmentNameGet', 'tenant', tenant);
            const localVarPath = `/ods/v2/{tenant}/treatments/treatmentName/{treatmentName}`
                .replace(`{${"treatmentName"}}`, encodeURIComponent(String(treatmentName)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a treatment by icd10 of product
         * @param {string} treatmentId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentTreatmentIdGet: (treatmentId, tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsTreatmentTreatmentIdGet', 'treatmentId', treatmentId);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('odsV2TenantTreatmentsTreatmentTreatmentIdGet', 'tenant', tenant);
            const localVarPath = `/ods/v2/{tenant}/treatments/treatment/{treatmentId}`
                .replace(`{${"treatmentId"}}`, encodeURIComponent(String(treatmentId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OdsControllerApi - functional programming interface
 * @export
 */
export const OdsControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OdsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Adds ods product and consultation to cart
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OdsPatchCartRequestV1} OdsPatchCartRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsApiPatchCart(tenant, OdsPatchCartRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsApiPatchCart(tenant, OdsPatchCartRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get treatments by icd10 of product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV1TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV1TenantTreatmentsPost(tenant, OdsRequestBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all timeslots
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantProvidersProviderIdTimeslotsGet(tenant, providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV2TenantProvidersProviderIdTimeslotsGet(tenant, providerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all treatments by icd10 of product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {'icd10'} [orderBy] orders the treatments by their id in ascending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsGet(tenant, orderBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV2TenantTreatmentsGet(tenant, orderBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get treatments by icd10 of product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OdsRequestBodyV1} OdsRequestBodyV1 Treatments request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsPost(tenant, OdsRequestBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV2TenantTreatmentsPost(tenant, OdsRequestBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a treatment by it\'s exact service id
         * @param {string} serviceId The service id for the treatment
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsServiceServiceIdGet(serviceId, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV2TenantTreatmentsServiceServiceIdGet(serviceId, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all providers of a certain treatment
         * @param {string} treatmentId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentIdProvidersGet(treatmentId, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV2TenantTreatmentsTreatmentIdProvidersGet(treatmentId, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get treatment by name of treatment
         * @param {string} treatmentName
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentNameTreatmentNameGet(treatmentName, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV2TenantTreatmentsTreatmentNameTreatmentNameGet(treatmentName, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a treatment by icd10 of product
         * @param {string} treatmentId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentTreatmentIdGet(treatmentId, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odsV2TenantTreatmentsTreatmentTreatmentIdGet(treatmentId, tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OdsControllerApi - factory interface
 * @export
 */
export const OdsControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OdsControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Adds ods product and consultation to cart
         * @param {OdsControllerApiOdsApiPatchCartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsApiPatchCart(requestParameters, options) {
            return localVarFp.odsApiPatchCart(requestParameters.tenant, requestParameters.OdsPatchCartRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get treatments by icd10 of product
         * @param {OdsControllerApiOdsV1TenantTreatmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV1TenantTreatmentsPost(requestParameters, options) {
            return localVarFp.odsV1TenantTreatmentsPost(requestParameters.tenant, requestParameters.OdsRequestBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all timeslots
         * @param {OdsControllerApiOdsV2TenantProvidersProviderIdTimeslotsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantProvidersProviderIdTimeslotsGet(requestParameters, options) {
            return localVarFp.odsV2TenantProvidersProviderIdTimeslotsGet(requestParameters.tenant, requestParameters.providerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all treatments by icd10 of product
         * @param {OdsControllerApiOdsV2TenantTreatmentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsGet(requestParameters, options) {
            return localVarFp.odsV2TenantTreatmentsGet(requestParameters.tenant, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get treatments by icd10 of product
         * @param {OdsControllerApiOdsV2TenantTreatmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsPost(requestParameters, options) {
            return localVarFp.odsV2TenantTreatmentsPost(requestParameters.tenant, requestParameters.OdsRequestBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a treatment by it\'s exact service id
         * @param {OdsControllerApiOdsV2TenantTreatmentsServiceServiceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsServiceServiceIdGet(requestParameters, options) {
            return localVarFp.odsV2TenantTreatmentsServiceServiceIdGet(requestParameters.serviceId, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all providers of a certain treatment
         * @param {OdsControllerApiOdsV2TenantTreatmentsTreatmentIdProvidersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentIdProvidersGet(requestParameters, options) {
            return localVarFp.odsV2TenantTreatmentsTreatmentIdProvidersGet(requestParameters.treatmentId, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get treatment by name of treatment
         * @param {OdsControllerApiOdsV2TenantTreatmentsTreatmentNameTreatmentNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentNameTreatmentNameGet(requestParameters, options) {
            return localVarFp.odsV2TenantTreatmentsTreatmentNameTreatmentNameGet(requestParameters.treatmentName, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a treatment by icd10 of product
         * @param {OdsControllerApiOdsV2TenantTreatmentsTreatmentTreatmentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odsV2TenantTreatmentsTreatmentTreatmentIdGet(requestParameters, options) {
            return localVarFp.odsV2TenantTreatmentsTreatmentTreatmentIdGet(requestParameters.treatmentId, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OdsControllerApi - object-oriented interface
 * @export
 * @class OdsControllerApi
 * @extends {BaseAPI}
 */
export class OdsControllerApi extends BaseAPI {
    /**
     *
     * @summary Adds ods product and consultation to cart
     * @param {OdsControllerApiOdsApiPatchCartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsApiPatchCart(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsApiPatchCart(requestParameters.tenant, requestParameters.OdsPatchCartRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {OdsControllerApiOdsV1TenantTreatmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV1TenantTreatmentsPost(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV1TenantTreatmentsPost(requestParameters.tenant, requestParameters.OdsRequestBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all timeslots
     * @param {OdsControllerApiOdsV2TenantProvidersProviderIdTimeslotsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV2TenantProvidersProviderIdTimeslotsGet(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV2TenantProvidersProviderIdTimeslotsGet(requestParameters.tenant, requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all treatments by icd10 of product
     * @param {OdsControllerApiOdsV2TenantTreatmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV2TenantTreatmentsGet(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV2TenantTreatmentsGet(requestParameters.tenant, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get treatments by icd10 of product
     * @param {OdsControllerApiOdsV2TenantTreatmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV2TenantTreatmentsPost(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV2TenantTreatmentsPost(requestParameters.tenant, requestParameters.OdsRequestBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a treatment by it\'s exact service id
     * @param {OdsControllerApiOdsV2TenantTreatmentsServiceServiceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV2TenantTreatmentsServiceServiceIdGet(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV2TenantTreatmentsServiceServiceIdGet(requestParameters.serviceId, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all providers of a certain treatment
     * @param {OdsControllerApiOdsV2TenantTreatmentsTreatmentIdProvidersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV2TenantTreatmentsTreatmentIdProvidersGet(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV2TenantTreatmentsTreatmentIdProvidersGet(requestParameters.treatmentId, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get treatment by name of treatment
     * @param {OdsControllerApiOdsV2TenantTreatmentsTreatmentNameTreatmentNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV2TenantTreatmentsTreatmentNameTreatmentNameGet(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV2TenantTreatmentsTreatmentNameTreatmentNameGet(requestParameters.treatmentName, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a treatment by icd10 of product
     * @param {OdsControllerApiOdsV2TenantTreatmentsTreatmentTreatmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdsControllerApi
     */
    odsV2TenantTreatmentsTreatmentTreatmentIdGet(requestParameters, options) {
        return OdsControllerApiFp(this.configuration).odsV2TenantTreatmentsTreatmentTreatmentIdGet(requestParameters.treatmentId, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OffersControllerApi - axios parameter creator
 * @export
 */
export const OffersControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used to get up-to-date offer details.
         * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
         * @param {string} tenant
         * @param {OffersRequestV1} OffersRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyOffersMultipleOffers: (tenant, OffersRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyOffersMultipleOffers', 'tenant', tenant);
            // verify required parameter 'OffersRequestV1' is not null or undefined
            assertParamExists('bullyOffersMultipleOffers', 'OffersRequestV1', OffersRequestV1);
            const localVarPath = `/offers/v1/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OffersRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the offer details for a provided offerId
         * @summary Request offer details for a single offer id
         * @param {string} tenant
         * @param {string} offerId Unique identifier of an offer
         * @param {string} [channel] The channel might adjust the returned price
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyOffersSingleOffer: (tenant, offerId, channel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyOffersSingleOffer', 'tenant', tenant);
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('bullyOffersSingleOffer', 'offerId', offerId);
            const localVarPath = `/offers/v1/{tenant}/offer/{offerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the offer details for a provided offerId
         * @summary Request offer delivery costs for shipping methods
         * @param {string} tenant
         * @param {string} offerId Unique identifier of an offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offersV1TenantOfferDeliveryCostsOfferIdGet: (tenant, offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('offersV1TenantOfferDeliveryCostsOfferIdGet', 'tenant', tenant);
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('offersV1TenantOfferDeliveryCostsOfferIdGet', 'offerId', offerId);
            const localVarPath = `/offers/v1/{tenant}/offer/delivery-costs/{offerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all active offers for a specific product by uPid
         * @param {string} tenant
         * @param {string} uPid Unique identifier of product
         * @param {string} [channel] The channel might adjust the returned price
         * @param {string} [language] for non german speaking countries the language is needed to get information from pim to enrich data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offersV1TenantUPidGet: (tenant, uPid, channel, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('offersV1TenantUPidGet', 'tenant', tenant);
            // verify required parameter 'uPid' is not null or undefined
            assertParamExists('offersV1TenantUPidGet', 'uPid', uPid);
            const localVarPath = `/offers/v1/{tenant}/{uPid}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"uPid"}}`, encodeURIComponent(String(uPid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OffersControllerApi - functional programming interface
 * @export
 */
export const OffersControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OffersControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Used to get up-to-date offer details.
         * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
         * @param {string} tenant
         * @param {OffersRequestV1} OffersRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyOffersMultipleOffers(tenant, OffersRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyOffersMultipleOffers(tenant, OffersRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns the offer details for a provided offerId
         * @summary Request offer details for a single offer id
         * @param {string} tenant
         * @param {string} offerId Unique identifier of an offer
         * @param {string} [channel] The channel might adjust the returned price
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyOffersSingleOffer(tenant, offerId, channel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyOffersSingleOffer(tenant, offerId, channel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns the offer details for a provided offerId
         * @summary Request offer delivery costs for shipping methods
         * @param {string} tenant
         * @param {string} offerId Unique identifier of an offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offersV1TenantOfferDeliveryCostsOfferIdGet(tenant, offerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.offersV1TenantOfferDeliveryCostsOfferIdGet(tenant, offerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all active offers for a specific product by uPid
         * @param {string} tenant
         * @param {string} uPid Unique identifier of product
         * @param {string} [channel] The channel might adjust the returned price
         * @param {string} [language] for non german speaking countries the language is needed to get information from pim to enrich data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offersV1TenantUPidGet(tenant, uPid, channel, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.offersV1TenantUPidGet(tenant, uPid, channel, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OffersControllerApi - factory interface
 * @export
 */
export const OffersControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OffersControllerApiFp(configuration);
    return {
        /**
         * Used to get up-to-date offer details.
         * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
         * @param {OffersControllerApiBullyOffersMultipleOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyOffersMultipleOffers(requestParameters, options) {
            return localVarFp.bullyOffersMultipleOffers(requestParameters.tenant, requestParameters.OffersRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the offer details for a provided offerId
         * @summary Request offer details for a single offer id
         * @param {OffersControllerApiBullyOffersSingleOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyOffersSingleOffer(requestParameters, options) {
            return localVarFp.bullyOffersSingleOffer(requestParameters.tenant, requestParameters.offerId, requestParameters.channel, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the offer details for a provided offerId
         * @summary Request offer delivery costs for shipping methods
         * @param {OffersControllerApiOffersV1TenantOfferDeliveryCostsOfferIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offersV1TenantOfferDeliveryCostsOfferIdGet(requestParameters, options) {
            return localVarFp.offersV1TenantOfferDeliveryCostsOfferIdGet(requestParameters.tenant, requestParameters.offerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all active offers for a specific product by uPid
         * @param {OffersControllerApiOffersV1TenantUPidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offersV1TenantUPidGet(requestParameters, options) {
            return localVarFp.offersV1TenantUPidGet(requestParameters.tenant, requestParameters.uPid, requestParameters.channel, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OffersControllerApi - object-oriented interface
 * @export
 * @class OffersControllerApi
 * @extends {BaseAPI}
 */
export class OffersControllerApi extends BaseAPI {
    /**
     * Used to get up-to-date offer details.
     * @summary Request multiple offer details by providing a list of {offerId + prescriptionType + channel}
     * @param {OffersControllerApiBullyOffersMultipleOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersControllerApi
     */
    bullyOffersMultipleOffers(requestParameters, options) {
        return OffersControllerApiFp(this.configuration).bullyOffersMultipleOffers(requestParameters.tenant, requestParameters.OffersRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer details for a single offer id
     * @param {OffersControllerApiBullyOffersSingleOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersControllerApi
     */
    bullyOffersSingleOffer(requestParameters, options) {
        return OffersControllerApiFp(this.configuration).bullyOffersSingleOffer(requestParameters.tenant, requestParameters.offerId, requestParameters.channel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the offer details for a provided offerId
     * @summary Request offer delivery costs for shipping methods
     * @param {OffersControllerApiOffersV1TenantOfferDeliveryCostsOfferIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersControllerApi
     */
    offersV1TenantOfferDeliveryCostsOfferIdGet(requestParameters, options) {
        return OffersControllerApiFp(this.configuration).offersV1TenantOfferDeliveryCostsOfferIdGet(requestParameters.tenant, requestParameters.offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all active offers for a specific product by uPid
     * @param {OffersControllerApiOffersV1TenantUPidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersControllerApi
     */
    offersV1TenantUPidGet(requestParameters, options) {
        return OffersControllerApiFp(this.configuration).offersV1TenantUPidGet(requestParameters.tenant, requestParameters.uPid, requestParameters.channel, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OptimizelyControllerApi - axios parameter creator
 * @export
 */
export const OptimizelyControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
         * @summary Activate selected features and experiments for the given user.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OptimizelyActivateContextV1} OptimizelyActivateContextV1
         * @param {Array<string>} [featureKey] Key for the Optimizely Feature
         * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
         * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
         * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
         * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantActivatePost: (tenant, OptimizelyActivateContextV1, featureKey, experimentKey, disableTracking, type, enabled, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV1TenantActivatePost', 'tenant', tenant);
            // verify required parameter 'OptimizelyActivateContextV1' is not null or undefined
            assertParamExists('optimizelyV1TenantActivatePost', 'OptimizelyActivateContextV1', OptimizelyActivateContextV1);
            const localVarPath = `/optimizely/v1/{tenant}/activate`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (featureKey) {
                localVarQueryParameter['featureKey'] = featureKey;
            }
            if (experimentKey) {
                localVarQueryParameter['experimentKey'] = experimentKey;
            }
            if (disableTracking !== undefined) {
                localVarQueryParameter['disableTracking'] = disableTracking;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OptimizelyActivateContextV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
         * @summary Override an experiment decision for a user
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {Array<OptimizelyOverrideContextInner>} OptimizelyOverrideContextInner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantOverridePost: (tenant, OptimizelyOverrideContextInner, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV1TenantOverridePost', 'tenant', tenant);
            // verify required parameter 'OptimizelyOverrideContextInner' is not null or undefined
            assertParamExists('optimizelyV1TenantOverridePost', 'OptimizelyOverrideContextInner', OptimizelyOverrideContextInner);
            const localVarPath = `/optimizely/v1/{tenant}/override`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OptimizelyOverrideContextInner, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
         * @summary Track event
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} eventKey Key of the event we\&#39;re tracking
         * @param {OptimizelyTrackContextV1} OptimizelyTrackContextV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantTrackPost: (tenant, eventKey, OptimizelyTrackContextV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV1TenantTrackPost', 'tenant', tenant);
            // verify required parameter 'eventKey' is not null or undefined
            assertParamExists('optimizelyV1TenantTrackPost', 'eventKey', eventKey);
            // verify required parameter 'OptimizelyTrackContextV1' is not null or undefined
            assertParamExists('optimizelyV1TenantTrackPost', 'OptimizelyTrackContextV1', OptimizelyTrackContextV1);
            const localVarPath = `/optimizely/v1/{tenant}/track`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (eventKey !== undefined) {
                localVarQueryParameter['eventKey'] = eventKey;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OptimizelyTrackContextV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} [browserFamily]
         * @param {string} [browserVersion]
         * @param {string} [deviceClass]
         * @param {string} [ipAddress]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        optimizelyV1TenantUserinfoGet: (tenant, browserFamily, browserVersion, deviceClass, ipAddress, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV1TenantUserinfoGet', 'tenant', tenant);
            const localVarPath = `/optimizely/v1/{tenant}/userinfo`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (browserFamily !== undefined) {
                localVarQueryParameter['browserFamily'] = browserFamily;
            }
            if (browserVersion !== undefined) {
                localVarQueryParameter['browserVersion'] = browserVersion;
            }
            if (deviceClass !== undefined) {
                localVarQueryParameter['deviceClass'] = deviceClass;
            }
            if (ipAddress !== undefined) {
                localVarQueryParameter['ipAddress'] = ipAddress;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} optimizelyFeatureKey
         * @param {string} [browserFamily]
         * @param {string} [browserVersion]
         * @param {string} [deviceClass]
         * @param {string} [ipAddress]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet: (tenant, optimizelyFeatureKey, browserFamily, browserVersion, deviceClass, ipAddress, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet', 'tenant', tenant);
            // verify required parameter 'optimizelyFeatureKey' is not null or undefined
            assertParamExists('optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet', 'optimizelyFeatureKey', optimizelyFeatureKey);
            const localVarPath = `/optimizely/v1/{tenant}/userinfo/{optimizelyFeatureKey}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"optimizelyFeatureKey"}}`, encodeURIComponent(String(optimizelyFeatureKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (browserFamily !== undefined) {
                localVarQueryParameter['browserFamily'] = browserFamily;
            }
            if (browserVersion !== undefined) {
                localVarQueryParameter['browserVersion'] = browserVersion;
            }
            if (deviceClass !== undefined) {
                localVarQueryParameter['deviceClass'] = deviceClass;
            }
            if (ipAddress !== undefined) {
                localVarQueryParameter['ipAddress'] = ipAddress;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
         * @summary Activate selected features and experiments for the given user.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OptimizelyActivateContextV2} OptimizelyActivateContextV2
         * @param {Array<string>} [featureKey] Key for the Optimizely Feature
         * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
         * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
         * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
         * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantActivatePost: (tenant, OptimizelyActivateContextV2, featureKey, experimentKey, disableTracking, type, enabled, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV2TenantActivatePost', 'tenant', tenant);
            // verify required parameter 'OptimizelyActivateContextV2' is not null or undefined
            assertParamExists('optimizelyV2TenantActivatePost', 'OptimizelyActivateContextV2', OptimizelyActivateContextV2);
            const localVarPath = `/optimizely/v2/{tenant}/activate`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (featureKey) {
                localVarQueryParameter['featureKey'] = featureKey;
            }
            if (experimentKey) {
                localVarQueryParameter['experimentKey'] = experimentKey;
            }
            if (disableTracking !== undefined) {
                localVarQueryParameter['disableTracking'] = disableTracking;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OptimizelyActivateContextV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
         * @summary Override an experiment decision for a user
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {Array<OptimizelyOverrideContextV2Inner>} OptimizelyOverrideContextV2Inner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantOverridePost: (tenant, OptimizelyOverrideContextV2Inner, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV2TenantOverridePost', 'tenant', tenant);
            // verify required parameter 'OptimizelyOverrideContextV2Inner' is not null or undefined
            assertParamExists('optimizelyV2TenantOverridePost', 'OptimizelyOverrideContextV2Inner', OptimizelyOverrideContextV2Inner);
            const localVarPath = `/optimizely/v2/{tenant}/override`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OptimizelyOverrideContextV2Inner, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
         * @summary Track event
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} eventKey Key of the event we\&#39;re tracking
         * @param {OptimizelyTrackContextV2} OptimizelyTrackContextV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantTrackPost: (tenant, eventKey, OptimizelyTrackContextV2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('optimizelyV2TenantTrackPost', 'tenant', tenant);
            // verify required parameter 'eventKey' is not null or undefined
            assertParamExists('optimizelyV2TenantTrackPost', 'eventKey', eventKey);
            // verify required parameter 'OptimizelyTrackContextV2' is not null or undefined
            assertParamExists('optimizelyV2TenantTrackPost', 'OptimizelyTrackContextV2', OptimizelyTrackContextV2);
            const localVarPath = `/optimizely/v2/{tenant}/track`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (eventKey !== undefined) {
                localVarQueryParameter['eventKey'] = eventKey;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OptimizelyTrackContextV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OptimizelyControllerApi - functional programming interface
 * @export
 */
export const OptimizelyControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OptimizelyControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
         * @summary Activate selected features and experiments for the given user.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OptimizelyActivateContextV1} OptimizelyActivateContextV1
         * @param {Array<string>} [featureKey] Key for the Optimizely Feature
         * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
         * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
         * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
         * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantActivatePost(tenant, OptimizelyActivateContextV1, featureKey, experimentKey, disableTracking, type, enabled, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV1TenantActivatePost(tenant, OptimizelyActivateContextV1, featureKey, experimentKey, disableTracking, type, enabled, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
         * @summary Override an experiment decision for a user
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {Array<OptimizelyOverrideContextInner>} OptimizelyOverrideContextInner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantOverridePost(tenant, OptimizelyOverrideContextInner, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV1TenantOverridePost(tenant, OptimizelyOverrideContextInner, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
         * @summary Track event
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} eventKey Key of the event we\&#39;re tracking
         * @param {OptimizelyTrackContextV1} OptimizelyTrackContextV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV1TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} [browserFamily]
         * @param {string} [browserVersion]
         * @param {string} [deviceClass]
         * @param {string} [ipAddress]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        optimizelyV1TenantUserinfoGet(tenant, browserFamily, browserVersion, deviceClass, ipAddress, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV1TenantUserinfoGet(tenant, browserFamily, browserVersion, deviceClass, ipAddress, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} optimizelyFeatureKey
         * @param {string} [browserFamily]
         * @param {string} [browserVersion]
         * @param {string} [deviceClass]
         * @param {string} [ipAddress]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(tenant, optimizelyFeatureKey, browserFamily, browserVersion, deviceClass, ipAddress, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(tenant, optimizelyFeatureKey, browserFamily, browserVersion, deviceClass, ipAddress, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
         * @summary Activate selected features and experiments for the given user.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OptimizelyActivateContextV2} OptimizelyActivateContextV2
         * @param {Array<string>} [featureKey] Key for the Optimizely Feature
         * @param {Array<string>} [experimentKey] Key for the Optimizely Experiment
         * @param {boolean} [disableTracking] Setting to true will disable impression tracking for experiments.
         * @param {'feature' | 'experiment'} [type] Limit the decisions to either experiment or features
         * @param {boolean} [enabled] Filter the activation response to return only enabled descisions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantActivatePost(tenant, OptimizelyActivateContextV2, featureKey, experimentKey, disableTracking, type, enabled, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV2TenantActivatePost(tenant, OptimizelyActivateContextV2, featureKey, experimentKey, disableTracking, type, enabled, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
         * @summary Override an experiment decision for a user
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {Array<OptimizelyOverrideContextV2Inner>} OptimizelyOverrideContextV2Inner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantOverridePost(tenant, OptimizelyOverrideContextV2Inner, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV2TenantOverridePost(tenant, OptimizelyOverrideContextV2Inner, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
         * @summary Track event
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} eventKey Key of the event we\&#39;re tracking
         * @param {OptimizelyTrackContextV2} OptimizelyTrackContextV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.optimizelyV2TenantTrackPost(tenant, eventKey, OptimizelyTrackContextV2, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OptimizelyControllerApi - factory interface
 * @export
 */
export const OptimizelyControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OptimizelyControllerApiFp(configuration);
    return {
        /**
         * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
         * @summary Activate selected features and experiments for the given user.
         * @param {OptimizelyControllerApiOptimizelyV1TenantActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantActivatePost(requestParameters, options) {
            return localVarFp.optimizelyV1TenantActivatePost(requestParameters.tenant, requestParameters.OptimizelyActivateContextV1, requestParameters.featureKey, requestParameters.experimentKey, requestParameters.disableTracking, requestParameters.type, requestParameters.enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
         * @summary Override an experiment decision for a user
         * @param {OptimizelyControllerApiOptimizelyV1TenantOverridePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantOverridePost(requestParameters, options) {
            return localVarFp.optimizelyV1TenantOverridePost(requestParameters.tenant, requestParameters.OptimizelyOverrideContextInner, options).then((request) => request(axios, basePath));
        },
        /**
         * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
         * @summary Track event
         * @param {OptimizelyControllerApiOptimizelyV1TenantTrackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV1TenantTrackPost(requestParameters, options) {
            return localVarFp.optimizelyV1TenantTrackPost(requestParameters.tenant, requestParameters.eventKey, requestParameters.OptimizelyTrackContextV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OptimizelyControllerApiOptimizelyV1TenantUserinfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        optimizelyV1TenantUserinfoGet(requestParameters, options) {
            return localVarFp.optimizelyV1TenantUserinfoGet(requestParameters.tenant, requestParameters.browserFamily, requestParameters.browserVersion, requestParameters.deviceClass, requestParameters.ipAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OptimizelyControllerApiOptimizelyV1TenantUserinfoOptimizelyFeatureKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(requestParameters, options) {
            return localVarFp.optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(requestParameters.tenant, requestParameters.optimizelyFeatureKey, requestParameters.browserFamily, requestParameters.browserVersion, requestParameters.deviceClass, requestParameters.ipAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
         * @summary Activate selected features and experiments for the given user.
         * @param {OptimizelyControllerApiOptimizelyV2TenantActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantActivatePost(requestParameters, options) {
            return localVarFp.optimizelyV2TenantActivatePost(requestParameters.tenant, requestParameters.OptimizelyActivateContextV2, requestParameters.featureKey, requestParameters.experimentKey, requestParameters.disableTracking, requestParameters.type, requestParameters.enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
         * @summary Override an experiment decision for a user
         * @param {OptimizelyControllerApiOptimizelyV2TenantOverridePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantOverridePost(requestParameters, options) {
            return localVarFp.optimizelyV2TenantOverridePost(requestParameters.tenant, requestParameters.OptimizelyOverrideContextV2Inner, options).then((request) => request(axios, basePath));
        },
        /**
         * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
         * @summary Track event
         * @param {OptimizelyControllerApiOptimizelyV2TenantTrackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizelyV2TenantTrackPost(requestParameters, options) {
            return localVarFp.optimizelyV2TenantTrackPost(requestParameters.tenant, requestParameters.eventKey, requestParameters.OptimizelyTrackContextV2, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OptimizelyControllerApi - object-oriented interface
 * @export
 * @class OptimizelyControllerApi
 * @extends {BaseAPI}
 */
export class OptimizelyControllerApi extends BaseAPI {
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {OptimizelyControllerApiOptimizelyV1TenantActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV1TenantActivatePost(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV1TenantActivatePost(requestParameters.tenant, requestParameters.OptimizelyActivateContextV1, requestParameters.featureKey, requestParameters.experimentKey, requestParameters.disableTracking, requestParameters.type, requestParameters.enabled, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {OptimizelyControllerApiOptimizelyV1TenantOverridePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV1TenantOverridePost(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV1TenantOverridePost(requestParameters.tenant, requestParameters.OptimizelyOverrideContextInner, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {OptimizelyControllerApiOptimizelyV1TenantTrackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV1TenantTrackPost(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV1TenantTrackPost(requestParameters.tenant, requestParameters.eventKey, requestParameters.OptimizelyTrackContextV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OptimizelyControllerApiOptimizelyV1TenantUserinfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV1TenantUserinfoGet(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV1TenantUserinfoGet(requestParameters.tenant, requestParameters.browserFamily, requestParameters.browserVersion, requestParameters.deviceClass, requestParameters.ipAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OptimizelyControllerApiOptimizelyV1TenantUserinfoOptimizelyFeatureKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV1TenantUserinfoOptimizelyFeatureKeyGet(requestParameters.tenant, requestParameters.optimizelyFeatureKey, requestParameters.browserFamily, requestParameters.browserVersion, requestParameters.deviceClass, requestParameters.ipAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns Optimizely\'s decision about which features and experiments a given user is exposed to. Optionally sends an impression event to the Optimizely analytics backend for any decision made for an experiment. This endpoint consolidates key functionality from the Full Stack SDKs into one convenient call.
     * @summary Activate selected features and experiments for the given user.
     * @param {OptimizelyControllerApiOptimizelyV2TenantActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV2TenantActivatePost(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV2TenantActivatePost(requestParameters.tenant, requestParameters.OptimizelyActivateContextV2, requestParameters.featureKey, requestParameters.experimentKey, requestParameters.disableTracking, requestParameters.type, requestParameters.enabled, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * For debugging or testing. Overrides an experiment and variation decision for a given user, in local memory only. Do not use this endpoint for production overrides.
     * @summary Override an experiment decision for a user
     * @param {OptimizelyControllerApiOptimizelyV2TenantOverridePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV2TenantOverridePost(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV2TenantOverridePost(requestParameters.tenant, requestParameters.OptimizelyOverrideContextV2Inner, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send event and user details to Optimizely analytics backend, so you can see metrics for an experiment. You can view metrics either on your Results page or as a data export.
     * @summary Track event
     * @param {OptimizelyControllerApiOptimizelyV2TenantTrackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptimizelyControllerApi
     */
    optimizelyV2TenantTrackPost(requestParameters, options) {
        return OptimizelyControllerApiFp(this.configuration).optimizelyV2TenantTrackPost(requestParameters.tenant, requestParameters.eventKey, requestParameters.OptimizelyTrackContextV2, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrderControllerApi - axios parameter creator
 * @export
 */
export const OrderControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {number} [ordersAgeLimitInSeconds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersGet: (tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('orderV1TenantOrdersGet', 'tenant', tenant);
            const localVarPath = `/order/v1/{tenant}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            if (ordersAgeLimitInSeconds !== undefined) {
                localVarQueryParameter['ordersAgeLimitInSeconds'] = ordersAgeLimitInSeconds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersOrderNumberGet: (tenant, orderNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('orderV1TenantOrdersOrderNumberGet', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('orderV1TenantOrdersOrderNumberGet', 'orderNumber', orderNumber);
            const localVarPath = `/order/v1/{tenant}/orders/{orderNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by the customer to cancel his order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost: (tenant, orderNumber, subOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost', 'orderNumber', orderNumber);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost', 'subOrderId', subOrderId);
            const localVarPath = `/order/v1/{tenant}/orders/{orderNumber}/subOrders/{subOrderId}/cancellation`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} transactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantPssOrdersGet: (tenant, transactionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('orderV1TenantPssOrdersGet', 'tenant', tenant);
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('orderV1TenantPssOrdersGet', 'transactionId', transactionId);
            const localVarPath = `/order/v1/{tenant}/pss/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by the customer to cancel his order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        orderV1TenantSubOrdersSubOrderIdCancellationPost: (tenant, subOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('orderV1TenantSubOrdersSubOrderIdCancellationPost', 'tenant', tenant);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('orderV1TenantSubOrdersSubOrderIdCancellationPost', 'subOrderId', subOrderId);
            const localVarPath = `/order/v1/{tenant}/subOrders/{subOrderId}/cancellation`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrderControllerApi - functional programming interface
 * @export
 */
export const OrderControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {number} [ordersAgeLimitInSeconds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersGet(tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderV1TenantOrdersGet(tenant, page, itemsPerPage, ordersAgeLimitInSeconds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderV1TenantOrdersOrderNumberGet(tenant, orderNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by the customer to cancel his order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost(tenant, orderNumber, subOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost(tenant, orderNumber, subOrderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} transactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantPssOrdersGet(tenant, transactionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderV1TenantPssOrdersGet(tenant, transactionId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Used by the customer to cancel his order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} subOrderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        orderV1TenantSubOrdersSubOrderIdCancellationPost(tenant, subOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderV1TenantSubOrdersSubOrderIdCancellationPost(tenant, subOrderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrderControllerApi - factory interface
 * @export
 */
export const OrderControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderControllerApiFp(configuration);
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {OrderControllerApiOrderV1TenantOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersGet(requestParameters, options) {
            return localVarFp.orderV1TenantOrdersGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ordersAgeLimitInSeconds, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {OrderControllerApiOrderV1TenantOrdersOrderNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersOrderNumberGet(requestParameters, options) {
            return localVarFp.orderV1TenantOrdersOrderNumberGet(requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the customer to cancel his order.
         * @param {OrderControllerApiOrderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost(requestParameters, options) {
            return localVarFp.orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost(requestParameters.tenant, requestParameters.orderNumber, requestParameters.subOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {OrderControllerApiOrderV1TenantPssOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderV1TenantPssOrdersGet(requestParameters, options) {
            return localVarFp.orderV1TenantPssOrdersGet(requestParameters.tenant, requestParameters.transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the customer to cancel his order.
         * @param {OrderControllerApiOrderV1TenantSubOrdersSubOrderIdCancellationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        orderV1TenantSubOrdersSubOrderIdCancellationPost(requestParameters, options) {
            return localVarFp.orderV1TenantSubOrdersSubOrderIdCancellationPost(requestParameters.tenant, requestParameters.subOrderId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderControllerApi - object-oriented interface
 * @export
 * @class OrderControllerApi
 * @extends {BaseAPI}
 */
export class OrderControllerApi extends BaseAPI {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {OrderControllerApiOrderV1TenantOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    orderV1TenantOrdersGet(requestParameters, options) {
        return OrderControllerApiFp(this.configuration).orderV1TenantOrdersGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ordersAgeLimitInSeconds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve a single order.
     * @param {OrderControllerApiOrderV1TenantOrdersOrderNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    orderV1TenantOrdersOrderNumberGet(requestParameters, options) {
        return OrderControllerApiFp(this.configuration).orderV1TenantOrdersOrderNumberGet(requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by the customer to cancel his order.
     * @param {OrderControllerApiOrderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost(requestParameters, options) {
        return OrderControllerApiFp(this.configuration).orderV1TenantOrdersOrderNumberSubOrdersSubOrderIdCancellationPost(requestParameters.tenant, requestParameters.orderNumber, requestParameters.subOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve a single order.
     * @param {OrderControllerApiOrderV1TenantPssOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    orderV1TenantPssOrdersGet(requestParameters, options) {
        return OrderControllerApiFp(this.configuration).orderV1TenantPssOrdersGet(requestParameters.tenant, requestParameters.transactionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by the customer to cancel his order.
     * @param {OrderControllerApiOrderV1TenantSubOrdersSubOrderIdCancellationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    orderV1TenantSubOrdersSubOrderIdCancellationPost(requestParameters, options) {
        return OrderControllerApiFp(this.configuration).orderV1TenantSubOrdersSubOrderIdCancellationPost(requestParameters.tenant, requestParameters.subOrderId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrdersControllerApi - axios parameter creator
 * @export
 */
export const OrdersControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used only for development of the confirmation page
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id Order id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersV1TenantIdGet: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('ordersV1TenantIdGet', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ordersV1TenantIdGet', 'id', id);
            const localVarPath = `/orders/v1/{tenant}/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrdersControllerApi - functional programming interface
 * @export
 */
export const OrdersControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrdersControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Used only for development of the confirmation page
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id Order id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersV1TenantIdGet(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersV1TenantIdGet(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrdersControllerApi - factory interface
 * @export
 */
export const OrdersControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrdersControllerApiFp(configuration);
    return {
        /**
         * Used only for development of the confirmation page
         * @param {OrdersControllerApiOrdersV1TenantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersV1TenantIdGet(requestParameters, options) {
            return localVarFp.ordersV1TenantIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrdersControllerApi - object-oriented interface
 * @export
 * @class OrdersControllerApi
 * @extends {BaseAPI}
 */
export class OrdersControllerApi extends BaseAPI {
    /**
     * Used only for development of the confirmation page
     * @param {OrdersControllerApiOrdersV1TenantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OrdersControllerApi
     */
    ordersV1TenantIdGet(requestParameters, options) {
        return OrdersControllerApiFp(this.configuration).ordersV1TenantIdGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PDPControllerApi - axios parameter creator
 * @export
 */
export const PDPControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
         * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
         * @param {string} [cbpFallbackChannel] The fallback channel to use in case cbpChannels is not provided for all variants
         * @param {string} [fields]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePdpV1TenantProductsUpidVariantsGet: (language, tenant, upid, channel, cbpUpids, cbpChannels, cbpFallbackChannel, fields, nowZipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePdpV1TenantProductsUpidVariantsGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePdpV1TenantProductsUpidVariantsGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('languagePdpV1TenantProductsUpidVariantsGet', 'upid', upid);
            const localVarPath = `/{language}/pdp/v1/{tenant}/products/{upid}/variants`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (cbpUpids !== undefined) {
                localVarQueryParameter['cbpUpids'] = cbpUpids;
            }
            if (cbpChannels !== undefined) {
                localVarQueryParameter['cbpChannels'] = cbpChannels;
            }
            if (cbpFallbackChannel !== undefined) {
                localVarQueryParameter['cbpFallbackChannel'] = cbpFallbackChannel;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PDPControllerApi - functional programming interface
 * @export
 */
export const PDPControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PDPControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
         * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
         * @param {string} [cbpFallbackChannel] The fallback channel to use in case cbpChannels is not provided for all variants
         * @param {string} [fields]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePdpV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, cbpUpids, cbpChannels, cbpFallbackChannel, fields, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePdpV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, cbpUpids, cbpChannels, cbpFallbackChannel, fields, nowZipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PDPControllerApi - factory interface
 * @export
 */
export const PDPControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PDPControllerApiFp(configuration);
    return {
        /**
         * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
         * @param {PDPControllerApiLanguagePdpV1TenantProductsUpidVariantsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePdpV1TenantProductsUpidVariantsGet(requestParameters, options) {
            return localVarFp.languagePdpV1TenantProductsUpidVariantsGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.cbpUpids, requestParameters.cbpChannels, requestParameters.cbpFallbackChannel, requestParameters.fields, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PDPControllerApi - object-oriented interface
 * @export
 * @class PDPControllerApi
 * @extends {BaseAPI}
 */
export class PDPControllerApi extends BaseAPI {
    /**
     * Returns response from [/pim/.../variants](#/PIM%20Controller/get__language__pim_v1__tenant__products__upid__variants) extended with notepad info and promotion images
     * @param {PDPControllerApiLanguagePdpV1TenantProductsUpidVariantsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDPControllerApi
     */
    languagePdpV1TenantProductsUpidVariantsGet(requestParameters, options) {
        return PDPControllerApiFp(this.configuration).languagePdpV1TenantProductsUpidVariantsGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.cbpUpids, requestParameters.cbpChannels, requestParameters.cbpFallbackChannel, requestParameters.fields, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PICSServiceApi - axios parameter creator
 * @export
 */
export const PICSServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary pharma-interaction data for experts requested by a list of FAM ids
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PicsInteractionsExpertRequestByFamId} PicsInteractionsExpertRequestByFamId List of FAM IDs and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expertInteractionsByFamIds: (tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('expertInteractionsByFamIds', 'tenant', tenant);
            // verify required parameter 'PicsInteractionsExpertRequestByFamId' is not null or undefined
            assertParamExists('expertInteractionsByFamIds', 'PicsInteractionsExpertRequestByFamId', PicsInteractionsExpertRequestByFamId);
            const localVarPath = `/pics/v1/{tenant}/interactions/expert/by-fam-id`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PicsInteractionsExpertRequestByFamId, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary pharma-interaction data for experts requested by a list of product ids
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PicsInteractionsExpertRequestByProductId} PicsInteractionsExpertRequestByProductId List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expertInteractionsByProductIds: (tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('expertInteractionsByProductIds', 'tenant', tenant);
            // verify required parameter 'PicsInteractionsExpertRequestByProductId' is not null or undefined
            assertParamExists('expertInteractionsByProductIds', 'PicsInteractionsExpertRequestByProductId', PicsInteractionsExpertRequestByProductId);
            const localVarPath = `/pics/v1/{tenant}/interactions/expert/by-product-id`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PicsInteractionsExpertRequestByProductId, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary pharma-interaction data for layman
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PicsInteractionsLaymanRequest} PicsInteractionsLaymanRequest List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laymanInteractions: (tenant, PicsInteractionsLaymanRequest, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('laymanInteractions', 'tenant', tenant);
            // verify required parameter 'PicsInteractionsLaymanRequest' is not null or undefined
            assertParamExists('laymanInteractions', 'PicsInteractionsLaymanRequest', PicsInteractionsLaymanRequest);
            const localVarPath = `/pics/v1/{tenant}/interactions/layman`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PicsInteractionsLaymanRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PICSServiceApi - functional programming interface
 * @export
 */
export const PICSServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = PICSServiceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary pharma-interaction data for experts requested by a list of FAM ids
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PicsInteractionsExpertRequestByFamId} PicsInteractionsExpertRequestByFamId List of FAM IDs and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expertInteractionsByFamIds(tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expertInteractionsByFamIds(tenant, PicsInteractionsExpertRequestByFamId, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary pharma-interaction data for experts requested by a list of product ids
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PicsInteractionsExpertRequestByProductId} PicsInteractionsExpertRequestByProductId List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expertInteractionsByProductIds(tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expertInteractionsByProductIds(tenant, PicsInteractionsExpertRequestByProductId, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary pharma-interaction data for layman
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {PicsInteractionsLaymanRequest} PicsInteractionsLaymanRequest List of productIds (PZN) and optional list of type clinical relevance (return interactions for all types of clinical relevance if missing)
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laymanInteractions(tenant, PicsInteractionsLaymanRequest, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.laymanInteractions(tenant, PicsInteractionsLaymanRequest, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PICSServiceApi - factory interface
 * @export
 */
export const PICSServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PICSServiceApiFp(configuration);
    return {
        /**
         *
         * @summary pharma-interaction data for experts requested by a list of FAM ids
         * @param {PICSServiceApiExpertInteractionsByFamIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expertInteractionsByFamIds(requestParameters, options) {
            return localVarFp.expertInteractionsByFamIds(requestParameters.tenant, requestParameters.PicsInteractionsExpertRequestByFamId, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary pharma-interaction data for experts requested by a list of product ids
         * @param {PICSServiceApiExpertInteractionsByProductIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expertInteractionsByProductIds(requestParameters, options) {
            return localVarFp.expertInteractionsByProductIds(requestParameters.tenant, requestParameters.PicsInteractionsExpertRequestByProductId, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary pharma-interaction data for layman
         * @param {PICSServiceApiLaymanInteractionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laymanInteractions(requestParameters, options) {
            return localVarFp.laymanInteractions(requestParameters.tenant, requestParameters.PicsInteractionsLaymanRequest, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PICSServiceApi - object-oriented interface
 * @export
 * @class PICSServiceApi
 * @extends {BaseAPI}
 */
export class PICSServiceApi extends BaseAPI {
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of FAM ids
     * @param {PICSServiceApiExpertInteractionsByFamIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PICSServiceApi
     */
    expertInteractionsByFamIds(requestParameters, options) {
        return PICSServiceApiFp(this.configuration).expertInteractionsByFamIds(requestParameters.tenant, requestParameters.PicsInteractionsExpertRequestByFamId, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary pharma-interaction data for experts requested by a list of product ids
     * @param {PICSServiceApiExpertInteractionsByProductIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PICSServiceApi
     */
    expertInteractionsByProductIds(requestParameters, options) {
        return PICSServiceApiFp(this.configuration).expertInteractionsByProductIds(requestParameters.tenant, requestParameters.PicsInteractionsExpertRequestByProductId, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary pharma-interaction data for layman
     * @param {PICSServiceApiLaymanInteractionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PICSServiceApi
     */
    laymanInteractions(requestParameters, options) {
        return PICSServiceApiFp(this.configuration).laymanInteractions(requestParameters.tenant, requestParameters.PicsInteractionsLaymanRequest, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PIMControllerApi - axios parameter creator
 * @export
 */
export const PIMControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upids Comma separated list of product identifiers
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {number} [offset] The number of documents to skip in the results set.
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyPimMutilple: (language, tenant, upids, channel, offset, limit, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('bullyPimMutilple', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyPimMutilple', 'tenant', tenant);
            // verify required parameter 'upids' is not null or undefined
            assertParamExists('bullyPimMutilple', 'upids', upids);
            const localVarPath = `/{language}/pim/v1/{tenant}/products`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (upids !== undefined) {
                localVarQueryParameter['upids'] = upids;
            }
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsUpidGet: (language, tenant, upid, channel, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePimV1TenantProductsUpidGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePimV1TenantProductsUpidGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('languagePimV1TenantProductsUpidGet', 'upid', upid);
            const localVarPath = `/{language}/pim/v1/{tenant}/products/{upid}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsUpidVariantsGet: (language, tenant, upid, channel, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePimV1TenantProductsUpidVariantsGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePimV1TenantProductsUpidVariantsGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('languagePimV1TenantProductsUpidVariantsGet', 'upid', upid);
            const localVarPath = `/{language}/pim/v1/{tenant}/products/{upid}/variants`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsWithVariantsUpidGet: (language, tenant, upid, channel, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePimV1TenantProductsWithVariantsUpidGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePimV1TenantProductsWithVariantsUpidGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('languagePimV1TenantProductsWithVariantsUpidGet', 'upid', upid);
            const localVarPath = `/{language}/pim/v1/{tenant}/products-with-variants/{upid}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PIMControllerApi - functional programming interface
 * @export
 */
export const PIMControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PIMControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upids Comma separated list of product identifiers
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {number} [offset] The number of documents to skip in the results set.
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyPimMutilple(language, tenant, upids, channel, offset, limit, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyPimMutilple(language, tenant, upids, channel, offset, limit, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsUpidGet(language, tenant, upid, channel, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePimV1TenantProductsUpidGet(language, tenant, upid, channel, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePimV1TenantProductsUpidVariantsGet(language, tenant, upid, channel, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {string} [channel] The channel (f.e. related to a product/offer to be added to a cart)
         * @param {string} [fields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsWithVariantsUpidGet(language, tenant, upid, channel, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePimV1TenantProductsWithVariantsUpidGet(language, tenant, upid, channel, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PIMControllerApi - factory interface
 * @export
 */
export const PIMControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PIMControllerApiFp(configuration);
    return {
        /**
         *
         * @param {PIMControllerApiBullyPimMutilpleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyPimMutilple(requestParameters, options) {
            return localVarFp.bullyPimMutilple(requestParameters.language, requestParameters.tenant, requestParameters.upids, requestParameters.channel, requestParameters.offset, requestParameters.limit, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PIMControllerApiLanguagePimV1TenantProductsUpidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsUpidGet(requestParameters, options) {
            return localVarFp.languagePimV1TenantProductsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PIMControllerApiLanguagePimV1TenantProductsUpidVariantsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsUpidVariantsGet(requestParameters, options) {
            return localVarFp.languagePimV1TenantProductsUpidVariantsGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PIMControllerApiLanguagePimV1TenantProductsWithVariantsUpidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePimV1TenantProductsWithVariantsUpidGet(requestParameters, options) {
            return localVarFp.languagePimV1TenantProductsWithVariantsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PIMControllerApi - object-oriented interface
 * @export
 * @class PIMControllerApi
 * @extends {BaseAPI}
 */
export class PIMControllerApi extends BaseAPI {
    /**
     *
     * @param {PIMControllerApiBullyPimMutilpleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PIMControllerApi
     */
    bullyPimMutilple(requestParameters, options) {
        return PIMControllerApiFp(this.configuration).bullyPimMutilple(requestParameters.language, requestParameters.tenant, requestParameters.upids, requestParameters.channel, requestParameters.offset, requestParameters.limit, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PIMControllerApiLanguagePimV1TenantProductsUpidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PIMControllerApi
     */
    languagePimV1TenantProductsUpidGet(requestParameters, options) {
        return PIMControllerApiFp(this.configuration).languagePimV1TenantProductsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PIMControllerApiLanguagePimV1TenantProductsUpidVariantsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PIMControllerApi
     */
    languagePimV1TenantProductsUpidVariantsGet(requestParameters, options) {
        return PIMControllerApiFp(this.configuration).languagePimV1TenantProductsUpidVariantsGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PIMControllerApiLanguagePimV1TenantProductsWithVariantsUpidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PIMControllerApi
     */
    languagePimV1TenantProductsWithVariantsUpidGet(requestParameters, options) {
        return PIMControllerApiFp(this.configuration).languagePimV1TenantProductsWithVariantsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, requestParameters.channel, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PaymentsControllerApi - axios parameter creator
 * @export
 */
export const PaymentsControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {DisableRequestV1} DisableRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantDisablePost: (tenant, DisableRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('paymentsV1TenantDisablePost', 'tenant', tenant);
            // verify required parameter 'DisableRequestV1' is not null or undefined
            assertParamExists('paymentsV1TenantDisablePost', 'DisableRequestV1', DisableRequestV1);
            const localVarPath = `/payments/v1/{tenant}/disable`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(DisableRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {NotificationsRequestV1} [NotificationsRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantNotificationsPost: (tenant, NotificationsRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('paymentsV1TenantNotificationsPost', 'tenant', tenant);
            const localVarPath = `/payments/v1/{tenant}/notifications`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(NotificationsRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentMethodsGet: (tenant, orderDraftId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentMethodsGet', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentMethodsGet', 'orderDraftId', orderDraftId);
            const localVarPath = `/payments/v1/{tenant}/{orderDraftId}/paymentMethods`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {PaymentsDetailsRequestV1} PaymentsDetailsRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentsDetailsPost: (tenant, orderDraftId, PaymentsDetailsRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentsDetailsPost', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentsDetailsPost', 'orderDraftId', orderDraftId);
            // verify required parameter 'PaymentsDetailsRequestV1' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentsDetailsPost', 'PaymentsDetailsRequestV1', PaymentsDetailsRequestV1);
            const localVarPath = `/payments/v1/{tenant}/{orderDraftId}/payments/details`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PaymentsDetailsRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Performs zero value creditCard authentication or processes the payment
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {PaymentsRequestV1} PaymentsRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentsPost: (tenant, orderDraftId, PaymentsRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentsPost', 'tenant', tenant);
            // verify required parameter 'orderDraftId' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentsPost', 'orderDraftId', orderDraftId);
            // verify required parameter 'PaymentsRequestV1' is not null or undefined
            assertParamExists('paymentsV1TenantOrderDraftIdPaymentsPost', 'PaymentsRequestV1', PaymentsRequestV1);
            const localVarPath = `/payments/v1/{tenant}/{orderDraftId}/payments`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderDraftId"}}`, encodeURIComponent(String(orderDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PaymentsRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OriginKeysRequestV1} [OriginKeysRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOriginKeysPost: (tenant, OriginKeysRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('paymentsV1TenantOriginKeysPost', 'tenant', tenant);
            const localVarPath = `/payments/v1/{tenant}/originKeys`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(OriginKeysRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentsControllerApi - functional programming interface
 * @export
 */
export const PaymentsControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {DisableRequestV1} DisableRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantDisablePost(tenant, DisableRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentsV1TenantDisablePost(tenant, DisableRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {NotificationsRequestV1} [NotificationsRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantNotificationsPost(tenant, NotificationsRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentsV1TenantNotificationsPost(tenant, NotificationsRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentMethodsGet(tenant, orderDraftId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentsV1TenantOrderDraftIdPaymentMethodsGet(tenant, orderDraftId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {PaymentsDetailsRequestV1} PaymentsDetailsRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentsDetailsPost(tenant, orderDraftId, PaymentsDetailsRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentsV1TenantOrderDraftIdPaymentsDetailsPost(tenant, orderDraftId, PaymentsDetailsRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Performs zero value creditCard authentication or processes the payment
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderDraftId
         * @param {PaymentsRequestV1} PaymentsRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentsPost(tenant, orderDraftId, PaymentsRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentsV1TenantOrderDraftIdPaymentsPost(tenant, orderDraftId, PaymentsRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {OriginKeysRequestV1} [OriginKeysRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOriginKeysPost(tenant, OriginKeysRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentsV1TenantOriginKeysPost(tenant, OriginKeysRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentsControllerApi - factory interface
 * @export
 */
export const PaymentsControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentsControllerApiFp(configuration);
    return {
        /**
         *
         * @param {PaymentsControllerApiPaymentsV1TenantDisablePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantDisablePost(requestParameters, options) {
            return localVarFp.paymentsV1TenantDisablePost(requestParameters.tenant, requestParameters.DisableRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentsControllerApiPaymentsV1TenantNotificationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantNotificationsPost(requestParameters, options) {
            return localVarFp.paymentsV1TenantNotificationsPost(requestParameters.tenant, requestParameters.NotificationsRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentsControllerApiPaymentsV1TenantOrderDraftIdPaymentMethodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentMethodsGet(requestParameters, options) {
            return localVarFp.paymentsV1TenantOrderDraftIdPaymentMethodsGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentsControllerApiPaymentsV1TenantOrderDraftIdPaymentsDetailsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentsDetailsPost(requestParameters, options) {
            return localVarFp.paymentsV1TenantOrderDraftIdPaymentsDetailsPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.PaymentsDetailsRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Performs zero value creditCard authentication or processes the payment
         * @param {PaymentsControllerApiPaymentsV1TenantOrderDraftIdPaymentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOrderDraftIdPaymentsPost(requestParameters, options) {
            return localVarFp.paymentsV1TenantOrderDraftIdPaymentsPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.PaymentsRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentsControllerApiPaymentsV1TenantOriginKeysPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsV1TenantOriginKeysPost(requestParameters, options) {
            return localVarFp.paymentsV1TenantOriginKeysPost(requestParameters.tenant, requestParameters.OriginKeysRequestV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentsControllerApi - object-oriented interface
 * @export
 * @class PaymentsControllerApi
 * @extends {BaseAPI}
 */
export class PaymentsControllerApi extends BaseAPI {
    /**
     *
     * @param {PaymentsControllerApiPaymentsV1TenantDisablePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    paymentsV1TenantDisablePost(requestParameters, options) {
        return PaymentsControllerApiFp(this.configuration).paymentsV1TenantDisablePost(requestParameters.tenant, requestParameters.DisableRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentsControllerApiPaymentsV1TenantNotificationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    paymentsV1TenantNotificationsPost(requestParameters, options) {
        return PaymentsControllerApiFp(this.configuration).paymentsV1TenantNotificationsPost(requestParameters.tenant, requestParameters.NotificationsRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentsControllerApiPaymentsV1TenantOrderDraftIdPaymentMethodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    paymentsV1TenantOrderDraftIdPaymentMethodsGet(requestParameters, options) {
        return PaymentsControllerApiFp(this.configuration).paymentsV1TenantOrderDraftIdPaymentMethodsGet(requestParameters.tenant, requestParameters.orderDraftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentsControllerApiPaymentsV1TenantOrderDraftIdPaymentsDetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    paymentsV1TenantOrderDraftIdPaymentsDetailsPost(requestParameters, options) {
        return PaymentsControllerApiFp(this.configuration).paymentsV1TenantOrderDraftIdPaymentsDetailsPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.PaymentsDetailsRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Performs zero value creditCard authentication or processes the payment
     * @param {PaymentsControllerApiPaymentsV1TenantOrderDraftIdPaymentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    paymentsV1TenantOrderDraftIdPaymentsPost(requestParameters, options) {
        return PaymentsControllerApiFp(this.configuration).paymentsV1TenantOrderDraftIdPaymentsPost(requestParameters.tenant, requestParameters.orderDraftId, requestParameters.PaymentsRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentsControllerApiPaymentsV1TenantOriginKeysPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    paymentsV1TenantOriginKeysPost(requestParameters, options) {
        return PaymentsControllerApiFp(this.configuration).paymentsV1TenantOriginKeysPost(requestParameters.tenant, requestParameters.OriginKeysRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersistentCartControllerApi - axios parameter creator
 * @export
 */
export const PersistentCartControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdDelete: (id, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdDelete', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdDelete', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdDelete', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {string} entryId PathParam entryId
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete: (id, entryId, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete', 'id', id);
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete', 'entryId', entryId);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries/{entryId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {string} entryId PathParam entryId
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdGet: (id, entryId, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdGet', 'id', id);
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdGet', 'entryId', entryId);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdGet', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries/{entryId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {string} entryId PathParam entryId
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdPut: (id, entryId, tenant, language, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdPut', 'id', id);
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdPut', 'entryId', entryId);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdPut', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesEntryIdPut', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries/{entryId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesPost: (id, tenant, language, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesPost', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdEntriesPost', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}/entries`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdGet: (id, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdGet', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdPatch: (id, tenant, language, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdPatch', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdPatch', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsIdPatch', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsPost: (tenant, language, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantCartsPost', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/carts`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantHealthGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantHealthGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languagePersistentCartV1TenantHealthGet', 'language', language);
            const localVarPath = `/{language}/persistent-cart/v1/{tenant}/health`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PersistentCartControllerApi - functional programming interface
 * @export
 */
export const PersistentCartControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersistentCartControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdDelete(id, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdDelete(id, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {string} entryId PathParam entryId
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(id, entryId, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(id, entryId, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {string} entryId PathParam entryId
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(id, entryId, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(id, entryId, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {string} entryId PathParam entryId
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(id, entryId, tenant, language, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(id, entryId, tenant, language, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesPost(id, tenant, language, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdEntriesPost(id, tenant, language, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdGet(id, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdGet(id, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdPatch(id, tenant, language, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsIdPatch(id, tenant, language, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsPost(tenant, language, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantCartsPost(tenant, language, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantHealthGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languagePersistentCartV1TenantHealthGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PersistentCartControllerApi - factory interface
 * @export
 */
export const PersistentCartControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersistentCartControllerApiFp(configuration);
    return {
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdDelete(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsIdDelete(requestParameters.id, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesEntryIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(requestParameters.id, requestParameters.entryId, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesEntryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(requestParameters.id, requestParameters.entryId, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesEntryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(requestParameters.id, requestParameters.entryId, requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdEntriesPost(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsIdEntriesPost(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdGet(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsIdPatch(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsIdPatch(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantCartsPost(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantCartsPost(requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantHealthGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languagePersistentCartV1TenantHealthGet(requestParameters, options) {
            return localVarFp.languagePersistentCartV1TenantHealthGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersistentCartControllerApi - object-oriented interface
 * @export
 * @class PersistentCartControllerApi
 * @extends {BaseAPI}
 */
export class PersistentCartControllerApi extends BaseAPI {
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsIdDelete(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsIdDelete(requestParameters.id, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesEntryIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsIdEntriesEntryIdDelete(requestParameters.id, requestParameters.entryId, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesEntryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsIdEntriesEntryIdGet(requestParameters.id, requestParameters.entryId, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesEntryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsIdEntriesEntryIdPut(requestParameters.id, requestParameters.entryId, requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdEntriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsIdEntriesPost(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsIdEntriesPost(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsIdGet(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsIdPatch(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsIdPatch(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantCartsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantCartsPost(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantCartsPost(requestParameters.tenant, requestParameters.language, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersistentCartControllerApiLanguagePersistentCartV1TenantHealthGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentCartControllerApi
     */
    languagePersistentCartV1TenantHealthGet(requestParameters, options) {
        return PersistentCartControllerApiFp(this.configuration).languagePersistentCartV1TenantHealthGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonalLayoutControllerV1Api - axios parameter creator
 * @export
 */
export const PersonalLayoutControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get personal widget layout and data for app home screen
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} variant variant
         * @param {string} [zipCode] zipCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalLayoutV1TenantLanguageVariantAppsHomeGet: (tenant, language, variant, zipCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('personalLayoutV1TenantLanguageVariantAppsHomeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('personalLayoutV1TenantLanguageVariantAppsHomeGet', 'language', language);
            // verify required parameter 'variant' is not null or undefined
            assertParamExists('personalLayoutV1TenantLanguageVariantAppsHomeGet', 'variant', variant);
            const localVarPath = `/personal-layout/v1/{tenant}/{language}/{variant}/apps/home`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"variant"}}`, encodeURIComponent(String(variant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (zipCode !== undefined) {
                localVarQueryParameter['zipCode'] = zipCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PersonalLayoutControllerV1Api - functional programming interface
 * @export
 */
export const PersonalLayoutControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonalLayoutControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get personal widget layout and data for app home screen
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} variant variant
         * @param {string} [zipCode] zipCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalLayoutV1TenantLanguageVariantAppsHomeGet(tenant, language, variant, zipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalLayoutV1TenantLanguageVariantAppsHomeGet(tenant, language, variant, zipCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PersonalLayoutControllerV1Api - factory interface
 * @export
 */
export const PersonalLayoutControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonalLayoutControllerV1ApiFp(configuration);
    return {
        /**
         * Get personal widget layout and data for app home screen
         * @param {PersonalLayoutControllerV1ApiPersonalLayoutV1TenantLanguageVariantAppsHomeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalLayoutV1TenantLanguageVariantAppsHomeGet(requestParameters, options) {
            return localVarFp.personalLayoutV1TenantLanguageVariantAppsHomeGet(requestParameters.tenant, requestParameters.language, requestParameters.variant, requestParameters.zipCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonalLayoutControllerV1Api - object-oriented interface
 * @export
 * @class PersonalLayoutControllerV1Api
 * @extends {BaseAPI}
 */
export class PersonalLayoutControllerV1Api extends BaseAPI {
    /**
     * Get personal widget layout and data for app home screen
     * @param {PersonalLayoutControllerV1ApiPersonalLayoutV1TenantLanguageVariantAppsHomeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalLayoutControllerV1Api
     */
    personalLayoutV1TenantLanguageVariantAppsHomeGet(requestParameters, options) {
        return PersonalLayoutControllerV1ApiFp(this.configuration).personalLayoutV1TenantLanguageVariantAppsHomeGet(requestParameters.tenant, requestParameters.language, requestParameters.variant, requestParameters.zipCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PickupFinderConfigControllerApi - axios parameter creator
 * @export
 */
export const PickupFinderConfigControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a JSON object controls and settings for pickup points and lockers providers.
         * @summary Fetch controls and settings for pickup providers
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pupfApiV1ControlsTenantGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('pupfApiV1ControlsTenantGet', 'tenant', tenant);
            const localVarPath = `/pupf/api/v1/controls/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PickupFinderConfigControllerApi - functional programming interface
 * @export
 */
export const PickupFinderConfigControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PickupFinderConfigControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a JSON object controls and settings for pickup points and lockers providers.
         * @summary Fetch controls and settings for pickup providers
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pupfApiV1ControlsTenantGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pupfApiV1ControlsTenantGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PickupFinderConfigControllerApi - factory interface
 * @export
 */
export const PickupFinderConfigControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PickupFinderConfigControllerApiFp(configuration);
    return {
        /**
         * Returns a JSON object controls and settings for pickup points and lockers providers.
         * @summary Fetch controls and settings for pickup providers
         * @param {PickupFinderConfigControllerApiPupfApiV1ControlsTenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pupfApiV1ControlsTenantGet(requestParameters, options) {
            return localVarFp.pupfApiV1ControlsTenantGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PickupFinderConfigControllerApi - object-oriented interface
 * @export
 * @class PickupFinderConfigControllerApi
 * @extends {BaseAPI}
 */
export class PickupFinderConfigControllerApi extends BaseAPI {
    /**
     * Returns a JSON object controls and settings for pickup points and lockers providers.
     * @summary Fetch controls and settings for pickup providers
     * @param {PickupFinderConfigControllerApiPupfApiV1ControlsTenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickupFinderConfigControllerApi
     */
    pupfApiV1ControlsTenantGet(requestParameters, options) {
        return PickupFinderConfigControllerApiFp(this.configuration).pupfApiV1ControlsTenantGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PickupFinderPointsControllerApi - axios parameter creator
 * @export
 */
export const PickupFinderPointsControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns points around the users point
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} lat Latitude of the users\&#39; location search
         * @param {string} lng Longitude of the users\&#39; location search
         * @param {string} [filterStations] Only show pickup points from certain delivery companies. (See \&quot;#/definitions/PointMarkerTypeObject/id\&quot;)
         * @param {string} [userLocationLat] Latitude of the users\&#39; location to calculate the distance from. Optional.
         * @param {string} [userLocationLng] Longitude of the users\&#39; location to calculate the distance from. Optional.
         * @param {string} [search] The user search input for logging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pupfApiV1PointsTenantLatLngGet: (tenant, lat, lng, filterStations, userLocationLat, userLocationLng, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('pupfApiV1PointsTenantLatLngGet', 'tenant', tenant);
            // verify required parameter 'lat' is not null or undefined
            assertParamExists('pupfApiV1PointsTenantLatLngGet', 'lat', lat);
            // verify required parameter 'lng' is not null or undefined
            assertParamExists('pupfApiV1PointsTenantLatLngGet', 'lng', lng);
            const localVarPath = `/pupf/api/v1/points/{tenant}/{lat}/{lng}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"lat"}}`, encodeURIComponent(String(lat)))
                .replace(`{${"lng"}}`, encodeURIComponent(String(lng)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filterStations !== undefined) {
                localVarQueryParameter['filterStations'] = filterStations;
            }
            if (userLocationLat !== undefined) {
                localVarQueryParameter['userLocationLat'] = userLocationLat;
            }
            if (userLocationLng !== undefined) {
                localVarQueryParameter['userLocationLng'] = userLocationLng;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PickupFinderPointsControllerApi - functional programming interface
 * @export
 */
export const PickupFinderPointsControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PickupFinderPointsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns points around the users point
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} lat Latitude of the users\&#39; location search
         * @param {string} lng Longitude of the users\&#39; location search
         * @param {string} [filterStations] Only show pickup points from certain delivery companies. (See \&quot;#/definitions/PointMarkerTypeObject/id\&quot;)
         * @param {string} [userLocationLat] Latitude of the users\&#39; location to calculate the distance from. Optional.
         * @param {string} [userLocationLng] Longitude of the users\&#39; location to calculate the distance from. Optional.
         * @param {string} [search] The user search input for logging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pupfApiV1PointsTenantLatLngGet(tenant, lat, lng, filterStations, userLocationLat, userLocationLng, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pupfApiV1PointsTenantLatLngGet(tenant, lat, lng, filterStations, userLocationLat, userLocationLng, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PickupFinderPointsControllerApi - factory interface
 * @export
 */
export const PickupFinderPointsControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PickupFinderPointsControllerApiFp(configuration);
    return {
        /**
         * Returns points around the users point
         * @param {PickupFinderPointsControllerApiPupfApiV1PointsTenantLatLngGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pupfApiV1PointsTenantLatLngGet(requestParameters, options) {
            return localVarFp.pupfApiV1PointsTenantLatLngGet(requestParameters.tenant, requestParameters.lat, requestParameters.lng, requestParameters.filterStations, requestParameters.userLocationLat, requestParameters.userLocationLng, requestParameters.search, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PickupFinderPointsControllerApi - object-oriented interface
 * @export
 * @class PickupFinderPointsControllerApi
 * @extends {BaseAPI}
 */
export class PickupFinderPointsControllerApi extends BaseAPI {
    /**
     * Returns points around the users point
     * @param {PickupFinderPointsControllerApiPupfApiV1PointsTenantLatLngGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickupFinderPointsControllerApi
     */
    pupfApiV1PointsTenantLatLngGet(requestParameters, options) {
        return PickupFinderPointsControllerApiFp(this.configuration).pupfApiV1PointsTenantLatLngGet(requestParameters.tenant, requestParameters.lat, requestParameters.lng, requestParameters.filterStations, requestParameters.userLocationLat, requestParameters.userLocationLng, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PrescriptionControllerApi - axios parameter creator
 * @export
 */
export const PrescriptionControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Claims prescriptions from Gematik App
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} client
         * @param {string} ti_id QueryParam ti_id
         * @param {string} transactionID QueryParam transactionID
         * @param {boolean} isQsMode QueryParam isQsMode
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageAssignLoggedoutClientPost: (tenant, language, client, ti_id, transactionID, isQsMode, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageAssignLoggedoutClientPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageAssignLoggedoutClientPost', 'language', language);
            // verify required parameter 'client' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageAssignLoggedoutClientPost', 'client', client);
            // verify required parameter 'ti_id' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageAssignLoggedoutClientPost', 'ti_id', ti_id);
            // verify required parameter 'transactionID' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageAssignLoggedoutClientPost', 'transactionID', transactionID);
            // verify required parameter 'isQsMode' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageAssignLoggedoutClientPost', 'isQsMode', isQsMode);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageAssignLoggedoutClientPost', 'body', body);
            const localVarPath = `/prescription/v1/{tenant}/{language}/assign/loggedout/{client}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"client"}}`, encodeURIComponent(String(client)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ti_id !== undefined) {
                localVarQueryParameter['ti_id'] = ti_id;
            }
            if (transactionID !== undefined) {
                localVarQueryParameter['transactionID'] = transactionID;
            }
            if (isQsMode !== undefined) {
                localVarQueryParameter['isQsMode'] = isQsMode;
            }
            localVarHeaderParameter['Content-Type'] = 'application/pkcs7-mime';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a quick checkout order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageCheckoutPost: (tenant, language, QuickCheckoutBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageCheckoutPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageCheckoutPost', 'language', language);
            // verify required parameter 'QuickCheckoutBodyV1' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageCheckoutPost', 'QuickCheckoutBodyV1', QuickCheckoutBodyV1);
            const localVarPath = `/prescription/v1/{tenant}/{language}/checkout`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(QuickCheckoutBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ClaimPrescriptionsByInsuranceNumbersRequestObject} ClaimPrescriptionsByInsuranceNumbersRequestObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost: (tenant, language, ClaimPrescriptionsByInsuranceNumbersRequestObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost', 'language', language);
            // verify required parameter 'ClaimPrescriptionsByInsuranceNumbersRequestObject' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost', 'ClaimPrescriptionsByInsuranceNumbersRequestObject', ClaimPrescriptionsByInsuranceNumbersRequestObject);
            const localVarPath = `/prescription/v1/{tenant}/{language}/claimPrescriptionsByInsuranceNumbers`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ClaimPrescriptionsByInsuranceNumbersRequestObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DatamatruxurlsArray} DatamatruxurlsArray
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageClaimPrescriptionsPost: (tenant, language, DatamatruxurlsArray, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageClaimPrescriptionsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageClaimPrescriptionsPost', 'language', language);
            // verify required parameter 'DatamatruxurlsArray' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageClaimPrescriptionsPost', 'DatamatruxurlsArray', DatamatruxurlsArray);
            const localVarPath = `/prescription/v1/{tenant}/{language}/claimPrescriptions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(DatamatruxurlsArray, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Receives an array of datamatrixurl components, converts them into image buffer.
         * @summary Creates image from datamatrixurl components.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageCreateImageFromUrlPost: (tenant, language, PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageCreateImageFromUrlPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageCreateImageFromUrlPost', 'language', language);
            // verify required parameter 'PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageCreateImageFromUrlPost', 'PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest', PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest);
            const localVarPath = `/prescription/v1/{tenant}/{language}/createImageFromUrl`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Responds with DatamatrixUrls for given token.
         * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet: (tenant, language, datamatrixUrlsToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet', 'language', language);
            // verify required parameter 'datamatrixUrlsToken' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet', 'datamatrixUrlsToken', datamatrixUrlsToken);
            const localVarPath = `/prescription/v1/{tenant}/{language}/datamatrixUrls/{datamatrixUrlsToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"datamatrixUrlsToken"}}`, encodeURIComponent(String(datamatrixUrlsToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sends voucher email event to mail assembly service.
         * @summary Sends an email to customer for erx voucher.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageEmailVoucherPost: (tenant, language, ErxVoucherEmailBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageEmailVoucherPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageEmailVoucherPost', 'language', language);
            // verify required parameter 'ErxVoucherEmailBodyV1' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageEmailVoucherPost', 'ErxVoucherEmailBodyV1', ErxVoucherEmailBodyV1);
            const localVarPath = `/prescription/v1/{tenant}/{language}/email/voucher`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ErxVoucherEmailBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Fetch multiple prescriptions that are already claimed together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {HashedTokensPayload} HashedTokensPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageGetPrescriptionsPost: (tenant, language, HashedTokensPayload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageGetPrescriptionsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageGetPrescriptionsPost', 'language', language);
            // verify required parameter 'HashedTokensPayload' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageGetPrescriptionsPost', 'HashedTokensPayload', HashedTokensPayload);
            const localVarPath = `/prescription/v1/{tenant}/{language}/getPrescriptions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(HashedTokensPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenAbortedPost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenAbortedPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenAbortedPost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenAbortedPost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/aborted`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenClosedPost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenClosedPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenClosedPost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenClosedPost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/closed`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenDelete: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenDelete', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenDelete', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenDelete', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenDeletePost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenDeletePost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenDeletePost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenDeletePost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/delete`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
         * @summary Get an already claimed ePrescription by providing hashed token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenGet: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenGet', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenGet', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenRejectedPost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenRejectedPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenRejectedPost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHashedTokenRejectedPost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v1/{tenant}/{language}/{hashedToken}/rejected`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the health status of eRX service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHealthGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHealthGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageHealthGet', 'language', language);
            const localVarPath = `/prescription/v1/{tenant}/{language}/health`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
         * @summary Claim prescription given original, non-hashed tokens.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DataMatrixURL} DataMatrixURL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguagePost: (tenant, language, DataMatrixURL, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguagePost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguagePost', 'language', language);
            // verify required parameter 'DataMatrixURL' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguagePost', 'DataMatrixURL', DataMatrixURL);
            const localVarPath = `/prescription/v1/{tenant}/{language}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(DataMatrixURL, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
         * @summary Provisioning eRX data for given e-prescription
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} X_API_KEY
         * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageTelemedDeliverPost: (tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageTelemedDeliverPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageTelemedDeliverPost', 'language', language);
            // verify required parameter 'X_API_KEY' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageTelemedDeliverPost', 'X_API_KEY', X_API_KEY);
            // verify required parameter 'DatamatrixUrlComponentsList' is not null or undefined
            assertParamExists('prescriptionV1TenantLanguageTelemedDeliverPost', 'DatamatrixUrlComponentsList', DatamatrixUrlComponentsList);
            const localVarPath = `/prescription/v1/{tenant}/{language}/telemed/deliver`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_API_KEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(X_API_KEY);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(DatamatrixUrlComponentsList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Claims prescriptions from Gematik App
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} client
         * @param {string} ti_id QueryParam ti_id
         * @param {string} transactionID QueryParam transactionID
         * @param {boolean} isQsMode QueryParam isQsMode
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageAssignLoggedoutClientPost: (tenant, language, client, ti_id, transactionID, isQsMode, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageAssignLoggedoutClientPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageAssignLoggedoutClientPost', 'language', language);
            // verify required parameter 'client' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageAssignLoggedoutClientPost', 'client', client);
            // verify required parameter 'ti_id' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageAssignLoggedoutClientPost', 'ti_id', ti_id);
            // verify required parameter 'transactionID' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageAssignLoggedoutClientPost', 'transactionID', transactionID);
            // verify required parameter 'isQsMode' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageAssignLoggedoutClientPost', 'isQsMode', isQsMode);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageAssignLoggedoutClientPost', 'body', body);
            const localVarPath = `/prescription/v3/{tenant}/{language}/assign/loggedout/{client}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"client"}}`, encodeURIComponent(String(client)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ti_id !== undefined) {
                localVarQueryParameter['ti_id'] = ti_id;
            }
            if (transactionID !== undefined) {
                localVarQueryParameter['transactionID'] = transactionID;
            }
            if (isQsMode !== undefined) {
                localVarQueryParameter['isQsMode'] = isQsMode;
            }
            localVarHeaderParameter['Content-Type'] = 'application/pkcs7-mime';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a quick checkout order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageCheckoutPost: (tenant, language, QuickCheckoutBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageCheckoutPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageCheckoutPost', 'language', language);
            // verify required parameter 'QuickCheckoutBodyV1' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageCheckoutPost', 'QuickCheckoutBodyV1', QuickCheckoutBodyV1);
            const localVarPath = `/prescription/v3/{tenant}/{language}/checkout`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(QuickCheckoutBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ClaimPrescriptionsByInsuranceNumbersRequestObjectV3} ClaimPrescriptionsByInsuranceNumbersRequestObjectV3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost: (tenant, language, ClaimPrescriptionsByInsuranceNumbersRequestObjectV3, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost', 'language', language);
            // verify required parameter 'ClaimPrescriptionsByInsuranceNumbersRequestObjectV3' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost', 'ClaimPrescriptionsByInsuranceNumbersRequestObjectV3', ClaimPrescriptionsByInsuranceNumbersRequestObjectV3);
            const localVarPath = `/prescription/v3/{tenant}/{language}/claimPrescriptionsByInsuranceNumbers`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ClaimPrescriptionsByInsuranceNumbersRequestObjectV3, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DatamatruxurlsArray} DatamatruxurlsArray
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageClaimPrescriptionsPost: (tenant, language, DatamatruxurlsArray, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageClaimPrescriptionsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageClaimPrescriptionsPost', 'language', language);
            // verify required parameter 'DatamatruxurlsArray' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageClaimPrescriptionsPost', 'DatamatruxurlsArray', DatamatruxurlsArray);
            const localVarPath = `/prescription/v3/{tenant}/{language}/claimPrescriptions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(DatamatruxurlsArray, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Receives an array of datamatrixurl components, converts them into image buffer.
         * @summary Creates image from datamatrixurl components.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageCreateImageFromUrlPost: (tenant, language, PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageCreateImageFromUrlPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageCreateImageFromUrlPost', 'language', language);
            // verify required parameter 'PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageCreateImageFromUrlPost', 'PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest', PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest);
            const localVarPath = `/prescription/v3/{tenant}/{language}/createImageFromUrl`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Responds with DatamatrixUrls for given token.
         * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet: (tenant, language, datamatrixUrlsToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet', 'language', language);
            // verify required parameter 'datamatrixUrlsToken' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet', 'datamatrixUrlsToken', datamatrixUrlsToken);
            const localVarPath = `/prescription/v3/{tenant}/{language}/datamatrixUrls/{datamatrixUrlsToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"datamatrixUrlsToken"}}`, encodeURIComponent(String(datamatrixUrlsToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sends voucher email event to mail assembly service.
         * @summary Sends an email to customer for erx voucher.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageEmailVoucherPost: (tenant, language, ErxVoucherEmailBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageEmailVoucherPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageEmailVoucherPost', 'language', language);
            // verify required parameter 'ErxVoucherEmailBodyV1' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageEmailVoucherPost', 'ErxVoucherEmailBodyV1', ErxVoucherEmailBodyV1);
            const localVarPath = `/prescription/v3/{tenant}/{language}/email/voucher`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ErxVoucherEmailBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Fetch multiple prescriptions that are already claimed together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {HashedTokensPayload} HashedTokensPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageGetPrescriptionsPost: (tenant, language, HashedTokensPayload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageGetPrescriptionsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageGetPrescriptionsPost', 'language', language);
            // verify required parameter 'HashedTokensPayload' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageGetPrescriptionsPost', 'HashedTokensPayload', HashedTokensPayload);
            const localVarPath = `/prescription/v3/{tenant}/{language}/getPrescriptions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(HashedTokensPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenAbortedPost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenAbortedPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenAbortedPost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenAbortedPost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/aborted`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenClosedPost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenClosedPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenClosedPost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenClosedPost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/closed`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenDelete: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenDelete', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenDelete', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenDelete', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenDeletePost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenDeletePost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenDeletePost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenDeletePost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/delete`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
         * @summary Get an already claimed ePrescription by providing hashed token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenGet: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenGet', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenGet', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenRejectedPost: (tenant, language, hashedToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenRejectedPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenRejectedPost', 'language', language);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHashedTokenRejectedPost', 'hashedToken', hashedToken);
            const localVarPath = `/prescription/v3/{tenant}/{language}/{hashedToken}/rejected`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the health status of eRX service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHealthGet: (tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHealthGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageHealthGet', 'language', language);
            const localVarPath = `/prescription/v3/{tenant}/{language}/health`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
         * @summary Claim prescription given original, non-hashed tokens.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DataMatrixURL} DataMatrixURL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguagePost: (tenant, language, DataMatrixURL, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguagePost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguagePost', 'language', language);
            // verify required parameter 'DataMatrixURL' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguagePost', 'DataMatrixURL', DataMatrixURL);
            const localVarPath = `/prescription/v3/{tenant}/{language}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(DataMatrixURL, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
         * @summary Provisioning eRX data for given e-prescription
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} X_API_KEY
         * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageTelemedDeliverPost: (tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageTelemedDeliverPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageTelemedDeliverPost', 'language', language);
            // verify required parameter 'X_API_KEY' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageTelemedDeliverPost', 'X_API_KEY', X_API_KEY);
            // verify required parameter 'DatamatrixUrlComponentsList' is not null or undefined
            assertParamExists('prescriptionV3TenantLanguageTelemedDeliverPost', 'DatamatrixUrlComponentsList', DatamatrixUrlComponentsList);
            const localVarPath = `/prescription/v3/{tenant}/{language}/telemed/deliver`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_API_KEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(X_API_KEY);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(DatamatrixUrlComponentsList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PrescriptionControllerApi - functional programming interface
 * @export
 */
export const PrescriptionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PrescriptionControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Claims prescriptions from Gematik App
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} client
         * @param {string} ti_id QueryParam ti_id
         * @param {string} transactionID QueryParam transactionID
         * @param {boolean} isQsMode QueryParam isQsMode
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageAssignLoggedoutClientPost(tenant, language, client, ti_id, transactionID, isQsMode, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageAssignLoggedoutClientPost(tenant, language, client, ti_id, transactionID, isQsMode, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Creates a quick checkout order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ClaimPrescriptionsByInsuranceNumbersRequestObject} ClaimPrescriptionsByInsuranceNumbersRequestObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(tenant, language, ClaimPrescriptionsByInsuranceNumbersRequestObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(tenant, language, ClaimPrescriptionsByInsuranceNumbersRequestObject, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DatamatruxurlsArray} DatamatruxurlsArray
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Receives an array of datamatrixurl components, converts them into image buffer.
         * @summary Creates image from datamatrixurl components.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageCreateImageFromUrlPost(tenant, language, PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageCreateImageFromUrlPost(tenant, language, PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Responds with DatamatrixUrls for given token.
         * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Sends voucher email event to mail assembly service.
         * @summary Sends an email to customer for erx voucher.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Fetch multiple prescriptions that are already claimed together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {HashedTokensPayload} HashedTokensPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
         * @summary Get an already claimed ePrescription by providing hashed token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenGet(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenGet(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the health status of eRX service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHealthGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageHealthGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
         * @summary Claim prescription given original, non-hashed tokens.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DataMatrixURL} DataMatrixURL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguagePost(tenant, language, DataMatrixURL, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguagePost(tenant, language, DataMatrixURL, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
         * @summary Provisioning eRX data for given e-prescription
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} X_API_KEY
         * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV1TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Claims prescriptions from Gematik App
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} client
         * @param {string} ti_id QueryParam ti_id
         * @param {string} transactionID QueryParam transactionID
         * @param {boolean} isQsMode QueryParam isQsMode
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageAssignLoggedoutClientPost(tenant, language, client, ti_id, transactionID, isQsMode, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageAssignLoggedoutClientPost(tenant, language, client, ti_id, transactionID, isQsMode, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Creates a quick checkout order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {QuickCheckoutBodyV1} QuickCheckoutBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageCheckoutPost(tenant, language, QuickCheckoutBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ClaimPrescriptionsByInsuranceNumbersRequestObjectV3} ClaimPrescriptionsByInsuranceNumbersRequestObjectV3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(tenant, language, ClaimPrescriptionsByInsuranceNumbersRequestObjectV3, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(tenant, language, ClaimPrescriptionsByInsuranceNumbersRequestObjectV3, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions and returns them together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DatamatruxurlsArray} DatamatruxurlsArray
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageClaimPrescriptionsPost(tenant, language, DatamatruxurlsArray, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Receives an array of datamatrixurl components, converts them into image buffer.
         * @summary Creates image from datamatrixurl components.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageCreateImageFromUrlPost(tenant, language, PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageCreateImageFromUrlPost(tenant, language, PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Responds with DatamatrixUrls for given token.
         * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} datamatrixUrlsToken Token used to fetch corresponding datamatrix urls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(tenant, language, datamatrixUrlsToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Sends voucher email event to mail assembly service.
         * @summary Sends an email to customer for erx voucher.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {ErxVoucherEmailBodyV1} ErxVoucherEmailBodyV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageEmailVoucherPost(tenant, language, ErxVoucherEmailBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Fetch multiple prescriptions that are already claimed together with product data.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {HashedTokensPayload} HashedTokensPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageGetPrescriptionsPost(tenant, language, HashedTokensPayload, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenAbortedPost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenClosedPost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenDelete(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenDeletePost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
         * @summary Get an already claimed ePrescription by providing hashed token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenGet(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenGet(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} hashedToken The prescription\&#39;s hashed token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageHashedTokenRejectedPost(tenant, language, hashedToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the health status of eRX service
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHealthGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageHealthGet(tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
         * @summary Claim prescription given original, non-hashed tokens.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {DataMatrixURL} DataMatrixURL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguagePost(tenant, language, DataMatrixURL, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguagePost(tenant, language, DataMatrixURL, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
         * @summary Provisioning eRX data for given e-prescription
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} X_API_KEY
         * @param {DatamatrixUrlComponentsList} DatamatrixUrlComponentsList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.prescriptionV3TenantLanguageTelemedDeliverPost(tenant, language, X_API_KEY, DatamatrixUrlComponentsList, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PrescriptionControllerApi - factory interface
 * @export
 */
export const PrescriptionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PrescriptionControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Claims prescriptions from Gematik App
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageAssignLoggedoutClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageAssignLoggedoutClientPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageAssignLoggedoutClientPost(requestParameters.tenant, requestParameters.language, requestParameters.client, requestParameters.ti_id, requestParameters.transactionID, requestParameters.isQsMode, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a quick checkout order.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageCheckoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageCheckoutPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageCheckoutPost(requestParameters.tenant, requestParameters.language, requestParameters.QuickCheckoutBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters.tenant, requestParameters.language, requestParameters.ClaimPrescriptionsByInsuranceNumbersRequestObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions and returns them together with product data.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageClaimPrescriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageClaimPrescriptionsPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageClaimPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.DatamatruxurlsArray, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives an array of datamatrixurl components, converts them into image buffer.
         * @summary Creates image from datamatrixurl components.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageCreateImageFromUrlPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageCreateImageFromUrlPost(requestParameters.tenant, requestParameters.language, requestParameters.PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Responds with DatamatrixUrls for given token.
         * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.datamatrixUrlsToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends voucher email event to mail assembly service.
         * @summary Sends an email to customer for erx voucher.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageEmailVoucherPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageEmailVoucherPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageEmailVoucherPost(requestParameters.tenant, requestParameters.language, requestParameters.ErxVoucherEmailBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Fetch multiple prescriptions that are already claimed together with product data.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageGetPrescriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageGetPrescriptionsPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageGetPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.HashedTokensPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenAbortedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenAbortedPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageHashedTokenAbortedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenClosedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenClosedPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageHashedTokenClosedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenDelete(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageHashedTokenDelete(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenDeletePost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageHashedTokenDeletePost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
         * @summary Get an already claimed ePrescription by providing hashed token.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenGet(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageHashedTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenRejectedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHashedTokenRejectedPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageHashedTokenRejectedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the health status of eRX service
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHealthGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageHealthGet(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageHealthGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
         * @summary Claim prescription given original, non-hashed tokens.
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguagePost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguagePost(requestParameters.tenant, requestParameters.language, requestParameters.DataMatrixURL, options).then((request) => request(axios, basePath));
        },
        /**
         * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
         * @summary Provisioning eRX data for given e-prescription
         * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageTelemedDeliverPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV1TenantLanguageTelemedDeliverPost(requestParameters, options) {
            return localVarFp.prescriptionV1TenantLanguageTelemedDeliverPost(requestParameters.tenant, requestParameters.language, requestParameters.X_API_KEY, requestParameters.DatamatrixUrlComponentsList, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Claims prescriptions from Gematik App
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageAssignLoggedoutClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageAssignLoggedoutClientPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageAssignLoggedoutClientPost(requestParameters.tenant, requestParameters.language, requestParameters.client, requestParameters.ti_id, requestParameters.transactionID, requestParameters.isQsMode, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a quick checkout order.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageCheckoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageCheckoutPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageCheckoutPost(requestParameters.tenant, requestParameters.language, requestParameters.QuickCheckoutBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters.tenant, requestParameters.language, requestParameters.ClaimPrescriptionsByInsuranceNumbersRequestObjectV3, options).then((request) => request(axios, basePath));
        },
        /**
         * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Claims multiple prescriptions and returns them together with product data.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageClaimPrescriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageClaimPrescriptionsPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageClaimPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.DatamatruxurlsArray, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives an array of datamatrixurl components, converts them into image buffer.
         * @summary Creates image from datamatrixurl components.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageCreateImageFromUrlPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageCreateImageFromUrlPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageCreateImageFromUrlPost(requestParameters.tenant, requestParameters.language, requestParameters.PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Responds with DatamatrixUrls for given token.
         * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.datamatrixUrlsToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends voucher email event to mail assembly service.
         * @summary Sends an email to customer for erx voucher.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageEmailVoucherPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageEmailVoucherPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageEmailVoucherPost(requestParameters.tenant, requestParameters.language, requestParameters.ErxVoucherEmailBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
         * @summary Fetch multiple prescriptions that are already claimed together with product data.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageGetPrescriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageGetPrescriptionsPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageGetPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.HashedTokensPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenAbortedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenAbortedPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageHashedTokenAbortedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenClosedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenClosedPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageHashedTokenClosedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenDelete(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageHashedTokenDelete(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
         * @summary Unclaims prescription from eRX.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenDeletePost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageHashedTokenDeletePost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
         * @summary Get an already claimed ePrescription by providing hashed token.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenGet(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageHashedTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
         * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenRejectedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHashedTokenRejectedPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageHashedTokenRejectedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the health status of eRX service
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHealthGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageHealthGet(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageHealthGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
         * @summary Claim prescription given original, non-hashed tokens.
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguagePost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguagePost(requestParameters.tenant, requestParameters.language, requestParameters.DataMatrixURL, options).then((request) => request(axios, basePath));
        },
        /**
         * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
         * @summary Provisioning eRX data for given e-prescription
         * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageTelemedDeliverPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionV3TenantLanguageTelemedDeliverPost(requestParameters, options) {
            return localVarFp.prescriptionV3TenantLanguageTelemedDeliverPost(requestParameters.tenant, requestParameters.language, requestParameters.X_API_KEY, requestParameters.DatamatrixUrlComponentsList, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PrescriptionControllerApi - object-oriented interface
 * @export
 * @class PrescriptionControllerApi
 * @extends {BaseAPI}
 */
export class PrescriptionControllerApi extends BaseAPI {
    /**
     *
     * @summary Claims prescriptions from Gematik App
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageAssignLoggedoutClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageAssignLoggedoutClientPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageAssignLoggedoutClientPost(requestParameters.tenant, requestParameters.language, requestParameters.client, requestParameters.ti_id, requestParameters.transactionID, requestParameters.isQsMode, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a quick checkout order.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageCheckoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageCheckoutPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageCheckoutPost(requestParameters.tenant, requestParameters.language, requestParameters.QuickCheckoutBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters.tenant, requestParameters.language, requestParameters.ClaimPrescriptionsByInsuranceNumbersRequestObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageClaimPrescriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageClaimPrescriptionsPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageClaimPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.DatamatruxurlsArray, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageCreateImageFromUrlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageCreateImageFromUrlPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageCreateImageFromUrlPost(requestParameters.tenant, requestParameters.language, requestParameters.PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.datamatrixUrlsToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageEmailVoucherPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageEmailVoucherPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageEmailVoucherPost(requestParameters.tenant, requestParameters.language, requestParameters.ErxVoucherEmailBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageGetPrescriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageGetPrescriptionsPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageGetPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.HashedTokensPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenAbortedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageHashedTokenAbortedPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageHashedTokenAbortedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenClosedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageHashedTokenClosedPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageHashedTokenClosedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageHashedTokenDelete(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageHashedTokenDelete(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageHashedTokenDeletePost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageHashedTokenDeletePost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageHashedTokenGet(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageHashedTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHashedTokenRejectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageHashedTokenRejectedPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageHashedTokenRejectedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the health status of eRX service
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageHealthGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageHealthGet(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageHealthGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguagePost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguagePost(requestParameters.tenant, requestParameters.language, requestParameters.DataMatrixURL, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {PrescriptionControllerApiPrescriptionV1TenantLanguageTelemedDeliverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV1TenantLanguageTelemedDeliverPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV1TenantLanguageTelemedDeliverPost(requestParameters.tenant, requestParameters.language, requestParameters.X_API_KEY, requestParameters.DatamatrixUrlComponentsList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Claims prescriptions from Gematik App
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageAssignLoggedoutClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageAssignLoggedoutClientPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageAssignLoggedoutClientPost(requestParameters.tenant, requestParameters.language, requestParameters.client, requestParameters.ti_id, requestParameters.transactionID, requestParameters.isQsMode, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a quick checkout order.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageCheckoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageCheckoutPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageCheckoutPost(requestParameters.tenant, requestParameters.language, requestParameters.QuickCheckoutBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Claims prescriptions by provided datamatrixurls. Checks if they match with provided insurance numbers. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returns an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions, checks if they match with provided insurance numbers and returns them together with product data.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageClaimPrescriptionsByInsuranceNumbersPost(requestParameters.tenant, requestParameters.language, requestParameters.ClaimPrescriptionsByInsuranceNumbersRequestObjectV3, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Claims prescriptions by provided datamatrixurls. Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Claims multiple prescriptions and returns them together with product data.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageClaimPrescriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageClaimPrescriptionsPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageClaimPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.DatamatruxurlsArray, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Receives an array of datamatrixurl components, converts them into image buffer.
     * @summary Creates image from datamatrixurl components.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageCreateImageFromUrlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageCreateImageFromUrlPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageCreateImageFromUrlPost(requestParameters.tenant, requestParameters.language, requestParameters.PrescriptionV1TenantLanguageCreateImageFromUrlPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Responds with DatamatrixUrls for given token.
     * @summary Fetches DatamatrixUrls that correspond to the token param through eRX Service
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageDatamatrixUrlsDatamatrixUrlsTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.datamatrixUrlsToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends voucher email event to mail assembly service.
     * @summary Sends an email to customer for erx voucher.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageEmailVoucherPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageEmailVoucherPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageEmailVoucherPost(requestParameters.tenant, requestParameters.language, requestParameters.ErxVoucherEmailBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns map of prescriptions having hashedToken as map key and the prescription data together with product data and http status code as a value. If server returnes an 5xx error - the whole request will be rejected with 5xx error as well.
     * @summary Fetch multiple prescriptions that are already claimed together with product data.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageGetPrescriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageGetPrescriptionsPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageGetPrescriptionsPost(requestParameters.tenant, requestParameters.language, requestParameters.HashedTokensPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Aborts prescription, removes the dataMatrixUrl from the prescription.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenAbortedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageHashedTokenAbortedPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageHashedTokenAbortedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Closes prescription, removes the dataMatrixUrl from the prescription.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenClosedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageHashedTokenClosedPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageHashedTokenClosedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageHashedTokenDelete(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageHashedTokenDelete(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, if a user removes the eRX Prescription we want to release the eRX in the Telematik IT.
     * @summary Unclaims prescription from eRX.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageHashedTokenDeletePost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageHashedTokenDeletePost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the ePrescription from the eRX service, and on successful response, it returns the same set of data as in the claim call. If the prescription is unclaimed, it will return an indicative error message.\'
     * @summary Get an already claimed ePrescription by providing hashed token.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageHashedTokenGet(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageHashedTokenGet(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given the hashed token, removes the dataMatrixUrl from the prescription in mongoDB.
     * @summary Rejects prescription, removes the dataMatrixUrl from the prescription.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHashedTokenRejectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageHashedTokenRejectedPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageHashedTokenRejectedPost(requestParameters.tenant, requestParameters.language, requestParameters.hashedToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the health status of eRX service
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageHealthGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageHealthGet(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageHealthGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Receives the extracted dataMatrixURL (which contains a task id) from the client, and makes a request to the eRX service, claiming the prescription item(s). It may then make a request to the Swap service, potentially swapping the prescription item(s) received from eRX service in the previous step. It then populates the product data for all prescription item(s) and returns the fully renderable payload to the client
     * @summary Claim prescription given original, non-hashed tokens.
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguagePost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguagePost(requestParameters.tenant, requestParameters.language, requestParameters.DataMatrixURL, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * When called the SAE eRX Service will provide a dedicated link for putting the eRX into the eRX Manager that can be later visited.
     * @summary Provisioning eRX data for given e-prescription
     * @param {PrescriptionControllerApiPrescriptionV3TenantLanguageTelemedDeliverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionControllerApi
     */
    prescriptionV3TenantLanguageTelemedDeliverPost(requestParameters, options) {
        return PrescriptionControllerApiFp(this.configuration).prescriptionV3TenantLanguageTelemedDeliverPost(requestParameters.tenant, requestParameters.language, requestParameters.X_API_KEY, requestParameters.DatamatrixUrlComponentsList, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductControllerApi - axios parameter creator
 * @export
 */
export const ProductControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} ids PathParam ids
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [page] QueryParam page
         * @param {string} [resultsPerPage] QueryParam resultsPerPage
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyProductsMutilple: (ids, tenant, language, page, resultsPerPage, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('bullyProductsMutilple', 'ids', ids);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyProductsMutilple', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('bullyProductsMutilple', 'language', language);
            const localVarPath = `/{language}/products/v3/{tenant}/multiple/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (resultsPerPage !== undefined) {
                localVarQueryParameter['resultsPerPage'] = resultsPerPage;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [page] QueryParam page
         * @param {string} [resultsPerPage] QueryParam resultsPerPage
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantCategoryIdGet: (id, tenant, language, page, resultsPerPage, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageProductsV3TenantCategoryIdGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageProductsV3TenantCategoryIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageProductsV3TenantCategoryIdGet', 'language', language);
            const localVarPath = `/{language}/products/v3/{tenant}/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (resultsPerPage !== undefined) {
                localVarQueryParameter['resultsPerPage'] = resultsPerPage;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [channel] QueryParam channel
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdGet: (id, tenant, language, channel, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageProductsV3TenantIdGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageProductsV3TenantIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageProductsV3TenantIdGet', 'language', language);
            const localVarPath = `/{language}/products/v3/{tenant}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [channel] QueryParam channel
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdProductWithVariantsGet: (id, tenant, language, channel, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageProductsV3TenantIdProductWithVariantsGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageProductsV3TenantIdProductWithVariantsGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageProductsV3TenantIdProductWithVariantsGet', 'language', language);
            const localVarPath = `/{language}/products/v3/{tenant}/{id}/productWithVariants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [channel] QueryParam channel
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdVariantsGet: (id, tenant, language, channel, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageProductsV3TenantIdVariantsGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageProductsV3TenantIdVariantsGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageProductsV3TenantIdVariantsGet', 'language', language);
            const localVarPath = `/{language}/products/v3/{tenant}/{id}/variants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductControllerApi - functional programming interface
 * @export
 */
export const ProductControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} ids PathParam ids
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [page] QueryParam page
         * @param {string} [resultsPerPage] QueryParam resultsPerPage
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyProductsMutilple(ids, tenant, language, page, resultsPerPage, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyProductsMutilple(ids, tenant, language, page, resultsPerPage, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [page] QueryParam page
         * @param {string} [resultsPerPage] QueryParam resultsPerPage
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantCategoryIdGet(id, tenant, language, page, resultsPerPage, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageProductsV3TenantCategoryIdGet(id, tenant, language, page, resultsPerPage, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [channel] QueryParam channel
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdGet(id, tenant, language, channel, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageProductsV3TenantIdGet(id, tenant, language, channel, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [channel] QueryParam channel
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdProductWithVariantsGet(id, tenant, language, channel, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageProductsV3TenantIdProductWithVariantsGet(id, tenant, language, channel, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [channel] QueryParam channel
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdVariantsGet(id, tenant, language, channel, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageProductsV3TenantIdVariantsGet(id, tenant, language, channel, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductControllerApi - factory interface
 * @export
 */
export const ProductControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ProductControllerApiBullyProductsMutilpleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyProductsMutilple(requestParameters, options) {
            return localVarFp.bullyProductsMutilple(requestParameters.ids, requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.resultsPerPage, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductControllerApiLanguageProductsV3TenantCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantCategoryIdGet(requestParameters, options) {
            return localVarFp.languageProductsV3TenantCategoryIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.resultsPerPage, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductControllerApiLanguageProductsV3TenantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdGet(requestParameters, options) {
            return localVarFp.languageProductsV3TenantIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.channel, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductControllerApiLanguageProductsV3TenantIdProductWithVariantsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdProductWithVariantsGet(requestParameters, options) {
            return localVarFp.languageProductsV3TenantIdProductWithVariantsGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.channel, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductControllerApiLanguageProductsV3TenantIdVariantsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageProductsV3TenantIdVariantsGet(requestParameters, options) {
            return localVarFp.languageProductsV3TenantIdVariantsGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.channel, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductControllerApi - object-oriented interface
 * @export
 * @class ProductControllerApi
 * @extends {BaseAPI}
 */
export class ProductControllerApi extends BaseAPI {
    /**
     *
     * @param {ProductControllerApiBullyProductsMutilpleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    bullyProductsMutilple(requestParameters, options) {
        return ProductControllerApiFp(this.configuration).bullyProductsMutilple(requestParameters.ids, requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.resultsPerPage, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductControllerApiLanguageProductsV3TenantCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    languageProductsV3TenantCategoryIdGet(requestParameters, options) {
        return ProductControllerApiFp(this.configuration).languageProductsV3TenantCategoryIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.resultsPerPage, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductControllerApiLanguageProductsV3TenantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    languageProductsV3TenantIdGet(requestParameters, options) {
        return ProductControllerApiFp(this.configuration).languageProductsV3TenantIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.channel, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductControllerApiLanguageProductsV3TenantIdProductWithVariantsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    languageProductsV3TenantIdProductWithVariantsGet(requestParameters, options) {
        return ProductControllerApiFp(this.configuration).languageProductsV3TenantIdProductWithVariantsGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.channel, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductControllerApiLanguageProductsV3TenantIdVariantsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    languageProductsV3TenantIdVariantsGet(requestParameters, options) {
        return ProductControllerApiFp(this.configuration).languageProductsV3TenantIdVariantsGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.channel, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductRatingControllerApi - axios parameter creator
 * @export
 */
export const ProductRatingControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {boolean} [isWidget] isWidget rating
         * @param {'rating' | 'author' | 'date'} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRatingsV2TenantCategoryIdGet: (id, tenant, language, isWidget, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageRatingsV2TenantCategoryIdGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageRatingsV2TenantCategoryIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageRatingsV2TenantCategoryIdGet', 'language', language);
            const localVarPath = `/{language}/ratings/v2/{tenant}/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isWidget !== undefined) {
                localVarQueryParameter['isWidget'] = isWidget;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {number} [page] QueryParam page
         * @param {boolean} [isWidget] isWidget rating
         * @param {number} [perPage] QueryParam perPage
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRatingsV2TenantProductIdGet: (id, tenant, language, page, isWidget, perPage, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('languageRatingsV2TenantProductIdGet', 'id', id);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageRatingsV2TenantProductIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageRatingsV2TenantProductIdGet', 'language', language);
            const localVarPath = `/{language}/ratings/v2/{tenant}/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (isWidget !== undefined) {
                localVarQueryParameter['isWidget'] = isWidget;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductRatingControllerApi - functional programming interface
 * @export
 */
export const ProductRatingControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductRatingControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {boolean} [isWidget] isWidget rating
         * @param {'rating' | 'author' | 'date'} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRatingsV2TenantCategoryIdGet(id, tenant, language, isWidget, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageRatingsV2TenantCategoryIdGet(id, tenant, language, isWidget, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id PathParam id
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'es-dev' | 'es-qs' | 'es' | 'fr-dev' | 'fr-qs' | 'fr' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {number} [page] QueryParam page
         * @param {boolean} [isWidget] isWidget rating
         * @param {number} [perPage] QueryParam perPage
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRatingsV2TenantProductIdGet(id, tenant, language, page, isWidget, perPage, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageRatingsV2TenantProductIdGet(id, tenant, language, page, isWidget, perPage, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductRatingControllerApi - factory interface
 * @export
 */
export const ProductRatingControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductRatingControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ProductRatingControllerApiLanguageRatingsV2TenantCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRatingsV2TenantCategoryIdGet(requestParameters, options) {
            return localVarFp.languageRatingsV2TenantCategoryIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.isWidget, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductRatingControllerApiLanguageRatingsV2TenantProductIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRatingsV2TenantProductIdGet(requestParameters, options) {
            return localVarFp.languageRatingsV2TenantProductIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.isWidget, requestParameters.perPage, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductRatingControllerApi - object-oriented interface
 * @export
 * @class ProductRatingControllerApi
 * @extends {BaseAPI}
 */
export class ProductRatingControllerApi extends BaseAPI {
    /**
     *
     * @param {ProductRatingControllerApiLanguageRatingsV2TenantCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRatingControllerApi
     */
    languageRatingsV2TenantCategoryIdGet(requestParameters, options) {
        return ProductRatingControllerApiFp(this.configuration).languageRatingsV2TenantCategoryIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.isWidget, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductRatingControllerApiLanguageRatingsV2TenantProductIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRatingControllerApi
     */
    languageRatingsV2TenantProductIdGet(requestParameters, options) {
        return ProductRatingControllerApiFp(this.configuration).languageRatingsV2TenantProductIdGet(requestParameters.id, requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.isWidget, requestParameters.perPage, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductReviewControllerApi - axios parameter creator
 * @export
 */
export const ProductReviewControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} categoryCode
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet: (language, tenant, categoryCode, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet', 'tenant', tenant);
            // verify required parameter 'categoryCode' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet', 'categoryCode', categoryCode);
            const localVarPath = `/product-review/v1/{language}/{tenant}/category/{categoryCode}/reviews`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantProductsUpidGet: (language, tenant, upid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantProductsUpidGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantProductsUpidGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantProductsUpidGet', 'upid', upid);
            const localVarPath = `/product-review/v1/{language}/{tenant}/products/{upid}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Post a new product review for a variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {ReviewRequestV1} ReviewRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantReviewsPost: (language, tenant, ReviewRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantReviewsPost', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantReviewsPost', 'tenant', tenant);
            // verify required parameter 'ReviewRequestV1' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantReviewsPost', 'ReviewRequestV1', ReviewRequestV1);
            const localVarPath = `/product-review/v1/{language}/{tenant}/reviews`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get rating stats for a certain variant for all languages (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet: (language, tenant, variant_code, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet', 'tenant', tenant);
            // verify required parameter 'variant_code' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet', 'variant_code', variant_code);
            const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/all/summary`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all active reviews for a certain variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeReviewsGet: (language, tenant, variant_code, page, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeReviewsGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeReviewsGet', 'tenant', tenant);
            // verify required parameter 'variant_code' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeReviewsGet', 'variant_code', variant_code);
            const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/reviews`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get rating stats for a certain variant (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeSummaryGet: (language, tenant, variant_code, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeSummaryGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeSummaryGet', 'tenant', tenant);
            // verify required parameter 'variant_code' is not null or undefined
            assertParamExists('productReviewV1LanguageTenantVariantsVariantCodeSummaryGet', 'variant_code', variant_code);
            const localVarPath = `/product-review/v1/{language}/{tenant}/variants/{variant_code}/summary`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"variant_code"}}`, encodeURIComponent(String(variant_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductReviewControllerApi - functional programming interface
 * @export
 */
export const ProductReviewControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductReviewControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} categoryCode
         * @param {number} [limit] The limit specifies the maximum number of documents the endpoint will return. A limit value of 0 is equivalent to setting no limit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(language, tenant, categoryCode, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantProductsUpidGet(language, tenant, upid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Post a new product review for a variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {ReviewRequestV1} ReviewRequestV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantReviewsPost(language, tenant, ReviewRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get rating stats for a certain variant for all languages (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(language, tenant, variant_code, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get all active reviews for a certain variant
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(language, tenant, variant_code, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(language, tenant, variant_code, page, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get rating stats for a certain variant (only active reviews)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} variant_code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(language, tenant, variant_code, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductReviewControllerApi - factory interface
 * @export
 */
export const ProductReviewControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductReviewControllerApiFp(configuration);
    return {
        /**
         * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantCategoryCategoryCodeReviewsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.categoryCode, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantProductsUpidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantProductsUpidGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantProductsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
        /**
         * Post a new product review for a variant
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantReviewsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantReviewsPost(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantReviewsPost(requestParameters.language, requestParameters.tenant, requestParameters.ReviewRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Get rating stats for a certain variant for all languages (only active reviews)
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeAllSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all active reviews for a certain variant
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeReviewsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get rating stats for a certain variant (only active reviews)
         * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters, options) {
            return localVarFp.productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductReviewControllerApi - object-oriented interface
 * @export
 * @class ProductReviewControllerApi
 * @extends {BaseAPI}
 */
export class ProductReviewControllerApi extends BaseAPI {
    /**
     * Get latest active reviews for a specific category (only one review per upid). Use \"all\" as a category code to get for all categories
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantCategoryCategoryCodeReviewsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductReviewControllerApi
     */
    productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantCategoryCategoryCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.categoryCode, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * check whether the customer has already rated a certain upid - returns review if positive and empty object if negative
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantProductsUpidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductReviewControllerApi
     */
    productReviewV1LanguageTenantProductsUpidGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantProductsUpidGet(requestParameters.language, requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Post a new product review for a variant
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantReviewsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductReviewControllerApi
     */
    productReviewV1LanguageTenantReviewsPost(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantReviewsPost(requestParameters.language, requestParameters.tenant, requestParameters.ReviewRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get rating stats for a certain variant for all languages (only active reviews)
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeAllSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductReviewControllerApi
     */
    productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantVariantsVariantCodeAllSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all active reviews for a certain variant
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeReviewsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductReviewControllerApi
     */
    productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantVariantsVariantCodeReviewsGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get rating stats for a certain variant (only active reviews)
     * @param {ProductReviewControllerApiProductReviewV1LanguageTenantVariantsVariantCodeSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductReviewControllerApi
     */
    productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters, options) {
        return ProductReviewControllerApiFp(this.configuration).productReviewV1LanguageTenantVariantsVariantCodeSummaryGet(requestParameters.language, requestParameters.tenant, requestParameters.variant_code, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReavailabilityNotificationControllerApi - axios parameter creator
 * @export
 */
export const ReavailabilityNotificationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get information whether customer has subscribed to passed product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantCustomerSubscriptionStatusUpidGet: (tenant, upid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('reavailabilityV1TenantCustomerSubscriptionStatusUpidGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('reavailabilityV1TenantCustomerSubscriptionStatusUpidGet', 'upid', upid);
            const localVarPath = `/reavailability/v1/{tenant}/customer-subscription-status/{upid}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Subscribing to reavailability notification for a product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantSubscribeUpidPost: (tenant, upid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('reavailabilityV1TenantSubscribeUpidPost', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('reavailabilityV1TenantSubscribeUpidPost', 'upid', upid);
            const localVarPath = `/reavailability/v1/{tenant}/subscribe/{upid}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReavailabilityNotificationControllerApi - functional programming interface
 * @export
 */
export const ReavailabilityNotificationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReavailabilityNotificationControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get information whether customer has subscribed to passed product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(tenant, upid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Subscribing to reavailability notification for a product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantSubscribeUpidPost(tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reavailabilityV1TenantSubscribeUpidPost(tenant, upid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ReavailabilityNotificationControllerApi - factory interface
 * @export
 */
export const ReavailabilityNotificationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReavailabilityNotificationControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Get information whether customer has subscribed to passed product
         * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantCustomerSubscriptionStatusUpidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters, options) {
            return localVarFp.reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Subscribing to reavailability notification for a product
         * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantSubscribeUpidPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantSubscribeUpidPost(requestParameters, options) {
            return localVarFp.reavailabilityV1TenantSubscribeUpidPost(requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReavailabilityNotificationControllerApi - object-oriented interface
 * @export
 * @class ReavailabilityNotificationControllerApi
 * @extends {BaseAPI}
 */
export class ReavailabilityNotificationControllerApi extends BaseAPI {
    /**
     *
     * @summary Get information whether customer has subscribed to passed product
     * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantCustomerSubscriptionStatusUpidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReavailabilityNotificationControllerApi
     */
    reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters, options) {
        return ReavailabilityNotificationControllerApiFp(this.configuration).reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Subscribing to reavailability notification for a product
     * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantSubscribeUpidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReavailabilityNotificationControllerApi
     */
    reavailabilityV1TenantSubscribeUpidPost(requestParameters, options) {
        return ReavailabilityNotificationControllerApiFp(this.configuration).reavailabilityV1TenantSubscribeUpidPost(requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RecentOrdersControllerV1Api - axios parameter creator
 * @export
 */
export const RecentOrdersControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets last orders enriched with products for rebuy.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [itemsPerPage]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRecentOrdersV1TenantGet: (language, tenant, itemsPerPage, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageRecentOrdersV1TenantGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageRecentOrdersV1TenantGet', 'tenant', tenant);
            const localVarPath = `/{language}/recent-orders/v1/{tenant}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RecentOrdersControllerV1Api - functional programming interface
 * @export
 */
export const RecentOrdersControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecentOrdersControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets last orders enriched with products for rebuy.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [itemsPerPage]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRecentOrdersV1TenantGet(language, tenant, itemsPerPage, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageRecentOrdersV1TenantGet(language, tenant, itemsPerPage, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RecentOrdersControllerV1Api - factory interface
 * @export
 */
export const RecentOrdersControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecentOrdersControllerV1ApiFp(configuration);
    return {
        /**
         * Gets last orders enriched with products for rebuy.
         * @param {RecentOrdersControllerV1ApiLanguageRecentOrdersV1TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRecentOrdersV1TenantGet(requestParameters, options) {
            return localVarFp.languageRecentOrdersV1TenantGet(requestParameters.language, requestParameters.tenant, requestParameters.itemsPerPage, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecentOrdersControllerV1Api - object-oriented interface
 * @export
 * @class RecentOrdersControllerV1Api
 * @extends {BaseAPI}
 */
export class RecentOrdersControllerV1Api extends BaseAPI {
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {RecentOrdersControllerV1ApiLanguageRecentOrdersV1TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecentOrdersControllerV1Api
     */
    languageRecentOrdersV1TenantGet(requestParameters, options) {
        return RecentOrdersControllerV1ApiFp(this.configuration).languageRecentOrdersV1TenantGet(requestParameters.language, requestParameters.tenant, requestParameters.itemsPerPage, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RecentOrdersControllerV2Api - axios parameter creator
 * @export
 */
export const RecentOrdersControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets last orders enriched with products for rebuy.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [itemsPerPage]
         * @param {number} [page]
         * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
         * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
         * @param {string} [cbpFallbackChannel] The fallback channel to use in case cbpChannels is not provided for all variants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRecentOrdersV2TenantGet: (language, tenant, itemsPerPage, page, cbpUpids, cbpChannels, cbpFallbackChannel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageRecentOrdersV2TenantGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageRecentOrdersV2TenantGet', 'tenant', tenant);
            const localVarPath = `/{language}/recent-orders/v2/{tenant}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (cbpUpids !== undefined) {
                localVarQueryParameter['cbpUpids'] = cbpUpids;
            }
            if (cbpChannels !== undefined) {
                localVarQueryParameter['cbpChannels'] = cbpChannels;
            }
            if (cbpFallbackChannel !== undefined) {
                localVarQueryParameter['cbpFallbackChannel'] = cbpFallbackChannel;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RecentOrdersControllerV2Api - functional programming interface
 * @export
 */
export const RecentOrdersControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecentOrdersControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets last orders enriched with products for rebuy.
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [itemsPerPage]
         * @param {number} [page]
         * @param {string} [cbpUpids] Comma separated list of upids which specifies for wich products another channel based pricing (cbp) should take effekt.
         * @param {string} [cbpChannels] Comma separated list of channels that corresponds to the upids in the query parameter cbpUpids.
         * @param {string} [cbpFallbackChannel] The fallback channel to use in case cbpChannels is not provided for all variants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRecentOrdersV2TenantGet(language, tenant, itemsPerPage, page, cbpUpids, cbpChannels, cbpFallbackChannel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageRecentOrdersV2TenantGet(language, tenant, itemsPerPage, page, cbpUpids, cbpChannels, cbpFallbackChannel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RecentOrdersControllerV2Api - factory interface
 * @export
 */
export const RecentOrdersControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecentOrdersControllerV2ApiFp(configuration);
    return {
        /**
         * Gets last orders enriched with products for rebuy.
         * @param {RecentOrdersControllerV2ApiLanguageRecentOrdersV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageRecentOrdersV2TenantGet(requestParameters, options) {
            return localVarFp.languageRecentOrdersV2TenantGet(requestParameters.language, requestParameters.tenant, requestParameters.itemsPerPage, requestParameters.page, requestParameters.cbpUpids, requestParameters.cbpChannels, requestParameters.cbpFallbackChannel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecentOrdersControllerV2Api - object-oriented interface
 * @export
 * @class RecentOrdersControllerV2Api
 * @extends {BaseAPI}
 */
export class RecentOrdersControllerV2Api extends BaseAPI {
    /**
     * Gets last orders enriched with products for rebuy.
     * @param {RecentOrdersControllerV2ApiLanguageRecentOrdersV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecentOrdersControllerV2Api
     */
    languageRecentOrdersV2TenantGet(requestParameters, options) {
        return RecentOrdersControllerV2ApiFp(this.configuration).languageRecentOrdersV2TenantGet(requestParameters.language, requestParameters.tenant, requestParameters.itemsPerPage, requestParameters.page, requestParameters.cbpUpids, requestParameters.cbpChannels, requestParameters.cbpFallbackChannel, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RedPointsMultiplierControllerApi - axios parameter creator
 * @export
 */
export const RedPointsMultiplierControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This endpoint allows the offer-service to get redpoints multiplier
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redPointsMultiplierServiceAppGetMultiplier: (tenant, upid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redPointsMultiplierServiceAppGetMultiplier', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('redPointsMultiplierServiceAppGetMultiplier', 'upid', upid);
            const localVarPath = `/redpointsmultiplier/v1/{tenant}/multiplier`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (upid !== undefined) {
                localVarQueryParameter['upid'] = upid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RedPointsMultiplierControllerApi - functional programming interface
 * @export
 */
export const RedPointsMultiplierControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RedPointsMultiplierControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * This endpoint allows the offer-service to get redpoints multiplier
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redPointsMultiplierServiceAppGetMultiplier(tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redPointsMultiplierServiceAppGetMultiplier(tenant, upid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RedPointsMultiplierControllerApi - factory interface
 * @export
 */
export const RedPointsMultiplierControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RedPointsMultiplierControllerApiFp(configuration);
    return {
        /**
         * This endpoint allows the offer-service to get redpoints multiplier
         * @param {RedPointsMultiplierControllerApiRedPointsMultiplierServiceAppGetMultiplierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redPointsMultiplierServiceAppGetMultiplier(requestParameters, options) {
            return localVarFp.redPointsMultiplierServiceAppGetMultiplier(requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RedPointsMultiplierControllerApi - object-oriented interface
 * @export
 * @class RedPointsMultiplierControllerApi
 * @extends {BaseAPI}
 */
export class RedPointsMultiplierControllerApi extends BaseAPI {
    /**
     * This endpoint allows the offer-service to get redpoints multiplier
     * @param {RedPointsMultiplierControllerApiRedPointsMultiplierServiceAppGetMultiplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedPointsMultiplierControllerApi
     */
    redPointsMultiplierServiceAppGetMultiplier(requestParameters, options) {
        return RedPointsMultiplierControllerApiFp(this.configuration).redPointsMultiplierServiceAppGetMultiplier(requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RedpointsControllerApi - axios parameter creator
 * @export
 */
export const RedpointsControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get redpoints and RX calculations
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} totalVoucherDiscountCents
         * @param {RedpointsOrderPointsRequestV1} RedpointsOrderPointsRequestV1
         * @param {string} [shopCartId]
         * @param {number} [totalRedeemedRedpointsDiscountCents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyRedpointsOrderPoints: (tenant, totalVoucherDiscountCents, RedpointsOrderPointsRequestV1, shopCartId, totalRedeemedRedpointsDiscountCents, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('bullyRedpointsOrderPoints', 'tenant', tenant);
            // verify required parameter 'totalVoucherDiscountCents' is not null or undefined
            assertParamExists('bullyRedpointsOrderPoints', 'totalVoucherDiscountCents', totalVoucherDiscountCents);
            // verify required parameter 'RedpointsOrderPointsRequestV1' is not null or undefined
            assertParamExists('bullyRedpointsOrderPoints', 'RedpointsOrderPointsRequestV1', RedpointsOrderPointsRequestV1);
            const localVarPath = `/redpoints/v1/{tenant}/orderpoints`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (shopCartId !== undefined) {
                localVarQueryParameter['shopCartId'] = shopCartId;
            }
            if (totalVoucherDiscountCents !== undefined) {
                localVarQueryParameter['totalVoucherDiscountCents'] = totalVoucherDiscountCents;
            }
            if (totalRedeemedRedpointsDiscountCents !== undefined) {
                localVarQueryParameter['totalRedeemedRedpointsDiscountCents'] = totalRedeemedRedpointsDiscountCents;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RedpointsOrderPointsRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return information about the given customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {string} [optInCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdGet: (tenant, id, optInCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersIdGet', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersIdGet', 'id', id);
            const localVarPath = `/redpoints/v1/{tenant}/customers/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (optInCode !== undefined) {
                localVarQueryParameter['optInCode'] = optInCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates an optIn code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {string} [email]
         * @param {string} [optInType]
         * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdInterestedPost: (tenant, id, email, optInType, RedpointsPostOptInRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersIdInterestedPost', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersIdInterestedPost', 'id', id);
            const localVarPath = `/redpoints/v1/{tenant}/customers/{id}/interested`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (optInType !== undefined) {
                localVarQueryParameter['optInType'] = optInType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RedpointsPostOptInRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns the redpoints registration status for given customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdRegistrationstatusGet: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersIdRegistrationstatusGet', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersIdRegistrationstatusGet', 'id', id);
            const localVarPath = `/redpoints/v1/{tenant}/customers/{id}/registrationstatus`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get event by customerId and eventId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet: (tenant, shopCustomerId, eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet', 'tenant', tenant);
            // verify required parameter 'shopCustomerId' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet', 'shopCustomerId', shopCustomerId);
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet', 'eventId', eventId);
            const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/events/{eventId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all events by customerId (e.g. EA123456)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdEventsGet: (tenant, shopCustomerId, page, itemsPerPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdEventsGet', 'tenant', tenant);
            // verify required parameter 'shopCustomerId' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdEventsGet', 'shopCustomerId', shopCustomerId);
            const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/events`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdOrdersPost: (tenant, shopCustomerId, RedpointsPostOrdersRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdOrdersPost', 'tenant', tenant);
            // verify required parameter 'shopCustomerId' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdOrdersPost', 'shopCustomerId', shopCustomerId);
            const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RedpointsPostOrdersRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Receive information about an order in the past
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {string} shopOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet: (tenant, shopCustomerId, shopOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet', 'tenant', tenant);
            // verify required parameter 'shopCustomerId' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet', 'shopCustomerId', shopCustomerId);
            // verify required parameter 'shopOrderId' is not null or undefined
            assertParamExists('redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet', 'shopOrderId', shopOrderId);
            const localVarPath = `/redpoints/v1/{tenant}/customers/{shopCustomerId}/orders/{shopOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"shopCustomerId"}}`, encodeURIComponent(String(shopCustomerId)))
                .replace(`{${"shopOrderId"}}`, encodeURIComponent(String(shopOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Checks the optIn code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} optInCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantOptinOptInCodeGet: (tenant, optInCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantOptinOptInCodeGet', 'tenant', tenant);
            // verify required parameter 'optInCode' is not null or undefined
            assertParamExists('redpointsV1TenantOptinOptInCodeGet', 'optInCode', optInCode);
            const localVarPath = `/redpoints/v1/{tenant}/optin/{optInCode}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"optInCode"}}`, encodeURIComponent(String(optInCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Confirm an opt in and register the customer in RedPoints if not already registered
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} optInCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantOptinOptInCodePost: (tenant, optInCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV1TenantOptinOptInCodePost', 'tenant', tenant);
            // verify required parameter 'optInCode' is not null or undefined
            assertParamExists('redpointsV1TenantOptinOptInCodePost', 'optInCode', optInCode);
            const localVarPath = `/redpoints/v1/{tenant}/optin/{optInCode}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"optInCode"}}`, encodeURIComponent(String(optInCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RedpointsControllerApi - functional programming interface
 * @export
 */
export const RedpointsControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RedpointsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get redpoints and RX calculations
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} totalVoucherDiscountCents
         * @param {RedpointsOrderPointsRequestV1} RedpointsOrderPointsRequestV1
         * @param {string} [shopCartId]
         * @param {number} [totalRedeemedRedpointsDiscountCents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyRedpointsOrderPoints(tenant, totalVoucherDiscountCents, RedpointsOrderPointsRequestV1, shopCartId, totalRedeemedRedpointsDiscountCents, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bullyRedpointsOrderPoints(tenant, totalVoucherDiscountCents, RedpointsOrderPointsRequestV1, shopCartId, totalRedeemedRedpointsDiscountCents, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return information about the given customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {string} [optInCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdGet(tenant, id, optInCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantCustomersIdGet(tenant, id, optInCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates an optIn code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {string} [email]
         * @param {string} [optInType]
         * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdInterestedPost(tenant, id, email, optInType, RedpointsPostOptInRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantCustomersIdInterestedPost(tenant, id, email, optInType, RedpointsPostOptInRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns the redpoints registration status for given customer
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdRegistrationstatusGet(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantCustomersIdRegistrationstatusGet(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get event by customerId and eventId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(tenant, shopCustomerId, eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(tenant, shopCustomerId, eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all events by customerId (e.g. EA123456)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdEventsGet(tenant, shopCustomerId, page, itemsPerPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdEventsGet(tenant, shopCustomerId, page, itemsPerPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdOrdersPost(tenant, shopCustomerId, RedpointsPostOrdersRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdOrdersPost(tenant, shopCustomerId, RedpointsPostOrdersRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Receive information about an order in the past
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopCustomerId
         * @param {string} shopOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(tenant, shopCustomerId, shopOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(tenant, shopCustomerId, shopOrderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Checks the optIn code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} optInCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantOptinOptInCodeGet(tenant, optInCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantOptinOptInCodeGet(tenant, optInCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Confirm an opt in and register the customer in RedPoints if not already registered
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} optInCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantOptinOptInCodePost(tenant, optInCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV1TenantOptinOptInCodePost(tenant, optInCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RedpointsControllerApi - factory interface
 * @export
 */
export const RedpointsControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RedpointsControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Get redpoints and RX calculations
         * @param {RedpointsControllerApiBullyRedpointsOrderPointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bullyRedpointsOrderPoints(requestParameters, options) {
            return localVarFp.bullyRedpointsOrderPoints(requestParameters.tenant, requestParameters.totalVoucherDiscountCents, requestParameters.RedpointsOrderPointsRequestV1, requestParameters.shopCartId, requestParameters.totalRedeemedRedpointsDiscountCents, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return information about the given customer
         * @param {RedpointsControllerApiRedpointsV1TenantCustomersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdGet(requestParameters, options) {
            return localVarFp.redpointsV1TenantCustomersIdGet(requestParameters.tenant, requestParameters.id, requestParameters.optInCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates an optIn code
         * @param {RedpointsControllerApiRedpointsV1TenantCustomersIdInterestedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdInterestedPost(requestParameters, options) {
            return localVarFp.redpointsV1TenantCustomersIdInterestedPost(requestParameters.tenant, requestParameters.id, requestParameters.email, requestParameters.optInType, requestParameters.RedpointsPostOptInRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the redpoints registration status for given customer
         * @param {RedpointsControllerApiRedpointsV1TenantCustomersIdRegistrationstatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersIdRegistrationstatusGet(requestParameters, options) {
            return localVarFp.redpointsV1TenantCustomersIdRegistrationstatusGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get event by customerId and eventId
         * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(requestParameters, options) {
            return localVarFp.redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all events by customerId (e.g. EA123456)
         * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdEventsGet(requestParameters, options) {
            return localVarFp.redpointsV1TenantCustomersShopCustomerIdEventsGet(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
         * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdOrdersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdOrdersPost(requestParameters, options) {
            return localVarFp.redpointsV1TenantCustomersShopCustomerIdOrdersPost(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.RedpointsPostOrdersRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Receive information about an order in the past
         * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(requestParameters, options) {
            return localVarFp.redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.shopOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Checks the optIn code
         * @param {RedpointsControllerApiRedpointsV1TenantOptinOptInCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantOptinOptInCodeGet(requestParameters, options) {
            return localVarFp.redpointsV1TenantOptinOptInCodeGet(requestParameters.tenant, requestParameters.optInCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirm an opt in and register the customer in RedPoints if not already registered
         * @param {RedpointsControllerApiRedpointsV1TenantOptinOptInCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV1TenantOptinOptInCodePost(requestParameters, options) {
            return localVarFp.redpointsV1TenantOptinOptInCodePost(requestParameters.tenant, requestParameters.optInCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RedpointsControllerApi - object-oriented interface
 * @export
 * @class RedpointsControllerApi
 * @extends {BaseAPI}
 */
export class RedpointsControllerApi extends BaseAPI {
    /**
     *
     * @summary Get redpoints and RX calculations
     * @param {RedpointsControllerApiBullyRedpointsOrderPointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    bullyRedpointsOrderPoints(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).bullyRedpointsOrderPoints(requestParameters.tenant, requestParameters.totalVoucherDiscountCents, requestParameters.RedpointsOrderPointsRequestV1, requestParameters.shopCartId, requestParameters.totalRedeemedRedpointsDiscountCents, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return information about the given customer
     * @param {RedpointsControllerApiRedpointsV1TenantCustomersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantCustomersIdGet(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantCustomersIdGet(requestParameters.tenant, requestParameters.id, requestParameters.optInCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates an optIn code
     * @param {RedpointsControllerApiRedpointsV1TenantCustomersIdInterestedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantCustomersIdInterestedPost(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantCustomersIdInterestedPost(requestParameters.tenant, requestParameters.id, requestParameters.email, requestParameters.optInType, requestParameters.RedpointsPostOptInRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns the redpoints registration status for given customer
     * @param {RedpointsControllerApiRedpointsV1TenantCustomersIdRegistrationstatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantCustomersIdRegistrationstatusGet(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantCustomersIdRegistrationstatusGet(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get event by customerId and eventId
     * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantCustomersShopCustomerIdEventsEventIdGet(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all events by customerId (e.g. EA123456)
     * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantCustomersShopCustomerIdEventsGet(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantCustomersShopCustomerIdEventsGet(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided.
     * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdOrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantCustomersShopCustomerIdOrdersPost(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantCustomersShopCustomerIdOrdersPost(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.RedpointsPostOrdersRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Receive information about an order in the past
     * @param {RedpointsControllerApiRedpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantCustomersShopCustomerIdOrdersShopOrderIdGet(requestParameters.tenant, requestParameters.shopCustomerId, requestParameters.shopOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Checks the optIn code
     * @param {RedpointsControllerApiRedpointsV1TenantOptinOptInCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantOptinOptInCodeGet(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantOptinOptInCodeGet(requestParameters.tenant, requestParameters.optInCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirm an opt in and register the customer in RedPoints if not already registered
     * @param {RedpointsControllerApiRedpointsV1TenantOptinOptInCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerApi
     */
    redpointsV1TenantOptinOptInCodePost(requestParameters, options) {
        return RedpointsControllerApiFp(this.configuration).redpointsV1TenantOptinOptInCodePost(requestParameters.tenant, requestParameters.optInCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RedpointsControllerV2Api - axios parameter creator
 * @export
 */
export const RedpointsControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantCustomerGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV2TenantCustomerGet', 'tenant', tenant);
            const localVarPath = `/redpoints/v2/{tenant}/customer`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get event by customerId extracted by JWT and eventId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantEventsEventIdGet: (tenant, eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV2TenantEventsEventIdGet', 'tenant', tenant);
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('redpointsV2TenantEventsEventIdGet', 'eventId', eventId);
            const localVarPath = `/redpoints/v2/{tenant}/events/{eventId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantEventsGet: (tenant, page, itemsPerPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV2TenantEventsGet', 'tenant', tenant);
            const localVarPath = `/redpoints/v2/{tenant}/events`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates an optIn code for the customer extracted by JWT.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} [email]
         * @param {string} [optInType]
         * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantInterestedPost: (tenant, email, optInType, RedpointsPostOptInRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV2TenantInterestedPost', 'tenant', tenant);
            const localVarPath = `/redpoints/v2/{tenant}/interested`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (optInType !== undefined) {
                localVarQueryParameter['optInType'] = optInType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RedpointsPostOptInRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantOrdersPost: (tenant, RedpointsPostOrdersRequestV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV2TenantOrdersPost', 'tenant', tenant);
            const localVarPath = `/redpoints/v2/{tenant}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RedpointsPostOrdersRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Receive information about an order in the past for the customer extracted by JWT.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantOrdersShopOrderIdGet: (tenant, shopOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV2TenantOrdersShopOrderIdGet', 'tenant', tenant);
            // verify required parameter 'shopOrderId' is not null or undefined
            assertParamExists('redpointsV2TenantOrdersShopOrderIdGet', 'shopOrderId', shopOrderId);
            const localVarPath = `/redpoints/v2/{tenant}/orders/{shopOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"shopOrderId"}}`, encodeURIComponent(String(shopOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantRegistrationstatusGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV2TenantRegistrationstatusGet', 'tenant', tenant);
            const localVarPath = `/redpoints/v2/{tenant}/registrationstatus`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RedpointsControllerV2Api - functional programming interface
 * @export
 */
export const RedpointsControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = RedpointsControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantCustomerGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV2TenantCustomerGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get event by customerId extracted by JWT and eventId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantEventsEventIdGet(tenant, eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV2TenantEventsEventIdGet(tenant, eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantEventsGet(tenant, page, itemsPerPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV2TenantEventsGet(tenant, page, itemsPerPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates an optIn code for the customer extracted by JWT.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} [email]
         * @param {string} [optInType]
         * @param {RedpointsPostOptInRequestV1} [RedpointsPostOptInRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantInterestedPost(tenant, email, optInType, RedpointsPostOptInRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV2TenantInterestedPost(tenant, email, optInType, RedpointsPostOptInRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {RedpointsPostOrdersRequestV1} [RedpointsPostOrdersRequestV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantOrdersPost(tenant, RedpointsPostOrdersRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV2TenantOrdersPost(tenant, RedpointsPostOrdersRequestV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Receive information about an order in the past for the customer extracted by JWT.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} shopOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantOrdersShopOrderIdGet(tenant, shopOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV2TenantOrdersShopOrderIdGet(tenant, shopOrderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantRegistrationstatusGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV2TenantRegistrationstatusGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RedpointsControllerV2Api - factory interface
 * @export
 */
export const RedpointsControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RedpointsControllerV2ApiFp(configuration);
    return {
        /**
         *
         * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
         * @param {RedpointsControllerV2ApiRedpointsV2TenantCustomerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantCustomerGet(requestParameters, options) {
            return localVarFp.redpointsV2TenantCustomerGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get event by customerId extracted by JWT and eventId
         * @param {RedpointsControllerV2ApiRedpointsV2TenantEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantEventsEventIdGet(requestParameters, options) {
            return localVarFp.redpointsV2TenantEventsEventIdGet(requestParameters.tenant, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
         * @param {RedpointsControllerV2ApiRedpointsV2TenantEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantEventsGet(requestParameters, options) {
            return localVarFp.redpointsV2TenantEventsGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates an optIn code for the customer extracted by JWT.
         * @param {RedpointsControllerV2ApiRedpointsV2TenantInterestedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantInterestedPost(requestParameters, options) {
            return localVarFp.redpointsV2TenantInterestedPost(requestParameters.tenant, requestParameters.email, requestParameters.optInType, requestParameters.RedpointsPostOptInRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
         * @param {RedpointsControllerV2ApiRedpointsV2TenantOrdersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantOrdersPost(requestParameters, options) {
            return localVarFp.redpointsV2TenantOrdersPost(requestParameters.tenant, requestParameters.RedpointsPostOrdersRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Receive information about an order in the past for the customer extracted by JWT.
         * @param {RedpointsControllerV2ApiRedpointsV2TenantOrdersShopOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantOrdersShopOrderIdGet(requestParameters, options) {
            return localVarFp.redpointsV2TenantOrdersShopOrderIdGet(requestParameters.tenant, requestParameters.shopOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
         * @param {RedpointsControllerV2ApiRedpointsV2TenantRegistrationstatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV2TenantRegistrationstatusGet(requestParameters, options) {
            return localVarFp.redpointsV2TenantRegistrationstatusGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RedpointsControllerV2Api - object-oriented interface
 * @export
 * @class RedpointsControllerV2Api
 * @extends {BaseAPI}
 */
export class RedpointsControllerV2Api extends BaseAPI {
    /**
     *
     * @summary Return information about the the customer. Extracts customer\'s id from jwt token.
     * @param {RedpointsControllerV2ApiRedpointsV2TenantCustomerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV2Api
     */
    redpointsV2TenantCustomerGet(requestParameters, options) {
        return RedpointsControllerV2ApiFp(this.configuration).redpointsV2TenantCustomerGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get event by customerId extracted by JWT and eventId
     * @param {RedpointsControllerV2ApiRedpointsV2TenantEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV2Api
     */
    redpointsV2TenantEventsEventIdGet(requestParameters, options) {
        return RedpointsControllerV2ApiFp(this.configuration).redpointsV2TenantEventsEventIdGet(requestParameters.tenant, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all events by customerId extracted by JWT (e.g. EA123456)
     * @param {RedpointsControllerV2ApiRedpointsV2TenantEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV2Api
     */
    redpointsV2TenantEventsGet(requestParameters, options) {
        return RedpointsControllerV2ApiFp(this.configuration).redpointsV2TenantEventsGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates an optIn code for the customer extracted by JWT.
     * @param {RedpointsControllerV2ApiRedpointsV2TenantInterestedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV2Api
     */
    redpointsV2TenantInterestedPost(requestParameters, options) {
        return RedpointsControllerV2ApiFp(this.configuration).redpointsV2TenantInterestedPost(requestParameters.tenant, requestParameters.email, requestParameters.optInType, requestParameters.RedpointsPostOptInRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Receive a list of points collected and points redeemed per order for the order IDs provided for the customer extracted by JWT.
     * @param {RedpointsControllerV2ApiRedpointsV2TenantOrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV2Api
     */
    redpointsV2TenantOrdersPost(requestParameters, options) {
        return RedpointsControllerV2ApiFp(this.configuration).redpointsV2TenantOrdersPost(requestParameters.tenant, requestParameters.RedpointsPostOrdersRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Receive information about an order in the past for the customer extracted by JWT.
     * @param {RedpointsControllerV2ApiRedpointsV2TenantOrdersShopOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV2Api
     */
    redpointsV2TenantOrdersShopOrderIdGet(requestParameters, options) {
        return RedpointsControllerV2ApiFp(this.configuration).redpointsV2TenantOrdersShopOrderIdGet(requestParameters.tenant, requestParameters.shopOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns the redpoints registration status for the customer. Extracts customer\'s id from jwt token.
     * @param {RedpointsControllerV2ApiRedpointsV2TenantRegistrationstatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV2Api
     */
    redpointsV2TenantRegistrationstatusGet(requestParameters, options) {
        return RedpointsControllerV2ApiFp(this.configuration).redpointsV2TenantRegistrationstatusGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RedpointsControllerV3Api - axios parameter creator
 * @export
 */
export const RedpointsControllerV3ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Aggregates events and customer call.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantCustomerEventsGet: (tenant, page, itemsPerPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV3TenantCustomerEventsGet', 'tenant', tenant);
            const localVarPath = `/redpoints/v3/{tenant}/customer-events`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates an optIn code for the customer. Also submits orders of last 24h
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {RedpointsInterestedRequestBodyV1} [RedpointsInterestedRequestBodyV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantInterestedPost: (tenant, RedpointsInterestedRequestBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV3TenantInterestedPost', 'tenant', tenant);
            const localVarPath = `/redpoints/v3/{tenant}/interested`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RedpointsInterestedRequestBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {RedpointsCustomAction} RedpointsCustomAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantSmartpatientactionsPost: (tenant, RedpointsCustomAction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('redpointsV3TenantSmartpatientactionsPost', 'tenant', tenant);
            // verify required parameter 'RedpointsCustomAction' is not null or undefined
            assertParamExists('redpointsV3TenantSmartpatientactionsPost', 'RedpointsCustomAction', RedpointsCustomAction);
            const localVarPath = `/redpoints/v3/{tenant}/smartpatientactions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(RedpointsCustomAction, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RedpointsControllerV3Api - functional programming interface
 * @export
 */
export const RedpointsControllerV3ApiFp = function (configuration) {
    const localVarAxiosParamCreator = RedpointsControllerV3ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Aggregates events and customer call.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantCustomerEventsGet(tenant, page, itemsPerPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV3TenantCustomerEventsGet(tenant, page, itemsPerPage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates an optIn code for the customer. Also submits orders of last 24h
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {RedpointsInterestedRequestBodyV1} [RedpointsInterestedRequestBodyV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantInterestedPost(tenant, RedpointsInterestedRequestBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV3TenantInterestedPost(tenant, RedpointsInterestedRequestBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {RedpointsCustomAction} RedpointsCustomAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantSmartpatientactionsPost(tenant, RedpointsCustomAction, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redpointsV3TenantSmartpatientactionsPost(tenant, RedpointsCustomAction, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RedpointsControllerV3Api - factory interface
 * @export
 */
export const RedpointsControllerV3ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RedpointsControllerV3ApiFp(configuration);
    return {
        /**
         *
         * @summary Aggregates events and customer call.
         * @param {RedpointsControllerV3ApiRedpointsV3TenantCustomerEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantCustomerEventsGet(requestParameters, options) {
            return localVarFp.redpointsV3TenantCustomerEventsGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates an optIn code for the customer. Also submits orders of last 24h
         * @param {RedpointsControllerV3ApiRedpointsV3TenantInterestedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantInterestedPost(requestParameters, options) {
            return localVarFp.redpointsV3TenantInterestedPost(requestParameters.tenant, requestParameters.RedpointsInterestedRequestBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
         * @param {RedpointsControllerV3ApiRedpointsV3TenantSmartpatientactionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redpointsV3TenantSmartpatientactionsPost(requestParameters, options) {
            return localVarFp.redpointsV3TenantSmartpatientactionsPost(requestParameters.tenant, requestParameters.RedpointsCustomAction, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RedpointsControllerV3Api - object-oriented interface
 * @export
 * @class RedpointsControllerV3Api
 * @extends {BaseAPI}
 */
export class RedpointsControllerV3Api extends BaseAPI {
    /**
     *
     * @summary Aggregates events and customer call.
     * @param {RedpointsControllerV3ApiRedpointsV3TenantCustomerEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV3Api
     */
    redpointsV3TenantCustomerEventsGet(requestParameters, options) {
        return RedpointsControllerV3ApiFp(this.configuration).redpointsV3TenantCustomerEventsGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates an optIn code for the customer. Also submits orders of last 24h
     * @param {RedpointsControllerV3ApiRedpointsV3TenantInterestedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV3Api
     */
    redpointsV3TenantInterestedPost(requestParameters, options) {
        return RedpointsControllerV3ApiFp(this.configuration).redpointsV3TenantInterestedPost(requestParameters.tenant, requestParameters.RedpointsInterestedRequestBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add a Smart Patient RedPoints transfer. Extracts customer\'s id from jwt token.
     * @param {RedpointsControllerV3ApiRedpointsV3TenantSmartpatientactionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedpointsControllerV3Api
     */
    redpointsV3TenantSmartpatientactionsPost(requestParameters, options) {
        return RedpointsControllerV3ApiFp(this.configuration).redpointsV3TenantSmartpatientactionsPost(requestParameters.tenant, requestParameters.RedpointsCustomAction, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReturnLabelControllerApi - axios parameter creator
 * @export
 */
export const ReturnLabelControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLabelAppGetReturnReasons: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('returnLabelAppGetReturnReasons', 'tenant', tenant);
            const localVarPath = `/returnlabel/v1/{tenant}/returnreason/reasons`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Request return label for listed products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} suborderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV1TenantSuborderIdGet: (tenant, suborderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('returnlabelV1TenantSuborderIdGet', 'tenant', tenant);
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('returnlabelV1TenantSuborderIdGet', 'suborderId', suborderId);
            const localVarPath = `/returnlabel/v1/{tenant}/{suborderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Request return label for listed products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} suborderId
         * @param {CreateReturnLabelRequestBodyV1} CreateReturnLabelRequestBodyV1 Return Label request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV1TenantSuborderIdPost: (tenant, suborderId, CreateReturnLabelRequestBodyV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('returnlabelV1TenantSuborderIdPost', 'tenant', tenant);
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('returnlabelV1TenantSuborderIdPost', 'suborderId', suborderId);
            // verify required parameter 'CreateReturnLabelRequestBodyV1' is not null or undefined
            assertParamExists('returnlabelV1TenantSuborderIdPost', 'CreateReturnLabelRequestBodyV1', CreateReturnLabelRequestBodyV1);
            const localVarPath = `/returnlabel/v1/{tenant}/{suborderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CreateReturnLabelRequestBodyV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Request return label for listed products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {string} suborderId
         * @param {CreateReturnLabelRequestBodyV2} CreateReturnLabelRequestBodyV2 Return Label request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV2TenantOrderNumberSuborderIdPost: (tenant, orderNumber, suborderId, CreateReturnLabelRequestBodyV2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('returnlabelV2TenantOrderNumberSuborderIdPost', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('returnlabelV2TenantOrderNumberSuborderIdPost', 'orderNumber', orderNumber);
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('returnlabelV2TenantOrderNumberSuborderIdPost', 'suborderId', suborderId);
            // verify required parameter 'CreateReturnLabelRequestBodyV2' is not null or undefined
            assertParamExists('returnlabelV2TenantOrderNumberSuborderIdPost', 'CreateReturnLabelRequestBodyV2', CreateReturnLabelRequestBodyV2);
            const localVarPath = `/returnlabel/v2/{tenant}/{orderNumber}/{suborderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CreateReturnLabelRequestBodyV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Request return label for listed products v2
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} suborderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV2TenantOrderSuborderIdGet: (tenant, suborderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('returnlabelV2TenantOrderSuborderIdGet', 'tenant', tenant);
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('returnlabelV2TenantOrderSuborderIdGet', 'suborderId', suborderId);
            const localVarPath = `/returnlabel/v2/{tenant}/order/{suborderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReturnLabelControllerApi - functional programming interface
 * @export
 */
export const ReturnLabelControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReturnLabelControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLabelAppGetReturnReasons(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnLabelAppGetReturnReasons(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Request return label for listed products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} suborderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV1TenantSuborderIdGet(tenant, suborderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnlabelV1TenantSuborderIdGet(tenant, suborderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Request return label for listed products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} suborderId
         * @param {CreateReturnLabelRequestBodyV1} CreateReturnLabelRequestBodyV1 Return Label request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV1TenantSuborderIdPost(tenant, suborderId, CreateReturnLabelRequestBodyV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnlabelV1TenantSuborderIdPost(tenant, suborderId, CreateReturnLabelRequestBodyV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Request return label for listed products
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {string} suborderId
         * @param {CreateReturnLabelRequestBodyV2} CreateReturnLabelRequestBodyV2 Return Label request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV2TenantOrderNumberSuborderIdPost(tenant, orderNumber, suborderId, CreateReturnLabelRequestBodyV2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnlabelV2TenantOrderNumberSuborderIdPost(tenant, orderNumber, suborderId, CreateReturnLabelRequestBodyV2, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Request return label for listed products v2
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} suborderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV2TenantOrderSuborderIdGet(tenant, suborderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnlabelV2TenantOrderSuborderIdGet(tenant, suborderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ReturnLabelControllerApi - factory interface
 * @export
 */
export const ReturnLabelControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReturnLabelControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ReturnLabelControllerApiReturnLabelAppGetReturnReasonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLabelAppGetReturnReasons(requestParameters, options) {
            return localVarFp.returnLabelAppGetReturnReasons(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Request return label for listed products
         * @param {ReturnLabelControllerApiReturnlabelV1TenantSuborderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV1TenantSuborderIdGet(requestParameters, options) {
            return localVarFp.returnlabelV1TenantSuborderIdGet(requestParameters.tenant, requestParameters.suborderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Request return label for listed products
         * @param {ReturnLabelControllerApiReturnlabelV1TenantSuborderIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV1TenantSuborderIdPost(requestParameters, options) {
            return localVarFp.returnlabelV1TenantSuborderIdPost(requestParameters.tenant, requestParameters.suborderId, requestParameters.CreateReturnLabelRequestBodyV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Request return label for listed products
         * @param {ReturnLabelControllerApiReturnlabelV2TenantOrderNumberSuborderIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV2TenantOrderNumberSuborderIdPost(requestParameters, options) {
            return localVarFp.returnlabelV2TenantOrderNumberSuborderIdPost(requestParameters.tenant, requestParameters.orderNumber, requestParameters.suborderId, requestParameters.CreateReturnLabelRequestBodyV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Request return label for listed products v2
         * @param {ReturnLabelControllerApiReturnlabelV2TenantOrderSuborderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnlabelV2TenantOrderSuborderIdGet(requestParameters, options) {
            return localVarFp.returnlabelV2TenantOrderSuborderIdGet(requestParameters.tenant, requestParameters.suborderId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReturnLabelControllerApi - object-oriented interface
 * @export
 * @class ReturnLabelControllerApi
 * @extends {BaseAPI}
 */
export class ReturnLabelControllerApi extends BaseAPI {
    /**
     *
     * @param {ReturnLabelControllerApiReturnLabelAppGetReturnReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnLabelControllerApi
     */
    returnLabelAppGetReturnReasons(requestParameters, options) {
        return ReturnLabelControllerApiFp(this.configuration).returnLabelAppGetReturnReasons(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request return label for listed products
     * @param {ReturnLabelControllerApiReturnlabelV1TenantSuborderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnLabelControllerApi
     */
    returnlabelV1TenantSuborderIdGet(requestParameters, options) {
        return ReturnLabelControllerApiFp(this.configuration).returnlabelV1TenantSuborderIdGet(requestParameters.tenant, requestParameters.suborderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request return label for listed products
     * @param {ReturnLabelControllerApiReturnlabelV1TenantSuborderIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnLabelControllerApi
     */
    returnlabelV1TenantSuborderIdPost(requestParameters, options) {
        return ReturnLabelControllerApiFp(this.configuration).returnlabelV1TenantSuborderIdPost(requestParameters.tenant, requestParameters.suborderId, requestParameters.CreateReturnLabelRequestBodyV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request return label for listed products
     * @param {ReturnLabelControllerApiReturnlabelV2TenantOrderNumberSuborderIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnLabelControllerApi
     */
    returnlabelV2TenantOrderNumberSuborderIdPost(requestParameters, options) {
        return ReturnLabelControllerApiFp(this.configuration).returnlabelV2TenantOrderNumberSuborderIdPost(requestParameters.tenant, requestParameters.orderNumber, requestParameters.suborderId, requestParameters.CreateReturnLabelRequestBodyV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request return label for listed products v2
     * @param {ReturnLabelControllerApiReturnlabelV2TenantOrderSuborderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnLabelControllerApi
     */
    returnlabelV2TenantOrderSuborderIdGet(requestParameters, options) {
        return ReturnLabelControllerApiFp(this.configuration).returnlabelV2TenantOrderSuborderIdGet(requestParameters.tenant, requestParameters.suborderId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SWAPServiceApi - axios parameter creator
 * @export
 */
export const SWAPServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of substitutions - currently only German tenants are being supported
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {SwapExchangeRequest} SwapExchangeRequest Prescriptions resolved from Data Matrix codes
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubstitutionsByProductIds: (tenant, SwapExchangeRequest, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getSubstitutionsByProductIds', 'tenant', tenant);
            // verify required parameter 'SwapExchangeRequest' is not null or undefined
            assertParamExists('getSubstitutionsByProductIds', 'SwapExchangeRequest', SwapExchangeRequest);
            const localVarPath = `/swap/v1/{tenant}/substitutions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(SwapExchangeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Provides list of possible alternatives for provided products and additional parameters
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AlternativesRequest} AlternativesRequest Body of request for product alternatives
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiAlternatives: (tenant, AlternativesRequest, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('swapServiceApiAlternatives', 'tenant', tenant);
            // verify required parameter 'AlternativesRequest' is not null or undefined
            assertParamExists('swapServiceApiAlternatives', 'AlternativesRequest', AlternativesRequest);
            const localVarPath = `/swap/v2/{tenant}/alternatives`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(AlternativesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get audit logs by swap processId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} swapProcessId The requested processId
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiAuditlogs: (tenant, swapProcessId, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('swapServiceApiAuditlogs', 'tenant', tenant);
            // verify required parameter 'swapProcessId' is not null or undefined
            assertParamExists('swapServiceApiAuditlogs', 'swapProcessId', swapProcessId);
            const localVarPath = `/swap/v2/{tenant}/auditlogs/{swapProcessId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"swapProcessId"}}`, encodeURIComponent(String(swapProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of substitutions - currently only German tenants are being supported
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {SwapSubstitutionsRequest} SwapSubstitutionsRequest Body of request for product substitutions
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiSubstitutions: (tenant, SwapSubstitutionsRequest, X_Request_ID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('swapServiceApiSubstitutions', 'tenant', tenant);
            // verify required parameter 'SwapSubstitutionsRequest' is not null or undefined
            assertParamExists('swapServiceApiSubstitutions', 'SwapSubstitutionsRequest', SwapSubstitutionsRequest);
            const localVarPath = `/swap/v2/{tenant}/substitutions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Request_ID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(X_Request_ID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(SwapSubstitutionsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SWAPServiceApi - functional programming interface
 * @export
 */
export const SWAPServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = SWAPServiceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of substitutions - currently only German tenants are being supported
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {SwapExchangeRequest} SwapExchangeRequest Prescriptions resolved from Data Matrix codes
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubstitutionsByProductIds(tenant, SwapExchangeRequest, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubstitutionsByProductIds(tenant, SwapExchangeRequest, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Provides list of possible alternatives for provided products and additional parameters
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {AlternativesRequest} AlternativesRequest Body of request for product alternatives
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiAlternatives(tenant, AlternativesRequest, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.swapServiceApiAlternatives(tenant, AlternativesRequest, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get audit logs by swap processId
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} swapProcessId The requested processId
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiAuditlogs(tenant, swapProcessId, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.swapServiceApiAuditlogs(tenant, swapProcessId, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of substitutions - currently only German tenants are being supported
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {SwapSubstitutionsRequest} SwapSubstitutionsRequest Body of request for product substitutions
         * @param {string} [X_Request_ID] Correlates HTTP requests between a client and server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiSubstitutions(tenant, SwapSubstitutionsRequest, X_Request_ID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.swapServiceApiSubstitutions(tenant, SwapSubstitutionsRequest, X_Request_ID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SWAPServiceApi - factory interface
 * @export
 */
export const SWAPServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SWAPServiceApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of substitutions - currently only German tenants are being supported
         * @param {SWAPServiceApiGetSubstitutionsByProductIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubstitutionsByProductIds(requestParameters, options) {
            return localVarFp.getSubstitutionsByProductIds(requestParameters.tenant, requestParameters.SwapExchangeRequest, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Provides list of possible alternatives for provided products and additional parameters
         * @param {SWAPServiceApiSwapServiceApiAlternativesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiAlternatives(requestParameters, options) {
            return localVarFp.swapServiceApiAlternatives(requestParameters.tenant, requestParameters.AlternativesRequest, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get audit logs by swap processId
         * @param {SWAPServiceApiSwapServiceApiAuditlogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiAuditlogs(requestParameters, options) {
            return localVarFp.swapServiceApiAuditlogs(requestParameters.tenant, requestParameters.swapProcessId, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of substitutions - currently only German tenants are being supported
         * @param {SWAPServiceApiSwapServiceApiSubstitutionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swapServiceApiSubstitutions(requestParameters, options) {
            return localVarFp.swapServiceApiSubstitutions(requestParameters.tenant, requestParameters.SwapSubstitutionsRequest, requestParameters.X_Request_ID, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SWAPServiceApi - object-oriented interface
 * @export
 * @class SWAPServiceApi
 * @extends {BaseAPI}
 */
export class SWAPServiceApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {SWAPServiceApiGetSubstitutionsByProductIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SWAPServiceApi
     */
    getSubstitutionsByProductIds(requestParameters, options) {
        return SWAPServiceApiFp(this.configuration).getSubstitutionsByProductIds(requestParameters.tenant, requestParameters.SwapExchangeRequest, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Provides list of possible alternatives for provided products and additional parameters
     * @param {SWAPServiceApiSwapServiceApiAlternativesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SWAPServiceApi
     */
    swapServiceApiAlternatives(requestParameters, options) {
        return SWAPServiceApiFp(this.configuration).swapServiceApiAlternatives(requestParameters.tenant, requestParameters.AlternativesRequest, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get audit logs by swap processId
     * @param {SWAPServiceApiSwapServiceApiAuditlogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SWAPServiceApi
     */
    swapServiceApiAuditlogs(requestParameters, options) {
        return SWAPServiceApiFp(this.configuration).swapServiceApiAuditlogs(requestParameters.tenant, requestParameters.swapProcessId, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of substitutions - currently only German tenants are being supported
     * @param {SWAPServiceApiSwapServiceApiSubstitutionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SWAPServiceApi
     */
    swapServiceApiSubstitutions(requestParameters, options) {
        return SWAPServiceApiFp(this.configuration).swapServiceApiSubstitutions(requestParameters.tenant, requestParameters.SwapSubstitutionsRequest, requestParameters.X_Request_ID, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SearchControllerApi - axios parameter creator
 * @export
 */
export const SearchControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageSearchEsV2TenantGet: (tenant, language, fields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageSearchEsV2TenantGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageSearchEsV2TenantGet', 'language', language);
            const localVarPath = `/{language}/search-es/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} query QueryParam query
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageSearchEsV2TenantSuggestGet: (query, tenant, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('languageSearchEsV2TenantSuggestGet', 'query', query);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageSearchEsV2TenantSuggestGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageSearchEsV2TenantSuggestGet', 'language', language);
            const localVarPath = `/{language}/search-es/v2/{tenant}/suggest`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SearchControllerApi - functional programming interface
 * @export
 */
export const SearchControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {string} [fields] QueryParam fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageSearchEsV2TenantGet(tenant, language, fields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageSearchEsV2TenantGet(tenant, language, fields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} query QueryParam query
         * @param {'at-dev' | 'at-qs' | 'at' | 'ch-dev' | 'ch-qs' | 'ch' | 'com-dev' | 'com-qs' | 'com' | 'it-dev' | 'it-qs' | 'it'} tenant ControllerParam tenant
         * @param {'de' | 'en' | 'fr' | 'it' | 'ch'} language ControllerParam language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageSearchEsV2TenantSuggestGet(query, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageSearchEsV2TenantSuggestGet(query, tenant, language, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SearchControllerApi - factory interface
 * @export
 */
export const SearchControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchControllerApiFp(configuration);
    return {
        /**
         *
         * @param {SearchControllerApiLanguageSearchEsV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageSearchEsV2TenantGet(requestParameters, options) {
            return localVarFp.languageSearchEsV2TenantGet(requestParameters.tenant, requestParameters.language, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchControllerApiLanguageSearchEsV2TenantSuggestGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageSearchEsV2TenantSuggestGet(requestParameters, options) {
            return localVarFp.languageSearchEsV2TenantSuggestGet(requestParameters.query, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchControllerApi - object-oriented interface
 * @export
 * @class SearchControllerApi
 * @extends {BaseAPI}
 */
export class SearchControllerApi extends BaseAPI {
    /**
     *
     * @param {SearchControllerApiLanguageSearchEsV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchControllerApi
     */
    languageSearchEsV2TenantGet(requestParameters, options) {
        return SearchControllerApiFp(this.configuration).languageSearchEsV2TenantGet(requestParameters.tenant, requestParameters.language, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchControllerApiLanguageSearchEsV2TenantSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchControllerApi
     */
    languageSearchEsV2TenantSuggestGet(requestParameters, options) {
        return SearchControllerApiFp(this.configuration).languageSearchEsV2TenantSuggestGet(requestParameters.query, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SellerControllerApi - axios parameter creator
 * @export
 */
export const SellerControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retreives a list of sellers
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} ids A comma seperated list of seller ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantGet: (tenant, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sellerV1TenantGet', 'tenant', tenant);
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('sellerV1TenantGet', 'ids', ids);
            const localVarPath = `/seller/v1/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
         * @summary Checks if customer is allowed to rate given mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} orderId order id
         * @param {string} subOrderId mirakl order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet: (tenant, sellerId, orderId, subOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet', 'tenant', tenant);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet', 'sellerId', sellerId);
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet', 'orderId', orderId);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet', 'subOrderId', subOrderId);
            const localVarPath = `/seller/v1/{tenant}/{sellerId}/canEvaluateOrder/{orderId}/{subOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
         * @summary Checks if customer is allowed to rate given mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} subOrderId mirakl order id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet: (tenant, sellerId, subOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet', 'tenant', tenant);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet', 'sellerId', sellerId);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet', 'subOrderId', subOrderId);
            const localVarPath = `/seller/v1/{tenant}/{sellerId}/canEvaluateOrder/{subOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create evaluation to a specific mirakl order
         * @summary Create evaluation to a specific mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} subOrderId the dedicated instance path selector
         * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluateSubOrderIdPost: (tenant, sellerId, subOrderId, SellerV1EvaluationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluateSubOrderIdPost', 'tenant', tenant);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluateSubOrderIdPost', 'sellerId', sellerId);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluateSubOrderIdPost', 'subOrderId', subOrderId);
            const localVarPath = `/seller/v1/{tenant}/{sellerId}/evaluate/{subOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(SellerV1EvaluationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create evaluation to a specific mirakl order
         * @summary Create evaluation to a specific mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} orderId order id
         * @param {string} subOrderId mirakl order id
         * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost: (tenant, sellerId, orderId, subOrderId, SellerV1EvaluationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost', 'tenant', tenant);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost', 'sellerId', sellerId);
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost', 'orderId', orderId);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost', 'subOrderId', subOrderId);
            const localVarPath = `/seller/v1/{tenant}/{sellerId}/evaluation/{orderId}/{subOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(SellerV1EvaluationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
         * @summary Retrieves a list of visible seller evaluations
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {number} [offset] starting index of retrieved evaluations\&#39; list
         * @param {number} [limit] the maximum count of evaluations retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluationsGet: (tenant, sellerId, offset, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluationsGet', 'tenant', tenant);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdEvaluationsGet', 'sellerId', sellerId);
            const localVarPath = `/seller/v1/{tenant}/{sellerId}/evaluations`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retreives a single seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdGet: (tenant, sellerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdGet', 'tenant', tenant);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('sellerV1TenantSellerIdGet', 'sellerId', sellerId);
            const localVarPath = `/seller/v1/{tenant}/{sellerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SellerControllerApi - functional programming interface
 * @export
 */
export const SellerControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SellerControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Retreives a list of sellers
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} ids A comma seperated list of seller ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantGet(tenant, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellerV1TenantGet(tenant, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
         * @summary Checks if customer is allowed to rate given mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} orderId order id
         * @param {string} subOrderId mirakl order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(tenant, sellerId, orderId, subOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(tenant, sellerId, orderId, subOrderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
         * @summary Checks if customer is allowed to rate given mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} subOrderId mirakl order id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(tenant, sellerId, subOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(tenant, sellerId, subOrderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create evaluation to a specific mirakl order
         * @summary Create evaluation to a specific mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} subOrderId the dedicated instance path selector
         * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluateSubOrderIdPost(tenant, sellerId, subOrderId, SellerV1EvaluationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellerV1TenantSellerIdEvaluateSubOrderIdPost(tenant, sellerId, subOrderId, SellerV1EvaluationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create evaluation to a specific mirakl order
         * @summary Create evaluation to a specific mirakl order
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {string} orderId order id
         * @param {string} subOrderId mirakl order id
         * @param {SellerV1EvaluationRequest} [SellerV1EvaluationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(tenant, sellerId, orderId, subOrderId, SellerV1EvaluationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(tenant, sellerId, orderId, subOrderId, SellerV1EvaluationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
         * @summary Retrieves a list of visible seller evaluations
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {number} [offset] starting index of retrieved evaluations\&#39; list
         * @param {number} [limit] the maximum count of evaluations retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluationsGet(tenant, sellerId, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellerV1TenantSellerIdEvaluationsGet(tenant, sellerId, offset, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retreives a single seller
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} sellerId the dedicated instance path selector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdGet(tenant, sellerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellerV1TenantSellerIdGet(tenant, sellerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SellerControllerApi - factory interface
 * @export
 */
export const SellerControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SellerControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Retreives a list of sellers
         * @param {SellerControllerApiSellerV1TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantGet(requestParameters, options) {
            return localVarFp.sellerV1TenantGet(requestParameters.tenant, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
         * @summary Checks if customer is allowed to rate given mirakl order
         * @param {SellerControllerApiSellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(requestParameters, options) {
            return localVarFp.sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(requestParameters.tenant, requestParameters.sellerId, requestParameters.orderId, requestParameters.subOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
         * @summary Checks if customer is allowed to rate given mirakl order
         * @param {SellerControllerApiSellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(requestParameters, options) {
            return localVarFp.sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(requestParameters.tenant, requestParameters.sellerId, requestParameters.subOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create evaluation to a specific mirakl order
         * @summary Create evaluation to a specific mirakl order
         * @param {SellerControllerApiSellerV1TenantSellerIdEvaluateSubOrderIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluateSubOrderIdPost(requestParameters, options) {
            return localVarFp.sellerV1TenantSellerIdEvaluateSubOrderIdPost(requestParameters.tenant, requestParameters.sellerId, requestParameters.subOrderId, requestParameters.SellerV1EvaluationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create evaluation to a specific mirakl order
         * @summary Create evaluation to a specific mirakl order
         * @param {SellerControllerApiSellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(requestParameters, options) {
            return localVarFp.sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(requestParameters.tenant, requestParameters.sellerId, requestParameters.orderId, requestParameters.subOrderId, requestParameters.SellerV1EvaluationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
         * @summary Retrieves a list of visible seller evaluations
         * @param {SellerControllerApiSellerV1TenantSellerIdEvaluationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdEvaluationsGet(requestParameters, options) {
            return localVarFp.sellerV1TenantSellerIdEvaluationsGet(requestParameters.tenant, requestParameters.sellerId, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retreives a single seller
         * @param {SellerControllerApiSellerV1TenantSellerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerV1TenantSellerIdGet(requestParameters, options) {
            return localVarFp.sellerV1TenantSellerIdGet(requestParameters.tenant, requestParameters.sellerId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SellerControllerApi - object-oriented interface
 * @export
 * @class SellerControllerApi
 * @extends {BaseAPI}
 */
export class SellerControllerApi extends BaseAPI {
    /**
     *
     * @summary Retreives a list of sellers
     * @param {SellerControllerApiSellerV1TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerControllerApi
     */
    sellerV1TenantGet(requestParameters, options) {
        return SellerControllerApiFp(this.configuration).sellerV1TenantGet(requestParameters.tenant, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {SellerControllerApiSellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerControllerApi
     */
    sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(requestParameters, options) {
        return SellerControllerApiFp(this.configuration).sellerV1TenantSellerIdCanEvaluateOrderOrderIdSubOrderIdGet(requestParameters.tenant, requestParameters.sellerId, requestParameters.orderId, requestParameters.subOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns single property that tells us if the customer is allowed to evaluate this mirakl order.
     * @summary Checks if customer is allowed to rate given mirakl order
     * @param {SellerControllerApiSellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SellerControllerApi
     */
    sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(requestParameters, options) {
        return SellerControllerApiFp(this.configuration).sellerV1TenantSellerIdCanEvaluateOrderSubOrderIdGet(requestParameters.tenant, requestParameters.sellerId, requestParameters.subOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {SellerControllerApiSellerV1TenantSellerIdEvaluateSubOrderIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SellerControllerApi
     */
    sellerV1TenantSellerIdEvaluateSubOrderIdPost(requestParameters, options) {
        return SellerControllerApiFp(this.configuration).sellerV1TenantSellerIdEvaluateSubOrderIdPost(requestParameters.tenant, requestParameters.sellerId, requestParameters.subOrderId, requestParameters.SellerV1EvaluationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create evaluation to a specific mirakl order
     * @summary Create evaluation to a specific mirakl order
     * @param {SellerControllerApiSellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerControllerApi
     */
    sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(requestParameters, options) {
        return SellerControllerApiFp(this.configuration).sellerV1TenantSellerIdEvaluationOrderIdSubOrderIdPost(requestParameters.tenant, requestParameters.sellerId, requestParameters.orderId, requestParameters.subOrderId, requestParameters.SellerV1EvaluationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The sellers\' evaluations can be marked as not visible by the marketplace\'s operator. This endpoint\'s response will __only contain evaluations market as visible__.
     * @summary Retrieves a list of visible seller evaluations
     * @param {SellerControllerApiSellerV1TenantSellerIdEvaluationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerControllerApi
     */
    sellerV1TenantSellerIdEvaluationsGet(requestParameters, options) {
        return SellerControllerApiFp(this.configuration).sellerV1TenantSellerIdEvaluationsGet(requestParameters.tenant, requestParameters.sellerId, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retreives a single seller
     * @param {SellerControllerApiSellerV1TenantSellerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerControllerApi
     */
    sellerV1TenantSellerIdGet(requestParameters, options) {
        return SellerControllerApiFp(this.configuration).sellerV1TenantSellerIdGet(requestParameters.tenant, requestParameters.sellerId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SepaDataStorageControllerApi - axios parameter creator
 * @export
 */
export const SepaDataStorageControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sepaV1TenantGet', 'tenant', tenant);
            const localVarPath = `/sepa/v1/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantIdDelete: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sepaV1TenantIdDelete', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sepaV1TenantIdDelete', 'id', id);
            const localVarPath = `/sepa/v1/{tenant}/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {SepaDataV1} [SepaDataV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantIdPut: (tenant, id, SepaDataV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sepaV1TenantIdPut', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sepaV1TenantIdPut', 'id', id);
            const localVarPath = `/sepa/v1/{tenant}/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(SepaDataV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantMigSepaDataIdDelete: (tenant, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sepaV1TenantMigSepaDataIdDelete', 'tenant', tenant);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sepaV1TenantMigSepaDataIdDelete', 'id', id);
            const localVarPath = `/sepa/v1/{tenant}/mig/sepaData/{id}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MigrateSepaDataV1} MigrateSepaDataV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantMigSepaDataPost: (tenant, MigrateSepaDataV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sepaV1TenantMigSepaDataPost', 'tenant', tenant);
            // verify required parameter 'MigrateSepaDataV1' is not null or undefined
            assertParamExists('sepaV1TenantMigSepaDataPost', 'MigrateSepaDataV1', MigrateSepaDataV1);
            const localVarPath = `/sepa/v1/{tenant}/mig/sepaData`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MigrateSepaDataV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {SepaDataV1} [SepaDataV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantPost: (tenant, SepaDataV1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sepaV1TenantPost', 'tenant', tenant);
            const localVarPath = `/sepa/v1/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(SepaDataV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SepaDataStorageControllerApi - functional programming interface
 * @export
 */
export const SepaDataStorageControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SepaDataStorageControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sepaV1TenantGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantIdDelete(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sepaV1TenantIdDelete(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {SepaDataV1} [SepaDataV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantIdPut(tenant, id, SepaDataV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sepaV1TenantIdPut(tenant, id, SepaDataV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantMigSepaDataIdDelete(tenant, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sepaV1TenantMigSepaDataIdDelete(tenant, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {MigrateSepaDataV1} MigrateSepaDataV1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantMigSepaDataPost(tenant, MigrateSepaDataV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sepaV1TenantMigSepaDataPost(tenant, MigrateSepaDataV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {SepaDataV1} [SepaDataV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantPost(tenant, SepaDataV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sepaV1TenantPost(tenant, SepaDataV1, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SepaDataStorageControllerApi - factory interface
 * @export
 */
export const SepaDataStorageControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SepaDataStorageControllerApiFp(configuration);
    return {
        /**
         * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {SepaDataStorageControllerApiSepaV1TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantGet(requestParameters, options) {
            return localVarFp.sepaV1TenantGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {SepaDataStorageControllerApiSepaV1TenantIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantIdDelete(requestParameters, options) {
            return localVarFp.sepaV1TenantIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {SepaDataStorageControllerApiSepaV1TenantIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantIdPut(requestParameters, options) {
            return localVarFp.sepaV1TenantIdPut(requestParameters.tenant, requestParameters.id, requestParameters.SepaDataV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
         * @param {SepaDataStorageControllerApiSepaV1TenantMigSepaDataIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantMigSepaDataIdDelete(requestParameters, options) {
            return localVarFp.sepaV1TenantMigSepaDataIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
         * @param {SepaDataStorageControllerApiSepaV1TenantMigSepaDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantMigSepaDataPost(requestParameters, options) {
            return localVarFp.sepaV1TenantMigSepaDataPost(requestParameters.tenant, requestParameters.MigrateSepaDataV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
         * @param {SepaDataStorageControllerApiSepaV1TenantPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sepaV1TenantPost(requestParameters, options) {
            return localVarFp.sepaV1TenantPost(requestParameters.tenant, requestParameters.SepaDataV1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SepaDataStorageControllerApi - object-oriented interface
 * @export
 * @class SepaDataStorageControllerApi
 * @extends {BaseAPI}
 */
export class SepaDataStorageControllerApi extends BaseAPI {
    /**
     * Endpoint to get SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {SepaDataStorageControllerApiSepaV1TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaDataStorageControllerApi
     */
    sepaV1TenantGet(requestParameters, options) {
        return SepaDataStorageControllerApiFp(this.configuration).sepaV1TenantGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Endpoint to delete SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {SepaDataStorageControllerApiSepaV1TenantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaDataStorageControllerApi
     */
    sepaV1TenantIdDelete(requestParameters, options) {
        return SepaDataStorageControllerApiFp(this.configuration).sepaV1TenantIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Endpoint to update SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {SepaDataStorageControllerApiSepaV1TenantIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaDataStorageControllerApi
     */
    sepaV1TenantIdPut(requestParameters, options) {
        return SepaDataStorageControllerApiFp(this.configuration).sepaV1TenantIdPut(requestParameters.tenant, requestParameters.id, requestParameters.SepaDataV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Endpoint to delete the migrated SEPA data of customer in Sepa-Data-Storage (for internal usage only)
     * @param {SepaDataStorageControllerApiSepaV1TenantMigSepaDataIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaDataStorageControllerApi
     */
    sepaV1TenantMigSepaDataIdDelete(requestParameters, options) {
        return SepaDataStorageControllerApiFp(this.configuration).sepaV1TenantMigSepaDataIdDelete(requestParameters.tenant, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Endpoint to migrate SEPA data of customers from LMS to Sepa-Data-Storage (for internal usage only)
     * @param {SepaDataStorageControllerApiSepaV1TenantMigSepaDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaDataStorageControllerApi
     */
    sepaV1TenantMigSepaDataPost(requestParameters, options) {
        return SepaDataStorageControllerApiFp(this.configuration).sepaV1TenantMigSepaDataPost(requestParameters.tenant, requestParameters.MigrateSepaDataV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Endpoint to save SEPA data for a customer which would be natively handled by Shop-Apotheke.
     * @param {SepaDataStorageControllerApiSepaV1TenantPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaDataStorageControllerApi
     */
    sepaV1TenantPost(requestParameters, options) {
        return SepaDataStorageControllerApiFp(this.configuration).sepaV1TenantPost(requestParameters.tenant, requestParameters.SepaDataV1, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ToggleControllerApi - axios parameter creator
 * @export
 */
export const ToggleControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get toggles by tenant
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TenantTogglesGet: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('toggleV1TenantTogglesGet', 'tenant', tenant);
            const localVarPath = `/toggle/v1/{tenant}/toggles`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get toggle by tenant and toggleName
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} toggleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TenantTogglesToggleNameGet: (tenant, toggleName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('toggleV1TenantTogglesToggleNameGet', 'tenant', tenant);
            // verify required parameter 'toggleName' is not null or undefined
            assertParamExists('toggleV1TenantTogglesToggleNameGet', 'toggleName', toggleName);
            const localVarPath = `/toggle/v1/{tenant}/toggles/{toggleName}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all toggles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TogglesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/toggle/v1/toggles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get toggle by toggleName for all tenants.
         * @param {string} toggleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TogglesToggleNameGet: (toggleName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'toggleName' is not null or undefined
            assertParamExists('toggleV1TogglesToggleNameGet', 'toggleName', toggleName);
            const localVarPath = `/toggle/v1/toggles/{toggleName}`
                .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ToggleControllerApi - functional programming interface
 * @export
 */
export const ToggleControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ToggleControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get toggles by tenant
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TenantTogglesGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.toggleV1TenantTogglesGet(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get toggle by tenant and toggleName
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} toggleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TenantTogglesToggleNameGet(tenant, toggleName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.toggleV1TenantTogglesToggleNameGet(tenant, toggleName, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all toggles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TogglesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.toggleV1TogglesGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get toggle by toggleName for all tenants.
         * @param {string} toggleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TogglesToggleNameGet(toggleName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.toggleV1TogglesToggleNameGet(toggleName, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ToggleControllerApi - factory interface
 * @export
 */
export const ToggleControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ToggleControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Get toggles by tenant
         * @param {ToggleControllerApiToggleV1TenantTogglesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TenantTogglesGet(requestParameters, options) {
            return localVarFp.toggleV1TenantTogglesGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get toggle by tenant and toggleName
         * @param {ToggleControllerApiToggleV1TenantTogglesToggleNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TenantTogglesToggleNameGet(requestParameters, options) {
            return localVarFp.toggleV1TenantTogglesToggleNameGet(requestParameters.tenant, requestParameters.toggleName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all toggles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TogglesGet(options) {
            return localVarFp.toggleV1TogglesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get toggle by toggleName for all tenants.
         * @param {ToggleControllerApiToggleV1TogglesToggleNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleV1TogglesToggleNameGet(requestParameters, options) {
            return localVarFp.toggleV1TogglesToggleNameGet(requestParameters.toggleName, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ToggleControllerApi - object-oriented interface
 * @export
 * @class ToggleControllerApi
 * @extends {BaseAPI}
 */
export class ToggleControllerApi extends BaseAPI {
    /**
     *
     * @summary Get toggles by tenant
     * @param {ToggleControllerApiToggleV1TenantTogglesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToggleControllerApi
     */
    toggleV1TenantTogglesGet(requestParameters, options) {
        return ToggleControllerApiFp(this.configuration).toggleV1TenantTogglesGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get toggle by tenant and toggleName
     * @param {ToggleControllerApiToggleV1TenantTogglesToggleNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToggleControllerApi
     */
    toggleV1TenantTogglesToggleNameGet(requestParameters, options) {
        return ToggleControllerApiFp(this.configuration).toggleV1TenantTogglesToggleNameGet(requestParameters.tenant, requestParameters.toggleName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all toggles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToggleControllerApi
     */
    toggleV1TogglesGet(options) {
        return ToggleControllerApiFp(this.configuration).toggleV1TogglesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get toggle by toggleName for all tenants.
     * @param {ToggleControllerApiToggleV1TogglesToggleNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToggleControllerApi
     */
    toggleV1TogglesToggleNameGet(requestParameters, options) {
        return ToggleControllerApiFp(this.configuration).toggleV1TogglesToggleNameGet(requestParameters.toggleName, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VatValidationControllerApi - axios parameter creator
 * @export
 */
export const VatValidationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This endpoint allows to validate a VAT Number against VIES
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} vatNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatV1TenantValidateGet: (tenant, vatNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('vatV1TenantValidateGet', 'tenant', tenant);
            // verify required parameter 'vatNumber' is not null or undefined
            assertParamExists('vatV1TenantValidateGet', 'vatNumber', vatNumber);
            const localVarPath = `/vat/v1/{tenant}/validate`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vatNumber !== undefined) {
                localVarQueryParameter['vatNumber'] = vatNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VatValidationControllerApi - functional programming interface
 * @export
 */
export const VatValidationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = VatValidationControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * This endpoint allows to validate a VAT Number against VIES
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} vatNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatV1TenantValidateGet(tenant, vatNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.vatV1TenantValidateGet(tenant, vatNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * VatValidationControllerApi - factory interface
 * @export
 */
export const VatValidationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VatValidationControllerApiFp(configuration);
    return {
        /**
         * This endpoint allows to validate a VAT Number against VIES
         * @param {VatValidationControllerApiVatV1TenantValidateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatV1TenantValidateGet(requestParameters, options) {
            return localVarFp.vatV1TenantValidateGet(requestParameters.tenant, requestParameters.vatNumber, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VatValidationControllerApi - object-oriented interface
 * @export
 * @class VatValidationControllerApi
 * @extends {BaseAPI}
 */
export class VatValidationControllerApi extends BaseAPI {
    /**
     * This endpoint allows to validate a VAT Number against VIES
     * @param {VatValidationControllerApiVatV1TenantValidateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatValidationControllerApi
     */
    vatV1TenantValidateGet(requestParameters, options) {
        return VatValidationControllerApiFp(this.configuration).vatV1TenantValidateGet(requestParameters.tenant, requestParameters.vatNumber, options).then((request) => request(this.axios, this.basePath));
    }
}
